
      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref443"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref443"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kGRcS", function(module, exports) {

var $fJ45P = parcelRequire("fJ45P");
var $f101009ed9c0563c$require$MAX_SAFE_COMPONENT_LENGTH = $fJ45P.MAX_SAFE_COMPONENT_LENGTH;
var $f101009ed9c0563c$require$MAX_SAFE_BUILD_LENGTH = $fJ45P.MAX_SAFE_BUILD_LENGTH;
var $f101009ed9c0563c$require$MAX_LENGTH = $fJ45P.MAX_LENGTH;

var $i9RZm = parcelRequire("i9RZm");
exports = module.exports = {};
// The actual regexps go on exports.re
const re = exports.re = [];
const safeRe = exports.safeRe = [];
const src = exports.src = [];
const t = exports.t = {};
let R = 0;
const LETTERDASHNUMBER = "[a-zA-Z0-9-]";
// Replace some greedy regex tokens to prevent regex dos issues. These regex are
// used internally via the safeRe object since all inputs in this library get
// normalized first to trim and collapse all extra whitespace. The original
// regexes are exported for userland consumption and lower level usage. A
// future breaking change could export the safer regex only with a note that
// all input should have extra whitespace removed.
const safeRegexReplacements = [
    [
        "\\s",
        1
    ],
    [
        "\\d",
        $f101009ed9c0563c$require$MAX_LENGTH
    ],
    [
        LETTERDASHNUMBER,
        $f101009ed9c0563c$require$MAX_SAFE_BUILD_LENGTH
    ]
];
const makeSafeRegex = (value)=>{
    for (const [token, max] of safeRegexReplacements)value = value.split(`${token}*`).join(`${token}{0,${max}}`).split(`${token}+`).join(`${token}{1,${max}}`);
    return value;
};
const createToken = (name, value, isGlobal)=>{
    const safe = makeSafeRegex(value);
    const index = R++;
    $i9RZm(name, index, value);
    t[name] = index;
    src[index] = value;
    re[index] = new RegExp(value, isGlobal ? "g" : undefined);
    safeRe[index] = new RegExp(safe, isGlobal ? "g" : undefined);
};
// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.
// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.
createToken("NUMERICIDENTIFIER", "0|[1-9]\\d*");
createToken("NUMERICIDENTIFIERLOOSE", "\\d+");
// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.
createToken("NONNUMERICIDENTIFIER", `\\d*[a-zA-Z-]${LETTERDASHNUMBER}*`);
// ## Main Version
// Three dot-separated numeric identifiers.
createToken("MAINVERSION", `(${src[t.NUMERICIDENTIFIER]})\\.` + `(${src[t.NUMERICIDENTIFIER]})\\.` + `(${src[t.NUMERICIDENTIFIER]})`);
createToken("MAINVERSIONLOOSE", `(${src[t.NUMERICIDENTIFIERLOOSE]})\\.` + `(${src[t.NUMERICIDENTIFIERLOOSE]})\\.` + `(${src[t.NUMERICIDENTIFIERLOOSE]})`);
// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.
createToken("PRERELEASEIDENTIFIER", `(?:${src[t.NUMERICIDENTIFIER]}|${src[t.NONNUMERICIDENTIFIER]})`);
createToken("PRERELEASEIDENTIFIERLOOSE", `(?:${src[t.NUMERICIDENTIFIERLOOSE]}|${src[t.NONNUMERICIDENTIFIER]})`);
// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.
createToken("PRERELEASE", `(?:-(${src[t.PRERELEASEIDENTIFIER]}(?:\\.${src[t.PRERELEASEIDENTIFIER]})*))`);
createToken("PRERELEASELOOSE", `(?:-?(${src[t.PRERELEASEIDENTIFIERLOOSE]}(?:\\.${src[t.PRERELEASEIDENTIFIERLOOSE]})*))`);
// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.
createToken("BUILDIDENTIFIER", `${LETTERDASHNUMBER}+`);
// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.
createToken("BUILD", `(?:\\+(${src[t.BUILDIDENTIFIER]}(?:\\.${src[t.BUILDIDENTIFIER]})*))`);
// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.
// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.
createToken("FULLPLAIN", `v?${src[t.MAINVERSION]}${src[t.PRERELEASE]}?${src[t.BUILD]}?`);
createToken("FULL", `^${src[t.FULLPLAIN]}$`);
// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
createToken("LOOSEPLAIN", `[v=\\s]*${src[t.MAINVERSIONLOOSE]}${src[t.PRERELEASELOOSE]}?${src[t.BUILD]}?`);
createToken("LOOSE", `^${src[t.LOOSEPLAIN]}$`);
createToken("GTLT", "((?:<|>)?=?)");
// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
createToken("XRANGEIDENTIFIERLOOSE", `${src[t.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`);
createToken("XRANGEIDENTIFIER", `${src[t.NUMERICIDENTIFIER]}|x|X|\\*`);
createToken("XRANGEPLAIN", `[v=\\s]*(${src[t.XRANGEIDENTIFIER]})` + `(?:\\.(${src[t.XRANGEIDENTIFIER]})` + `(?:\\.(${src[t.XRANGEIDENTIFIER]})` + `(?:${src[t.PRERELEASE]})?${src[t.BUILD]}?` + `)?)?`);
createToken("XRANGEPLAINLOOSE", `[v=\\s]*(${src[t.XRANGEIDENTIFIERLOOSE]})` + `(?:\\.(${src[t.XRANGEIDENTIFIERLOOSE]})` + `(?:\\.(${src[t.XRANGEIDENTIFIERLOOSE]})` + `(?:${src[t.PRERELEASELOOSE]})?${src[t.BUILD]}?` + `)?)?`);
createToken("XRANGE", `^${src[t.GTLT]}\\s*${src[t.XRANGEPLAIN]}$`);
createToken("XRANGELOOSE", `^${src[t.GTLT]}\\s*${src[t.XRANGEPLAINLOOSE]}$`);
// Coercion.
// Extract anything that could conceivably be a part of a valid semver
createToken("COERCE", `${"(^|[^\\d])(\\d{1,"}${$f101009ed9c0563c$require$MAX_SAFE_COMPONENT_LENGTH}})` + `(?:\\.(\\d{1,${$f101009ed9c0563c$require$MAX_SAFE_COMPONENT_LENGTH}}))?` + `(?:\\.(\\d{1,${$f101009ed9c0563c$require$MAX_SAFE_COMPONENT_LENGTH}}))?` + `(?:$|[^\\d])`);
createToken("COERCERTL", src[t.COERCE], true);
// Tilde ranges.
// Meaning is "reasonably at or greater than"
createToken("LONETILDE", "(?:~>?)");
createToken("TILDETRIM", `(\\s*)${src[t.LONETILDE]}\\s+`, true);
exports.tildeTrimReplace = "$1~";
createToken("TILDE", `^${src[t.LONETILDE]}${src[t.XRANGEPLAIN]}$`);
createToken("TILDELOOSE", `^${src[t.LONETILDE]}${src[t.XRANGEPLAINLOOSE]}$`);
// Caret ranges.
// Meaning is "at least and backwards compatible with"
createToken("LONECARET", "(?:\\^)");
createToken("CARETTRIM", `(\\s*)${src[t.LONECARET]}\\s+`, true);
exports.caretTrimReplace = "$1^";
createToken("CARET", `^${src[t.LONECARET]}${src[t.XRANGEPLAIN]}$`);
createToken("CARETLOOSE", `^${src[t.LONECARET]}${src[t.XRANGEPLAINLOOSE]}$`);
// A simple gt/lt/eq thing, or just "" to indicate "any version"
createToken("COMPARATORLOOSE", `^${src[t.GTLT]}\\s*(${src[t.LOOSEPLAIN]})$|^$`);
createToken("COMPARATOR", `^${src[t.GTLT]}\\s*(${src[t.FULLPLAIN]})$|^$`);
// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
createToken("COMPARATORTRIM", `(\\s*)${src[t.GTLT]}\\s*(${src[t.LOOSEPLAIN]}|${src[t.XRANGEPLAIN]})`, true);
exports.comparatorTrimReplace = "$1$2$3";
// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
createToken("HYPHENRANGE", `^\\s*(${src[t.XRANGEPLAIN]})` + `\\s+-\\s+` + `(${src[t.XRANGEPLAIN]})` + `\\s*$`);
createToken("HYPHENRANGELOOSE", `^\\s*(${src[t.XRANGEPLAINLOOSE]})` + `\\s+-\\s+` + `(${src[t.XRANGEPLAINLOOSE]})` + `\\s*$`);
// Star ranges basically just allow anything at all.
createToken("STAR", "(<|>)?=?\\s*\\*");
// >=0.0.0 is like a star
createToken("GTE0", "^\\s*>=\\s*0\\.0\\.0\\s*$");
createToken("GTE0PRE", "^\\s*>=\\s*0\\.0\\.0-0\\s*$");

});
parcelRegister("fJ45P", function(module, exports) {
// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
const $b72e3bc5fa8d2c21$var$SEMVER_SPEC_VERSION = "2.0.0";
const $b72e3bc5fa8d2c21$var$MAX_LENGTH = 256;
const $b72e3bc5fa8d2c21$var$MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || /* istanbul ignore next */ 9007199254740991;
// Max safe segment length for coercion.
const $b72e3bc5fa8d2c21$var$MAX_SAFE_COMPONENT_LENGTH = 16;
// Max safe length for a build identifier. The max length minus 6 characters for
// the shortest version with a build 0.0.0+BUILD.
const $b72e3bc5fa8d2c21$var$MAX_SAFE_BUILD_LENGTH = $b72e3bc5fa8d2c21$var$MAX_LENGTH - 6;
const $b72e3bc5fa8d2c21$var$RELEASE_TYPES = [
    "major",
    "premajor",
    "minor",
    "preminor",
    "patch",
    "prepatch",
    "prerelease"
];
module.exports = {
    MAX_LENGTH: $b72e3bc5fa8d2c21$var$MAX_LENGTH,
    MAX_SAFE_COMPONENT_LENGTH: $b72e3bc5fa8d2c21$var$MAX_SAFE_COMPONENT_LENGTH,
    MAX_SAFE_BUILD_LENGTH: $b72e3bc5fa8d2c21$var$MAX_SAFE_BUILD_LENGTH,
    MAX_SAFE_INTEGER: $b72e3bc5fa8d2c21$var$MAX_SAFE_INTEGER,
    RELEASE_TYPES: $b72e3bc5fa8d2c21$var$RELEASE_TYPES,
    SEMVER_SPEC_VERSION: $b72e3bc5fa8d2c21$var$SEMVER_SPEC_VERSION,
    FLAG_INCLUDE_PRERELEASE: 1,
    FLAG_LOOSE: 2
};

});

parcelRegister("i9RZm", function(module, exports) {

var $kjyEk = parcelRequire("kjyEk");
const $d382f2433df5837c$var$debug = (typeof $kjyEk === "object" && $kjyEk.env && undefined, ()=>{});
module.exports = $d382f2433df5837c$var$debug;

});
parcelRegister("kjyEk", function(module, exports) {
"use strict";

});



parcelRegister("iIDdR", function(module, exports) {
(function(root) {
    "use strict";
    function isBase64(v, opts) {
        if (v instanceof Boolean || typeof v === "boolean") return false;
        if (!(opts instanceof Object)) opts = {};
        if (opts.hasOwnProperty("allowBlank") && !opts.allowBlank && v === "") return false;
        var regex = "(?:[A-Za-z0-9+\\/]{4})*(?:[A-Za-z0-9+\\/]{2}==|[A-Za-z0-9+/]{3}=)?";
        if (opts.mime) regex = "(data:\\w+\\/[a-zA-Z\\+\\-\\.]+;base64,)?" + regex;
        if (opts.paddingRequired === false) regex = "(?:[A-Za-z0-9+\\/]{4})*(?:[A-Za-z0-9+\\/]{2}(==)?|[A-Za-z0-9+\\/]{3}=?)?";
        return new RegExp("^" + regex + "$", "gi").test(v);
    }
    if (0, module.exports) exports = module.exports = isBase64;
    exports.isBase64 = isBase64;
})(this);

});

parcelRegister("1SXIy", function(module, exports) {
/* eslint-env browser */ /**
 * This is the web browser implementation of `debug()`.
 */ 
var $kjyEk = parcelRequire("kjyEk");
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = localstorage();
exports.destroy = (()=>{
    let warned = false;
    return ()=>{
        if (!warned) {
            warned = true;
            console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
        }
    };
})();
/**
 * Colors.
 */ exports.colors = [
    "#0000CC",
    "#0000FF",
    "#0033CC",
    "#0033FF",
    "#0066CC",
    "#0066FF",
    "#0099CC",
    "#0099FF",
    "#00CC00",
    "#00CC33",
    "#00CC66",
    "#00CC99",
    "#00CCCC",
    "#00CCFF",
    "#3300CC",
    "#3300FF",
    "#3333CC",
    "#3333FF",
    "#3366CC",
    "#3366FF",
    "#3399CC",
    "#3399FF",
    "#33CC00",
    "#33CC33",
    "#33CC66",
    "#33CC99",
    "#33CCCC",
    "#33CCFF",
    "#6600CC",
    "#6600FF",
    "#6633CC",
    "#6633FF",
    "#66CC00",
    "#66CC33",
    "#9900CC",
    "#9900FF",
    "#9933CC",
    "#9933FF",
    "#99CC00",
    "#99CC33",
    "#CC0000",
    "#CC0033",
    "#CC0066",
    "#CC0099",
    "#CC00CC",
    "#CC00FF",
    "#CC3300",
    "#CC3333",
    "#CC3366",
    "#CC3399",
    "#CC33CC",
    "#CC33FF",
    "#CC6600",
    "#CC6633",
    "#CC9900",
    "#CC9933",
    "#CCCC00",
    "#CCCC33",
    "#FF0000",
    "#FF0033",
    "#FF0066",
    "#FF0099",
    "#FF00CC",
    "#FF00FF",
    "#FF3300",
    "#FF3333",
    "#FF3366",
    "#FF3399",
    "#FF33CC",
    "#FF33FF",
    "#FF6600",
    "#FF6633",
    "#FF9900",
    "#FF9933",
    "#FFCC00",
    "#FFCC33"
];
/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */ // eslint-disable-next-line complexity
function useColors() {
    // NB: In an Electron preload script, document will be defined but not fully
    // initialized. Since we know we're in Chrome, we'll just detect this case
    // explicitly
    if (typeof window !== "undefined" && window.process && (window.process.type === "renderer" || window.process.__nwjs)) return true;
    // Internet Explorer and Edge do not support colors.
    if (typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) return false;
    // Is webkit? http://stackoverflow.com/a/16459606/376773
    // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
    return typeof document !== "undefined" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // Is firebug? http://stackoverflow.com/a/398120/376773
    typeof window !== "undefined" && window.console && (window.console.firebug || window.console.exception && window.console.table) || // Is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // Double check webkit in userAgent just in case we are in a worker
    typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
}
/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */ function formatArgs(args) {
    args[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + args[0] + (this.useColors ? "%c " : " ") + "+" + module.exports.humanize(this.diff);
    if (!this.useColors) return;
    const c = "color: " + this.color;
    args.splice(1, 0, c, "color: inherit");
    // The final "%c" is somewhat tricky, because there could be other
    // arguments passed either before or after the %c, so we need to
    // figure out the correct index to insert the CSS into
    let index = 0;
    let lastC = 0;
    args[0].replace(/%[a-zA-Z%]/g, (match)=>{
        if (match === "%%") return;
        index++;
        if (match === "%c") // We only are interested in the *last* %c
        // (the user may have provided their own)
        lastC = index;
    });
    args.splice(lastC, 0, c);
}
/**
 * Invokes `console.debug()` when available.
 * No-op when `console.debug` is not a "function".
 * If `console.debug` is not available, falls back
 * to `console.log`.
 *
 * @api public
 */ exports.log = console.debug || console.log || (()=>{});
/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */ function save(namespaces) {
    try {
        if (namespaces) exports.storage.setItem("debug", namespaces);
        else exports.storage.removeItem("debug");
    } catch (error) {
    // Swallow
    // XXX (@Qix-) should we be logging these?
    }
}
/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */ function load() {
    let r;
    try {
        r = exports.storage.getItem("debug");
    } catch (error) {
    // Swallow
    // XXX (@Qix-) should we be logging these?
    }
    // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
    if (!r && typeof $kjyEk !== "undefined" && "env" in $kjyEk) r = undefined;
    return r;
}
/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */ function localstorage() {
    try {
        // TVMLKit (Apple TV JS Runtime) does not have a window object, just localStorage in the global context
        // The Browser also has localStorage in the global context.
        return localStorage;
    } catch (error) {
    // Swallow
    // XXX (@Qix-) should we be logging these?
    }
}

module.exports = (parcelRequire("7kBR8"))(exports);
const { formatters } = module.exports;
/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */ formatters.j = function(v) {
    try {
        return JSON.stringify(v);
    } catch (error) {
        return "[UnexpectedJSONParseError]: " + error.message;
    }
};

});
parcelRegister("7kBR8", function(module, exports) {
/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 */ 
function $5567c417bf6247fd$var$setup(env) {
    createDebug.debug = createDebug;
    createDebug.default = createDebug;
    createDebug.coerce = coerce;
    createDebug.disable = disable;
    createDebug.enable = enable;
    createDebug.enabled = enabled;
    createDebug.humanize = (parcelRequire("3pRq5"));
    createDebug.destroy = destroy;
    Object.keys(env).forEach((key)=>{
        createDebug[key] = env[key];
    });
    /**
	* The currently active debug mode names, and names to skip.
	*/ createDebug.names = [];
    createDebug.skips = [];
    /**
	* Map of special "%n" handling functions, for the debug "format" argument.
	*
	* Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	*/ createDebug.formatters = {};
    /**
	* Selects a color for a debug namespace
	* @param {String} namespace The namespace string for the debug instance to be colored
	* @return {Number|String} An ANSI color code for the given namespace
	* @api private
	*/ function selectColor(namespace) {
        let hash = 0;
        for(let i = 0; i < namespace.length; i++){
            hash = (hash << 5) - hash + namespace.charCodeAt(i);
            hash |= 0; // Convert to 32bit integer
        }
        return createDebug.colors[Math.abs(hash) % createDebug.colors.length];
    }
    createDebug.selectColor = selectColor;
    /**
	* Create a debugger with the given `namespace`.
	*
	* @param {String} namespace
	* @return {Function}
	* @api public
	*/ function createDebug(namespace) {
        let prevTime;
        let enableOverride = null;
        let namespacesCache;
        let enabledCache;
        function debug(...args) {
            // Disabled?
            if (!debug.enabled) return;
            const self = debug;
            // Set `diff` timestamp
            const curr = Number(new Date());
            const ms = curr - (prevTime || curr);
            self.diff = ms;
            self.prev = prevTime;
            self.curr = curr;
            prevTime = curr;
            args[0] = createDebug.coerce(args[0]);
            if (typeof args[0] !== "string") // Anything else let's inspect with %O
            args.unshift("%O");
            // Apply any `formatters` transformations
            let index = 0;
            args[0] = args[0].replace(/%([a-zA-Z%])/g, (match, format)=>{
                // If we encounter an escaped % then don't increase the array index
                if (match === "%%") return "%";
                index++;
                const formatter = createDebug.formatters[format];
                if (typeof formatter === "function") {
                    const val = args[index];
                    match = formatter.call(self, val);
                    // Now we need to remove `args[index]` since it's inlined in the `format`
                    args.splice(index, 1);
                    index--;
                }
                return match;
            });
            // Apply env-specific formatting (colors, etc.)
            createDebug.formatArgs.call(self, args);
            const logFn = self.log || createDebug.log;
            logFn.apply(self, args);
        }
        debug.namespace = namespace;
        debug.useColors = createDebug.useColors();
        debug.color = createDebug.selectColor(namespace);
        debug.extend = extend;
        debug.destroy = createDebug.destroy; // XXX Temporary. Will be removed in the next major release.
        Object.defineProperty(debug, "enabled", {
            enumerable: true,
            configurable: false,
            get: ()=>{
                if (enableOverride !== null) return enableOverride;
                if (namespacesCache !== createDebug.namespaces) {
                    namespacesCache = createDebug.namespaces;
                    enabledCache = createDebug.enabled(namespace);
                }
                return enabledCache;
            },
            set: (v)=>{
                enableOverride = v;
            }
        });
        // Env-specific initialization logic for debug instances
        if (typeof createDebug.init === "function") createDebug.init(debug);
        return debug;
    }
    function extend(namespace, delimiter) {
        const newDebug = createDebug(this.namespace + (typeof delimiter === "undefined" ? ":" : delimiter) + namespace);
        newDebug.log = this.log;
        return newDebug;
    }
    /**
	* Enables a debug mode by namespaces. This can include modes
	* separated by a colon and wildcards.
	*
	* @param {String} namespaces
	* @api public
	*/ function enable(namespaces) {
        createDebug.save(namespaces);
        createDebug.namespaces = namespaces;
        createDebug.names = [];
        createDebug.skips = [];
        let i;
        const split = (typeof namespaces === "string" ? namespaces : "").split(/[\s,]+/);
        const len = split.length;
        for(i = 0; i < len; i++){
            if (!split[i]) continue;
            namespaces = split[i].replace(/\*/g, ".*?");
            if (namespaces[0] === "-") createDebug.skips.push(new RegExp("^" + namespaces.slice(1) + "$"));
            else createDebug.names.push(new RegExp("^" + namespaces + "$"));
        }
    }
    /**
	* Disable debug output.
	*
	* @return {String} namespaces
	* @api public
	*/ function disable() {
        const namespaces = [
            ...createDebug.names.map(toNamespace),
            ...createDebug.skips.map(toNamespace).map((namespace)=>"-" + namespace)
        ].join(",");
        createDebug.enable("");
        return namespaces;
    }
    /**
	* Returns true if the given mode name is enabled, false otherwise.
	*
	* @param {String} name
	* @return {Boolean}
	* @api public
	*/ function enabled(name) {
        if (name[name.length - 1] === "*") return true;
        let i;
        let len;
        for(i = 0, len = createDebug.skips.length; i < len; i++){
            if (createDebug.skips[i].test(name)) return false;
        }
        for(i = 0, len = createDebug.names.length; i < len; i++){
            if (createDebug.names[i].test(name)) return true;
        }
        return false;
    }
    /**
	* Convert regexp to namespace
	*
	* @param {RegExp} regxep
	* @return {String} namespace
	* @api private
	*/ function toNamespace(regexp) {
        return regexp.toString().substring(2, regexp.toString().length - 2).replace(/\.\*\?$/, "*");
    }
    /**
	* Coerce `val`.
	*
	* @param {Mixed} val
	* @return {Mixed}
	* @api private
	*/ function coerce(val) {
        if (val instanceof Error) return val.stack || val.message;
        return val;
    }
    /**
	* XXX DO NOT USE. This is a temporary stub function.
	* XXX It WILL be removed in the next major release.
	*/ function destroy() {
        console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
    }
    createDebug.enable(createDebug.load());
    return createDebug;
}
module.exports = $5567c417bf6247fd$var$setup;

});
parcelRegister("3pRq5", function(module, exports) {
/**
 * Helpers.
 */ var $27cd24efd2f930b8$var$s = 1000;
var $27cd24efd2f930b8$var$m = $27cd24efd2f930b8$var$s * 60;
var $27cd24efd2f930b8$var$h = $27cd24efd2f930b8$var$m * 60;
var $27cd24efd2f930b8$var$d = $27cd24efd2f930b8$var$h * 24;
var $27cd24efd2f930b8$var$w = $27cd24efd2f930b8$var$d * 7;
var $27cd24efd2f930b8$var$y = $27cd24efd2f930b8$var$d * 365.25;
/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */ module.exports = function(val, options) {
    options = options || {};
    var type = typeof val;
    if (type === "string" && val.length > 0) return $27cd24efd2f930b8$var$parse(val);
    else if (type === "number" && isFinite(val)) return options.long ? $27cd24efd2f930b8$var$fmtLong(val) : $27cd24efd2f930b8$var$fmtShort(val);
    throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(val));
};
/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */ function $27cd24efd2f930b8$var$parse(str) {
    str = String(str);
    if (str.length > 100) return;
    var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(str);
    if (!match) return;
    var n = parseFloat(match[1]);
    var type = (match[2] || "ms").toLowerCase();
    switch(type){
        case "years":
        case "year":
        case "yrs":
        case "yr":
        case "y":
            return n * $27cd24efd2f930b8$var$y;
        case "weeks":
        case "week":
        case "w":
            return n * $27cd24efd2f930b8$var$w;
        case "days":
        case "day":
        case "d":
            return n * $27cd24efd2f930b8$var$d;
        case "hours":
        case "hour":
        case "hrs":
        case "hr":
        case "h":
            return n * $27cd24efd2f930b8$var$h;
        case "minutes":
        case "minute":
        case "mins":
        case "min":
        case "m":
            return n * $27cd24efd2f930b8$var$m;
        case "seconds":
        case "second":
        case "secs":
        case "sec":
        case "s":
            return n * $27cd24efd2f930b8$var$s;
        case "milliseconds":
        case "millisecond":
        case "msecs":
        case "msec":
        case "ms":
            return n;
        default:
            return undefined;
    }
}
/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $27cd24efd2f930b8$var$fmtShort(ms) {
    var msAbs = Math.abs(ms);
    if (msAbs >= $27cd24efd2f930b8$var$d) return Math.round(ms / $27cd24efd2f930b8$var$d) + "d";
    if (msAbs >= $27cd24efd2f930b8$var$h) return Math.round(ms / $27cd24efd2f930b8$var$h) + "h";
    if (msAbs >= $27cd24efd2f930b8$var$m) return Math.round(ms / $27cd24efd2f930b8$var$m) + "m";
    if (msAbs >= $27cd24efd2f930b8$var$s) return Math.round(ms / $27cd24efd2f930b8$var$s) + "s";
    return ms + "ms";
}
/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $27cd24efd2f930b8$var$fmtLong(ms) {
    var msAbs = Math.abs(ms);
    if (msAbs >= $27cd24efd2f930b8$var$d) return $27cd24efd2f930b8$var$plural(ms, msAbs, $27cd24efd2f930b8$var$d, "day");
    if (msAbs >= $27cd24efd2f930b8$var$h) return $27cd24efd2f930b8$var$plural(ms, msAbs, $27cd24efd2f930b8$var$h, "hour");
    if (msAbs >= $27cd24efd2f930b8$var$m) return $27cd24efd2f930b8$var$plural(ms, msAbs, $27cd24efd2f930b8$var$m, "minute");
    if (msAbs >= $27cd24efd2f930b8$var$s) return $27cd24efd2f930b8$var$plural(ms, msAbs, $27cd24efd2f930b8$var$s, "second");
    return ms + " ms";
}
/**
 * Pluralization helper.
 */ function $27cd24efd2f930b8$var$plural(ms, msAbs, n, name) {
    var isPlural = msAbs >= n * 1.5;
    return Math.round(ms / n) + " " + name + (isPlural ? "s" : "");
}

});



parcelRegister("R5nvG", function(module, exports) {
var global = typeof self !== "undefined" ? self : this;
var __self__ = function() {
    function F() {
        this.fetch = false;
        this.DOMException = global.DOMException;
    }
    F.prototype = global;
    return new F();
}();
(function(self1) {
    var irrelevant = function(exports1) {
        var support = {
            searchParams: "URLSearchParams" in self1,
            iterable: "Symbol" in self1 && "iterator" in Symbol,
            blob: "FileReader" in self1 && "Blob" in self1 && function() {
                try {
                    new Blob();
                    return true;
                } catch (e) {
                    return false;
                }
            }(),
            formData: "FormData" in self1,
            arrayBuffer: "ArrayBuffer" in self1
        };
        function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        }
        if (support.arrayBuffer) {
            var viewClasses = [
                "[object Int8Array]",
                "[object Uint8Array]",
                "[object Uint8ClampedArray]",
                "[object Int16Array]",
                "[object Uint16Array]",
                "[object Int32Array]",
                "[object Uint32Array]",
                "[object Float32Array]",
                "[object Float64Array]"
            ];
            var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
        }
        function normalizeName(name) {
            if (typeof name !== "string") name = String(name);
            if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) throw new TypeError("Invalid character in header field name");
            return name.toLowerCase();
        }
        function normalizeValue(value) {
            if (typeof value !== "string") value = String(value);
            return value;
        }
        // Build a destructive iterator for the value list
        function iteratorFor(items) {
            var iterator = {
                next: function() {
                    var value = items.shift();
                    return {
                        done: value === undefined,
                        value: value
                    };
                }
            };
            if (support.iterable) iterator[Symbol.iterator] = function() {
                return iterator;
            };
            return iterator;
        }
        function Headers(headers) {
            this.map = {};
            if (headers instanceof Headers) headers.forEach(function(value, name) {
                this.append(name, value);
            }, this);
            else if (Array.isArray(headers)) headers.forEach(function(header) {
                this.append(header[0], header[1]);
            }, this);
            else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                this.append(name, headers[name]);
            }, this);
        }
        Headers.prototype.append = function(name, value) {
            name = normalizeName(name);
            value = normalizeValue(value);
            var oldValue = this.map[name];
            this.map[name] = oldValue ? oldValue + ", " + value : value;
        };
        Headers.prototype["delete"] = function(name) {
            delete this.map[normalizeName(name)];
        };
        Headers.prototype.get = function(name) {
            name = normalizeName(name);
            return this.has(name) ? this.map[name] : null;
        };
        Headers.prototype.has = function(name) {
            return this.map.hasOwnProperty(normalizeName(name));
        };
        Headers.prototype.set = function(name, value) {
            this.map[normalizeName(name)] = normalizeValue(value);
        };
        Headers.prototype.forEach = function(callback, thisArg) {
            for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
        };
        Headers.prototype.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return iteratorFor(items);
        };
        Headers.prototype.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return iteratorFor(items);
        };
        Headers.prototype.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return iteratorFor(items);
        };
        if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        function consumed(body) {
            if (body.bodyUsed) return Promise.reject(new TypeError("Already read"));
            body.bodyUsed = true;
        }
        function fileReaderReady(reader) {
            return new Promise(function(resolve, reject) {
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = function() {
                    reject(reader.error);
                };
            });
        }
        function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
        }
        function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsText(blob);
            return promise;
        }
        function readArrayBufferAsText(buf) {
            var view = new Uint8Array(buf);
            var chars = new Array(view.length);
            for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
            return chars.join("");
        }
        function bufferClone(buf) {
            if (buf.slice) return buf.slice(0);
            else {
                var view = new Uint8Array(buf.byteLength);
                view.set(new Uint8Array(buf));
                return view.buffer;
            }
        }
        function Body() {
            this.bodyUsed = false;
            this._initBody = function(body) {
                this._bodyInit = body;
                if (!body) this._bodyText = "";
                else if (typeof body === "string") this._bodyText = body;
                else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                else if (support.arrayBuffer && support.blob && isDataView(body)) {
                    this._bodyArrayBuffer = bufferClone(body.buffer);
                    // IE 10-11 can't handle a DataView body.
                    this._bodyInit = new Blob([
                        this._bodyArrayBuffer
                    ]);
                } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                else this._bodyText = body = Object.prototype.toString.call(body);
                if (!this.headers.get("content-type")) {
                    if (typeof body === "string") this.headers.set("content-type", "text/plain;charset=UTF-8");
                    else if (this._bodyBlob && this._bodyBlob.type) this.headers.set("content-type", this._bodyBlob.type);
                    else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8");
                }
            };
            if (support.blob) {
                this.blob = function() {
                    var rejected = consumed(this);
                    if (rejected) return rejected;
                    if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                    else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                        this._bodyArrayBuffer
                    ]));
                    else if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                    else return Promise.resolve(new Blob([
                        this._bodyText
                    ]));
                };
                this.arrayBuffer = function() {
                    if (this._bodyArrayBuffer) return consumed(this) || Promise.resolve(this._bodyArrayBuffer);
                    else return this.blob().then(readBlobAsArrayBuffer);
                };
            }
            this.text = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                else if (this._bodyFormData) throw new Error("could not read FormData body as text");
                else return Promise.resolve(this._bodyText);
            };
            if (support.formData) this.formData = function() {
                return this.text().then(decode);
            };
            this.json = function() {
                return this.text().then(JSON.parse);
            };
            return this;
        }
        // HTTP methods whose capitalization should be normalized
        var methods = [
            "DELETE",
            "GET",
            "HEAD",
            "OPTIONS",
            "POST",
            "PUT"
        ];
        function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
        }
        function Request(input, options) {
            options = options || {};
            var body = options.body;
            if (input instanceof Request) {
                if (input.bodyUsed) throw new TypeError("Already read");
                this.url = input.url;
                this.credentials = input.credentials;
                if (!options.headers) this.headers = new Headers(input.headers);
                this.method = input.method;
                this.mode = input.mode;
                this.signal = input.signal;
                if (!body && input._bodyInit != null) {
                    body = input._bodyInit;
                    input.bodyUsed = true;
                }
            } else this.url = String(input);
            this.credentials = options.credentials || this.credentials || "same-origin";
            if (options.headers || !this.headers) this.headers = new Headers(options.headers);
            this.method = normalizeMethod(options.method || this.method || "GET");
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal;
            this.referrer = null;
            if ((this.method === "GET" || this.method === "HEAD") && body) throw new TypeError("Body not allowed for GET or HEAD requests");
            this._initBody(body);
        }
        Request.prototype.clone = function() {
            return new Request(this, {
                body: this._bodyInit
            });
        };
        function decode(body) {
            var form = new FormData();
            body.trim().split("&").forEach(function(bytes) {
                if (bytes) {
                    var split = bytes.split("=");
                    var name = split.shift().replace(/\+/g, " ");
                    var value = split.join("=").replace(/\+/g, " ");
                    form.append(decodeURIComponent(name), decodeURIComponent(value));
                }
            });
            return form;
        }
        function parseHeaders(rawHeaders) {
            var headers = new Headers();
            // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
            // https://tools.ietf.org/html/rfc7230#section-3.2
            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, " ");
            preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
                var parts = line.split(":");
                var key = parts.shift().trim();
                if (key) {
                    var value = parts.join(":").trim();
                    headers.append(key, value);
                }
            });
            return headers;
        }
        Body.call(Request.prototype);
        function Response(bodyInit, options) {
            if (!options) options = {};
            this.type = "default";
            this.status = options.status === undefined ? 200 : options.status;
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = "statusText" in options ? options.statusText : "OK";
            this.headers = new Headers(options.headers);
            this.url = options.url || "";
            this._initBody(bodyInit);
        }
        Body.call(Response.prototype);
        Response.prototype.clone = function() {
            return new Response(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new Headers(this.headers),
                url: this.url
            });
        };
        Response.error = function() {
            var response = new Response(null, {
                status: 0,
                statusText: ""
            });
            response.type = "error";
            return response;
        };
        var redirectStatuses = [
            301,
            302,
            303,
            307,
            308
        ];
        Response.redirect = function(url, status) {
            if (redirectStatuses.indexOf(status) === -1) throw new RangeError("Invalid status code");
            return new Response(null, {
                status: status,
                headers: {
                    location: url
                }
            });
        };
        exports1.DOMException = self1.DOMException;
        try {
            new exports1.DOMException();
        } catch (err) {
            exports1.DOMException = function(message, name) {
                this.message = message;
                this.name = name;
                var error = Error(message);
                this.stack = error.stack;
            };
            exports1.DOMException.prototype = Object.create(Error.prototype);
            exports1.DOMException.prototype.constructor = exports1.DOMException;
        }
        function fetch(input, init) {
            return new Promise(function(resolve, reject) {
                var request = new Request(input, init);
                if (request.signal && request.signal.aborted) return reject(new exports1.DOMException("Aborted", "AbortError"));
                var xhr = new XMLHttpRequest();
                function abortXhr() {
                    xhr.abort();
                }
                xhr.onload = function() {
                    var options = {
                        status: xhr.status,
                        statusText: xhr.statusText,
                        headers: parseHeaders(xhr.getAllResponseHeaders() || "")
                    };
                    options.url = "responseURL" in xhr ? xhr.responseURL : options.headers.get("X-Request-URL");
                    var body = "response" in xhr ? xhr.response : xhr.responseText;
                    resolve(new Response(body, options));
                };
                xhr.onerror = function() {
                    reject(new TypeError("Network request failed"));
                };
                xhr.ontimeout = function() {
                    reject(new TypeError("Network request failed"));
                };
                xhr.onabort = function() {
                    reject(new exports1.DOMException("Aborted", "AbortError"));
                };
                xhr.open(request.method, request.url, true);
                if (request.credentials === "include") xhr.withCredentials = true;
                else if (request.credentials === "omit") xhr.withCredentials = false;
                if ("responseType" in xhr && support.blob) xhr.responseType = "blob";
                request.headers.forEach(function(value, name) {
                    xhr.setRequestHeader(name, value);
                });
                if (request.signal) {
                    request.signal.addEventListener("abort", abortXhr);
                    xhr.onreadystatechange = function() {
                        // DONE (success or failure)
                        if (xhr.readyState === 4) request.signal.removeEventListener("abort", abortXhr);
                    };
                }
                xhr.send(typeof request._bodyInit === "undefined" ? null : request._bodyInit);
            });
        }
        fetch.polyfill = true;
        if (!self1.fetch) {
            self1.fetch = fetch;
            self1.Headers = Headers;
            self1.Request = Request;
            self1.Response = Response;
        }
        exports1.Headers = Headers;
        exports1.Request = Request;
        exports1.Response = Response;
        exports1.fetch = fetch;
        Object.defineProperty(exports1, "__esModule", {
            value: true
        });
        return exports1;
    }({});
})(__self__);
__self__.fetch.ponyfill = true;
// Remove "polyfill" property added by whatwg-fetch
delete __self__.fetch.polyfill;
// Choose between native implementation (global) or custom implementation (__self__)
// var ctx = global.fetch ? global : __self__;
var ctx = __self__; // this line disable service worker support temporarily
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
;
exports.default = ctx.fetch // For TypeScript consumers without esModuleInterop.
;
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
;
exports.Headers = ctx.Headers;
exports.Request = ctx.Request;
exports.Response = ctx.Response;
module.exports = exports;

});

parcelRegister("lzME1", function(module, exports) {
(function(factory) {
    typeof define === "function" && define.amd ? define(factory) : factory();
})(function() {
    "use strict";
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function _defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
    }
    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                writable: true,
                configurable: true
            }
        });
        if (superClass) _setPrototypeOf(subClass, superClass);
    }
    function _getPrototypeOf(o) {
        _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
            return o.__proto__ || Object.getPrototypeOf(o);
        };
        return _getPrototypeOf(o);
    }
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _isNativeReflectConstruct() {
        if (typeof Reflect === "undefined" || !Reflect.construct) return false;
        if (Reflect.construct.sham) return false;
        if (typeof Proxy === "function") return true;
        try {
            Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
            return true;
        } catch (e) {
            return false;
        }
    }
    function _assertThisInitialized(self1) {
        if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return self1;
    }
    function _possibleConstructorReturn(self1, call) {
        if (call && (typeof call === "object" || typeof call === "function")) return call;
        return _assertThisInitialized(self1);
    }
    function _createSuper(Derived) {
        var hasNativeReflectConstruct = _isNativeReflectConstruct();
        return function _createSuperInternal() {
            var Super = _getPrototypeOf(Derived), result;
            if (hasNativeReflectConstruct) {
                var NewTarget = _getPrototypeOf(this).constructor;
                result = Reflect.construct(Super, arguments, NewTarget);
            } else result = Super.apply(this, arguments);
            return _possibleConstructorReturn(this, result);
        };
    }
    function _superPropBase(object, property) {
        while(!Object.prototype.hasOwnProperty.call(object, property)){
            object = _getPrototypeOf(object);
            if (object === null) break;
        }
        return object;
    }
    function _get(target, property, receiver) {
        if (typeof Reflect !== "undefined" && Reflect.get) _get = Reflect.get;
        else _get = function _get(target, property, receiver) {
            var base = _superPropBase(target, property);
            if (!base) return;
            var desc = Object.getOwnPropertyDescriptor(base, property);
            if (desc.get) return desc.get.call(receiver);
            return desc.value;
        };
        return _get(target, property, receiver || target);
    }
    var Emitter = /*#__PURE__*/ function() {
        function Emitter() {
            _classCallCheck(this, Emitter);
            Object.defineProperty(this, "listeners", {
                value: {},
                writable: true,
                configurable: true
            });
        }
        _createClass(Emitter, [
            {
                key: "addEventListener",
                value: function addEventListener(type, callback, options) {
                    if (!(type in this.listeners)) this.listeners[type] = [];
                    this.listeners[type].push({
                        callback: callback,
                        options: options
                    });
                }
            },
            {
                key: "removeEventListener",
                value: function removeEventListener(type, callback) {
                    if (!(type in this.listeners)) return;
                    var stack = this.listeners[type];
                    for(var i = 0, l = stack.length; i < l; i++)if (stack[i].callback === callback) {
                        stack.splice(i, 1);
                        return;
                    }
                }
            },
            {
                key: "dispatchEvent",
                value: function dispatchEvent(event) {
                    if (!(event.type in this.listeners)) return;
                    var stack = this.listeners[event.type];
                    var stackToCall = stack.slice();
                    for(var i = 0, l = stackToCall.length; i < l; i++){
                        var listener = stackToCall[i];
                        try {
                            listener.callback.call(this, event);
                        } catch (e) {
                            Promise.resolve().then(function() {
                                throw e;
                            });
                        }
                        if (listener.options && listener.options.once) this.removeEventListener(event.type, listener.callback);
                    }
                    return !event.defaultPrevented;
                }
            }
        ]);
        return Emitter;
    }();
    var AbortSignal = /*#__PURE__*/ function(_Emitter) {
        _inherits(AbortSignal, _Emitter);
        var _super = _createSuper(AbortSignal);
        function AbortSignal() {
            var _this;
            _classCallCheck(this, AbortSignal);
            _this = _super.call(this); // Some versions of babel does not transpile super() correctly for IE <= 10, if the parent
            // constructor has failed to run, then "this.listeners" will still be undefined and then we call
            // the parent constructor directly instead as a workaround. For general details, see babel bug:
            // https://github.com/babel/babel/issues/3041
            // This hack was added as a fix for the issue described here:
            // https://github.com/Financial-Times/polyfill-library/pull/59#issuecomment-477558042
            if (!_this.listeners) Emitter.call(_assertThisInitialized(_this));
             // Compared to assignment, Object.defineProperty makes properties non-enumerable by default and
            // we want Object.keys(new AbortController().signal) to be [] for compat with the native impl
            Object.defineProperty(_assertThisInitialized(_this), "aborted", {
                value: false,
                writable: true,
                configurable: true
            });
            Object.defineProperty(_assertThisInitialized(_this), "onabort", {
                value: null,
                writable: true,
                configurable: true
            });
            return _this;
        }
        _createClass(AbortSignal, [
            {
                key: "toString",
                value: function toString() {
                    return "[object AbortSignal]";
                }
            },
            {
                key: "dispatchEvent",
                value: function dispatchEvent(event) {
                    if (event.type === "abort") {
                        this.aborted = true;
                        if (typeof this.onabort === "function") this.onabort.call(this, event);
                    }
                    _get(_getPrototypeOf(AbortSignal.prototype), "dispatchEvent", this).call(this, event);
                }
            }
        ]);
        return AbortSignal;
    }(Emitter);
    var AbortController = /*#__PURE__*/ function() {
        function AbortController() {
            _classCallCheck(this, AbortController);
            // Compared to assignment, Object.defineProperty makes properties non-enumerable by default and
            // we want Object.keys(new AbortController()) to be [] for compat with the native impl
            Object.defineProperty(this, "signal", {
                value: new AbortSignal(),
                writable: true,
                configurable: true
            });
        }
        _createClass(AbortController, [
            {
                key: "abort",
                value: function abort() {
                    var event;
                    try {
                        event = new Event("abort");
                    } catch (e) {
                        if (typeof document !== "undefined") {
                            if (!document.createEvent) {
                                // For Internet Explorer 8:
                                event = document.createEventObject();
                                event.type = "abort";
                            } else {
                                // For Internet Explorer 11:
                                event = document.createEvent("Event");
                                event.initEvent("abort", false, false);
                            }
                        } else // Fallback where document isn't available:
                        event = {
                            type: "abort",
                            bubbles: false,
                            cancelable: false
                        };
                    }
                    this.signal.dispatchEvent(event);
                }
            },
            {
                key: "toString",
                value: function toString() {
                    return "[object AbortController]";
                }
            }
        ]);
        return AbortController;
    }();
    if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
        // These are necessary to make sure that we get correct output for:
        // Object.prototype.toString.call(new AbortController())
        AbortController.prototype[Symbol.toStringTag] = "AbortController";
        AbortSignal.prototype[Symbol.toStringTag] = "AbortSignal";
    }
    function polyfillNeeded(self1) {
        if (self1.__FORCE_INSTALL_ABORTCONTROLLER_POLYFILL) {
            console.log("__FORCE_INSTALL_ABORTCONTROLLER_POLYFILL=true is set, will force install polyfill");
            return true;
        } // Note that the "unfetch" minimal fetch polyfill defines fetch() without
        // defining window.Request, and this polyfill need to work on top of unfetch
        // so the below feature detection needs the !self.AbortController part.
        // The Request.prototype check is also needed because Safari versions 11.1.2
        // up to and including 12.1.x has a window.AbortController present but still
        // does NOT correctly implement abortable fetch:
        // https://bugs.webkit.org/show_bug.cgi?id=174980#c2
        return typeof self1.Request === "function" && !self1.Request.prototype.hasOwnProperty("signal") || !self1.AbortController;
    }
    (function(self1) {
        if (!polyfillNeeded(self1)) return;
        self1.AbortController = AbortController;
        self1.AbortSignal = AbortSignal;
    })(typeof self !== "undefined" ? self : $parcel$global);
});

});

parcelRegister("lAjGr", function(module, exports) {
"use strict";

/**
 *  The update function for updating forms or resources to the version in this filename.
 * @return the updated form or resource.
 */ module.exports = function(parsedJSON) {
    // In this version, the calculatedExpresion URI changed.  This
    // affects both LForms definitions and Questionnaires.
    let util = (parcelRequire("bVDgi"));
    if (!util.isFHIRResource(parsedJSON) || parsedJSON.resourceType === "Questionnaire") util.findExtensions(parsedJSON, function(extArray) {
        for (let ext of extArray)if (ext.url === "http://hl7.org/fhir/StructureDefinition/questionnaire-launchContext") ext.url = "http://hl7.org/fhir/uv/sdc/StructureDefinition/sdc-questionnaire-launchContext";
    });
    return parsedJSON;
};

});
parcelRegister("bVDgi", function(module, exports) {
// Utility functions used by other modules in this package.
"use strict";
const $8af37926e509ced1$var$VERSION_REGEX = /^lformsVersion: (.+)$/;
module.exports = {
    /**
   *  Returns true if the given parsed JSON is a FHIR resource.
   */ isFHIRResource: function(parsedJSON) {
        return !!parsedJSON.resourceType;
    },
    /**
   *  Finds extension arrays in the given structure, and calls the callback
   *  for each array found, passing it as a parameter.
   */ findExtensions: function(parsedJSON, callback) {
        if (parsedJSON.extension) callback(parsedJSON.extension);
        let items = parsedJSON.item || parsedJSON.items; // "items" is the LForms format
        if (items) for (let i of items)this.findExtensions(i, callback);
    },
    /**
   *  Finds the item by searching extension arrays in the given structure, and calls the callback
   *  for each array found, passing the item as a parameter.
   */ findItemByExtension: function(parsedJSON, callback) {
        if (parsedJSON.extension) callback(parsedJSON);
        let items = parsedJSON.item || parsedJSON.items; // "items" is the LForms format
        if (items) for (let i of items)this.findItemByExtension(i, callback);
    },
    /**
   *  Returns true if the first version is less than the second version.
   *  Assumption: There are always three numeric parts in the version strings,
   *  separated by periods.
   * @param left the first version (left of the < operator).  This can be
   *  undefined or null; in that case the return value is true.
   * @param right the second version (right of the < operator)
   */ versionLessThan: function(left, right) {
        let rtn;
        if (!left) rtn = true; // unversioned case
        else {
            let leftParts = left.split(".");
            let rightParts = right.split(".");
            for(let i = 0; i < 3 && rtn === undefined; ++i){
                let lp = parseInt(leftParts[i]), rp = parseInt(rightParts[i]);
                if (lp != rp) rtn = lp < rp;
            }
            if (rtn === undefined) rtn = false;
        }
        return rtn;
    },
    /**
   *  Returns a FHIR tag display string for a given LForms version string.
   * @param lformsVersion The LForms SemVer string for which a tag is needed.
   */ makeVersionTag: function(lformsVersion) {
        return "lformsVersion: " + lformsVersion;
    },
    /**
   *  Returns the LForms SemVer version from the given FHIR tag object,
   *  or null if the given tag string does not indicate an LForms version.
   * @param tag A FHIR tag object
   */ versionFromTag: function(tag) {
        let rtn = null;
        // Currently the version is on the "code" attribute, but originally it was
        // on the "display" attribute, so we check both.
        let versionStr = tag.code || tag.display;
        let md = versionStr.match($8af37926e509ced1$var$VERSION_REGEX);
        if (md) rtn = md[1];
        return rtn;
    },
    /**
   *  Returns true if there is a LForms tag in the FHIR resource
   * @param parsedJSON the updated resource
   */ hasLformsTag (parsedJSON) {
        if (parsedJSON.meta && parsedJSON.meta.tag) for (const tag of parsedJSON.meta.tag){
            if (tag.code && tag.code.match($8af37926e509ced1$var$VERSION_REGEX)) return true;
        }
        return false;
    }
};

});


parcelRegister("1m1ub", function(module, exports) {
"use strict";

/**
 *  The update function for updating forms or resources to the version in this filename.
 * @return the updated form or resource.
 */ module.exports = function(parsedJSON) {
    // If an observationLinkPeriod extension is used we add observationExtract
    // This affects LForms and versioned Questionnaires
    let util = (parcelRequire("bVDgi"));
    if (!util.isFHIRResource(parsedJSON) || parsedJSON.resourceType === "Questionnaire" && util.hasLformsTag(parsedJSON)) util.findExtensions(parsedJSON, function(extArray) {
        for (const ext of extArray)// If the observationLinkPeriod is used then add the observationExtract extension too
        if (ext.url === "http://hl7.org/fhir/uv/sdc/StructureDefinition/sdc-questionnaire-observationLinkPeriod") {
            extArray.push({
                url: "http://hl7.org/fhir/uv/sdc/StructureDefinition/sdc-questionnaire-observationExtract",
                valueBoolean: true
            });
            break;
        }
    });
    return parsedJSON;
};

});

parcelRegister("bPSgt", function(module, exports) {
"use strict";

/**
 *  The update function for updating forms or resources to the version in this filename.
 * @return the updated form or resource.
 */ module.exports = function(parsedJSON) {
    // In this version new defaults were provided for templateOptions to hide the header
    // and the form controls. This only affects LForms.
    let util = (parcelRequire("bVDgi"));
    if (!util.isFHIRResource(parsedJSON)) {
        if (typeof parsedJSON.templateOptions === "object") {
            // If template options were specified we won't override them
            if (parsedJSON.templateOptions.hideFormControls === undefined) parsedJSON.templateOptions.hideFormControls = false;
            if (parsedJSON.templateOptions.showFormHeader === undefined) parsedJSON.templateOptions.showFormHeader = true;
        } else // If template options were not specified then add the previous defaults
        parsedJSON.templateOptions = {
            hideFormControls: false,
            showFormHeader: true
        };
    }
    return parsedJSON;
};

});

parcelRegister("7U9wy", function(module, exports) {
"use strict";

/**
 *  The update function for updating forms or resources to the version in this filename.
 * @return the updated form or resource.
 */ module.exports = function(parsedJSON) {
    // In this version, the calculatedExpresion URI changed.  This
    // affects both LForms definitions and Questionnaires.
    let util = (parcelRequire("bVDgi"));
    if (!util.isFHIRResource(parsedJSON) || parsedJSON.resourceType === "Questionnaire") util.findExtensions(parsedJSON, function(extArray) {
        for (let ext of extArray)if (ext.url === "http://hl7.org/fhir/StructureDefinition/questionnaire-calculatedExpression") ext.url = "http://hl7.org/fhir/uv/sdc/StructureDefinition/sdc-questionnaire-calculatedExpression";
    });
    return parsedJSON;
};

});

parcelRegister("63bjx", function(module, exports) {
"use strict";
const $467bcca416378ced$var$PATH_DELIMITER = "/";
/**
 * Generate linkId from questionCode and replace questionCode in form controls
 * with linkId.
 * @param lfData a LForms form definition data object
 */ function $467bcca416378ced$var$convertCodeToLinkId(lfData) {
    $467bcca416378ced$var$_addLinkId(lfData.items, "", lfData);
    $467bcca416378ced$var$_convertFormControls(lfData.items);
    $467bcca416378ced$var$_removeTempFields(lfData.items);
}
/**
 * Remove the temporary fields created during the conversion
 * @param items a list of LForms items
 * @private
 */ function $467bcca416378ced$var$_removeTempFields(items) {
    // for each item on this level
    for(var i = 0, iLen = items.length; i < iLen; i++){
        var item = items[i];
        delete item._parentItem;
        delete item._codePath;
        // process the sub items
        if (item.items && item.items.length > 0) $467bcca416378ced$var$_removeTempFields(item.items);
    }
}
/**
 * Generate linkId from questionCode
 * @param items a list of LForms items
 * @param parentItemCodePath the codePath of the parent item
 * @param parentItem the parent item
 * @private
 */ function $467bcca416378ced$var$_addLinkId(items, parentItemCodePath, parentItem) {
    var iLen = items.length, prevSibling = null, itemId = 1;
    // for each item on this level
    for(var i = 0; i < iLen; i++){
        var item = items[i];
        var questionRepeatable = item.questionCardinality && item.questionCardinality.max && (item.questionCardinality.max === "*" || parseInt(item.questionCardinality.max) > 1);
        // id
        if (questionRepeatable && prevSibling && prevSibling.questionCode === item.questionCode) itemId += 1;
        else itemId = 1;
        // codePath as linkId
        var codePath = parentItemCodePath + $467bcca416378ced$var$PATH_DELIMITER + item.questionCode;
        item._parentItem = parentItem;
        item._codePath = codePath;
        // linkId for Questionnaire
        if (!item.linkId) item.linkId = codePath;
        // keep a reference to the previous item for checking repeating items.
        prevSibling = item;
        // process the sub items
        if (item.items && item.items.length > 0) $467bcca416378ced$var$_addLinkId(item.items, codePath, item);
    }
}
/**
 * Convert questionCode in all form controls (skip logic, data control, calculation method)
 * to linkId
 * @param items a list of LForms items
 * @private
 */ function $467bcca416378ced$var$_convertFormControls(items) {
    for(var i = 0, iLen = items.length; i < iLen; i++){
        var item = items[i];
        // convert code in skip logic to be linkId
        if (item.skipLogic && item.skipLogic.conditions) for(var j = 0, jLen = item.skipLogic.conditions.length; j < jLen; j++){
            var condition = item.skipLogic.conditions[j];
            var sourceItem = $467bcca416378ced$var$_findItemsUpwardsAlongAncestorTree(item, condition.source); // source is still a code
            condition.source = sourceItem.linkId;
        } // end of conditions loop
        // convert code in dataControl to be linkId
        if (item.dataControl) for(var j = 0, jLen = item.dataControl.length; j < jLen; j++){
            var source = item.dataControl[j].source;
            // has a source configuration
            if (source && (!source.sourceType || source.sourceType === "INTERNAL") && source.sourceItemCode) {
                // get the source item object
                var sourceItem = $467bcca416378ced$var$_findItemsUpwardsAlongAncestorTree(item, source.sourceItemCode);
                if (!sourceItem) // This is an error in the form definition.  Provide a useful
                // debugging message.
                throw new Error("Data control for item '" + item.question + "' refers to source item '" + source.sourceItemCode + "' which was not found as a sibling, ancestor, or ancestor sibling.");
                source.sourceLinkId = sourceItem.linkId;
                delete source.sourceItemCode;
            }
        }
        // convert code in calculationMethod to be linkId
        if (item.calculationMethod && item.calculationMethod.value && Array.isArray(item.calculationMethod.value)) {
            var newValue = [];
            for(var j = 0, jLen = item.calculationMethod.value.length; j < jLen; j++){
                var questionCode = item.calculationMethod.value[j];
                var sourceItem = $467bcca416378ced$var$_findItemsUpwardsAlongAncestorTree(item, questionCode);
                newValue.push(sourceItem.linkId);
            }
            item.calculationMethod.value = newValue;
        }
        if (item.items && item.items.length > 0) $467bcca416378ced$var$_convertFormControls(item.items);
    }
}
/**
 * Search upwards along the tree structure to find the item with a matching questionCode
 * @param item the item to start with
 * @param questionCode the code of an item
 * @returns {}
 * @private
 */ function $467bcca416378ced$var$_findItemsUpwardsAlongAncestorTree(item, questionCode) {
    var sourceItem = null;
    // check siblings
    if (item._parentItem && Array.isArray(item._parentItem.items)) {
        for(var i = 0, iLen = item._parentItem.items.length; i < iLen; i++)if (item._parentItem.items[i].questionCode === questionCode) {
            sourceItem = item._parentItem.items[i];
            break;
        }
    }
    // check ancestors and each ancestors siblings
    if (!sourceItem) {
        var parentItem = item._parentItem;
        while(parentItem){
            var foundSource = false;
            // check the ancestor
            if (parentItem.questionCode === questionCode) {
                sourceItem = parentItem;
                foundSource = true;
            } else if (parentItem._parentItem && Array.isArray(parentItem._parentItem.items)) {
                var parentSiblings = parentItem._parentItem.items;
                for(var i = 0, iLen = parentSiblings.length; i < iLen; i++)if (parentSiblings[i].questionCode === questionCode) {
                    sourceItem = parentSiblings[i];
                    foundSource = true;
                    break;
                }
            }
            if (foundSource) break;
            parentItem = parentItem._parentItem;
        }
    }
    return sourceItem;
}

/**
 *  The update function for updating forms or resources to the version in this filename.
 * @param parsedJSON either an LForms definition or a resource generated by
 *  LForms.
 * @return the updated form or resource.
 */ module.exports = function(parsedJSON) {
    let util = (parcelRequire("bVDgi"));
    // if it is LForms form data object
    if (!util.isFHIRResource(parsedJSON) && parsedJSON.items) $467bcca416378ced$var$convertCodeToLinkId(parsedJSON);
    return parsedJSON;
};

});

parcelRegister("jfylo", function(module, exports) {
"use strict";

/**
 *  The update function for updating forms or resources to the version in this filename.
 * @param parsedJSON either an LForms definition or a resource generated by
 *  LForms.
 * @return the updated form or resource.
 */ module.exports = function(parsedJSON) {
    // In this version, the lformsVersion tag changed to have its value on the
    // "code" field rather than the "display" field (because the HAPI FHIR server
    // requires a "code" for tags).
    let util = (parcelRequire("bVDgi"));
    let meta = parsedJSON.meta;
    if (meta) {
        let tags = meta.tag;
        if (tags) for (let t of tags){
            let version = util.versionFromTag(t);
            if (version) {
                // Move the version string from "display" to "code".  The index.js
                // code will handle updating the version number.
                if (t.display && !t.code) {
                    t.code = t.display;
                    delete t.display;
                }
                break;
            }
        }
    }
    // In this version the extension in Questionnaire for answer repeats is removed, and replaced with repeats = true.
    if (parsedJSON.resourceType === "Questionnaire") util.findItemByExtension(parsedJSON, function(item) {
        if (item.extension) for(let i = 0; i < item.extension.length; i++){
            let ext = item.extension[i];
            if (ext.url === "http://hl7.org/fhir/StructureDefinition/questionnaire-answerRepeats") {
                item.repeats = true;
                item.extension.splice(i, 1);
                i = i - 1;
            }
        }
    });
    return parsedJSON;
};

});

parcelRegister("8tvbb", function(module, exports) {
"use strict";

/**
 *  The update function for updating forms or resources to the version in this filename.
 * @return the updated form or resource.
 */ module.exports = function(parsedJSON) {
    // In this version, the observationLinkPeriod extension changed.  This
    // affects both LForms definitions and Questionnaires.
    let util = (parcelRequire("bVDgi"));
    if (!util.isFHIRResource(parsedJSON) || parsedJSON.resourceType === "Questionnaire") util.findExtensions(parsedJSON, function(extArray) {
        for (let ext of extArray)if (ext.url === "http://hl7.org/fhir/StructureDefinition/questionnaire-observationLinkPeriod") ext.url = "http://hl7.org/fhir/uv/sdc/StructureDefinition/sdc-questionnaire-observationLinkPeriod";
    });
    return parsedJSON;
};

});

// This file is the main script for the application.  When this was written,
// there were originally two pages, index.html and viewer.html which both used app.js, and
// this file contained the code only used by viewer.html.  The code here is
// mostly for the lforms version menu, and it includes app.js.
// This file defines the function for loading a particular version of lforms,
// and also exports useful functions for getting the list of supported versions
// and switching to a new version.
var $3c149acde0254244$exports = {};
var $20d4c8016361ffad$exports = {};
var $df90e8d1cf1cf055$exports = {};

var $i9RZm = parcelRequire("i9RZm");

var $fJ45P = parcelRequire("fJ45P");
var $df90e8d1cf1cf055$require$MAX_LENGTH = $fJ45P.MAX_LENGTH;
var $df90e8d1cf1cf055$require$MAX_SAFE_INTEGER = $fJ45P.MAX_SAFE_INTEGER;

var $kGRcS = parcelRequire("kGRcS");
var $df90e8d1cf1cf055$require$re = $kGRcS.safeRe;
var $df90e8d1cf1cf055$require$t = $kGRcS.t;
var $100fa442ed30ac34$exports = {};
// parse out just the options we care about
const $100fa442ed30ac34$var$looseOption = Object.freeze({
    loose: true
});
const $100fa442ed30ac34$var$emptyOpts = Object.freeze({});
const $100fa442ed30ac34$var$parseOptions = (options)=>{
    if (!options) return $100fa442ed30ac34$var$emptyOpts;
    if (typeof options !== "object") return $100fa442ed30ac34$var$looseOption;
    return options;
};
$100fa442ed30ac34$exports = $100fa442ed30ac34$var$parseOptions;


var $ed5e7d6476f836e9$exports = {};
const $ed5e7d6476f836e9$var$numeric = /^[0-9]+$/;
const $ed5e7d6476f836e9$var$compareIdentifiers = (a, b)=>{
    const anum = $ed5e7d6476f836e9$var$numeric.test(a);
    const bnum = $ed5e7d6476f836e9$var$numeric.test(b);
    if (anum && bnum) {
        a = +a;
        b = +b;
    }
    return a === b ? 0 : anum && !bnum ? -1 : bnum && !anum ? 1 : a < b ? -1 : 1;
};
const $ed5e7d6476f836e9$var$rcompareIdentifiers = (a, b)=>$ed5e7d6476f836e9$var$compareIdentifiers(b, a);
$ed5e7d6476f836e9$exports = {
    compareIdentifiers: $ed5e7d6476f836e9$var$compareIdentifiers,
    rcompareIdentifiers: $ed5e7d6476f836e9$var$rcompareIdentifiers
};


var $df90e8d1cf1cf055$require$compareIdentifiers = $ed5e7d6476f836e9$exports.compareIdentifiers;
class $df90e8d1cf1cf055$var$SemVer {
    constructor(version, options){
        options = $100fa442ed30ac34$exports(options);
        if (version instanceof $df90e8d1cf1cf055$var$SemVer) {
            if (version.loose === !!options.loose && version.includePrerelease === !!options.includePrerelease) return version;
            else version = version.version;
        } else if (typeof version !== "string") throw new TypeError(`Invalid version. Must be a string. Got type "${typeof version}".`);
        if (version.length > $df90e8d1cf1cf055$require$MAX_LENGTH) throw new TypeError(`version is longer than ${$df90e8d1cf1cf055$require$MAX_LENGTH} characters`);
        $i9RZm("SemVer", version, options);
        this.options = options;
        this.loose = !!options.loose;
        // this isn't actually relevant for versions, but keep it so that we
        // don't run into trouble passing this.options around.
        this.includePrerelease = !!options.includePrerelease;
        const m = version.trim().match(options.loose ? $df90e8d1cf1cf055$require$re[$df90e8d1cf1cf055$require$t.LOOSE] : $df90e8d1cf1cf055$require$re[$df90e8d1cf1cf055$require$t.FULL]);
        if (!m) throw new TypeError(`Invalid Version: ${version}`);
        this.raw = version;
        // these are actually numbers
        this.major = +m[1];
        this.minor = +m[2];
        this.patch = +m[3];
        if (this.major > $df90e8d1cf1cf055$require$MAX_SAFE_INTEGER || this.major < 0) throw new TypeError("Invalid major version");
        if (this.minor > $df90e8d1cf1cf055$require$MAX_SAFE_INTEGER || this.minor < 0) throw new TypeError("Invalid minor version");
        if (this.patch > $df90e8d1cf1cf055$require$MAX_SAFE_INTEGER || this.patch < 0) throw new TypeError("Invalid patch version");
        // numberify any prerelease numeric ids
        if (!m[4]) this.prerelease = [];
        else this.prerelease = m[4].split(".").map((id)=>{
            if (/^[0-9]+$/.test(id)) {
                const num = +id;
                if (num >= 0 && num < $df90e8d1cf1cf055$require$MAX_SAFE_INTEGER) return num;
            }
            return id;
        });
        this.build = m[5] ? m[5].split(".") : [];
        this.format();
    }
    format() {
        this.version = `${this.major}.${this.minor}.${this.patch}`;
        if (this.prerelease.length) this.version += `-${this.prerelease.join(".")}`;
        return this.version;
    }
    toString() {
        return this.version;
    }
    compare(other) {
        $i9RZm("SemVer.compare", this.version, this.options, other);
        if (!(other instanceof $df90e8d1cf1cf055$var$SemVer)) {
            if (typeof other === "string" && other === this.version) return 0;
            other = new $df90e8d1cf1cf055$var$SemVer(other, this.options);
        }
        if (other.version === this.version) return 0;
        return this.compareMain(other) || this.comparePre(other);
    }
    compareMain(other) {
        if (!(other instanceof $df90e8d1cf1cf055$var$SemVer)) other = new $df90e8d1cf1cf055$var$SemVer(other, this.options);
        return $df90e8d1cf1cf055$require$compareIdentifiers(this.major, other.major) || $df90e8d1cf1cf055$require$compareIdentifiers(this.minor, other.minor) || $df90e8d1cf1cf055$require$compareIdentifiers(this.patch, other.patch);
    }
    comparePre(other) {
        if (!(other instanceof $df90e8d1cf1cf055$var$SemVer)) other = new $df90e8d1cf1cf055$var$SemVer(other, this.options);
        // NOT having a prerelease is > having one
        if (this.prerelease.length && !other.prerelease.length) return -1;
        else if (!this.prerelease.length && other.prerelease.length) return 1;
        else if (!this.prerelease.length && !other.prerelease.length) return 0;
        let i = 0;
        do {
            const a = this.prerelease[i];
            const b = other.prerelease[i];
            $i9RZm("prerelease compare", i, a, b);
            if (a === undefined && b === undefined) return 0;
            else if (b === undefined) return 1;
            else if (a === undefined) return -1;
            else if (a === b) continue;
            else return $df90e8d1cf1cf055$require$compareIdentifiers(a, b);
        }while (++i);
    }
    compareBuild(other) {
        if (!(other instanceof $df90e8d1cf1cf055$var$SemVer)) other = new $df90e8d1cf1cf055$var$SemVer(other, this.options);
        let i = 0;
        do {
            const a = this.build[i];
            const b = other.build[i];
            $i9RZm("prerelease compare", i, a, b);
            if (a === undefined && b === undefined) return 0;
            else if (b === undefined) return 1;
            else if (a === undefined) return -1;
            else if (a === b) continue;
            else return $df90e8d1cf1cf055$require$compareIdentifiers(a, b);
        }while (++i);
    }
    // preminor will bump the version up to the next minor release, and immediately
    // down to pre-release. premajor and prepatch work the same way.
    inc(release, identifier, identifierBase) {
        switch(release){
            case "premajor":
                this.prerelease.length = 0;
                this.patch = 0;
                this.minor = 0;
                this.major++;
                this.inc("pre", identifier, identifierBase);
                break;
            case "preminor":
                this.prerelease.length = 0;
                this.patch = 0;
                this.minor++;
                this.inc("pre", identifier, identifierBase);
                break;
            case "prepatch":
                // If this is already a prerelease, it will bump to the next version
                // drop any prereleases that might already exist, since they are not
                // relevant at this point.
                this.prerelease.length = 0;
                this.inc("patch", identifier, identifierBase);
                this.inc("pre", identifier, identifierBase);
                break;
            // If the input is a non-prerelease version, this acts the same as
            // prepatch.
            case "prerelease":
                if (this.prerelease.length === 0) this.inc("patch", identifier, identifierBase);
                this.inc("pre", identifier, identifierBase);
                break;
            case "major":
                // If this is a pre-major version, bump up to the same major version.
                // Otherwise increment major.
                // 1.0.0-5 bumps to 1.0.0
                // 1.1.0 bumps to 2.0.0
                if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) this.major++;
                this.minor = 0;
                this.patch = 0;
                this.prerelease = [];
                break;
            case "minor":
                // If this is a pre-minor version, bump up to the same minor version.
                // Otherwise increment minor.
                // 1.2.0-5 bumps to 1.2.0
                // 1.2.1 bumps to 1.3.0
                if (this.patch !== 0 || this.prerelease.length === 0) this.minor++;
                this.patch = 0;
                this.prerelease = [];
                break;
            case "patch":
                // If this is not a pre-release version, it will increment the patch.
                // If it is a pre-release it will bump up to the same patch version.
                // 1.2.0-5 patches to 1.2.0
                // 1.2.0 patches to 1.2.1
                if (this.prerelease.length === 0) this.patch++;
                this.prerelease = [];
                break;
            // This probably shouldn't be used publicly.
            // 1.0.0 'pre' would become 1.0.0-0 which is the wrong direction.
            case "pre":
                {
                    const base = Number(identifierBase) ? 1 : 0;
                    if (!identifier && identifierBase === false) throw new Error("invalid increment argument: identifier is empty");
                    if (this.prerelease.length === 0) this.prerelease = [
                        base
                    ];
                    else {
                        let i = this.prerelease.length;
                        while(--i >= 0)if (typeof this.prerelease[i] === "number") {
                            this.prerelease[i]++;
                            i = -2;
                        }
                        if (i === -1) {
                            // didn't increment anything
                            if (identifier === this.prerelease.join(".") && identifierBase === false) throw new Error("invalid increment argument: identifier already exists");
                            this.prerelease.push(base);
                        }
                    }
                    if (identifier) {
                        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
                        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
                        let prerelease = [
                            identifier,
                            base
                        ];
                        if (identifierBase === false) prerelease = [
                            identifier
                        ];
                        if ($df90e8d1cf1cf055$require$compareIdentifiers(this.prerelease[0], identifier) === 0) {
                            if (isNaN(this.prerelease[1])) this.prerelease = prerelease;
                        } else this.prerelease = prerelease;
                    }
                    break;
                }
            default:
                throw new Error(`invalid increment argument: ${release}`);
        }
        this.raw = this.format();
        if (this.build.length) this.raw += `+${this.build.join(".")}`;
        return this;
    }
}
$df90e8d1cf1cf055$exports = $df90e8d1cf1cf055$var$SemVer;


const $20d4c8016361ffad$var$compareBuild = (a, b, loose)=>{
    const versionA = new $df90e8d1cf1cf055$exports(a, loose);
    const versionB = new $df90e8d1cf1cf055$exports(b, loose);
    return versionA.compare(versionB) || versionA.compareBuild(versionB);
};
$20d4c8016361ffad$exports = $20d4c8016361ffad$var$compareBuild;


const $3c149acde0254244$var$rsort = (list, loose)=>list.sort((a, b)=>$20d4c8016361ffad$exports(b, a, loose));
$3c149acde0254244$exports = $3c149acde0254244$var$rsort;


const $59b86b14c2bfb676$var$DEFAULT_LFORMS_SOURCE = "https://lhcforms-static.nlm.nih.gov/lforms-versions/";
const $59b86b14c2bfb676$var$MAX_TRIES = 10;
/**
 *  Loads LForms into the page, returning a promise that resolves when it is
 *  ready.
 * @param version the version to be loaded.  This is ignored if lhcFormsSource is
 *  provided.
 * @param styleCallback (optional) a function to call as soon as the styles are loaded
 * @param lhcFormsSource (optional) a base URL from which the LForms files can be
 *  retrieved.  If not specified, the DEFAULT_LFORMS_SOURCE, which also
 *  hosts most versions of LForms, will be used as the source.
 */ function $59b86b14c2bfb676$var$_loadLForms(version, styleCallback, lhcFormsSource) {
    const lformsDir = lhcFormsSource ? lhcFormsSource : `${$59b86b14c2bfb676$var$DEFAULT_LFORMS_SOURCE}${version}`;
    // TBD Add support for versions < 33
    let cssFile, lformsScripts, fhirScript;
    const majorVersion = version.split(".")[0];
    if (majorVersion >= 33) {
        cssFile = "/webcomponent/styles.css";
        // Time tests demonstrated that using the concatenated file is a little
        // faster when there is latency.
        //lformsScripts = ['assets/lib/zone.min.js', 'scripts.js', 'runtime.js',
        //  'polyfills.js', 'main.js'].map(f=>'/webcomponent/'+f);
        lformsScripts = [
            "assets/lib/zone.min.js",
            "lhc-forms.js"
        ].map((f)=>"/webcomponent/" + f);
        fhirScript = "/fhir/lformsFHIRAll.min.js";
    } else if (majorVersion >= 30) {
        cssFile = "/webcomponent/styles.css";
        //lformsScripts = ['assets/lib/zone.min.js', 'scripts.js', 'runtime-es5.js',
        //  'polyfills-es5.js', 'main-es5.js'].map(f=>'/webcomponent/'+f);
        lformsScripts = [
            "assets/lib/zone.min.js",
            "lhc-forms.es5.js"
        ].map((f)=>"/webcomponent/" + f);
        fhirScript = "/fhir/lformsFHIRAll.min.js";
    } else {
        cssFile = "/styles/lforms.min.css";
        lformsScripts = [
            "/lforms.min.js"
        ];
        fhirScript = "/fhir/lformsFHIRAll.min.js";
    }
    const cssTag = document.createElement("link");
    cssTag.setAttribute("href", lformsDir + cssFile);
    cssTag.setAttribute("media", "screen");
    cssTag.setAttribute("rel", "stylesheet");
    let loadPromises = [];
    loadPromises.push($59b86b14c2bfb676$var$loadTag(cssTag).then(()=>styleCallback && styleCallback()));
    lformsScripts.push(fhirScript);
    for (let filename of lformsScripts){
        const scriptTag = document.createElement("script");
        scriptTag.setAttribute("src", lformsDir + filename);
        scriptTag.setAttribute("async", false); // has no effect; set again below
        scriptTag.setAttribute("defer", true);
        loadPromises.push($59b86b14c2bfb676$var$loadTag(scriptTag));
    }
    // We need to wait for the LForms script to load before loading the FHIR
    // support.
    return Promise.all(loadPromises).then(()=>console.log("Loaded LHC-Forms " + (lhcFormsSource ? "from " + lhcFormsSource : "version " + version)));
}
/**
 *  Returns a promise that resolves to an array of the available LForms version
 *  strings for the versions supported by this loader script.  The versions will
 *  be sorted, with the most recent version first.
 */ function $59b86b14c2bfb676$var$_getSupportedLFormsVersions() {
    return fetch($59b86b14c2bfb676$var$DEFAULT_LFORMS_SOURCE).then((response)=>{
        // https://lhcforms-static.nlm.nih.gov/lforms-versions/ contains output like:
        // <a href='lforms-9.0.2.zip'>lforms-9.0.2.zip</a>
        // https://clinicaltables.nlm.nih.gov/lforms-versions contains output like:
        // <span class="name">lforms-9.0.2.zip</span>
        if (!response.ok) throw new Error("Unable to retrieve the list of LForms versions from " + $59b86b14c2bfb676$var$DEFAULT_LFORMS_SOURCE);
        else return response.text().then((pageText)=>{
            const versions = [
                ...pageText.matchAll(/>lforms-([^<]+)\.zip</g)
            ].map((m)=>m[1]).filter((v)=>v.split(".")[0] >= 29);
            (0, (/*@__PURE__*/$parcel$interopDefault($3c149acde0254244$exports)))(versions);
            return versions;
        });
    });
}
function $59b86b14c2bfb676$export$3c5c654e2756614d(newLFormsVersion) {
    // We need to reload the page.
    // The menu only shows if parameters were not set for the questionnaire, so
    // we can't preserve any field values the user might have filled in for the
    // questionnaire.
    let pageURL = window.location.origin + window.location.pathname;
    const params = new URLSearchParams(window.location.search);
    params.set("lfv", newLFormsVersion);
    window.location = pageURL + "?" + params;
}
/**
 *  Loads a tag (for CSS or a script) and returns a promise that resolves
 *  when all of the associated file has loaded or has failed to load.
 * @param tag the tag to load
 */ function $59b86b14c2bfb676$var$loadTag(tag) {
    return new Promise((resolve, reject)=>{
        tag.addEventListener("error", (event)=>{
            reject(event); // Let the caller know the cause.
        });
        tag.addEventListener("load", (event)=>{
            resolve(event); // Give caller additional info.
        });
        if (tag.tagName == "LINK") document.head.appendChild(tag);
        else {
            tag.async = false;
            document.body.appendChild(tag);
        }
    });
}
function $59b86b14c2bfb676$export$80204ecbcb196cff() {
    let tries = 1;
    function loop() {
        return new Promise((resolve, reject)=>{
            $59b86b14c2bfb676$var$_getSupportedLFormsVersions().then((versions)=>{
                resolve(versions);
            }).catch((err)=>{
                tries++;
                if (tries > $59b86b14c2bfb676$var$MAX_TRIES) {
                    const msg = `${Date.now()}: Failed to get LForms version after ${tries - 1} attempts.`;
                    console.error(`${msg} - ${err.stack}`);
                    reject(err);
                } else setTimeout(async ()=>{
                    console.log(`${Date.now()}: ${err.message}`);
                    console.log(`Retrying getSupportedLFormsVersions() again: ${tries}...`);
                    await loop().then(resolve, reject);
                }, 500);
            });
        });
    }
    return loop();
}
async function $59b86b14c2bfb676$export$bec67c290a90f8(version, styleCallback, lhcFormsSource) {
    let tries = 1;
    function loop() {
        return new Promise((resolve, reject)=>{
            $59b86b14c2bfb676$var$_loadLForms(version, styleCallback, lhcFormsSource).then(()=>{
                resolve(LForms.lformsVersion);
            }).catch((errorEvent)=>{
                tries++;
                if (tries > $59b86b14c2bfb676$var$MAX_TRIES) {
                    const msg = `${Date.now()}: Failed to get LForms library files after ${tries} attempts.`;
                    console.error(`${msg} - ${errorEvent.error?.stack}`);
                    reject(errorEvent);
                } else setTimeout(async ()=>{
                    console.log(`${Date.now()}: ${errorEvent.message}`);
                    console.log(`Retrying loadLForms() again: ${tries}...`);
                    return loop(version).then(resolve, reject);
                }, 500);
            });
        });
    }
    return loop();
}
async function $59b86b14c2bfb676$export$d93f70a031589e2d() {
    return await $59b86b14c2bfb676$export$80204ecbcb196cff().then(async (versions)=>{
        const latestVersion = versions[0];
        const backupVersion = versions[1];
        return await $59b86b14c2bfb676$export$bec67c290a90f8(latestVersion).catch(async (error)=>{
            if (backupVersion) return await $59b86b14c2bfb676$export$bec67c290a90f8(backupVersion);
            throw error;
        });
    });
}


// Imports for webpack to find assets

var $8fa5292818130bae$exports = {};
// Top level file is just a mixin of submodules & constants
"use strict";
var $701cc75d47025217$exports = {};
"use strict";
var $701cc75d47025217$var$TYPED_OK = typeof Uint8Array !== "undefined" && typeof Uint16Array !== "undefined" && typeof Int32Array !== "undefined";
function $701cc75d47025217$var$_has(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
$701cc75d47025217$exports.assign = function(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    while(sources.length){
        var source = sources.shift();
        if (!source) continue;
        if (typeof source !== "object") throw new TypeError(source + "must be non-object");
        for(var p in source)if ($701cc75d47025217$var$_has(source, p)) obj[p] = source[p];
    }
    return obj;
};
// reduce buffer size, avoiding mem copy
$701cc75d47025217$exports.shrinkBuf = function(buf, size) {
    if (buf.length === size) return buf;
    if (buf.subarray) return buf.subarray(0, size);
    buf.length = size;
    return buf;
};
var $701cc75d47025217$var$fnTyped = {
    arraySet: function(dest, src, src_offs, len, dest_offs) {
        if (src.subarray && dest.subarray) {
            dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
            return;
        }
        // Fallback to ordinary array
        for(var i = 0; i < len; i++)dest[dest_offs + i] = src[src_offs + i];
    },
    // Join array of chunks to single array.
    flattenChunks: function(chunks) {
        var i, l, len, pos, chunk, result;
        // calculate data length
        len = 0;
        for(i = 0, l = chunks.length; i < l; i++)len += chunks[i].length;
        // join chunks
        result = new Uint8Array(len);
        pos = 0;
        for(i = 0, l = chunks.length; i < l; i++){
            chunk = chunks[i];
            result.set(chunk, pos);
            pos += chunk.length;
        }
        return result;
    }
};
var $701cc75d47025217$var$fnUntyped = {
    arraySet: function(dest, src, src_offs, len, dest_offs) {
        for(var i = 0; i < len; i++)dest[dest_offs + i] = src[src_offs + i];
    },
    // Join array of chunks to single array.
    flattenChunks: function(chunks) {
        return [].concat.apply([], chunks);
    }
};
// Enable/Disable typed arrays use, for testing
//
$701cc75d47025217$exports.setTyped = function(on) {
    if (on) {
        $701cc75d47025217$exports.Buf8 = Uint8Array;
        $701cc75d47025217$exports.Buf16 = Uint16Array;
        $701cc75d47025217$exports.Buf32 = Int32Array;
        $701cc75d47025217$exports.assign($701cc75d47025217$exports, $701cc75d47025217$var$fnTyped);
    } else {
        $701cc75d47025217$exports.Buf8 = Array;
        $701cc75d47025217$exports.Buf16 = Array;
        $701cc75d47025217$exports.Buf32 = Array;
        $701cc75d47025217$exports.assign($701cc75d47025217$exports, $701cc75d47025217$var$fnUntyped);
    }
};
$701cc75d47025217$exports.setTyped($701cc75d47025217$var$TYPED_OK);


var $8fa5292818130bae$require$assign = $701cc75d47025217$exports.assign;
var $1d57b756249bc6d3$exports = {};

$parcel$export($1d57b756249bc6d3$exports, "Deflate", () => $1d57b756249bc6d3$export$ae157b6234afe138, (v) => $1d57b756249bc6d3$export$ae157b6234afe138 = v);
$parcel$export($1d57b756249bc6d3$exports, "deflate", () => $1d57b756249bc6d3$export$2316623ecd1285ab, (v) => $1d57b756249bc6d3$export$2316623ecd1285ab = v);
$parcel$export($1d57b756249bc6d3$exports, "deflateRaw", () => $1d57b756249bc6d3$export$e95d6a8f69fb340a, (v) => $1d57b756249bc6d3$export$e95d6a8f69fb340a = v);
$parcel$export($1d57b756249bc6d3$exports, "gzip", () => $1d57b756249bc6d3$export$69f0ea7cf3a331a8, (v) => $1d57b756249bc6d3$export$69f0ea7cf3a331a8 = v);
var $1d57b756249bc6d3$export$ae157b6234afe138;
var $1d57b756249bc6d3$export$2316623ecd1285ab;
var $1d57b756249bc6d3$export$e95d6a8f69fb340a;
var $1d57b756249bc6d3$export$69f0ea7cf3a331a8;
"use strict";
var $fc8941aa2060205a$export$72b35d618fb8ad9b;
var $fc8941aa2060205a$export$a65c7b2bde87cb70;
var $fc8941aa2060205a$export$8f99f0e30bc7dd53;
var $fc8941aa2060205a$export$e78fab288549509;
var $fc8941aa2060205a$export$1cd50f7b2515ba19;
var $fc8941aa2060205a$export$2316623ecd1285ab;
var $fc8941aa2060205a$export$599854fa319a815f;
var $fc8941aa2060205a$export$f55e0b3ab66b5d46;
var $fc8941aa2060205a$export$12b6e1fcadea22f9;
"use strict";

var $cc3a58b664fcb155$export$4e4fc0157c3cd14d;
var $cc3a58b664fcb155$export$8959e34c5e020172;
var $cc3a58b664fcb155$export$44f15b52eef0cf41;
var $cc3a58b664fcb155$export$b3cbce147289408f;
var $cc3a58b664fcb155$export$bfb360e02ee9b403;
"use strict";

/* Public constants ==========================================================*/ /* ===========================================================================*/ //var Z_FILTERED          = 1;
//var Z_HUFFMAN_ONLY      = 2;
//var Z_RLE               = 3;
var $cc3a58b664fcb155$var$Z_FIXED = 4;
//var Z_DEFAULT_STRATEGY  = 0;
/* Possible values of the data_type field (though see inflate()) */ var $cc3a58b664fcb155$var$Z_BINARY = 0;
var $cc3a58b664fcb155$var$Z_TEXT = 1;
//var Z_ASCII             = 1; // = Z_TEXT
var $cc3a58b664fcb155$var$Z_UNKNOWN = 2;
/*============================================================================*/ function $cc3a58b664fcb155$var$zero(buf) {
    var len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
// From zutil.h
var $cc3a58b664fcb155$var$STORED_BLOCK = 0;
var $cc3a58b664fcb155$var$STATIC_TREES = 1;
var $cc3a58b664fcb155$var$DYN_TREES = 2;
/* The three kinds of block type */ var $cc3a58b664fcb155$var$MIN_MATCH = 3;
var $cc3a58b664fcb155$var$MAX_MATCH = 258;
/* The minimum and maximum match lengths */ // From deflate.h
/* ===========================================================================
 * Internal compression state.
 */ var $cc3a58b664fcb155$var$LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ var $cc3a58b664fcb155$var$LITERALS = 256;
/* number of literal bytes 0..255 */ var $cc3a58b664fcb155$var$L_CODES = $cc3a58b664fcb155$var$LITERALS + 1 + $cc3a58b664fcb155$var$LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ var $cc3a58b664fcb155$var$D_CODES = 30;
/* number of distance codes */ var $cc3a58b664fcb155$var$BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ var $cc3a58b664fcb155$var$HEAP_SIZE = 2 * $cc3a58b664fcb155$var$L_CODES + 1;
/* maximum heap size */ var $cc3a58b664fcb155$var$MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ var $cc3a58b664fcb155$var$Buf_size = 16;
/* size of bit buffer in bi_buf */ /* ===========================================================================
 * Constants
 */ var $cc3a58b664fcb155$var$MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */ var $cc3a58b664fcb155$var$END_BLOCK = 256;
/* end of block literal code */ var $cc3a58b664fcb155$var$REP_3_6 = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */ var $cc3a58b664fcb155$var$REPZ_3_10 = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */ var $cc3a58b664fcb155$var$REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */ /* eslint-disable comma-spacing,array-bracket-spacing */ var $cc3a58b664fcb155$var$extra_lbits = /* extra bits for each length code */ [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0
];
var $cc3a58b664fcb155$var$extra_dbits = /* extra bits for each distance code */ [
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13
];
var $cc3a58b664fcb155$var$extra_blbits = /* extra bits for each bit length code */ [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    7
];
var $cc3a58b664fcb155$var$bl_order = [
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
];
/* eslint-enable comma-spacing,array-bracket-spacing */ /* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */ /* ===========================================================================
 * Local data. These are initialized only once.
 */ // We pre-fill arrays with 0 to avoid uninitialized gaps
var $cc3a58b664fcb155$var$DIST_CODE_LEN = 512; /* see definition of array dist_code below */ 
// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
var $cc3a58b664fcb155$var$static_ltree = new Array(($cc3a58b664fcb155$var$L_CODES + 2) * 2);
$cc3a58b664fcb155$var$zero($cc3a58b664fcb155$var$static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */ var $cc3a58b664fcb155$var$static_dtree = new Array($cc3a58b664fcb155$var$D_CODES * 2);
$cc3a58b664fcb155$var$zero($cc3a58b664fcb155$var$static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */ var $cc3a58b664fcb155$var$_dist_code = new Array($cc3a58b664fcb155$var$DIST_CODE_LEN);
$cc3a58b664fcb155$var$zero($cc3a58b664fcb155$var$_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */ var $cc3a58b664fcb155$var$_length_code = new Array($cc3a58b664fcb155$var$MAX_MATCH - $cc3a58b664fcb155$var$MIN_MATCH + 1);
$cc3a58b664fcb155$var$zero($cc3a58b664fcb155$var$_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */ var $cc3a58b664fcb155$var$base_length = new Array($cc3a58b664fcb155$var$LENGTH_CODES);
$cc3a58b664fcb155$var$zero($cc3a58b664fcb155$var$base_length);
/* First normalized length for each code (0 = MIN_MATCH) */ var $cc3a58b664fcb155$var$base_dist = new Array($cc3a58b664fcb155$var$D_CODES);
$cc3a58b664fcb155$var$zero($cc3a58b664fcb155$var$base_dist);
/* First normalized distance for each code (0 = distance of 1) */ function $cc3a58b664fcb155$var$StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
    this.static_tree = static_tree; /* static tree or NULL */ 
    this.extra_bits = extra_bits; /* extra bits for each code or NULL */ 
    this.extra_base = extra_base; /* base index for extra_bits */ 
    this.elems = elems; /* max number of elements in the tree */ 
    this.max_length = max_length; /* max bit length for the codes */ 
    // show if `static_tree` has data or dummy - needed for monomorphic objects
    this.has_stree = static_tree && static_tree.length;
}
var $cc3a58b664fcb155$var$static_l_desc;
var $cc3a58b664fcb155$var$static_d_desc;
var $cc3a58b664fcb155$var$static_bl_desc;
function $cc3a58b664fcb155$var$TreeDesc(dyn_tree, stat_desc) {
    this.dyn_tree = dyn_tree; /* the dynamic tree */ 
    this.max_code = 0; /* largest code with non zero frequency */ 
    this.stat_desc = stat_desc; /* the corresponding static tree */ 
}
function $cc3a58b664fcb155$var$d_code(dist) {
    return dist < 256 ? $cc3a58b664fcb155$var$_dist_code[dist] : $cc3a58b664fcb155$var$_dist_code[256 + (dist >>> 7)];
}
/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */ function $cc3a58b664fcb155$var$put_short(s, w) {
    //    put_byte(s, (uch)((w) & 0xff));
    //    put_byte(s, (uch)((ush)(w) >> 8));
    s.pending_buf[s.pending++] = w & 0xff;
    s.pending_buf[s.pending++] = w >>> 8 & 0xff;
}
/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */ function $cc3a58b664fcb155$var$send_bits(s, value, length) {
    if (s.bi_valid > $cc3a58b664fcb155$var$Buf_size - length) {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        $cc3a58b664fcb155$var$put_short(s, s.bi_buf);
        s.bi_buf = value >> $cc3a58b664fcb155$var$Buf_size - s.bi_valid;
        s.bi_valid += length - $cc3a58b664fcb155$var$Buf_size;
    } else {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        s.bi_valid += length;
    }
}
function $cc3a58b664fcb155$var$send_code(s, c, tree) {
    $cc3a58b664fcb155$var$send_bits(s, tree[c * 2], tree[c * 2 + 1]);
}
/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */ function $cc3a58b664fcb155$var$bi_reverse(code, len) {
    var res = 0;
    do {
        res |= code & 1;
        code >>>= 1;
        res <<= 1;
    }while (--len > 0);
    return res >>> 1;
}
/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */ function $cc3a58b664fcb155$var$bi_flush(s) {
    if (s.bi_valid === 16) {
        $cc3a58b664fcb155$var$put_short(s, s.bi_buf);
        s.bi_buf = 0;
        s.bi_valid = 0;
    } else if (s.bi_valid >= 8) {
        s.pending_buf[s.pending++] = s.bi_buf & 0xff;
        s.bi_buf >>= 8;
        s.bi_valid -= 8;
    }
}
/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */ function $cc3a58b664fcb155$var$gen_bitlen(s, desc) //    deflate_state *s;
//    tree_desc *desc;    /* the tree descriptor */
{
    var tree = desc.dyn_tree;
    var max_code = desc.max_code;
    var stree = desc.stat_desc.static_tree;
    var has_stree = desc.stat_desc.has_stree;
    var extra = desc.stat_desc.extra_bits;
    var base = desc.stat_desc.extra_base;
    var max_length = desc.stat_desc.max_length;
    var h; /* heap index */ 
    var n, m; /* iterate over the tree elements */ 
    var bits; /* bit length */ 
    var xbits; /* extra bits */ 
    var f; /* frequency */ 
    var overflow = 0; /* number of elements with bit length too large */ 
    for(bits = 0; bits <= $cc3a58b664fcb155$var$MAX_BITS; bits++)s.bl_count[bits] = 0;
    /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */ tree[s.heap[s.heap_max] * 2 + 1] = 0; /* root of the heap */ 
    for(h = s.heap_max + 1; h < $cc3a58b664fcb155$var$HEAP_SIZE; h++){
        n = s.heap[h];
        bits = tree[tree[n * 2 + 1] * 2 + 1] + 1;
        if (bits > max_length) {
            bits = max_length;
            overflow++;
        }
        tree[n * 2 + 1] = bits;
        /* We overwrite tree[n].Dad which is no longer needed */ if (n > max_code) continue;
         /* not a leaf node */ 
        s.bl_count[bits]++;
        xbits = 0;
        if (n >= base) xbits = extra[n - base];
        f = tree[n * 2] /*.Freq*/ ;
        s.opt_len += f * (bits + xbits);
        if (has_stree) s.static_len += f * (stree[n * 2 + 1] + xbits);
    }
    if (overflow === 0) return;
    // Trace((stderr,"\nbit length overflow\n"));
    /* This happens for example on obj2 and pic of the Calgary corpus */ /* Find the first bit length which could increase: */ do {
        bits = max_length - 1;
        while(s.bl_count[bits] === 0)bits--;
        s.bl_count[bits]--; /* move one leaf down the tree */ 
        s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */ 
        s.bl_count[max_length]--;
        /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */ overflow -= 2;
    }while (overflow > 0);
    /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */ for(bits = max_length; bits !== 0; bits--){
        n = s.bl_count[bits];
        while(n !== 0){
            m = s.heap[--h];
            if (m > max_code) continue;
            if (tree[m * 2 + 1] !== bits) {
                // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
                s.opt_len += (bits - tree[m * 2 + 1]) * tree[m * 2] /*.Freq*/ ;
                tree[m * 2 + 1] = bits;
            }
            n--;
        }
    }
}
/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */ function $cc3a58b664fcb155$var$gen_codes(tree, max_code, bl_count) //    ct_data *tree;             /* the tree to decorate */
//    int max_code;              /* largest code with non zero frequency */
//    ushf *bl_count;            /* number of codes at each bit length */
{
    var next_code = new Array($cc3a58b664fcb155$var$MAX_BITS + 1); /* next code value for each bit length */ 
    var code = 0; /* running code value */ 
    var bits; /* bit index */ 
    var n; /* code index */ 
    /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */ for(bits = 1; bits <= $cc3a58b664fcb155$var$MAX_BITS; bits++)next_code[bits] = code = code + bl_count[bits - 1] << 1;
    /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */ //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
    //        "inconsistent bit counts");
    //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
    for(n = 0; n <= max_code; n++){
        var len = tree[n * 2 + 1] /*.Len*/ ;
        if (len === 0) continue;
        /* Now reverse the bits */ tree[n * 2] = $cc3a58b664fcb155$var$bi_reverse(next_code[len]++, len);
    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
    }
}
/* ===========================================================================
 * Initialize the various 'constant' tables.
 */ function $cc3a58b664fcb155$var$tr_static_init() {
    var n; /* iterates over tree elements */ 
    var bits; /* bit counter */ 
    var length; /* length value */ 
    var code; /* code value */ 
    var dist; /* distance index */ 
    var bl_count = new Array($cc3a58b664fcb155$var$MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ // do check in _tr_init()
    //if (static_init_done) return;
    /* For some embedded targets, global variables are not initialized: */ /*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/ /* Initialize the mapping length (0..255) -> length code (0..28) */ length = 0;
    for(code = 0; code < $cc3a58b664fcb155$var$LENGTH_CODES - 1; code++){
        $cc3a58b664fcb155$var$base_length[code] = length;
        for(n = 0; n < 1 << $cc3a58b664fcb155$var$extra_lbits[code]; n++)$cc3a58b664fcb155$var$_length_code[length++] = code;
    }
    //Assert (length == 256, "tr_static_init: length != 256");
    /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */ $cc3a58b664fcb155$var$_length_code[length - 1] = code;
    /* Initialize the mapping dist (0..32K) -> dist code (0..29) */ dist = 0;
    for(code = 0; code < 16; code++){
        $cc3a58b664fcb155$var$base_dist[code] = dist;
        for(n = 0; n < 1 << $cc3a58b664fcb155$var$extra_dbits[code]; n++)$cc3a58b664fcb155$var$_dist_code[dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: dist != 256");
    dist >>= 7; /* from now on, all distances are divided by 128 */ 
    for(; code < $cc3a58b664fcb155$var$D_CODES; code++){
        $cc3a58b664fcb155$var$base_dist[code] = dist << 7;
        for(n = 0; n < 1 << $cc3a58b664fcb155$var$extra_dbits[code] - 7; n++)$cc3a58b664fcb155$var$_dist_code[256 + dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: 256+dist != 512");
    /* Construct the codes of the static literal tree */ for(bits = 0; bits <= $cc3a58b664fcb155$var$MAX_BITS; bits++)bl_count[bits] = 0;
    n = 0;
    while(n <= 143){
        $cc3a58b664fcb155$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    while(n <= 255){
        $cc3a58b664fcb155$var$static_ltree[n * 2 + 1] = 9;
        n++;
        bl_count[9]++;
    }
    while(n <= 279){
        $cc3a58b664fcb155$var$static_ltree[n * 2 + 1] = 7;
        n++;
        bl_count[7]++;
    }
    while(n <= 287){
        $cc3a58b664fcb155$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */ $cc3a58b664fcb155$var$gen_codes($cc3a58b664fcb155$var$static_ltree, $cc3a58b664fcb155$var$L_CODES + 1, bl_count);
    /* The static distance tree is trivial: */ for(n = 0; n < $cc3a58b664fcb155$var$D_CODES; n++){
        $cc3a58b664fcb155$var$static_dtree[n * 2 + 1] = 5;
        $cc3a58b664fcb155$var$static_dtree[n * 2] = $cc3a58b664fcb155$var$bi_reverse(n, 5);
    }
    // Now data ready and we can init static trees
    $cc3a58b664fcb155$var$static_l_desc = new $cc3a58b664fcb155$var$StaticTreeDesc($cc3a58b664fcb155$var$static_ltree, $cc3a58b664fcb155$var$extra_lbits, $cc3a58b664fcb155$var$LITERALS + 1, $cc3a58b664fcb155$var$L_CODES, $cc3a58b664fcb155$var$MAX_BITS);
    $cc3a58b664fcb155$var$static_d_desc = new $cc3a58b664fcb155$var$StaticTreeDesc($cc3a58b664fcb155$var$static_dtree, $cc3a58b664fcb155$var$extra_dbits, 0, $cc3a58b664fcb155$var$D_CODES, $cc3a58b664fcb155$var$MAX_BITS);
    $cc3a58b664fcb155$var$static_bl_desc = new $cc3a58b664fcb155$var$StaticTreeDesc(new Array(0), $cc3a58b664fcb155$var$extra_blbits, 0, $cc3a58b664fcb155$var$BL_CODES, $cc3a58b664fcb155$var$MAX_BL_BITS);
//static_init_done = true;
}
/* ===========================================================================
 * Initialize a new block.
 */ function $cc3a58b664fcb155$var$init_block(s) {
    var n; /* iterates over tree elements */ 
    /* Initialize the trees. */ for(n = 0; n < $cc3a58b664fcb155$var$L_CODES; n++)s.dyn_ltree[n * 2] = 0;
    for(n = 0; n < $cc3a58b664fcb155$var$D_CODES; n++)s.dyn_dtree[n * 2] = 0;
    for(n = 0; n < $cc3a58b664fcb155$var$BL_CODES; n++)s.bl_tree[n * 2] = 0;
    s.dyn_ltree[$cc3a58b664fcb155$var$END_BLOCK * 2] = 1;
    s.opt_len = s.static_len = 0;
    s.last_lit = s.matches = 0;
}
/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */ function $cc3a58b664fcb155$var$bi_windup(s) {
    if (s.bi_valid > 8) $cc3a58b664fcb155$var$put_short(s, s.bi_buf);
    else if (s.bi_valid > 0) //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
    s.bi_buf = 0;
    s.bi_valid = 0;
}
/* ===========================================================================
 * Copy a stored block, storing first the length and its
 * one's complement if requested.
 */ function $cc3a58b664fcb155$var$copy_block(s, buf, len, header) //DeflateState *s;
//charf    *buf;    /* the input data */
//unsigned len;     /* its length */
//int      header;  /* true if block header must be written */
{
    $cc3a58b664fcb155$var$bi_windup(s); /* align on byte boundary */ 
    if (header) {
        $cc3a58b664fcb155$var$put_short(s, len);
        $cc3a58b664fcb155$var$put_short(s, ~len);
    }
    //  while (len--) {
    //    put_byte(s, *buf++);
    //  }
    $701cc75d47025217$exports.arraySet(s.pending_buf, s.window, buf, len, s.pending);
    s.pending += len;
}
/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */ function $cc3a58b664fcb155$var$smaller(tree, n, m, depth) {
    var _n2 = n * 2;
    var _m2 = m * 2;
    return tree[_n2] < tree[_m2] || tree[_n2] === tree[_m2] && depth[n] <= depth[m];
}
/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */ function $cc3a58b664fcb155$var$pqdownheap(s, tree, k) //    deflate_state *s;
//    ct_data *tree;  /* the tree to restore */
//    int k;               /* node to move down */
{
    var v = s.heap[k];
    var j = k << 1; /* left son of k */ 
    while(j <= s.heap_len){
        /* Set j to the smallest of the two sons: */ if (j < s.heap_len && $cc3a58b664fcb155$var$smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) j++;
        /* Exit if v is smaller than both sons */ if ($cc3a58b664fcb155$var$smaller(tree, v, s.heap[j], s.depth)) break;
        /* Exchange v with the smallest son */ s.heap[k] = s.heap[j];
        k = j;
        /* And continue down the tree, setting j to the left son of k */ j <<= 1;
    }
    s.heap[k] = v;
}
// inlined manually
// var SMALLEST = 1;
/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */ function $cc3a58b664fcb155$var$compress_block(s, ltree, dtree) //    deflate_state *s;
//    const ct_data *ltree; /* literal tree */
//    const ct_data *dtree; /* distance tree */
{
    var dist; /* distance of matched string */ 
    var lc; /* match length or unmatched char (if dist == 0) */ 
    var lx = 0; /* running index in l_buf */ 
    var code; /* the code to send */ 
    var extra; /* number of extra bits to send */ 
    if (s.last_lit !== 0) do {
        dist = s.pending_buf[s.d_buf + lx * 2] << 8 | s.pending_buf[s.d_buf + lx * 2 + 1];
        lc = s.pending_buf[s.l_buf + lx];
        lx++;
        if (dist === 0) $cc3a58b664fcb155$var$send_code(s, lc, ltree); /* send a literal byte */ 
        else {
            /* Here, lc is the match length - MIN_MATCH */ code = $cc3a58b664fcb155$var$_length_code[lc];
            $cc3a58b664fcb155$var$send_code(s, code + $cc3a58b664fcb155$var$LITERALS + 1, ltree); /* send the length code */ 
            extra = $cc3a58b664fcb155$var$extra_lbits[code];
            if (extra !== 0) {
                lc -= $cc3a58b664fcb155$var$base_length[code];
                $cc3a58b664fcb155$var$send_bits(s, lc, extra); /* send the extra length bits */ 
            }
            dist--; /* dist is now the match distance - 1 */ 
            code = $cc3a58b664fcb155$var$d_code(dist);
            //Assert (code < D_CODES, "bad d_code");
            $cc3a58b664fcb155$var$send_code(s, code, dtree); /* send the distance code */ 
            extra = $cc3a58b664fcb155$var$extra_dbits[code];
            if (extra !== 0) {
                dist -= $cc3a58b664fcb155$var$base_dist[code];
                $cc3a58b664fcb155$var$send_bits(s, dist, extra); /* send the extra distance bits */ 
            }
        } /* literal or match pair ? */ 
    /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */ //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
    //       "pendingBuf overflow");
    }while (lx < s.last_lit);
    $cc3a58b664fcb155$var$send_code(s, $cc3a58b664fcb155$var$END_BLOCK, ltree);
}
/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */ function $cc3a58b664fcb155$var$build_tree(s, desc) //    deflate_state *s;
//    tree_desc *desc; /* the tree descriptor */
{
    var tree = desc.dyn_tree;
    var stree = desc.stat_desc.static_tree;
    var has_stree = desc.stat_desc.has_stree;
    var elems = desc.stat_desc.elems;
    var n, m; /* iterate over heap elements */ 
    var max_code = -1; /* largest code with non zero frequency */ 
    var node; /* new node being created */ 
    /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */ s.heap_len = 0;
    s.heap_max = $cc3a58b664fcb155$var$HEAP_SIZE;
    for(n = 0; n < elems; n++)if (tree[n * 2] !== 0) {
        s.heap[++s.heap_len] = max_code = n;
        s.depth[n] = 0;
    } else tree[n * 2 + 1] = 0;
    /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */ while(s.heap_len < 2){
        node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
        tree[node * 2] = 1;
        s.depth[node] = 0;
        s.opt_len--;
        if (has_stree) s.static_len -= stree[node * 2 + 1] /*.Len*/ ;
    /* node is 0 or 1 so it does not have extra bits */ }
    desc.max_code = max_code;
    /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */ for(n = s.heap_len >> 1 /*int /2*/ ; n >= 1; n--)$cc3a58b664fcb155$var$pqdownheap(s, tree, n);
    /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */ node = elems; /* next internal node of the tree */ 
    do {
        //pqremove(s, tree, n);  /* n = node of least frequency */
        /*** pqremove ***/ n = s.heap[1 /*SMALLEST*/ ];
        s.heap[1 /*SMALLEST*/ ] = s.heap[s.heap_len--];
        $cc3a58b664fcb155$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
        /***/ m = s.heap[1 /*SMALLEST*/ ]; /* m = node of next least frequency */ 
        s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */ 
        s.heap[--s.heap_max] = m;
        /* Create a new node father of n and m */ tree[node * 2] = tree[n * 2] + tree[m * 2] /*.Freq*/ ;
        s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
        tree[n * 2 + 1] = tree[m * 2 + 1] = node;
        /* and insert the new node in the heap */ s.heap[1 /*SMALLEST*/ ] = node++;
        $cc3a58b664fcb155$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
    }while (s.heap_len >= 2);
    s.heap[--s.heap_max] = s.heap[1 /*SMALLEST*/ ];
    /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */ $cc3a58b664fcb155$var$gen_bitlen(s, desc);
    /* The field len is now set, we can generate the bit codes */ $cc3a58b664fcb155$var$gen_codes(tree, max_code, s.bl_count);
}
/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */ function $cc3a58b664fcb155$var$scan_tree(s, tree, max_code) //    deflate_state *s;
//    ct_data *tree;   /* the tree to be scanned */
//    int max_code;    /* and its largest code of non zero frequency */
{
    var n; /* iterates over all tree elements */ 
    var prevlen = -1; /* last emitted length */ 
    var curlen; /* length of current code */ 
    var nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    var count = 0; /* repeat count of the current code */ 
    var max_count = 7; /* max repeat count */ 
    var min_count = 4; /* min repeat count */ 
    if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    tree[(max_code + 1) * 2 + 1] = 0xffff; /* guard */ 
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) s.bl_tree[curlen * 2] += count;
        else if (curlen !== 0) {
            if (curlen !== prevlen) s.bl_tree[curlen * 2]++;
            s.bl_tree[$cc3a58b664fcb155$var$REP_3_6 * 2]++;
        } else if (count <= 10) s.bl_tree[$cc3a58b664fcb155$var$REPZ_3_10 * 2]++;
        else s.bl_tree[$cc3a58b664fcb155$var$REPZ_11_138 * 2]++;
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
}
/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */ function $cc3a58b664fcb155$var$send_tree(s, tree, max_code) //    deflate_state *s;
//    ct_data *tree; /* the tree to be scanned */
//    int max_code;       /* and its largest code of non zero frequency */
{
    var n; /* iterates over all tree elements */ 
    var prevlen = -1; /* last emitted length */ 
    var curlen; /* length of current code */ 
    var nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    var count = 0; /* repeat count of the current code */ 
    var max_count = 7; /* max repeat count */ 
    var min_count = 4; /* min repeat count */ 
    /* tree[max_code+1].Len = -1; */ /* guard already set */ if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) do $cc3a58b664fcb155$var$send_code(s, curlen, s.bl_tree);
        while (--count !== 0);
        else if (curlen !== 0) {
            if (curlen !== prevlen) {
                $cc3a58b664fcb155$var$send_code(s, curlen, s.bl_tree);
                count--;
            }
            //Assert(count >= 3 && count <= 6, " 3_6?");
            $cc3a58b664fcb155$var$send_code(s, $cc3a58b664fcb155$var$REP_3_6, s.bl_tree);
            $cc3a58b664fcb155$var$send_bits(s, count - 3, 2);
        } else if (count <= 10) {
            $cc3a58b664fcb155$var$send_code(s, $cc3a58b664fcb155$var$REPZ_3_10, s.bl_tree);
            $cc3a58b664fcb155$var$send_bits(s, count - 3, 3);
        } else {
            $cc3a58b664fcb155$var$send_code(s, $cc3a58b664fcb155$var$REPZ_11_138, s.bl_tree);
            $cc3a58b664fcb155$var$send_bits(s, count - 11, 7);
        }
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
}
/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */ function $cc3a58b664fcb155$var$build_bl_tree(s) {
    var max_blindex; /* index of last bit length code of non zero freq */ 
    /* Determine the bit length frequencies for literal and distance trees */ $cc3a58b664fcb155$var$scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
    $cc3a58b664fcb155$var$scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
    /* Build the bit length tree: */ $cc3a58b664fcb155$var$build_tree(s, s.bl_desc);
    /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */ /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */ for(max_blindex = $cc3a58b664fcb155$var$BL_CODES - 1; max_blindex >= 3; max_blindex--){
        if (s.bl_tree[$cc3a58b664fcb155$var$bl_order[max_blindex] * 2 + 1] !== 0) break;
    }
    /* Update opt_len to include the bit length tree and counts */ s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
    //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
    //        s->opt_len, s->static_len));
    return max_blindex;
}
/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */ function $cc3a58b664fcb155$var$send_all_trees(s, lcodes, dcodes, blcodes) //    deflate_state *s;
//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
{
    var rank; /* index in bl_order */ 
    //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
    //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
    //        "too many codes");
    //Tracev((stderr, "\nbl counts: "));
    $cc3a58b664fcb155$var$send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */ 
    $cc3a58b664fcb155$var$send_bits(s, dcodes - 1, 5);
    $cc3a58b664fcb155$var$send_bits(s, blcodes - 4, 4); /* not -3 as stated in appnote.txt */ 
    for(rank = 0; rank < blcodes; rank++)//Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    $cc3a58b664fcb155$var$send_bits(s, s.bl_tree[$cc3a58b664fcb155$var$bl_order[rank] * 2 + 1], 3);
    //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
    $cc3a58b664fcb155$var$send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */ 
    //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
    $cc3a58b664fcb155$var$send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */ 
//Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
}
/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "black list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */ function $cc3a58b664fcb155$var$detect_data_type(s) {
    /* black_mask is the bit mask of black-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */ var black_mask = 0xf3ffc07f;
    var n;
    /* Check for non-textual ("black-listed") bytes. */ for(n = 0; n <= 31; n++, black_mask >>>= 1){
        if (black_mask & 1 && s.dyn_ltree[n * 2] !== 0) return $cc3a58b664fcb155$var$Z_BINARY;
    }
    /* Check for textual ("white-listed") bytes. */ if (s.dyn_ltree[18] !== 0 || s.dyn_ltree[20] !== 0 || s.dyn_ltree[26] !== 0) return $cc3a58b664fcb155$var$Z_TEXT;
    for(n = 32; n < $cc3a58b664fcb155$var$LITERALS; n++){
        if (s.dyn_ltree[n * 2] !== 0) return $cc3a58b664fcb155$var$Z_TEXT;
    }
    /* There are no "black-listed" or "white-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */ return $cc3a58b664fcb155$var$Z_BINARY;
}
var $cc3a58b664fcb155$var$static_init_done = false;
/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */ function $cc3a58b664fcb155$var$_tr_init(s) {
    if (!$cc3a58b664fcb155$var$static_init_done) {
        $cc3a58b664fcb155$var$tr_static_init();
        $cc3a58b664fcb155$var$static_init_done = true;
    }
    s.l_desc = new $cc3a58b664fcb155$var$TreeDesc(s.dyn_ltree, $cc3a58b664fcb155$var$static_l_desc);
    s.d_desc = new $cc3a58b664fcb155$var$TreeDesc(s.dyn_dtree, $cc3a58b664fcb155$var$static_d_desc);
    s.bl_desc = new $cc3a58b664fcb155$var$TreeDesc(s.bl_tree, $cc3a58b664fcb155$var$static_bl_desc);
    s.bi_buf = 0;
    s.bi_valid = 0;
    /* Initialize the first block of the first file: */ $cc3a58b664fcb155$var$init_block(s);
}
/* ===========================================================================
 * Send a stored block
 */ function $cc3a58b664fcb155$var$_tr_stored_block(s, buf, stored_len, last) //DeflateState *s;
//charf *buf;       /* input block */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
    $cc3a58b664fcb155$var$send_bits(s, ($cc3a58b664fcb155$var$STORED_BLOCK << 1) + (last ? 1 : 0), 3); /* send block type */ 
    $cc3a58b664fcb155$var$copy_block(s, buf, stored_len, true); /* with header */ 
}
/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */ function $cc3a58b664fcb155$var$_tr_align(s) {
    $cc3a58b664fcb155$var$send_bits(s, $cc3a58b664fcb155$var$STATIC_TREES << 1, 3);
    $cc3a58b664fcb155$var$send_code(s, $cc3a58b664fcb155$var$END_BLOCK, $cc3a58b664fcb155$var$static_ltree);
    $cc3a58b664fcb155$var$bi_flush(s);
}
/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and output the encoded block to the zip file.
 */ function $cc3a58b664fcb155$var$_tr_flush_block(s, buf, stored_len, last) //DeflateState *s;
//charf *buf;       /* input block, or NULL if too old */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
    var opt_lenb, static_lenb; /* opt_len and static_len in bytes */ 
    var max_blindex = 0; /* index of last bit length code of non zero freq */ 
    /* Build the Huffman trees unless a stored block is forced */ if (s.level > 0) {
        /* Check if the file is binary or text */ if (s.strm.data_type === $cc3a58b664fcb155$var$Z_UNKNOWN) s.strm.data_type = $cc3a58b664fcb155$var$detect_data_type(s);
        /* Construct the literal and distance trees */ $cc3a58b664fcb155$var$build_tree(s, s.l_desc);
        // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        $cc3a58b664fcb155$var$build_tree(s, s.d_desc);
        // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */ /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */ max_blindex = $cc3a58b664fcb155$var$build_bl_tree(s);
        /* Determine the best encoding. Compute the block lengths in bytes. */ opt_lenb = s.opt_len + 3 + 7 >>> 3;
        static_lenb = s.static_len + 3 + 7 >>> 3;
        // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
        //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
        //        s->last_lit));
        if (static_lenb <= opt_lenb) opt_lenb = static_lenb;
    } else // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */ 
    if (stored_len + 4 <= opt_lenb && buf !== -1) /* 4: two words for the lengths */ /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */ $cc3a58b664fcb155$var$_tr_stored_block(s, buf, stored_len, last);
    else if (s.strategy === $cc3a58b664fcb155$var$Z_FIXED || static_lenb === opt_lenb) {
        $cc3a58b664fcb155$var$send_bits(s, ($cc3a58b664fcb155$var$STATIC_TREES << 1) + (last ? 1 : 0), 3);
        $cc3a58b664fcb155$var$compress_block(s, $cc3a58b664fcb155$var$static_ltree, $cc3a58b664fcb155$var$static_dtree);
    } else {
        $cc3a58b664fcb155$var$send_bits(s, ($cc3a58b664fcb155$var$DYN_TREES << 1) + (last ? 1 : 0), 3);
        $cc3a58b664fcb155$var$send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
        $cc3a58b664fcb155$var$compress_block(s, s.dyn_ltree, s.dyn_dtree);
    }
    // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
    /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */ $cc3a58b664fcb155$var$init_block(s);
    if (last) $cc3a58b664fcb155$var$bi_windup(s);
// Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
//       s->compressed_len-7*last));
}
/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */ function $cc3a58b664fcb155$var$_tr_tally(s, dist, lc) //    deflate_state *s;
//    unsigned dist;  /* distance of matched string */
//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
{
    //var out_length, in_length, dcode;
    s.pending_buf[s.d_buf + s.last_lit * 2] = dist >>> 8 & 0xff;
    s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
    s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
    s.last_lit++;
    if (dist === 0) /* lc is the unmatched char */ s.dyn_ltree[lc * 2]++;
    else {
        s.matches++;
        /* Here, lc is the match length - MIN_MATCH */ dist--; /* dist = match distance - 1 */ 
        //Assert((ush)dist < (ush)MAX_DIST(s) &&
        //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
        //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
        s.dyn_ltree[($cc3a58b664fcb155$var$_length_code[lc] + $cc3a58b664fcb155$var$LITERALS + 1) * 2]++;
        s.dyn_dtree[$cc3a58b664fcb155$var$d_code(dist) * 2]++;
    }
    // (!) This block is disabled in zlib defaults,
    // don't enable it for binary compatibility
    //#ifdef TRUNCATE_BLOCK
    //  /* Try to guess if it is profitable to stop the current block here */
    //  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
    //    /* Compute an upper bound for the compressed length */
    //    out_length = s.last_lit*8;
    //    in_length = s.strstart - s.block_start;
    //
    //    for (dcode = 0; dcode < D_CODES; dcode++) {
    //      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
    //    }
    //    out_length >>>= 3;
    //    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
    //    //       s->last_lit, in_length, out_length,
    //    //       100L - out_length*100L/in_length));
    //    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
    //      return true;
    //    }
    //  }
    //#endif
    return s.last_lit === s.lit_bufsize - 1;
/* We avoid equality with lit_bufsize because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */ }
$cc3a58b664fcb155$export$4e4fc0157c3cd14d = $cc3a58b664fcb155$var$_tr_init;
$cc3a58b664fcb155$export$8959e34c5e020172 = $cc3a58b664fcb155$var$_tr_stored_block;
$cc3a58b664fcb155$export$44f15b52eef0cf41 = $cc3a58b664fcb155$var$_tr_flush_block;
$cc3a58b664fcb155$export$b3cbce147289408f = $cc3a58b664fcb155$var$_tr_tally;
$cc3a58b664fcb155$export$bfb360e02ee9b403 = $cc3a58b664fcb155$var$_tr_align;


var $c2fc869ba2d0859c$exports = {};
"use strict";
// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It isn't worth it to make additional optimizations as in original.
// Small size is preferable.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $c2fc869ba2d0859c$var$adler32(adler, buf, len, pos) {
    var s1 = adler & 0xffff | 0, s2 = adler >>> 16 & 0xffff | 0, n = 0;
    while(len !== 0){
        // Set limit ~ twice less than 5552, to keep
        // s2 in 31-bits, because we force signed ints.
        // in other case %= will fail.
        n = len > 2000 ? 2000 : len;
        len -= n;
        do {
            s1 = s1 + buf[pos++] | 0;
            s2 = s2 + s1 | 0;
        }while (--n);
        s1 %= 65521;
        s2 %= 65521;
    }
    return s1 | s2 << 16 | 0;
}
$c2fc869ba2d0859c$exports = $c2fc869ba2d0859c$var$adler32;


var $44e7d98dd6723a9a$exports = {};
"use strict";
// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// Use ordinary array, since untyped makes no boost here
function $44e7d98dd6723a9a$var$makeTable() {
    var c, table = [];
    for(var n = 0; n < 256; n++){
        c = n;
        for(var k = 0; k < 8; k++)c = c & 1 ? 0xEDB88320 ^ c >>> 1 : c >>> 1;
        table[n] = c;
    }
    return table;
}
// Create table on load. Just 255 signed longs. Not a problem.
var $44e7d98dd6723a9a$var$crcTable = $44e7d98dd6723a9a$var$makeTable();
function $44e7d98dd6723a9a$var$crc32(crc, buf, len, pos) {
    var t = $44e7d98dd6723a9a$var$crcTable, end = pos + len;
    crc ^= -1;
    for(var i = pos; i < end; i++)crc = crc >>> 8 ^ t[(crc ^ buf[i]) & 0xFF];
    return crc ^ -1; // >>> 0;
}
$44e7d98dd6723a9a$exports = $44e7d98dd6723a9a$var$crc32;


var $54a63c0c56b6e112$exports = {};
"use strict";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
$54a63c0c56b6e112$exports = {
    2: "need dictionary",
    /* Z_NEED_DICT       2  */ 1: "stream end",
    /* Z_STREAM_END      1  */ 0: "",
    /* Z_OK              0  */ "-1": "file error",
    /* Z_ERRNO         (-1) */ "-2": "stream error",
    /* Z_STREAM_ERROR  (-2) */ "-3": "data error",
    /* Z_DATA_ERROR    (-3) */ "-4": "insufficient memory",
    /* Z_MEM_ERROR     (-4) */ "-5": "buffer error",
    /* Z_BUF_ERROR     (-5) */ "-6": "incompatible version" /* Z_VERSION_ERROR (-6) */ 
};


/* Public constants ==========================================================*/ /* ===========================================================================*/ /* Allowed flush values; see deflate() and inflate() below for details */ var $fc8941aa2060205a$var$Z_NO_FLUSH = 0;
var $fc8941aa2060205a$var$Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
var $fc8941aa2060205a$var$Z_FULL_FLUSH = 3;
var $fc8941aa2060205a$var$Z_FINISH = 4;
var $fc8941aa2060205a$var$Z_BLOCK = 5;
//var Z_TREES         = 6;
/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */ var $fc8941aa2060205a$var$Z_OK = 0;
var $fc8941aa2060205a$var$Z_STREAM_END = 1;
//var Z_NEED_DICT     = 2;
//var Z_ERRNO         = -1;
var $fc8941aa2060205a$var$Z_STREAM_ERROR = -2;
var $fc8941aa2060205a$var$Z_DATA_ERROR = -3;
//var Z_MEM_ERROR     = -4;
var $fc8941aa2060205a$var$Z_BUF_ERROR = -5;
//var Z_VERSION_ERROR = -6;
/* compression levels */ //var Z_NO_COMPRESSION      = 0;
//var Z_BEST_SPEED          = 1;
//var Z_BEST_COMPRESSION    = 9;
var $fc8941aa2060205a$var$Z_DEFAULT_COMPRESSION = -1;
var $fc8941aa2060205a$var$Z_FILTERED = 1;
var $fc8941aa2060205a$var$Z_HUFFMAN_ONLY = 2;
var $fc8941aa2060205a$var$Z_RLE = 3;
var $fc8941aa2060205a$var$Z_FIXED = 4;
var $fc8941aa2060205a$var$Z_DEFAULT_STRATEGY = 0;
/* Possible values of the data_type field (though see inflate()) */ //var Z_BINARY              = 0;
//var Z_TEXT                = 1;
//var Z_ASCII               = 1; // = Z_TEXT
var $fc8941aa2060205a$var$Z_UNKNOWN = 2;
/* The deflate compression method */ var $fc8941aa2060205a$var$Z_DEFLATED = 8;
/*============================================================================*/ var $fc8941aa2060205a$var$MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */ var $fc8941aa2060205a$var$MAX_WBITS = 15;
/* 32K LZ77 window */ var $fc8941aa2060205a$var$DEF_MEM_LEVEL = 8;
var $fc8941aa2060205a$var$LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ var $fc8941aa2060205a$var$LITERALS = 256;
/* number of literal bytes 0..255 */ var $fc8941aa2060205a$var$L_CODES = $fc8941aa2060205a$var$LITERALS + 1 + $fc8941aa2060205a$var$LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ var $fc8941aa2060205a$var$D_CODES = 30;
/* number of distance codes */ var $fc8941aa2060205a$var$BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ var $fc8941aa2060205a$var$HEAP_SIZE = 2 * $fc8941aa2060205a$var$L_CODES + 1;
/* maximum heap size */ var $fc8941aa2060205a$var$MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ var $fc8941aa2060205a$var$MIN_MATCH = 3;
var $fc8941aa2060205a$var$MAX_MATCH = 258;
var $fc8941aa2060205a$var$MIN_LOOKAHEAD = $fc8941aa2060205a$var$MAX_MATCH + $fc8941aa2060205a$var$MIN_MATCH + 1;
var $fc8941aa2060205a$var$PRESET_DICT = 0x20;
var $fc8941aa2060205a$var$INIT_STATE = 42;
var $fc8941aa2060205a$var$EXTRA_STATE = 69;
var $fc8941aa2060205a$var$NAME_STATE = 73;
var $fc8941aa2060205a$var$COMMENT_STATE = 91;
var $fc8941aa2060205a$var$HCRC_STATE = 103;
var $fc8941aa2060205a$var$BUSY_STATE = 113;
var $fc8941aa2060205a$var$FINISH_STATE = 666;
var $fc8941aa2060205a$var$BS_NEED_MORE = 1; /* block not completed, need more input or more output */ 
var $fc8941aa2060205a$var$BS_BLOCK_DONE = 2; /* block flush performed */ 
var $fc8941aa2060205a$var$BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */ 
var $fc8941aa2060205a$var$BS_FINISH_DONE = 4; /* finish done, accept no more input or output */ 
var $fc8941aa2060205a$var$OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
function $fc8941aa2060205a$var$err(strm, errorCode) {
    strm.msg = $54a63c0c56b6e112$exports[errorCode];
    return errorCode;
}
function $fc8941aa2060205a$var$rank(f) {
    return (f << 1) - (f > 4 ? 9 : 0);
}
function $fc8941aa2060205a$var$zero(buf) {
    var len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
/* =========================================================================
 * Flush as much pending output as possible. All deflate() output goes
 * through this function so some applications may wish to modify it
 * to avoid allocating a large strm->output buffer and copying into it.
 * (See also read_buf()).
 */ function $fc8941aa2060205a$var$flush_pending(strm) {
    var s = strm.state;
    //_tr_flush_bits(s);
    var len = s.pending;
    if (len > strm.avail_out) len = strm.avail_out;
    if (len === 0) return;
    $701cc75d47025217$exports.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
    strm.next_out += len;
    s.pending_out += len;
    strm.total_out += len;
    strm.avail_out -= len;
    s.pending -= len;
    if (s.pending === 0) s.pending_out = 0;
}
function $fc8941aa2060205a$var$flush_block_only(s, last) {
    $cc3a58b664fcb155$export$44f15b52eef0cf41(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last);
    s.block_start = s.strstart;
    $fc8941aa2060205a$var$flush_pending(s.strm);
}
function $fc8941aa2060205a$var$put_byte(s, b) {
    s.pending_buf[s.pending++] = b;
}
/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */ function $fc8941aa2060205a$var$putShortMSB(s, b) {
    //  put_byte(s, (Byte)(b >> 8));
    //  put_byte(s, (Byte)(b & 0xff));
    s.pending_buf[s.pending++] = b >>> 8 & 0xff;
    s.pending_buf[s.pending++] = b & 0xff;
}
/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */ function $fc8941aa2060205a$var$read_buf(strm, buf, start, size) {
    var len = strm.avail_in;
    if (len > size) len = size;
    if (len === 0) return 0;
    strm.avail_in -= len;
    // zmemcpy(buf, strm->next_in, len);
    $701cc75d47025217$exports.arraySet(buf, strm.input, strm.next_in, len, start);
    if (strm.state.wrap === 1) strm.adler = $c2fc869ba2d0859c$exports(strm.adler, buf, len, start);
    else if (strm.state.wrap === 2) strm.adler = $44e7d98dd6723a9a$exports(strm.adler, buf, len, start);
    strm.next_in += len;
    strm.total_in += len;
    return len;
}
/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */ function $fc8941aa2060205a$var$longest_match(s, cur_match) {
    var chain_length = s.max_chain_length; /* max hash chain length */ 
    var scan = s.strstart; /* current string */ 
    var match; /* matched string */ 
    var len; /* length of current match */ 
    var best_len = s.prev_length; /* best match length so far */ 
    var nice_match = s.nice_match; /* stop if match long enough */ 
    var limit = s.strstart > s.w_size - $fc8941aa2060205a$var$MIN_LOOKAHEAD ? s.strstart - (s.w_size - $fc8941aa2060205a$var$MIN_LOOKAHEAD) : 0 /*NIL*/ ;
    var _win = s.window; // shortcut
    var wmask = s.w_mask;
    var prev = s.prev;
    /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */ var strend = s.strstart + $fc8941aa2060205a$var$MAX_MATCH;
    var scan_end1 = _win[scan + best_len - 1];
    var scan_end = _win[scan + best_len];
    /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */ // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
    /* Do not waste too much time if we already have a good match: */ if (s.prev_length >= s.good_match) chain_length >>= 2;
    /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */ if (nice_match > s.lookahead) nice_match = s.lookahead;
    // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
    do {
        // Assert(cur_match < s->strstart, "no future");
        match = cur_match;
        /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */ if (_win[match + best_len] !== scan_end || _win[match + best_len - 1] !== scan_end1 || _win[match] !== _win[scan] || _win[++match] !== _win[scan + 1]) continue;
        /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */ scan += 2;
        match++;
        // Assert(*scan == *match, "match[2]?");
        /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */ do ;
        while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && scan < strend);
        // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
        len = $fc8941aa2060205a$var$MAX_MATCH - (strend - scan);
        scan = strend - $fc8941aa2060205a$var$MAX_MATCH;
        if (len > best_len) {
            s.match_start = cur_match;
            best_len = len;
            if (len >= nice_match) break;
            scan_end1 = _win[scan + best_len - 1];
            scan_end = _win[scan + best_len];
        }
    }while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
    if (best_len <= s.lookahead) return best_len;
    return s.lookahead;
}
/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */ function $fc8941aa2060205a$var$fill_window(s) {
    var _w_size = s.w_size;
    var p, n, m, more, str;
    //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
    do {
        more = s.window_size - s.lookahead - s.strstart;
        // JS ints have 32 bit, block below not needed
        /* Deal with !@#$% 64K limit: */ //if (sizeof(int) <= 2) {
        //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
        //        more = wsize;
        //
        //  } else if (more == (unsigned)(-1)) {
        //        /* Very unlikely, but possible on 16 bit machine if
        //         * strstart == 0 && lookahead == 1 (input done a byte at time)
        //         */
        //        more--;
        //    }
        //}
        /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */ if (s.strstart >= _w_size + (_w_size - $fc8941aa2060205a$var$MIN_LOOKAHEAD)) {
            $701cc75d47025217$exports.arraySet(s.window, s.window, _w_size, _w_size, 0);
            s.match_start -= _w_size;
            s.strstart -= _w_size;
            /* we now have strstart >= MAX_DIST */ s.block_start -= _w_size;
            /* Slide the hash table (could be avoided with 32 bit values
       at the expense of memory usage). We slide even when level == 0
       to keep the hash table consistent if we switch back to level > 0
       later. (Using level 0 permanently is not an optimal usage of
       zlib, so we don't care about this pathological case.)
       */ n = s.hash_size;
            p = n;
            do {
                m = s.head[--p];
                s.head[p] = m >= _w_size ? m - _w_size : 0;
            }while (--n);
            n = _w_size;
            p = n;
            do {
                m = s.prev[--p];
                s.prev[p] = m >= _w_size ? m - _w_size : 0;
            /* If n is not on any hash chain, prev[n] is garbage but
         * its value will never be used.
         */ }while (--n);
            more += _w_size;
        }
        if (s.strm.avail_in === 0) break;
        /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */ //Assert(more >= 2, "more < 2");
        n = $fc8941aa2060205a$var$read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
        s.lookahead += n;
        /* Initialize the hash value now that we have some input: */ if (s.lookahead + s.insert >= $fc8941aa2060205a$var$MIN_MATCH) {
            str = s.strstart - s.insert;
            s.ins_h = s.window[str];
            /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + 1]) & s.hash_mask;
            //#if MIN_MATCH != 3
            //        Call update_hash() MIN_MATCH-3 more times
            //#endif
            while(s.insert){
                /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + $fc8941aa2060205a$var$MIN_MATCH - 1]) & s.hash_mask;
                s.prev[str & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = str;
                str++;
                s.insert--;
                if (s.lookahead + s.insert < $fc8941aa2060205a$var$MIN_MATCH) break;
            }
        }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */ }while (s.lookahead < $fc8941aa2060205a$var$MIN_LOOKAHEAD && s.strm.avail_in !== 0);
/* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */ //  if (s.high_water < s.window_size) {
//    var curr = s.strstart + s.lookahead;
//    var init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
}
/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 * This function does not insert new strings in the dictionary since
 * uncompressible data is probably not useful. This function is used
 * only for the level=0 compression option.
 * NOTE: this function should be optimized to avoid extra copying from
 * window to pending_buf.
 */ function $fc8941aa2060205a$var$deflate_stored(s, flush) {
    /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
   * to pending_buf_size, and each stored block has a 5 byte header:
   */ var max_block_size = 0xffff;
    if (max_block_size > s.pending_buf_size - 5) max_block_size = s.pending_buf_size - 5;
    /* Copy as much as possible from input to output: */ for(;;){
        /* Fill the window as much as possible: */ if (s.lookahead <= 1) {
            //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
            //  s->block_start >= (long)s->w_size, "slide too late");
            //      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
            //        s.block_start >= s.w_size)) {
            //        throw  new Error("slide too late");
            //      }
            $fc8941aa2060205a$var$fill_window(s);
            if (s.lookahead === 0 && flush === $fc8941aa2060205a$var$Z_NO_FLUSH) return $fc8941aa2060205a$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
        /* flush the current block */ }
        //Assert(s->block_start >= 0L, "block gone");
        //    if (s.block_start < 0) throw new Error("block gone");
        s.strstart += s.lookahead;
        s.lookahead = 0;
        /* Emit a stored block if pending_buf will be full: */ var max_start = s.block_start + max_block_size;
        if (s.strstart === 0 || s.strstart >= max_start) {
            /* strstart == 0 is possible when wraparound on 16-bit machine */ s.lookahead = s.strstart - max_start;
            s.strstart = max_start;
            /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
        /***/ }
        /* Flush if we may have to slide, otherwise block_start may become
     * negative and the data will be gone:
     */ if (s.strstart - s.block_start >= s.w_size - $fc8941aa2060205a$var$MIN_LOOKAHEAD) {
            /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $fc8941aa2060205a$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $fc8941aa2060205a$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_FINISH_STARTED;
        /***/ return $fc8941aa2060205a$var$BS_FINISH_DONE;
    }
    if (s.strstart > s.block_start) {
        /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
    /***/ }
    return $fc8941aa2060205a$var$BS_NEED_MORE;
}
/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */ function $fc8941aa2060205a$var$deflate_fast(s, flush) {
    var hash_head; /* head of the hash chain */ 
    var bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $fc8941aa2060205a$var$MIN_LOOKAHEAD) {
            $fc8941aa2060205a$var$fill_window(s);
            if (s.lookahead < $fc8941aa2060205a$var$MIN_LOOKAHEAD && flush === $fc8941aa2060205a$var$Z_NO_FLUSH) return $fc8941aa2060205a$var$BS_NEED_MORE;
            if (s.lookahead === 0) break; /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $fc8941aa2060205a$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $fc8941aa2060205a$var$MIN_MATCH - 1]) & s.hash_mask;
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */ if (hash_head !== 0 /*NIL*/  && s.strstart - hash_head <= s.w_size - $fc8941aa2060205a$var$MIN_LOOKAHEAD) /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $fc8941aa2060205a$var$longest_match(s, hash_head);
        if (s.match_length >= $fc8941aa2060205a$var$MIN_MATCH) {
            // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
            /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/ bflush = $cc3a58b664fcb155$export$b3cbce147289408f(s, s.strstart - s.match_start, s.match_length - $fc8941aa2060205a$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */ if (s.match_length <= s.max_lazy_match /*max_insert_length*/  && s.lookahead >= $fc8941aa2060205a$var$MIN_MATCH) {
                s.match_length--; /* string at strstart already in table */ 
                do {
                    s.strstart++;
                    /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $fc8941aa2060205a$var$MIN_MATCH - 1]) & s.hash_mask;
                    hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                    s.head[s.ins_h] = s.strstart;
                /***/ /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */ }while (--s.match_length !== 0);
                s.strstart++;
            } else {
                s.strstart += s.match_length;
                s.match_length = 0;
                s.ins_h = s.window[s.strstart];
                /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + 1]) & s.hash_mask;
            //#if MIN_MATCH != 3
            //                Call UPDATE_HASH() MIN_MATCH-3 more times
            //#endif
            /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */ }
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s.window[s.strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $cc3a58b664fcb155$export$b3cbce147289408f(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = s.strstart < $fc8941aa2060205a$var$MIN_MATCH - 1 ? s.strstart : $fc8941aa2060205a$var$MIN_MATCH - 1;
    if (flush === $fc8941aa2060205a$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $fc8941aa2060205a$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_FINISH_STARTED;
        /***/ return $fc8941aa2060205a$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
    /***/ }
    return $fc8941aa2060205a$var$BS_BLOCK_DONE;
}
/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */ function $fc8941aa2060205a$var$deflate_slow(s, flush) {
    var hash_head; /* head of hash chain */ 
    var bflush; /* set if current block must be flushed */ 
    var max_insert;
    /* Process the input block. */ for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $fc8941aa2060205a$var$MIN_LOOKAHEAD) {
            $fc8941aa2060205a$var$fill_window(s);
            if (s.lookahead < $fc8941aa2060205a$var$MIN_LOOKAHEAD && flush === $fc8941aa2060205a$var$Z_NO_FLUSH) return $fc8941aa2060205a$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $fc8941aa2060205a$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $fc8941aa2060205a$var$MIN_MATCH - 1]) & s.hash_mask;
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     */ s.prev_length = s.match_length;
        s.prev_match = s.match_start;
        s.match_length = $fc8941aa2060205a$var$MIN_MATCH - 1;
        if (hash_head !== 0 /*NIL*/  && s.prev_length < s.max_lazy_match && s.strstart - hash_head <= s.w_size - $fc8941aa2060205a$var$MIN_LOOKAHEAD) {
            /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $fc8941aa2060205a$var$longest_match(s, hash_head);
            /* longest_match() sets match_start */ if (s.match_length <= 5 && (s.strategy === $fc8941aa2060205a$var$Z_FILTERED || s.match_length === $fc8941aa2060205a$var$MIN_MATCH && s.strstart - s.match_start > 4096 /*TOO_FAR*/ )) /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */ s.match_length = $fc8941aa2060205a$var$MIN_MATCH - 1;
        }
        /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */ if (s.prev_length >= $fc8941aa2060205a$var$MIN_MATCH && s.match_length <= s.prev_length) {
            max_insert = s.strstart + s.lookahead - $fc8941aa2060205a$var$MIN_MATCH;
            /* Do not insert strings in hash table beyond this. */ //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
            /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/ bflush = $cc3a58b664fcb155$export$b3cbce147289408f(s, s.strstart - 1 - s.prev_match, s.prev_length - $fc8941aa2060205a$var$MIN_MATCH);
            /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */ s.lookahead -= s.prev_length - 1;
            s.prev_length -= 2;
            do if (++s.strstart <= max_insert) {
                /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $fc8941aa2060205a$var$MIN_MATCH - 1]) & s.hash_mask;
                hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = s.strstart;
            /***/ }
            while (--s.prev_length !== 0);
            s.match_available = 0;
            s.match_length = $fc8941aa2060205a$var$MIN_MATCH - 1;
            s.strstart++;
            if (bflush) {
                /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
                if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
            /***/ }
        } else if (s.match_available) {
            /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */ //Tracevv((stderr,"%c", s->window[s->strstart-1]));
            /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $cc3a58b664fcb155$export$b3cbce147289408f(s, 0, s.window[s.strstart - 1]);
            if (bflush) /*** FLUSH_BLOCK_ONLY(s, 0) ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
            s.strstart++;
            s.lookahead--;
            if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
        } else {
            /* There is no previous match to compare with, wait for
       * the next step to decide.
       */ s.match_available = 1;
            s.strstart++;
            s.lookahead--;
        }
    }
    //Assert (flush != Z_NO_FLUSH, "no flush?");
    if (s.match_available) {
        //Tracevv((stderr,"%c", s->window[s->strstart-1]));
        /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $cc3a58b664fcb155$export$b3cbce147289408f(s, 0, s.window[s.strstart - 1]);
        s.match_available = 0;
    }
    s.insert = s.strstart < $fc8941aa2060205a$var$MIN_MATCH - 1 ? s.strstart : $fc8941aa2060205a$var$MIN_MATCH - 1;
    if (flush === $fc8941aa2060205a$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $fc8941aa2060205a$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_FINISH_STARTED;
        /***/ return $fc8941aa2060205a$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
    /***/ }
    return $fc8941aa2060205a$var$BS_BLOCK_DONE;
}
/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */ function $fc8941aa2060205a$var$deflate_rle(s, flush) {
    var bflush; /* set if current block must be flushed */ 
    var prev; /* byte at distance one to match */ 
    var scan, strend; /* scan goes up to strend for length of run */ 
    var _win = s.window;
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */ if (s.lookahead <= $fc8941aa2060205a$var$MAX_MATCH) {
            $fc8941aa2060205a$var$fill_window(s);
            if (s.lookahead <= $fc8941aa2060205a$var$MAX_MATCH && flush === $fc8941aa2060205a$var$Z_NO_FLUSH) return $fc8941aa2060205a$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* See how many times the previous byte repeats */ s.match_length = 0;
        if (s.lookahead >= $fc8941aa2060205a$var$MIN_MATCH && s.strstart > 0) {
            scan = s.strstart - 1;
            prev = _win[scan];
            if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
                strend = s.strstart + $fc8941aa2060205a$var$MAX_MATCH;
                do ;
                while (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && scan < strend);
                s.match_length = $fc8941aa2060205a$var$MAX_MATCH - (strend - scan);
                if (s.match_length > s.lookahead) s.match_length = s.lookahead;
            }
        //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
        }
        /* Emit match if have run of MIN_MATCH or longer, else emit literal */ if (s.match_length >= $fc8941aa2060205a$var$MIN_MATCH) {
            //check_match(s, s.strstart, s.strstart - 1, s.match_length);
            /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/ bflush = $cc3a58b664fcb155$export$b3cbce147289408f(s, 1, s.match_length - $fc8941aa2060205a$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            s.strstart += s.match_length;
            s.match_length = 0;
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s->window[s->strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $cc3a58b664fcb155$export$b3cbce147289408f(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $fc8941aa2060205a$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $fc8941aa2060205a$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_FINISH_STARTED;
        /***/ return $fc8941aa2060205a$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
    /***/ }
    return $fc8941aa2060205a$var$BS_BLOCK_DONE;
}
/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */ function $fc8941aa2060205a$var$deflate_huff(s, flush) {
    var bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we have a literal to write. */ if (s.lookahead === 0) {
            $fc8941aa2060205a$var$fill_window(s);
            if (s.lookahead === 0) {
                if (flush === $fc8941aa2060205a$var$Z_NO_FLUSH) return $fc8941aa2060205a$var$BS_NEED_MORE;
                break; /* flush the current block */ 
            }
        }
        /* Output a literal byte */ s.match_length = 0;
        //Tracevv((stderr,"%c", s->window[s->strstart]));
        /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $cc3a58b664fcb155$export$b3cbce147289408f(s, 0, s.window[s.strstart]);
        s.lookahead--;
        s.strstart++;
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $fc8941aa2060205a$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $fc8941aa2060205a$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_FINISH_STARTED;
        /***/ return $fc8941aa2060205a$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $fc8941aa2060205a$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $fc8941aa2060205a$var$BS_NEED_MORE;
    /***/ }
    return $fc8941aa2060205a$var$BS_BLOCK_DONE;
}
/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */ function $fc8941aa2060205a$var$Config(good_length, max_lazy, nice_length, max_chain, func) {
    this.good_length = good_length;
    this.max_lazy = max_lazy;
    this.nice_length = nice_length;
    this.max_chain = max_chain;
    this.func = func;
}
var $fc8941aa2060205a$var$configuration_table;
$fc8941aa2060205a$var$configuration_table = [
    /*      good lazy nice chain */ new $fc8941aa2060205a$var$Config(0, 0, 0, 0, $fc8941aa2060205a$var$deflate_stored),
    /* 0 store only */ new $fc8941aa2060205a$var$Config(4, 4, 8, 4, $fc8941aa2060205a$var$deflate_fast),
    /* 1 max speed, no lazy matches */ new $fc8941aa2060205a$var$Config(4, 5, 16, 8, $fc8941aa2060205a$var$deflate_fast),
    /* 2 */ new $fc8941aa2060205a$var$Config(4, 6, 32, 32, $fc8941aa2060205a$var$deflate_fast),
    /* 3 */ new $fc8941aa2060205a$var$Config(4, 4, 16, 16, $fc8941aa2060205a$var$deflate_slow),
    /* 4 lazy matches */ new $fc8941aa2060205a$var$Config(8, 16, 32, 32, $fc8941aa2060205a$var$deflate_slow),
    /* 5 */ new $fc8941aa2060205a$var$Config(8, 16, 128, 128, $fc8941aa2060205a$var$deflate_slow),
    /* 6 */ new $fc8941aa2060205a$var$Config(8, 32, 128, 256, $fc8941aa2060205a$var$deflate_slow),
    /* 7 */ new $fc8941aa2060205a$var$Config(32, 128, 258, 1024, $fc8941aa2060205a$var$deflate_slow),
    /* 8 */ new $fc8941aa2060205a$var$Config(32, 258, 258, 4096, $fc8941aa2060205a$var$deflate_slow)
];
/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */ function $fc8941aa2060205a$var$lm_init(s) {
    s.window_size = 2 * s.w_size;
    /*** CLEAR_HASH(s); ***/ $fc8941aa2060205a$var$zero(s.head); // Fill with NIL (= 0);
    /* Set the default configuration parameters:
   */ s.max_lazy_match = $fc8941aa2060205a$var$configuration_table[s.level].max_lazy;
    s.good_match = $fc8941aa2060205a$var$configuration_table[s.level].good_length;
    s.nice_match = $fc8941aa2060205a$var$configuration_table[s.level].nice_length;
    s.max_chain_length = $fc8941aa2060205a$var$configuration_table[s.level].max_chain;
    s.strstart = 0;
    s.block_start = 0;
    s.lookahead = 0;
    s.insert = 0;
    s.match_length = s.prev_length = $fc8941aa2060205a$var$MIN_MATCH - 1;
    s.match_available = 0;
    s.ins_h = 0;
}
function $fc8941aa2060205a$var$DeflateState() {
    this.strm = null; /* pointer back to this zlib stream */ 
    this.status = 0; /* as the name implies */ 
    this.pending_buf = null; /* output still pending */ 
    this.pending_buf_size = 0; /* size of pending_buf */ 
    this.pending_out = 0; /* next pending byte to output to the stream */ 
    this.pending = 0; /* nb of bytes in the pending buffer */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.gzhead = null; /* gzip header information to write */ 
    this.gzindex = 0; /* where in extra, name, or comment */ 
    this.method = $fc8941aa2060205a$var$Z_DEFLATED; /* can only be DEFLATED */ 
    this.last_flush = -1; /* value of flush param for previous deflate call */ 
    this.w_size = 0; /* LZ77 window size (32K by default) */ 
    this.w_bits = 0; /* log2(w_size)  (8..16) */ 
    this.w_mask = 0; /* w_size - 1 */ 
    this.window = null;
    /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */ this.window_size = 0;
    /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */ this.prev = null;
    /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */ this.head = null; /* Heads of the hash chains or NIL. */ 
    this.ins_h = 0; /* hash index of string to be inserted */ 
    this.hash_size = 0; /* number of elements in hash table */ 
    this.hash_bits = 0; /* log2(hash_size) */ 
    this.hash_mask = 0; /* hash_size-1 */ 
    this.hash_shift = 0;
    /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */ this.block_start = 0;
    /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */ this.match_length = 0; /* length of best match */ 
    this.prev_match = 0; /* previous match */ 
    this.match_available = 0; /* set if previous match exists */ 
    this.strstart = 0; /* start of string to insert */ 
    this.match_start = 0; /* start of matching string */ 
    this.lookahead = 0; /* number of valid bytes ahead in window */ 
    this.prev_length = 0;
    /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */ this.max_chain_length = 0;
    /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */ this.max_lazy_match = 0;
    /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */ // That's alias to max_lazy_match, don't use directly
    //this.max_insert_length = 0;
    /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */ this.level = 0; /* compression level (1..9) */ 
    this.strategy = 0; /* favor or force Huffman coding*/ 
    this.good_match = 0;
    /* Use a faster search when the previous match is longer than this */ this.nice_match = 0; /* Stop searching when current match exceeds this */ 
    /* used by trees.c: */ /* Didn't use ct_data typedef below to suppress compiler warning */ // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
    // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
    // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
    // Use flat array of DOUBLE size, with interleaved fata,
    // because JS does not support effective
    this.dyn_ltree = new $701cc75d47025217$exports.Buf16($fc8941aa2060205a$var$HEAP_SIZE * 2);
    this.dyn_dtree = new $701cc75d47025217$exports.Buf16((2 * $fc8941aa2060205a$var$D_CODES + 1) * 2);
    this.bl_tree = new $701cc75d47025217$exports.Buf16((2 * $fc8941aa2060205a$var$BL_CODES + 1) * 2);
    $fc8941aa2060205a$var$zero(this.dyn_ltree);
    $fc8941aa2060205a$var$zero(this.dyn_dtree);
    $fc8941aa2060205a$var$zero(this.bl_tree);
    this.l_desc = null; /* desc. for literal tree */ 
    this.d_desc = null; /* desc. for distance tree */ 
    this.bl_desc = null; /* desc. for bit length tree */ 
    //ush bl_count[MAX_BITS+1];
    this.bl_count = new $701cc75d47025217$exports.Buf16($fc8941aa2060205a$var$MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
    this.heap = new $701cc75d47025217$exports.Buf16(2 * $fc8941aa2060205a$var$L_CODES + 1); /* heap used to build the Huffman trees */ 
    $fc8941aa2060205a$var$zero(this.heap);
    this.heap_len = 0; /* number of elements in the heap */ 
    this.heap_max = 0; /* element of largest frequency */ 
    /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */ this.depth = new $701cc75d47025217$exports.Buf16(2 * $fc8941aa2060205a$var$L_CODES + 1); //uch depth[2*L_CODES+1];
    $fc8941aa2060205a$var$zero(this.depth);
    /* Depth of each subtree used as tie breaker for trees of equal frequency
   */ this.l_buf = 0; /* buffer index for literals or lengths */ 
    this.lit_bufsize = 0;
    /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */ this.last_lit = 0; /* running index in l_buf */ 
    this.d_buf = 0;
    /* Buffer index for distances. To simplify the code, d_buf and l_buf have
   * the same number of elements. To use different lengths, an extra flag
   * array would be necessary.
   */ this.opt_len = 0; /* bit length of current block with optimal trees */ 
    this.static_len = 0; /* bit length of current block with static trees */ 
    this.matches = 0; /* number of string matches in current block */ 
    this.insert = 0; /* bytes at end of window left to insert */ 
    this.bi_buf = 0;
    /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */ this.bi_valid = 0;
/* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */ // Used for window memory init. We safely ignore it for JS. That makes
// sense only for pointers and memory check tools.
//this.high_water = 0;
/* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */ }
function $fc8941aa2060205a$var$deflateResetKeep(strm) {
    var s;
    if (!strm || !strm.state) return $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$var$Z_STREAM_ERROR);
    strm.total_in = strm.total_out = 0;
    strm.data_type = $fc8941aa2060205a$var$Z_UNKNOWN;
    s = strm.state;
    s.pending = 0;
    s.pending_out = 0;
    if (s.wrap < 0) s.wrap = -s.wrap;
    s.status = s.wrap ? $fc8941aa2060205a$var$INIT_STATE : $fc8941aa2060205a$var$BUSY_STATE;
    strm.adler = s.wrap === 2 ? 0 // crc32(0, Z_NULL, 0)
     : 1; // adler32(0, Z_NULL, 0)
    s.last_flush = $fc8941aa2060205a$var$Z_NO_FLUSH;
    $cc3a58b664fcb155$export$4e4fc0157c3cd14d(s);
    return $fc8941aa2060205a$var$Z_OK;
}
function $fc8941aa2060205a$var$deflateReset(strm) {
    var ret = $fc8941aa2060205a$var$deflateResetKeep(strm);
    if (ret === $fc8941aa2060205a$var$Z_OK) $fc8941aa2060205a$var$lm_init(strm.state);
    return ret;
}
function $fc8941aa2060205a$var$deflateSetHeader(strm, head) {
    if (!strm || !strm.state) return $fc8941aa2060205a$var$Z_STREAM_ERROR;
    if (strm.state.wrap !== 2) return $fc8941aa2060205a$var$Z_STREAM_ERROR;
    strm.state.gzhead = head;
    return $fc8941aa2060205a$var$Z_OK;
}
function $fc8941aa2060205a$var$deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
    if (!strm) return $fc8941aa2060205a$var$Z_STREAM_ERROR;
    var wrap = 1;
    if (level === $fc8941aa2060205a$var$Z_DEFAULT_COMPRESSION) level = 6;
    if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else if (windowBits > 15) {
        wrap = 2; /* write gzip wrapper instead */ 
        windowBits -= 16;
    }
    if (memLevel < 1 || memLevel > $fc8941aa2060205a$var$MAX_MEM_LEVEL || method !== $fc8941aa2060205a$var$Z_DEFLATED || windowBits < 8 || windowBits > 15 || level < 0 || level > 9 || strategy < 0 || strategy > $fc8941aa2060205a$var$Z_FIXED) return $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$var$Z_STREAM_ERROR);
    if (windowBits === 8) windowBits = 9;
    /* until 256-byte window bug fixed */ var s = new $fc8941aa2060205a$var$DeflateState();
    strm.state = s;
    s.strm = strm;
    s.wrap = wrap;
    s.gzhead = null;
    s.w_bits = windowBits;
    s.w_size = 1 << s.w_bits;
    s.w_mask = s.w_size - 1;
    s.hash_bits = memLevel + 7;
    s.hash_size = 1 << s.hash_bits;
    s.hash_mask = s.hash_size - 1;
    s.hash_shift = ~~((s.hash_bits + $fc8941aa2060205a$var$MIN_MATCH - 1) / $fc8941aa2060205a$var$MIN_MATCH);
    s.window = new $701cc75d47025217$exports.Buf8(s.w_size * 2);
    s.head = new $701cc75d47025217$exports.Buf16(s.hash_size);
    s.prev = new $701cc75d47025217$exports.Buf16(s.w_size);
    // Don't need mem init magic for JS.
    //s.high_water = 0;  /* nothing written to s->window yet */
    s.lit_bufsize = 1 << memLevel + 6; /* 16K elements by default */ 
    s.pending_buf_size = s.lit_bufsize * 4;
    //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
    //s->pending_buf = (uchf *) overlay;
    s.pending_buf = new $701cc75d47025217$exports.Buf8(s.pending_buf_size);
    // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
    //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
    s.d_buf = 1 * s.lit_bufsize;
    //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
    s.l_buf = 3 * s.lit_bufsize;
    s.level = level;
    s.strategy = strategy;
    s.method = method;
    return $fc8941aa2060205a$var$deflateReset(strm);
}
function $fc8941aa2060205a$var$deflateInit(strm, level) {
    return $fc8941aa2060205a$var$deflateInit2(strm, level, $fc8941aa2060205a$var$Z_DEFLATED, $fc8941aa2060205a$var$MAX_WBITS, $fc8941aa2060205a$var$DEF_MEM_LEVEL, $fc8941aa2060205a$var$Z_DEFAULT_STRATEGY);
}
function $fc8941aa2060205a$var$deflate(strm, flush) {
    var old_flush, s;
    var beg, val; // for gzip header write only
    if (!strm || !strm.state || flush > $fc8941aa2060205a$var$Z_BLOCK || flush < 0) return strm ? $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$var$Z_STREAM_ERROR) : $fc8941aa2060205a$var$Z_STREAM_ERROR;
    s = strm.state;
    if (!strm.output || !strm.input && strm.avail_in !== 0 || s.status === $fc8941aa2060205a$var$FINISH_STATE && flush !== $fc8941aa2060205a$var$Z_FINISH) return $fc8941aa2060205a$var$err(strm, strm.avail_out === 0 ? $fc8941aa2060205a$var$Z_BUF_ERROR : $fc8941aa2060205a$var$Z_STREAM_ERROR);
    s.strm = strm; /* just in case */ 
    old_flush = s.last_flush;
    s.last_flush = flush;
    /* Write the header */ if (s.status === $fc8941aa2060205a$var$INIT_STATE) {
        if (s.wrap === 2) {
            strm.adler = 0; //crc32(0L, Z_NULL, 0);
            $fc8941aa2060205a$var$put_byte(s, 31);
            $fc8941aa2060205a$var$put_byte(s, 139);
            $fc8941aa2060205a$var$put_byte(s, 8);
            if (!s.gzhead) {
                $fc8941aa2060205a$var$put_byte(s, 0);
                $fc8941aa2060205a$var$put_byte(s, 0);
                $fc8941aa2060205a$var$put_byte(s, 0);
                $fc8941aa2060205a$var$put_byte(s, 0);
                $fc8941aa2060205a$var$put_byte(s, 0);
                $fc8941aa2060205a$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $fc8941aa2060205a$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                $fc8941aa2060205a$var$put_byte(s, $fc8941aa2060205a$var$OS_CODE);
                s.status = $fc8941aa2060205a$var$BUSY_STATE;
            } else {
                $fc8941aa2060205a$var$put_byte(s, (s.gzhead.text ? 1 : 0) + (s.gzhead.hcrc ? 2 : 0) + (!s.gzhead.extra ? 0 : 4) + (!s.gzhead.name ? 0 : 8) + (!s.gzhead.comment ? 0 : 16));
                $fc8941aa2060205a$var$put_byte(s, s.gzhead.time & 0xff);
                $fc8941aa2060205a$var$put_byte(s, s.gzhead.time >> 8 & 0xff);
                $fc8941aa2060205a$var$put_byte(s, s.gzhead.time >> 16 & 0xff);
                $fc8941aa2060205a$var$put_byte(s, s.gzhead.time >> 24 & 0xff);
                $fc8941aa2060205a$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $fc8941aa2060205a$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                $fc8941aa2060205a$var$put_byte(s, s.gzhead.os & 0xff);
                if (s.gzhead.extra && s.gzhead.extra.length) {
                    $fc8941aa2060205a$var$put_byte(s, s.gzhead.extra.length & 0xff);
                    $fc8941aa2060205a$var$put_byte(s, s.gzhead.extra.length >> 8 & 0xff);
                }
                if (s.gzhead.hcrc) strm.adler = $44e7d98dd6723a9a$exports(strm.adler, s.pending_buf, s.pending, 0);
                s.gzindex = 0;
                s.status = $fc8941aa2060205a$var$EXTRA_STATE;
            }
        } else {
            var header = $fc8941aa2060205a$var$Z_DEFLATED + (s.w_bits - 8 << 4) << 8;
            var level_flags = -1;
            if (s.strategy >= $fc8941aa2060205a$var$Z_HUFFMAN_ONLY || s.level < 2) level_flags = 0;
            else if (s.level < 6) level_flags = 1;
            else if (s.level === 6) level_flags = 2;
            else level_flags = 3;
            header |= level_flags << 6;
            if (s.strstart !== 0) header |= $fc8941aa2060205a$var$PRESET_DICT;
            header += 31 - header % 31;
            s.status = $fc8941aa2060205a$var$BUSY_STATE;
            $fc8941aa2060205a$var$putShortMSB(s, header);
            /* Save the adler32 of the preset dictionary: */ if (s.strstart !== 0) {
                $fc8941aa2060205a$var$putShortMSB(s, strm.adler >>> 16);
                $fc8941aa2060205a$var$putShortMSB(s, strm.adler & 0xffff);
            }
            strm.adler = 1; // adler32(0L, Z_NULL, 0);
        }
    }
    //#ifdef GZIP
    if (s.status === $fc8941aa2060205a$var$EXTRA_STATE) {
        if (s.gzhead.extra /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            while(s.gzindex < (s.gzhead.extra.length & 0xffff)){
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $44e7d98dd6723a9a$exports(strm.adler, s.pending_buf, s.pending - beg, beg);
                    $fc8941aa2060205a$var$flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) break;
                }
                $fc8941aa2060205a$var$put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
                s.gzindex++;
            }
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $44e7d98dd6723a9a$exports(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (s.gzindex === s.gzhead.extra.length) {
                s.gzindex = 0;
                s.status = $fc8941aa2060205a$var$NAME_STATE;
            }
        } else s.status = $fc8941aa2060205a$var$NAME_STATE;
    }
    if (s.status === $fc8941aa2060205a$var$NAME_STATE) {
        if (s.gzhead.name /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            //int val;
            do {
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $44e7d98dd6723a9a$exports(strm.adler, s.pending_buf, s.pending - beg, beg);
                    $fc8941aa2060205a$var$flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) {
                        val = 1;
                        break;
                    }
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.name.length) val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $fc8941aa2060205a$var$put_byte(s, val);
            }while (val !== 0);
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $44e7d98dd6723a9a$exports(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (val === 0) {
                s.gzindex = 0;
                s.status = $fc8941aa2060205a$var$COMMENT_STATE;
            }
        } else s.status = $fc8941aa2060205a$var$COMMENT_STATE;
    }
    if (s.status === $fc8941aa2060205a$var$COMMENT_STATE) {
        if (s.gzhead.comment /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            //int val;
            do {
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $44e7d98dd6723a9a$exports(strm.adler, s.pending_buf, s.pending - beg, beg);
                    $fc8941aa2060205a$var$flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) {
                        val = 1;
                        break;
                    }
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.comment.length) val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $fc8941aa2060205a$var$put_byte(s, val);
            }while (val !== 0);
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $44e7d98dd6723a9a$exports(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (val === 0) s.status = $fc8941aa2060205a$var$HCRC_STATE;
        } else s.status = $fc8941aa2060205a$var$HCRC_STATE;
    }
    if (s.status === $fc8941aa2060205a$var$HCRC_STATE) {
        if (s.gzhead.hcrc) {
            if (s.pending + 2 > s.pending_buf_size) $fc8941aa2060205a$var$flush_pending(strm);
            if (s.pending + 2 <= s.pending_buf_size) {
                $fc8941aa2060205a$var$put_byte(s, strm.adler & 0xff);
                $fc8941aa2060205a$var$put_byte(s, strm.adler >> 8 & 0xff);
                strm.adler = 0; //crc32(0L, Z_NULL, 0);
                s.status = $fc8941aa2060205a$var$BUSY_STATE;
            }
        } else s.status = $fc8941aa2060205a$var$BUSY_STATE;
    }
    //#endif
    /* Flush as much pending output as possible */ if (s.pending !== 0) {
        $fc8941aa2060205a$var$flush_pending(strm);
        if (strm.avail_out === 0) {
            /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */ s.last_flush = -1;
            return $fc8941aa2060205a$var$Z_OK;
        }
    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */ } else if (strm.avail_in === 0 && $fc8941aa2060205a$var$rank(flush) <= $fc8941aa2060205a$var$rank(old_flush) && flush !== $fc8941aa2060205a$var$Z_FINISH) return $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$var$Z_BUF_ERROR);
    /* User must not provide more input after the first FINISH: */ if (s.status === $fc8941aa2060205a$var$FINISH_STATE && strm.avail_in !== 0) return $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$var$Z_BUF_ERROR);
    /* Start a new block or continue the current one.
   */ if (strm.avail_in !== 0 || s.lookahead !== 0 || flush !== $fc8941aa2060205a$var$Z_NO_FLUSH && s.status !== $fc8941aa2060205a$var$FINISH_STATE) {
        var bstate = s.strategy === $fc8941aa2060205a$var$Z_HUFFMAN_ONLY ? $fc8941aa2060205a$var$deflate_huff(s, flush) : s.strategy === $fc8941aa2060205a$var$Z_RLE ? $fc8941aa2060205a$var$deflate_rle(s, flush) : $fc8941aa2060205a$var$configuration_table[s.level].func(s, flush);
        if (bstate === $fc8941aa2060205a$var$BS_FINISH_STARTED || bstate === $fc8941aa2060205a$var$BS_FINISH_DONE) s.status = $fc8941aa2060205a$var$FINISH_STATE;
        if (bstate === $fc8941aa2060205a$var$BS_NEED_MORE || bstate === $fc8941aa2060205a$var$BS_FINISH_STARTED) {
            if (strm.avail_out === 0) s.last_flush = -1;
            return $fc8941aa2060205a$var$Z_OK;
        /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */ }
        if (bstate === $fc8941aa2060205a$var$BS_BLOCK_DONE) {
            if (flush === $fc8941aa2060205a$var$Z_PARTIAL_FLUSH) $cc3a58b664fcb155$export$bfb360e02ee9b403(s);
            else if (flush !== $fc8941aa2060205a$var$Z_BLOCK) {
                $cc3a58b664fcb155$export$8959e34c5e020172(s, 0, 0, false);
                /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */ if (flush === $fc8941aa2060205a$var$Z_FULL_FLUSH) {
                    /*** CLEAR_HASH(s); ***/ /* forget history */ $fc8941aa2060205a$var$zero(s.head); // Fill with NIL (= 0);
                    if (s.lookahead === 0) {
                        s.strstart = 0;
                        s.block_start = 0;
                        s.insert = 0;
                    }
                }
            }
            $fc8941aa2060205a$var$flush_pending(strm);
            if (strm.avail_out === 0) {
                s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */ 
                return $fc8941aa2060205a$var$Z_OK;
            }
        }
    }
    //Assert(strm->avail_out > 0, "bug2");
    //if (strm.avail_out <= 0) { throw new Error("bug2");}
    if (flush !== $fc8941aa2060205a$var$Z_FINISH) return $fc8941aa2060205a$var$Z_OK;
    if (s.wrap <= 0) return $fc8941aa2060205a$var$Z_STREAM_END;
    /* Write the trailer */ if (s.wrap === 2) {
        $fc8941aa2060205a$var$put_byte(s, strm.adler & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.adler >> 8 & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.adler >> 16 & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.adler >> 24 & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.total_in & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.total_in >> 8 & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.total_in >> 16 & 0xff);
        $fc8941aa2060205a$var$put_byte(s, strm.total_in >> 24 & 0xff);
    } else {
        $fc8941aa2060205a$var$putShortMSB(s, strm.adler >>> 16);
        $fc8941aa2060205a$var$putShortMSB(s, strm.adler & 0xffff);
    }
    $fc8941aa2060205a$var$flush_pending(strm);
    /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */ if (s.wrap > 0) s.wrap = -s.wrap;
    /* write the trailer only once! */ return s.pending !== 0 ? $fc8941aa2060205a$var$Z_OK : $fc8941aa2060205a$var$Z_STREAM_END;
}
function $fc8941aa2060205a$var$deflateEnd(strm) {
    var status;
    if (!strm /*== Z_NULL*/  || !strm.state /*== Z_NULL*/ ) return $fc8941aa2060205a$var$Z_STREAM_ERROR;
    status = strm.state.status;
    if (status !== $fc8941aa2060205a$var$INIT_STATE && status !== $fc8941aa2060205a$var$EXTRA_STATE && status !== $fc8941aa2060205a$var$NAME_STATE && status !== $fc8941aa2060205a$var$COMMENT_STATE && status !== $fc8941aa2060205a$var$HCRC_STATE && status !== $fc8941aa2060205a$var$BUSY_STATE && status !== $fc8941aa2060205a$var$FINISH_STATE) return $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$var$Z_STREAM_ERROR);
    strm.state = null;
    return status === $fc8941aa2060205a$var$BUSY_STATE ? $fc8941aa2060205a$var$err(strm, $fc8941aa2060205a$var$Z_DATA_ERROR) : $fc8941aa2060205a$var$Z_OK;
}
/* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */ function $fc8941aa2060205a$var$deflateSetDictionary(strm, dictionary) {
    var dictLength = dictionary.length;
    var s;
    var str, n;
    var wrap;
    var avail;
    var next;
    var input;
    var tmpDict;
    if (!strm /*== Z_NULL*/  || !strm.state /*== Z_NULL*/ ) return $fc8941aa2060205a$var$Z_STREAM_ERROR;
    s = strm.state;
    wrap = s.wrap;
    if (wrap === 2 || wrap === 1 && s.status !== $fc8941aa2060205a$var$INIT_STATE || s.lookahead) return $fc8941aa2060205a$var$Z_STREAM_ERROR;
    /* when using zlib wrappers, compute Adler-32 for provided dictionary */ if (wrap === 1) /* adler32(strm->adler, dictionary, dictLength); */ strm.adler = $c2fc869ba2d0859c$exports(strm.adler, dictionary, dictLength, 0);
    s.wrap = 0; /* avoid computing Adler-32 in read_buf */ 
    /* if dictionary would fill window, just replace the history */ if (dictLength >= s.w_size) {
        if (wrap === 0) {
            /*** CLEAR_HASH(s); ***/ $fc8941aa2060205a$var$zero(s.head); // Fill with NIL (= 0);
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
        }
        /* use the tail */ // dictionary = dictionary.slice(dictLength - s.w_size);
        tmpDict = new $701cc75d47025217$exports.Buf8(s.w_size);
        $701cc75d47025217$exports.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
        dictionary = tmpDict;
        dictLength = s.w_size;
    }
    /* insert dictionary into window and hash */ avail = strm.avail_in;
    next = strm.next_in;
    input = strm.input;
    strm.avail_in = dictLength;
    strm.next_in = 0;
    strm.input = dictionary;
    $fc8941aa2060205a$var$fill_window(s);
    while(s.lookahead >= $fc8941aa2060205a$var$MIN_MATCH){
        str = s.strstart;
        n = s.lookahead - ($fc8941aa2060205a$var$MIN_MATCH - 1);
        do {
            /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + $fc8941aa2060205a$var$MIN_MATCH - 1]) & s.hash_mask;
            s.prev[str & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = str;
            str++;
        }while (--n);
        s.strstart = str;
        s.lookahead = $fc8941aa2060205a$var$MIN_MATCH - 1;
        $fc8941aa2060205a$var$fill_window(s);
    }
    s.strstart += s.lookahead;
    s.block_start = s.strstart;
    s.insert = s.lookahead;
    s.lookahead = 0;
    s.match_length = s.prev_length = $fc8941aa2060205a$var$MIN_MATCH - 1;
    s.match_available = 0;
    strm.next_in = next;
    strm.input = input;
    strm.avail_in = avail;
    s.wrap = wrap;
    return $fc8941aa2060205a$var$Z_OK;
}
$fc8941aa2060205a$export$72b35d618fb8ad9b = $fc8941aa2060205a$var$deflateInit;
$fc8941aa2060205a$export$a65c7b2bde87cb70 = $fc8941aa2060205a$var$deflateInit2;
$fc8941aa2060205a$export$8f99f0e30bc7dd53 = $fc8941aa2060205a$var$deflateReset;
$fc8941aa2060205a$export$e78fab288549509 = $fc8941aa2060205a$var$deflateResetKeep;
$fc8941aa2060205a$export$1cd50f7b2515ba19 = $fc8941aa2060205a$var$deflateSetHeader;
$fc8941aa2060205a$export$2316623ecd1285ab = $fc8941aa2060205a$var$deflate;
$fc8941aa2060205a$export$599854fa319a815f = $fc8941aa2060205a$var$deflateEnd;
$fc8941aa2060205a$export$f55e0b3ab66b5d46 = $fc8941aa2060205a$var$deflateSetDictionary;
$fc8941aa2060205a$export$12b6e1fcadea22f9 = "pako deflate (from Nodeca project)"; /* Not implemented
exports.deflateBound = deflateBound;
exports.deflateCopy = deflateCopy;
exports.deflateParams = deflateParams;
exports.deflatePending = deflatePending;
exports.deflatePrime = deflatePrime;
exports.deflateTune = deflateTune;
*/ 



// String encode/decode helpers
// convert string to array (typed, when possible)
var $d8cddf31faab2448$export$7a4c1b2f775b5a9f;
// Convert byte array to binary string
var $d8cddf31faab2448$export$a751fe64af8a9a51;
// Convert binary string (typed, when possible)
var $d8cddf31faab2448$export$1d1a7119601ff18c;
// convert array to string
var $d8cddf31faab2448$export$49a50563f377746;
// Calculate max possible position in utf8 buffer,
// that will not break sequence. If that's not possible
// - (very small limits) return max size as is.
//
// buf[] - utf8 bytes array
// max   - length limit (mandatory);
var $d8cddf31faab2448$export$53dee3f58a714214;
"use strict";

// Quick check if we can use fast array to bin string conversion
//
// - apply(Array) can fail on Android 2.2
// - apply(Uint8Array) can fail on iOS 5.1 Safari
//
var $d8cddf31faab2448$var$STR_APPLY_OK = true;
var $d8cddf31faab2448$var$STR_APPLY_UIA_OK = true;
try {
    String.fromCharCode.apply(null, [
        0
    ]);
} catch (__) {
    $d8cddf31faab2448$var$STR_APPLY_OK = false;
}
try {
    String.fromCharCode.apply(null, new Uint8Array(1));
} catch (__) {
    $d8cddf31faab2448$var$STR_APPLY_UIA_OK = false;
}
// Table with utf8 lengths (calculated by first byte of sequence)
// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
// because max possible codepoint is 0x10ffff
var $d8cddf31faab2448$var$_utf8len = new $701cc75d47025217$exports.Buf8(256);
for(var $d8cddf31faab2448$var$q = 0; $d8cddf31faab2448$var$q < 256; $d8cddf31faab2448$var$q++)$d8cddf31faab2448$var$_utf8len[$d8cddf31faab2448$var$q] = $d8cddf31faab2448$var$q >= 252 ? 6 : $d8cddf31faab2448$var$q >= 248 ? 5 : $d8cddf31faab2448$var$q >= 240 ? 4 : $d8cddf31faab2448$var$q >= 224 ? 3 : $d8cddf31faab2448$var$q >= 192 ? 2 : 1;
$d8cddf31faab2448$var$_utf8len[254] = $d8cddf31faab2448$var$_utf8len[254] = 1; // Invalid sequence start
$d8cddf31faab2448$export$7a4c1b2f775b5a9f = function(str) {
    var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;
    // count binary size
    for(m_pos = 0; m_pos < str_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
    }
    // allocate buffer
    buf = new $701cc75d47025217$exports.Buf8(buf_len);
    // convert
    for(i = 0, m_pos = 0; i < buf_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        if (c < 0x80) /* one byte */ buf[i++] = c;
        else if (c < 0x800) {
            /* two bytes */ buf[i++] = 0xC0 | c >>> 6;
            buf[i++] = 0x80 | c & 0x3f;
        } else if (c < 0x10000) {
            /* three bytes */ buf[i++] = 0xE0 | c >>> 12;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        } else {
            /* four bytes */ buf[i++] = 0xf0 | c >>> 18;
            buf[i++] = 0x80 | c >>> 12 & 0x3f;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        }
    }
    return buf;
};
// Helper (used in 2 places)
function $d8cddf31faab2448$var$buf2binstring(buf, len) {
    // On Chrome, the arguments in a function call that are allowed is `65534`.
    // If the length of the buffer is smaller than that, we can use this optimization,
    // otherwise we will take a slower path.
    if (len < 65534) {
        if (buf.subarray && $d8cddf31faab2448$var$STR_APPLY_UIA_OK || !buf.subarray && $d8cddf31faab2448$var$STR_APPLY_OK) return String.fromCharCode.apply(null, $701cc75d47025217$exports.shrinkBuf(buf, len));
    }
    var result = "";
    for(var i = 0; i < len; i++)result += String.fromCharCode(buf[i]);
    return result;
}
$d8cddf31faab2448$export$a751fe64af8a9a51 = function(buf) {
    return $d8cddf31faab2448$var$buf2binstring(buf, buf.length);
};
$d8cddf31faab2448$export$1d1a7119601ff18c = function(str) {
    var buf = new $701cc75d47025217$exports.Buf8(str.length);
    for(var i = 0, len = buf.length; i < len; i++)buf[i] = str.charCodeAt(i);
    return buf;
};
$d8cddf31faab2448$export$49a50563f377746 = function(buf, max) {
    var i, out, c, c_len;
    var len = max || buf.length;
    // Reserve max possible length (2 words per char)
    // NB: by unknown reasons, Array is significantly faster for
    //     String.fromCharCode.apply than Uint16Array.
    var utf16buf = new Array(len * 2);
    for(out = 0, i = 0; i < len;){
        c = buf[i++];
        // quick process ascii
        if (c < 0x80) {
            utf16buf[out++] = c;
            continue;
        }
        c_len = $d8cddf31faab2448$var$_utf8len[c];
        // skip 5 & 6 byte codes
        if (c_len > 4) {
            utf16buf[out++] = 0xfffd;
            i += c_len - 1;
            continue;
        }
        // apply mask on first byte
        c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
        // join the rest
        while(c_len > 1 && i < len){
            c = c << 6 | buf[i++] & 0x3f;
            c_len--;
        }
        // terminated by end of string?
        if (c_len > 1) {
            utf16buf[out++] = 0xfffd;
            continue;
        }
        if (c < 0x10000) utf16buf[out++] = c;
        else {
            c -= 0x10000;
            utf16buf[out++] = 0xd800 | c >> 10 & 0x3ff;
            utf16buf[out++] = 0xdc00 | c & 0x3ff;
        }
    }
    return $d8cddf31faab2448$var$buf2binstring(utf16buf, out);
};
$d8cddf31faab2448$export$53dee3f58a714214 = function(buf, max) {
    var pos;
    max = max || buf.length;
    if (max > buf.length) max = buf.length;
    // go back from last position, until start of sequence found
    pos = max - 1;
    while(pos >= 0 && (buf[pos] & 0xC0) === 0x80)pos--;
    // Very small and broken sequence,
    // return max, because we should return something anyway.
    if (pos < 0) return max;
    // If we came to start of buffer - that means buffer is too small,
    // return max too.
    if (pos === 0) return max;
    return pos + $d8cddf31faab2448$var$_utf8len[buf[pos]] > max ? pos : max;
};



var $73d8265e2c50d00b$exports = {};
"use strict";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $73d8265e2c50d00b$var$ZStream() {
    /* next input byte */ this.input = null; // JS specific, because we have no pointers
    this.next_in = 0;
    /* number of bytes available at input */ this.avail_in = 0;
    /* total number of input bytes read so far */ this.total_in = 0;
    /* next output byte should be put there */ this.output = null; // JS specific, because we have no pointers
    this.next_out = 0;
    /* remaining free space at output */ this.avail_out = 0;
    /* total number of bytes output so far */ this.total_out = 0;
    /* last error message, NULL if no error */ this.msg = "" /*Z_NULL*/ ;
    /* not visible by applications */ this.state = null;
    /* best guess about the data type: binary or text */ this.data_type = 2 /*Z_UNKNOWN*/ ;
    /* adler32 value of the uncompressed data */ this.adler = 0;
}
$73d8265e2c50d00b$exports = $73d8265e2c50d00b$var$ZStream;


var $1d57b756249bc6d3$var$toString = Object.prototype.toString;
/* Public constants ==========================================================*/ /* ===========================================================================*/ var $1d57b756249bc6d3$var$Z_NO_FLUSH = 0;
var $1d57b756249bc6d3$var$Z_FINISH = 4;
var $1d57b756249bc6d3$var$Z_OK = 0;
var $1d57b756249bc6d3$var$Z_STREAM_END = 1;
var $1d57b756249bc6d3$var$Z_SYNC_FLUSH = 2;
var $1d57b756249bc6d3$var$Z_DEFAULT_COMPRESSION = -1;
var $1d57b756249bc6d3$var$Z_DEFAULT_STRATEGY = 0;
var $1d57b756249bc6d3$var$Z_DEFLATED = 8;
/* ===========================================================================*/ /**
 * class Deflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[deflate]],
 * [[deflateRaw]] and [[gzip]].
 **/ /* internal
 * Deflate.chunks -> Array
 *
 * Chunks of output data, if [[Deflate#onData]] not overridden.
 **/ /**
 * Deflate.result -> Uint8Array|Array
 *
 * Compressed result, generated by default [[Deflate#onData]]
 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Deflate#push]] with `Z_FINISH` / `true` param)  or if you
 * push a chunk with explicit flush (call [[Deflate#push]] with
 * `Z_SYNC_FLUSH` param).
 **/ /**
 * Deflate.err -> Number
 *
 * Error code after deflate finished. 0 (Z_OK) on success.
 * You will not need it in real life, because deflate errors
 * are possible only on wrong options or bad `onData` / `onEnd`
 * custom handlers.
 **/ /**
 * Deflate.msg -> String
 *
 * Error message, if [[Deflate.err]] != 0
 **/ /**
 * new Deflate(options)
 * - options (Object): zlib deflate options.
 *
 * Creates new deflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `level`
 * - `windowBits`
 * - `memLevel`
 * - `strategy`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw deflate
 * - `gzip` (Boolean) - create gzip wrapper
 * - `to` (String) - if equal to 'string', then result will be "binary string"
 *    (each char code [0..255])
 * - `header` (Object) - custom header for gzip
 *   - `text` (Boolean) - true if compressed data believed to be text
 *   - `time` (Number) - modification time, unix timestamp
 *   - `os` (Number) - operation system code
 *   - `extra` (Array) - array of bytes with extra data (max 65536)
 *   - `name` (String) - file name (binary string)
 *   - `comment` (String) - comment (binary string)
 *   - `hcrc` (Boolean) - true if header crc should be added
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * var deflate = new pako.Deflate({ level: 3});
 *
 * deflate.push(chunk1, false);
 * deflate.push(chunk2, true);  // true -> last chunk
 *
 * if (deflate.err) { throw new Error(deflate.err); }
 *
 * console.log(deflate.result);
 * ```
 **/ function $1d57b756249bc6d3$var$Deflate(options) {
    if (!(this instanceof $1d57b756249bc6d3$var$Deflate)) return new $1d57b756249bc6d3$var$Deflate(options);
    this.options = $701cc75d47025217$exports.assign({
        level: $1d57b756249bc6d3$var$Z_DEFAULT_COMPRESSION,
        method: $1d57b756249bc6d3$var$Z_DEFLATED,
        chunkSize: 16384,
        windowBits: 15,
        memLevel: 8,
        strategy: $1d57b756249bc6d3$var$Z_DEFAULT_STRATEGY,
        to: ""
    }, options || {});
    var opt = this.options;
    if (opt.raw && opt.windowBits > 0) opt.windowBits = -opt.windowBits;
    else if (opt.gzip && opt.windowBits > 0 && opt.windowBits < 16) opt.windowBits += 16;
    this.err = 0; // error code, if happens (0 = Z_OK)
    this.msg = ""; // error message
    this.ended = false; // used to avoid multiple onEnd() calls
    this.chunks = []; // chunks of compressed data
    this.strm = new $73d8265e2c50d00b$exports();
    this.strm.avail_out = 0;
    var status = $fc8941aa2060205a$export$a65c7b2bde87cb70(this.strm, opt.level, opt.method, opt.windowBits, opt.memLevel, opt.strategy);
    if (status !== $1d57b756249bc6d3$var$Z_OK) throw new Error($54a63c0c56b6e112$exports[status]);
    if (opt.header) $fc8941aa2060205a$export$1cd50f7b2515ba19(this.strm, opt.header);
    if (opt.dictionary) {
        var dict;
        // Convert data if needed
        if (typeof opt.dictionary === "string") // If we need to compress text, change encoding to utf8.
        dict = $d8cddf31faab2448$export$7a4c1b2f775b5a9f(opt.dictionary);
        else if ($1d57b756249bc6d3$var$toString.call(opt.dictionary) === "[object ArrayBuffer]") dict = new Uint8Array(opt.dictionary);
        else dict = opt.dictionary;
        status = $fc8941aa2060205a$export$f55e0b3ab66b5d46(this.strm, dict);
        if (status !== $1d57b756249bc6d3$var$Z_OK) throw new Error($54a63c0c56b6e112$exports[status]);
        this._dict_set = true;
    }
}
/**
 * Deflate#push(data[, mode]) -> Boolean
 * - data (Uint8Array|Array|ArrayBuffer|String): input data. Strings will be
 *   converted to utf8 byte sequence.
 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
 * new compressed chunks. Returns `true` on success. The last data block must have
 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
 * [[Deflate#onEnd]]. For interim explicit flushes (without ending the stream) you
 * can use mode Z_SYNC_FLUSH, keeping the compression context.
 *
 * On fail call [[Deflate#onEnd]] with error code and return false.
 *
 * We strongly recommend to use `Uint8Array` on input for best speed (output
 * array format is detected automatically). Also, don't skip last param and always
 * use the same type in your code (boolean or number). That will improve JS speed.
 *
 * For regular `Array`-s make sure all elements are [0..255].
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ $1d57b756249bc6d3$var$Deflate.prototype.push = function(data, mode) {
    var strm = this.strm;
    var chunkSize = this.options.chunkSize;
    var status, _mode;
    if (this.ended) return false;
    _mode = mode === ~~mode ? mode : mode === true ? $1d57b756249bc6d3$var$Z_FINISH : $1d57b756249bc6d3$var$Z_NO_FLUSH;
    // Convert data if needed
    if (typeof data === "string") // If we need to compress text, change encoding to utf8.
    strm.input = $d8cddf31faab2448$export$7a4c1b2f775b5a9f(data);
    else if ($1d57b756249bc6d3$var$toString.call(data) === "[object ArrayBuffer]") strm.input = new Uint8Array(data);
    else strm.input = data;
    strm.next_in = 0;
    strm.avail_in = strm.input.length;
    do {
        if (strm.avail_out === 0) {
            strm.output = new $701cc75d47025217$exports.Buf8(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
        }
        status = $fc8941aa2060205a$export$2316623ecd1285ab(strm, _mode); /* no bad return value */ 
        if (status !== $1d57b756249bc6d3$var$Z_STREAM_END && status !== $1d57b756249bc6d3$var$Z_OK) {
            this.onEnd(status);
            this.ended = true;
            return false;
        }
        if (strm.avail_out === 0 || strm.avail_in === 0 && (_mode === $1d57b756249bc6d3$var$Z_FINISH || _mode === $1d57b756249bc6d3$var$Z_SYNC_FLUSH)) {
            if (this.options.to === "string") this.onData($d8cddf31faab2448$export$a751fe64af8a9a51($701cc75d47025217$exports.shrinkBuf(strm.output, strm.next_out)));
            else this.onData($701cc75d47025217$exports.shrinkBuf(strm.output, strm.next_out));
        }
    }while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== $1d57b756249bc6d3$var$Z_STREAM_END);
    // Finalize on the last chunk.
    if (_mode === $1d57b756249bc6d3$var$Z_FINISH) {
        status = $fc8941aa2060205a$export$599854fa319a815f(this.strm);
        this.onEnd(status);
        this.ended = true;
        return status === $1d57b756249bc6d3$var$Z_OK;
    }
    // callback interim results if Z_SYNC_FLUSH.
    if (_mode === $1d57b756249bc6d3$var$Z_SYNC_FLUSH) {
        this.onEnd($1d57b756249bc6d3$var$Z_OK);
        strm.avail_out = 0;
        return true;
    }
    return true;
};
/**
 * Deflate#onData(chunk) -> Void
 * - chunk (Uint8Array|Array|String): output data. Type of array depends
 *   on js engine support. When string output requested, each chunk
 *   will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ $1d57b756249bc6d3$var$Deflate.prototype.onData = function(chunk) {
    this.chunks.push(chunk);
};
/**
 * Deflate#onEnd(status) -> Void
 * - status (Number): deflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called once after you tell deflate that the input stream is
 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
 * or if an error happened. By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ $1d57b756249bc6d3$var$Deflate.prototype.onEnd = function(status) {
    // On success - join
    if (status === $1d57b756249bc6d3$var$Z_OK) {
        if (this.options.to === "string") this.result = this.chunks.join("");
        else this.result = $701cc75d47025217$exports.flattenChunks(this.chunks);
    }
    this.chunks = [];
    this.err = status;
    this.msg = this.strm.msg;
};
/**
 * deflate(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * Compress `data` with deflate algorithm and `options`.
 *
 * Supported options are:
 *
 * - level
 * - windowBits
 * - memLevel
 * - strategy
 * - dictionary
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be "binary string"
 *    (each char code [0..255])
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , data = Uint8Array([1,2,3,4,5,6,7,8,9]);
 *
 * console.log(pako.deflate(data));
 * ```
 **/ function $1d57b756249bc6d3$var$deflate(input, options) {
    var deflator = new $1d57b756249bc6d3$var$Deflate(options);
    deflator.push(input, true);
    // That will never happens, if you don't cheat with options :)
    if (deflator.err) throw deflator.msg || $54a63c0c56b6e112$exports[deflator.err];
    return deflator.result;
}
/**
 * deflateRaw(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function $1d57b756249bc6d3$var$deflateRaw(input, options) {
    options = options || {};
    options.raw = true;
    return $1d57b756249bc6d3$var$deflate(input, options);
}
/**
 * gzip(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but create gzip wrapper instead of
 * deflate one.
 **/ function $1d57b756249bc6d3$var$gzip(input, options) {
    options = options || {};
    options.gzip = true;
    return $1d57b756249bc6d3$var$deflate(input, options);
}
$1d57b756249bc6d3$export$ae157b6234afe138 = $1d57b756249bc6d3$var$Deflate;
$1d57b756249bc6d3$export$2316623ecd1285ab = $1d57b756249bc6d3$var$deflate;
$1d57b756249bc6d3$export$e95d6a8f69fb340a = $1d57b756249bc6d3$var$deflateRaw;
$1d57b756249bc6d3$export$69f0ea7cf3a331a8 = $1d57b756249bc6d3$var$gzip;


var $2c8537a6b47169be$exports = {};

$parcel$export($2c8537a6b47169be$exports, "Inflate", () => $2c8537a6b47169be$export$d1de70a877d6e43c, (v) => $2c8537a6b47169be$export$d1de70a877d6e43c = v);
$parcel$export($2c8537a6b47169be$exports, "inflate", () => $2c8537a6b47169be$export$cae1ce83fe4a1782, (v) => $2c8537a6b47169be$export$cae1ce83fe4a1782 = v);
$parcel$export($2c8537a6b47169be$exports, "inflateRaw", () => $2c8537a6b47169be$export$d0f0aa2d05c905c5, (v) => $2c8537a6b47169be$export$d0f0aa2d05c905c5 = v);
$parcel$export($2c8537a6b47169be$exports, "ungzip", () => $2c8537a6b47169be$export$95adf9d270383091, (v) => $2c8537a6b47169be$export$95adf9d270383091 = v);
/**
 * ungzip(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Just shortcut to [[inflate]], because it autodetects format
 * by header.content. Done for convenience.
 **/ var $2c8537a6b47169be$export$d1de70a877d6e43c;
var $2c8537a6b47169be$export$cae1ce83fe4a1782;
var $2c8537a6b47169be$export$d0f0aa2d05c905c5;
var $2c8537a6b47169be$export$95adf9d270383091;
"use strict";
var $b562a383a327bea1$export$42de45683a92ba94;
var $b562a383a327bea1$export$7633ac2cd30f9650;
var $b562a383a327bea1$export$6710ea52c4ec9d6a;
var $b562a383a327bea1$export$9c140b25e26874f9;
var $b562a383a327bea1$export$6792d92addc5c8a0;
var $b562a383a327bea1$export$cae1ce83fe4a1782;
var $b562a383a327bea1$export$224e1a443c3fba76;
var $b562a383a327bea1$export$6d4647cb9e1c75fc;
var $b562a383a327bea1$export$60da749bed98ccf8;
var $b562a383a327bea1$export$220f6291ca35fd71;
"use strict";



var $4f67bc996330e695$exports = {};
"use strict";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// See state defs from inflate.js
var $4f67bc996330e695$var$BAD = 30; /* got a data error -- remain here until reset */ 
var $4f67bc996330e695$var$TYPE = 12; /* i: waiting for type bits, including last-flag bit */ 
/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */ $4f67bc996330e695$exports = function inflate_fast(strm, start) {
    var state;
    var _in; /* local strm.input */ 
    var last; /* have enough input while in < last */ 
    var _out; /* local strm.output */ 
    var beg; /* inflate()'s initial strm.output */ 
    var end; /* while out < end, enough space available */ 
    //#ifdef INFLATE_STRICT
    var dmax; /* maximum distance from zlib header */ 
    //#endif
    var wsize; /* window size or zero if not using window */ 
    var whave; /* valid bytes in the window */ 
    var wnext; /* window write index */ 
    // Use `s_window` instead `window`, avoid conflict with instrumentation tools
    var s_window; /* allocated sliding window, if wsize != 0 */ 
    var hold; /* local strm.hold */ 
    var bits; /* local strm.bits */ 
    var lcode; /* local strm.lencode */ 
    var dcode; /* local strm.distcode */ 
    var lmask; /* mask for first level of length codes */ 
    var dmask; /* mask for first level of distance codes */ 
    var here; /* retrieved table entry */ 
    var op; /* code bits, operation, extra bits, or */ 
    /*  window position, window bytes to copy */ var len; /* match length, unused bytes */ 
    var dist; /* match distance */ 
    var from; /* where to copy match from */ 
    var from_source;
    var input, output; // JS specific, because we have no pointers
    /* copy state to local variables */ state = strm.state;
    //here = state.here;
    _in = strm.next_in;
    input = strm.input;
    last = _in + (strm.avail_in - 5);
    _out = strm.next_out;
    output = strm.output;
    beg = _out - (start - strm.avail_out);
    end = _out + (strm.avail_out - 257);
    //#ifdef INFLATE_STRICT
    dmax = state.dmax;
    //#endif
    wsize = state.wsize;
    whave = state.whave;
    wnext = state.wnext;
    s_window = state.window;
    hold = state.hold;
    bits = state.bits;
    lcode = state.lencode;
    dcode = state.distcode;
    lmask = (1 << state.lenbits) - 1;
    dmask = (1 << state.distbits) - 1;
    /* decode literals and length/distances until end-of-block or not enough
     input data or output space */ top: do {
        if (bits < 15) {
            hold += input[_in++] << bits;
            bits += 8;
            hold += input[_in++] << bits;
            bits += 8;
        }
        here = lcode[hold & lmask];
        dolen: for(;;){
            op = here >>> 24 /*here.bits*/ ;
            hold >>>= op;
            bits -= op;
            op = here >>> 16 & 0xff /*here.op*/ ;
            if (op === 0) //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
            //        "inflate:         literal '%c'\n" :
            //        "inflate:         literal 0x%02x\n", here.val));
            output[_out++] = here & 0xffff /*here.val*/ ;
            else if (op & 16) {
                len = here & 0xffff /*here.val*/ ;
                op &= 15; /* number of extra bits */ 
                if (op) {
                    if (bits < op) {
                        hold += input[_in++] << bits;
                        bits += 8;
                    }
                    len += hold & (1 << op) - 1;
                    hold >>>= op;
                    bits -= op;
                }
                //Tracevv((stderr, "inflate:         length %u\n", len));
                if (bits < 15) {
                    hold += input[_in++] << bits;
                    bits += 8;
                    hold += input[_in++] << bits;
                    bits += 8;
                }
                here = dcode[hold & dmask];
                dodist: for(;;){
                    op = here >>> 24 /*here.bits*/ ;
                    hold >>>= op;
                    bits -= op;
                    op = here >>> 16 & 0xff /*here.op*/ ;
                    if (op & 16) {
                        dist = here & 0xffff /*here.val*/ ;
                        op &= 15; /* number of extra bits */ 
                        if (bits < op) {
                            hold += input[_in++] << bits;
                            bits += 8;
                            if (bits < op) {
                                hold += input[_in++] << bits;
                                bits += 8;
                            }
                        }
                        dist += hold & (1 << op) - 1;
                        //#ifdef INFLATE_STRICT
                        if (dist > dmax) {
                            strm.msg = "invalid distance too far back";
                            state.mode = $4f67bc996330e695$var$BAD;
                            break top;
                        }
                        //#endif
                        hold >>>= op;
                        bits -= op;
                        //Tracevv((stderr, "inflate:         distance %u\n", dist));
                        op = _out - beg; /* max distance in output */ 
                        if (dist > op) {
                            op = dist - op; /* distance back in window */ 
                            if (op > whave) {
                                if (state.sane) {
                                    strm.msg = "invalid distance too far back";
                                    state.mode = $4f67bc996330e695$var$BAD;
                                    break top;
                                }
                            }
                            from = 0; // window index
                            from_source = s_window;
                            if (wnext === 0) {
                                from += wsize - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            } else if (wnext < op) {
                                from += wsize + wnext - op;
                                op -= wnext;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = 0;
                                    if (wnext < len) {
                                        op = wnext;
                                        len -= op;
                                        do output[_out++] = s_window[from++];
                                        while (--op);
                                        from = _out - dist; /* rest from output */ 
                                        from_source = output;
                                    }
                                }
                            } else {
                                from += wnext - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            }
                            while(len > 2){
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                len -= 3;
                            }
                            if (len) {
                                output[_out++] = from_source[from++];
                                if (len > 1) output[_out++] = from_source[from++];
                            }
                        } else {
                            from = _out - dist; /* copy direct from output */ 
                            do {
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                len -= 3;
                            }while (len > 2);
                            if (len) {
                                output[_out++] = output[from++];
                                if (len > 1) output[_out++] = output[from++];
                            }
                        }
                    } else if ((op & 64) === 0) {
                        here = dcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                        continue dodist;
                    } else {
                        strm.msg = "invalid distance code";
                        state.mode = $4f67bc996330e695$var$BAD;
                        break top;
                    }
                    break; // need to emulate goto via "continue"
                }
            } else if ((op & 64) === 0) {
                here = lcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                continue dolen;
            } else if (op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.mode = $4f67bc996330e695$var$TYPE;
                break top;
            } else {
                strm.msg = "invalid literal/length code";
                state.mode = $4f67bc996330e695$var$BAD;
                break top;
            }
            break; // need to emulate goto via "continue"
        }
    }while (_in < last && _out < end);
    /* return unused bytes (on entry, bits < 8, so in won't go too far back) */ len = bits >> 3;
    _in -= len;
    bits -= len << 3;
    hold &= (1 << bits) - 1;
    /* update state and return */ strm.next_in = _in;
    strm.next_out = _out;
    strm.avail_in = _in < last ? 5 + (last - _in) : 5 - (_in - last);
    strm.avail_out = _out < end ? 257 + (end - _out) : 257 - (_out - end);
    state.hold = hold;
    state.bits = bits;
    return;
};


var $86622ca50c32b2ec$exports = {};
"use strict";

var $86622ca50c32b2ec$var$MAXBITS = 15;
var $86622ca50c32b2ec$var$ENOUGH_LENS = 852;
var $86622ca50c32b2ec$var$ENOUGH_DISTS = 592;
//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
var $86622ca50c32b2ec$var$CODES = 0;
var $86622ca50c32b2ec$var$LENS = 1;
var $86622ca50c32b2ec$var$DISTS = 2;
var $86622ca50c32b2ec$var$lbase = [
    /* Length codes 257..285 base */ 3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    13,
    15,
    17,
    19,
    23,
    27,
    31,
    35,
    43,
    51,
    59,
    67,
    83,
    99,
    115,
    131,
    163,
    195,
    227,
    258,
    0,
    0
];
var $86622ca50c32b2ec$var$lext = [
    /* Length codes 257..285 extra */ 16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    16,
    72,
    78
];
var $86622ca50c32b2ec$var$dbase = [
    /* Distance codes 0..29 base */ 1,
    2,
    3,
    4,
    5,
    7,
    9,
    13,
    17,
    25,
    33,
    49,
    65,
    97,
    129,
    193,
    257,
    385,
    513,
    769,
    1025,
    1537,
    2049,
    3073,
    4097,
    6145,
    8193,
    12289,
    16385,
    24577,
    0,
    0
];
var $86622ca50c32b2ec$var$dext = [
    /* Distance codes 0..29 extra */ 16,
    16,
    16,
    16,
    17,
    17,
    18,
    18,
    19,
    19,
    20,
    20,
    21,
    21,
    22,
    22,
    23,
    23,
    24,
    24,
    25,
    25,
    26,
    26,
    27,
    27,
    28,
    28,
    29,
    29,
    64,
    64
];
$86622ca50c32b2ec$exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts) {
    var bits = opts.bits;
    //here = opts.here; /* table entry for duplication */
    var len = 0; /* a code's length in bits */ 
    var sym = 0; /* index of code symbols */ 
    var min = 0, max = 0; /* minimum and maximum code lengths */ 
    var root = 0; /* number of index bits for root table */ 
    var curr = 0; /* number of index bits for current table */ 
    var drop = 0; /* code bits to drop for sub-table */ 
    var left = 0; /* number of prefix codes available */ 
    var used = 0; /* code entries in table used */ 
    var huff = 0; /* Huffman code */ 
    var incr; /* for incrementing code, index */ 
    var fill; /* index for replicating entries */ 
    var low; /* low bits for current root entry */ 
    var mask; /* mask for low root bits */ 
    var next; /* next available space in table */ 
    var base = null; /* base value table to use */ 
    var base_index = 0;
    //  var shoextra;    /* extra bits table to use */
    var end; /* use base and extra for symbol > end */ 
    var count = new $701cc75d47025217$exports.Buf16($86622ca50c32b2ec$var$MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
    var offs = new $701cc75d47025217$exports.Buf16($86622ca50c32b2ec$var$MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
    var extra = null;
    var extra_index = 0;
    var here_bits, here_op, here_val;
    /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */ /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */ for(len = 0; len <= $86622ca50c32b2ec$var$MAXBITS; len++)count[len] = 0;
    for(sym = 0; sym < codes; sym++)count[lens[lens_index + sym]]++;
    /* bound code lengths, force root to be within code lengths */ root = bits;
    for(max = $86622ca50c32b2ec$var$MAXBITS; max >= 1; max--){
        if (count[max] !== 0) break;
    }
    if (root > max) root = max;
    if (max === 0) {
        //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
        //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
        //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
        table[table_index++] = 20971520;
        //table.op[opts.table_index] = 64;
        //table.bits[opts.table_index] = 1;
        //table.val[opts.table_index++] = 0;
        table[table_index++] = 20971520;
        opts.bits = 1;
        return 0; /* no symbols, but wait for decoding to report error */ 
    }
    for(min = 1; min < max; min++){
        if (count[min] !== 0) break;
    }
    if (root < min) root = min;
    /* check for an over-subscribed or incomplete set of lengths */ left = 1;
    for(len = 1; len <= $86622ca50c32b2ec$var$MAXBITS; len++){
        left <<= 1;
        left -= count[len];
        if (left < 0) return -1;
         /* over-subscribed */ 
    }
    if (left > 0 && (type === $86622ca50c32b2ec$var$CODES || max !== 1)) return -1; /* incomplete set */ 
    /* generate offsets into symbol table for each length for sorting */ offs[1] = 0;
    for(len = 1; len < $86622ca50c32b2ec$var$MAXBITS; len++)offs[len + 1] = offs[len] + count[len];
    /* sort symbols by length, by symbol order within each length */ for(sym = 0; sym < codes; sym++)if (lens[lens_index + sym] !== 0) work[offs[lens[lens_index + sym]]++] = sym;
    /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */ /* set up for code type */ // poor man optimization - use if-else instead of switch,
    // to avoid deopts in old v8
    if (type === $86622ca50c32b2ec$var$CODES) {
        base = extra = work; /* dummy value--not used */ 
        end = 19;
    } else if (type === $86622ca50c32b2ec$var$LENS) {
        base = $86622ca50c32b2ec$var$lbase;
        base_index -= 257;
        extra = $86622ca50c32b2ec$var$lext;
        extra_index -= 257;
        end = 256;
    } else {
        base = $86622ca50c32b2ec$var$dbase;
        extra = $86622ca50c32b2ec$var$dext;
        end = -1;
    }
    /* initialize opts for loop */ huff = 0; /* starting code */ 
    sym = 0; /* starting code symbol */ 
    len = min; /* starting code length */ 
    next = table_index; /* current table to fill in */ 
    curr = root; /* current table index bits */ 
    drop = 0; /* current bits to drop from code for index */ 
    low = -1; /* trigger new sub-table when len > root */ 
    used = 1 << root; /* use root table entries */ 
    mask = used - 1; /* mask for comparing low */ 
    /* check available table space */ if (type === $86622ca50c32b2ec$var$LENS && used > $86622ca50c32b2ec$var$ENOUGH_LENS || type === $86622ca50c32b2ec$var$DISTS && used > $86622ca50c32b2ec$var$ENOUGH_DISTS) return 1;
    /* process all codes and make table entries */ for(;;){
        /* create table entry */ here_bits = len - drop;
        if (work[sym] < end) {
            here_op = 0;
            here_val = work[sym];
        } else if (work[sym] > end) {
            here_op = extra[extra_index + work[sym]];
            here_val = base[base_index + work[sym]];
        } else {
            here_op = 96; /* end of block */ 
            here_val = 0;
        }
        /* replicate for those indices with low len bits equal to huff */ incr = 1 << len - drop;
        fill = 1 << curr;
        min = fill; /* save offset to next table */ 
        do {
            fill -= incr;
            table[next + (huff >> drop) + fill] = here_bits << 24 | here_op << 16 | here_val | 0;
        }while (fill !== 0);
        /* backwards increment the len-bit code huff */ incr = 1 << len - 1;
        while(huff & incr)incr >>= 1;
        if (incr !== 0) {
            huff &= incr - 1;
            huff += incr;
        } else huff = 0;
        /* go to next symbol, update count, len */ sym++;
        if (--count[len] === 0) {
            if (len === max) break;
            len = lens[lens_index + work[sym]];
        }
        /* create new sub-table if needed */ if (len > root && (huff & mask) !== low) {
            /* if first time, transition to sub-tables */ if (drop === 0) drop = root;
            /* increment past last table */ next += min; /* here min is 1 << curr */ 
            /* determine length of next table */ curr = len - drop;
            left = 1 << curr;
            while(curr + drop < max){
                left -= count[curr + drop];
                if (left <= 0) break;
                curr++;
                left <<= 1;
            }
            /* check for enough space */ used += 1 << curr;
            if (type === $86622ca50c32b2ec$var$LENS && used > $86622ca50c32b2ec$var$ENOUGH_LENS || type === $86622ca50c32b2ec$var$DISTS && used > $86622ca50c32b2ec$var$ENOUGH_DISTS) return 1;
            /* point entry in root table to sub-table */ low = huff & mask;
            /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/ table[low] = root << 24 | curr << 16 | next - table_index | 0;
        }
    }
    /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */ if (huff !== 0) //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = len - drop << 24 | 4194304;
    /* set return parameters */ //opts.table_index += used;
    opts.bits = root;
    return 0;
};


var $b562a383a327bea1$var$CODES = 0;
var $b562a383a327bea1$var$LENS = 1;
var $b562a383a327bea1$var$DISTS = 2;
/* Public constants ==========================================================*/ /* ===========================================================================*/ /* Allowed flush values; see deflate() and inflate() below for details */ //var Z_NO_FLUSH      = 0;
//var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
//var Z_FULL_FLUSH    = 3;
var $b562a383a327bea1$var$Z_FINISH = 4;
var $b562a383a327bea1$var$Z_BLOCK = 5;
var $b562a383a327bea1$var$Z_TREES = 6;
/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */ var $b562a383a327bea1$var$Z_OK = 0;
var $b562a383a327bea1$var$Z_STREAM_END = 1;
var $b562a383a327bea1$var$Z_NEED_DICT = 2;
//var Z_ERRNO         = -1;
var $b562a383a327bea1$var$Z_STREAM_ERROR = -2;
var $b562a383a327bea1$var$Z_DATA_ERROR = -3;
var $b562a383a327bea1$var$Z_MEM_ERROR = -4;
var $b562a383a327bea1$var$Z_BUF_ERROR = -5;
//var Z_VERSION_ERROR = -6;
/* The deflate compression method */ var $b562a383a327bea1$var$Z_DEFLATED = 8;
/* STATES ====================================================================*/ /* ===========================================================================*/ var $b562a383a327bea1$var$HEAD = 1; /* i: waiting for magic header */ 
var $b562a383a327bea1$var$FLAGS = 2; /* i: waiting for method and flags (gzip) */ 
var $b562a383a327bea1$var$TIME = 3; /* i: waiting for modification time (gzip) */ 
var $b562a383a327bea1$var$OS = 4; /* i: waiting for extra flags and operating system (gzip) */ 
var $b562a383a327bea1$var$EXLEN = 5; /* i: waiting for extra length (gzip) */ 
var $b562a383a327bea1$var$EXTRA = 6; /* i: waiting for extra bytes (gzip) */ 
var $b562a383a327bea1$var$NAME = 7; /* i: waiting for end of file name (gzip) */ 
var $b562a383a327bea1$var$COMMENT = 8; /* i: waiting for end of comment (gzip) */ 
var $b562a383a327bea1$var$HCRC = 9; /* i: waiting for header crc (gzip) */ 
var $b562a383a327bea1$var$DICTID = 10; /* i: waiting for dictionary check value */ 
var $b562a383a327bea1$var$DICT = 11; /* waiting for inflateSetDictionary() call */ 
var $b562a383a327bea1$var$TYPE = 12; /* i: waiting for type bits, including last-flag bit */ 
var $b562a383a327bea1$var$TYPEDO = 13; /* i: same, but skip check to exit inflate on new block */ 
var $b562a383a327bea1$var$STORED = 14; /* i: waiting for stored size (length and complement) */ 
var $b562a383a327bea1$var$COPY_ = 15; /* i/o: same as COPY below, but only first time in */ 
var $b562a383a327bea1$var$COPY = 16; /* i/o: waiting for input or output to copy stored block */ 
var $b562a383a327bea1$var$TABLE = 17; /* i: waiting for dynamic block table lengths */ 
var $b562a383a327bea1$var$LENLENS = 18; /* i: waiting for code length code lengths */ 
var $b562a383a327bea1$var$CODELENS = 19; /* i: waiting for length/lit and distance code lengths */ 
var $b562a383a327bea1$var$LEN_ = 20; /* i: same as LEN below, but only first time in */ 
var $b562a383a327bea1$var$LEN = 21; /* i: waiting for length/lit/eob code */ 
var $b562a383a327bea1$var$LENEXT = 22; /* i: waiting for length extra bits */ 
var $b562a383a327bea1$var$DIST = 23; /* i: waiting for distance code */ 
var $b562a383a327bea1$var$DISTEXT = 24; /* i: waiting for distance extra bits */ 
var $b562a383a327bea1$var$MATCH = 25; /* o: waiting for output space to copy string */ 
var $b562a383a327bea1$var$LIT = 26; /* o: waiting for output space to write literal */ 
var $b562a383a327bea1$var$CHECK = 27; /* i: waiting for 32-bit check value */ 
var $b562a383a327bea1$var$LENGTH = 28; /* i: waiting for 32-bit length (gzip) */ 
var $b562a383a327bea1$var$DONE = 29; /* finished check, done -- remain here until reset */ 
var $b562a383a327bea1$var$BAD = 30; /* got a data error -- remain here until reset */ 
var $b562a383a327bea1$var$MEM = 31; /* got an inflate() memory error -- remain here until reset */ 
var $b562a383a327bea1$var$SYNC = 32; /* looking for synchronization bytes to restart inflate() */ 
/* ===========================================================================*/ var $b562a383a327bea1$var$ENOUGH_LENS = 852;
var $b562a383a327bea1$var$ENOUGH_DISTS = 592;
//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
var $b562a383a327bea1$var$MAX_WBITS = 15;
/* 32K LZ77 window */ var $b562a383a327bea1$var$DEF_WBITS = $b562a383a327bea1$var$MAX_WBITS;
function $b562a383a327bea1$var$zswap32(q) {
    return (q >>> 24 & 0xff) + (q >>> 8 & 0xff00) + ((q & 0xff00) << 8) + ((q & 0xff) << 24);
}
function $b562a383a327bea1$var$InflateState() {
    this.mode = 0; /* current inflate mode */ 
    this.last = false; /* true if processing last block */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.havedict = false; /* true if dictionary provided */ 
    this.flags = 0; /* gzip header method and flags (0 if zlib) */ 
    this.dmax = 0; /* zlib header max distance (INFLATE_STRICT) */ 
    this.check = 0; /* protected copy of check value */ 
    this.total = 0; /* protected copy of output count */ 
    // TODO: may be {}
    this.head = null; /* where to save gzip header information */ 
    /* sliding window */ this.wbits = 0; /* log base 2 of requested window size */ 
    this.wsize = 0; /* window size or zero if not using window */ 
    this.whave = 0; /* valid bytes in the window */ 
    this.wnext = 0; /* window write index */ 
    this.window = null; /* allocated sliding window, if needed */ 
    /* bit accumulator */ this.hold = 0; /* input bit accumulator */ 
    this.bits = 0; /* number of bits in "in" */ 
    /* for string and stored block copying */ this.length = 0; /* literal or length of data to copy */ 
    this.offset = 0; /* distance back to copy string from */ 
    /* for table and code decoding */ this.extra = 0; /* extra bits needed */ 
    /* fixed and dynamic code tables */ this.lencode = null; /* starting table for length/literal codes */ 
    this.distcode = null; /* starting table for distance codes */ 
    this.lenbits = 0; /* index bits for lencode */ 
    this.distbits = 0; /* index bits for distcode */ 
    /* dynamic table building */ this.ncode = 0; /* number of code length code lengths */ 
    this.nlen = 0; /* number of length code lengths */ 
    this.ndist = 0; /* number of distance code lengths */ 
    this.have = 0; /* number of code lengths in lens[] */ 
    this.next = null; /* next available space in codes[] */ 
    this.lens = new $701cc75d47025217$exports.Buf16(320); /* temporary storage for code lengths */ 
    this.work = new $701cc75d47025217$exports.Buf16(288); /* work area for code table building */ 
    /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */ //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
    this.lendyn = null; /* dynamic table for length/literal codes (JS specific) */ 
    this.distdyn = null; /* dynamic table for distance codes (JS specific) */ 
    this.sane = 0; /* if false, allow invalid distance too far */ 
    this.back = 0; /* bits back of last unprocessed length/lit */ 
    this.was = 0; /* initial length of match */ 
}
function $b562a383a327bea1$var$inflateResetKeep(strm) {
    var state;
    if (!strm || !strm.state) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    state = strm.state;
    strm.total_in = strm.total_out = state.total = 0;
    strm.msg = ""; /*Z_NULL*/ 
    if (state.wrap) strm.adler = state.wrap & 1;
    state.mode = $b562a383a327bea1$var$HEAD;
    state.last = 0;
    state.havedict = 0;
    state.dmax = 32768;
    state.head = null /*Z_NULL*/ ;
    state.hold = 0;
    state.bits = 0;
    //state.lencode = state.distcode = state.next = state.codes;
    state.lencode = state.lendyn = new $701cc75d47025217$exports.Buf32($b562a383a327bea1$var$ENOUGH_LENS);
    state.distcode = state.distdyn = new $701cc75d47025217$exports.Buf32($b562a383a327bea1$var$ENOUGH_DISTS);
    state.sane = 1;
    state.back = -1;
    //Tracev((stderr, "inflate: reset\n"));
    return $b562a383a327bea1$var$Z_OK;
}
function $b562a383a327bea1$var$inflateReset(strm) {
    var state;
    if (!strm || !strm.state) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    state = strm.state;
    state.wsize = 0;
    state.whave = 0;
    state.wnext = 0;
    return $b562a383a327bea1$var$inflateResetKeep(strm);
}
function $b562a383a327bea1$var$inflateReset2(strm, windowBits) {
    var wrap;
    var state;
    /* get the state */ if (!strm || !strm.state) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    state = strm.state;
    /* extract wrap request from windowBits parameter */ if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else {
        wrap = (windowBits >> 4) + 1;
        if (windowBits < 48) windowBits &= 15;
    }
    /* set number of window bits, free window if different */ if (windowBits && (windowBits < 8 || windowBits > 15)) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    if (state.window !== null && state.wbits !== windowBits) state.window = null;
    /* update state and reset the rest of it */ state.wrap = wrap;
    state.wbits = windowBits;
    return $b562a383a327bea1$var$inflateReset(strm);
}
function $b562a383a327bea1$var$inflateInit2(strm, windowBits) {
    var ret;
    var state;
    if (!strm) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    //strm.msg = Z_NULL;                 /* in case we return an error */
    state = new $b562a383a327bea1$var$InflateState();
    //if (state === Z_NULL) return Z_MEM_ERROR;
    //Tracev((stderr, "inflate: allocated\n"));
    strm.state = state;
    state.window = null /*Z_NULL*/ ;
    ret = $b562a383a327bea1$var$inflateReset2(strm, windowBits);
    if (ret !== $b562a383a327bea1$var$Z_OK) strm.state = null /*Z_NULL*/ ;
    return ret;
}
function $b562a383a327bea1$var$inflateInit(strm) {
    return $b562a383a327bea1$var$inflateInit2(strm, $b562a383a327bea1$var$DEF_WBITS);
}
/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */ var $b562a383a327bea1$var$virgin = true;
var $b562a383a327bea1$var$lenfix, $b562a383a327bea1$var$distfix; // We have no pointers in JS, so keep tables separate
function $b562a383a327bea1$var$fixedtables(state) {
    /* build fixed huffman tables if first call (may not be thread safe) */ if ($b562a383a327bea1$var$virgin) {
        var sym;
        $b562a383a327bea1$var$lenfix = new $701cc75d47025217$exports.Buf32(512);
        $b562a383a327bea1$var$distfix = new $701cc75d47025217$exports.Buf32(32);
        /* literal/length table */ sym = 0;
        while(sym < 144)state.lens[sym++] = 8;
        while(sym < 256)state.lens[sym++] = 9;
        while(sym < 280)state.lens[sym++] = 7;
        while(sym < 288)state.lens[sym++] = 8;
        $86622ca50c32b2ec$exports($b562a383a327bea1$var$LENS, state.lens, 0, 288, $b562a383a327bea1$var$lenfix, 0, state.work, {
            bits: 9
        });
        /* distance table */ sym = 0;
        while(sym < 32)state.lens[sym++] = 5;
        $86622ca50c32b2ec$exports($b562a383a327bea1$var$DISTS, state.lens, 0, 32, $b562a383a327bea1$var$distfix, 0, state.work, {
            bits: 5
        });
        /* do this just once */ $b562a383a327bea1$var$virgin = false;
    }
    state.lencode = $b562a383a327bea1$var$lenfix;
    state.lenbits = 9;
    state.distcode = $b562a383a327bea1$var$distfix;
    state.distbits = 5;
}
/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */ function $b562a383a327bea1$var$updatewindow(strm, src, end, copy) {
    var dist;
    var state = strm.state;
    /* if it hasn't been done already, allocate space for the window */ if (state.window === null) {
        state.wsize = 1 << state.wbits;
        state.wnext = 0;
        state.whave = 0;
        state.window = new $701cc75d47025217$exports.Buf8(state.wsize);
    }
    /* copy state->wsize or less output bytes into the circular window */ if (copy >= state.wsize) {
        $701cc75d47025217$exports.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
        state.wnext = 0;
        state.whave = state.wsize;
    } else {
        dist = state.wsize - state.wnext;
        if (dist > copy) dist = copy;
        //zmemcpy(state->window + state->wnext, end - copy, dist);
        $701cc75d47025217$exports.arraySet(state.window, src, end - copy, dist, state.wnext);
        copy -= dist;
        if (copy) {
            //zmemcpy(state->window, end - copy, copy);
            $701cc75d47025217$exports.arraySet(state.window, src, end - copy, copy, 0);
            state.wnext = copy;
            state.whave = state.wsize;
        } else {
            state.wnext += dist;
            if (state.wnext === state.wsize) state.wnext = 0;
            if (state.whave < state.wsize) state.whave += dist;
        }
    }
    return 0;
}
function $b562a383a327bea1$var$inflate(strm, flush) {
    var state;
    var input, output; // input/output buffers
    var next; /* next input INDEX */ 
    var put; /* next output INDEX */ 
    var have, left; /* available input and output */ 
    var hold; /* bit buffer */ 
    var bits; /* bits in bit buffer */ 
    var _in, _out; /* save starting available input and output */ 
    var copy; /* number of stored or match bytes to copy */ 
    var from; /* where to copy match bytes from */ 
    var from_source;
    var here = 0; /* current decoding table entry */ 
    var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
    //var last;                   /* parent table entry */
    var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
    var len; /* length to copy for repeats, bits to drop */ 
    var ret; /* return code */ 
    var hbuf = new $701cc75d47025217$exports.Buf8(4); /* buffer for gzip header crc calculation */ 
    var opts;
    var n; // temporary var for NEED_BITS
    var order = /* permutation of code lengths */ [
        16,
        17,
        18,
        0,
        8,
        7,
        9,
        6,
        10,
        5,
        11,
        4,
        12,
        3,
        13,
        2,
        14,
        1,
        15
    ];
    if (!strm || !strm.state || !strm.output || !strm.input && strm.avail_in !== 0) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    state = strm.state;
    if (state.mode === $b562a383a327bea1$var$TYPE) state.mode = $b562a383a327bea1$var$TYPEDO;
     /* skip check */ 
    //--- LOAD() ---
    put = strm.next_out;
    output = strm.output;
    left = strm.avail_out;
    next = strm.next_in;
    input = strm.input;
    have = strm.avail_in;
    hold = state.hold;
    bits = state.bits;
    //---
    _in = have;
    _out = left;
    ret = $b562a383a327bea1$var$Z_OK;
    inf_leave: for(;;)switch(state.mode){
        case $b562a383a327bea1$var$HEAD:
            if (state.wrap === 0) {
                state.mode = $b562a383a327bea1$var$TYPEDO;
                break;
            }
            //=== NEEDBITS(16);
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.wrap & 2 && hold === 0x8b1f) {
                state.check = 0 /*crc32(0L, Z_NULL, 0)*/ ;
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $44e7d98dd6723a9a$exports(state.check, hbuf, 2, 0);
                //===//
                //=== INITBITS();
                hold = 0;
                bits = 0;
                //===//
                state.mode = $b562a383a327bea1$var$FLAGS;
                break;
            }
            state.flags = 0; /* expect zlib header */ 
            if (state.head) state.head.done = false;
            if (!(state.wrap & 1) || /* check if zlib header allowed */ (((hold & 0xff) << 8) + (hold >> 8)) % 31) {
                strm.msg = "incorrect header check";
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            if ((hold & 0x0f) !== $b562a383a327bea1$var$Z_DEFLATED) {
                strm.msg = "unknown compression method";
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            len = (hold & 0x0f) + 8;
            if (state.wbits === 0) state.wbits = len;
            else if (len > state.wbits) {
                strm.msg = "invalid window size";
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            state.dmax = 1 << len;
            //Tracev((stderr, "inflate:   zlib header ok\n"));
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = hold & 0x200 ? $b562a383a327bea1$var$DICTID : $b562a383a327bea1$var$TYPE;
            //=== INITBITS();
            hold = 0;
            bits = 0;
            break;
        case $b562a383a327bea1$var$FLAGS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.flags = hold;
            if ((state.flags & 0xff) !== $b562a383a327bea1$var$Z_DEFLATED) {
                strm.msg = "unknown compression method";
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            if (state.flags & 0xe000) {
                strm.msg = "unknown header flags set";
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            if (state.head) state.head.text = hold >> 8 & 1;
            if (state.flags & 0x0200) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $44e7d98dd6723a9a$exports(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $b562a383a327bea1$var$TIME;
        /* falls through */ case $b562a383a327bea1$var$TIME:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) state.head.time = hold;
            if (state.flags & 0x0200) {
                //=== CRC4(state.check, hold)
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                hbuf[2] = hold >>> 16 & 0xff;
                hbuf[3] = hold >>> 24 & 0xff;
                state.check = $44e7d98dd6723a9a$exports(state.check, hbuf, 4, 0);
            //===
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $b562a383a327bea1$var$OS;
        /* falls through */ case $b562a383a327bea1$var$OS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) {
                state.head.xflags = hold & 0xff;
                state.head.os = hold >> 8;
            }
            if (state.flags & 0x0200) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $44e7d98dd6723a9a$exports(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $b562a383a327bea1$var$EXLEN;
        /* falls through */ case $b562a383a327bea1$var$EXLEN:
            if (state.flags & 0x0400) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length = hold;
                if (state.head) state.head.extra_len = hold;
                if (state.flags & 0x0200) {
                    //=== CRC2(state.check, hold);
                    hbuf[0] = hold & 0xff;
                    hbuf[1] = hold >>> 8 & 0xff;
                    state.check = $44e7d98dd6723a9a$exports(state.check, hbuf, 2, 0);
                //===//
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            } else if (state.head) state.head.extra = null /*Z_NULL*/ ;
            state.mode = $b562a383a327bea1$var$EXTRA;
        /* falls through */ case $b562a383a327bea1$var$EXTRA:
            if (state.flags & 0x0400) {
                copy = state.length;
                if (copy > have) copy = have;
                if (copy) {
                    if (state.head) {
                        len = state.head.extra_len - state.length;
                        if (!state.head.extra) // Use untyped array for more convenient processing later
                        state.head.extra = new Array(state.head.extra_len);
                        $701cc75d47025217$exports.arraySet(state.head.extra, input, next, // extra field is limited to 65536 bytes
                        // - no need for additional size check
                        copy, /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/ len);
                    //zmemcpy(state.head.extra + len, next,
                    //        len + copy > state.head.extra_max ?
                    //        state.head.extra_max - len : copy);
                    }
                    if (state.flags & 0x0200) state.check = $44e7d98dd6723a9a$exports(state.check, input, copy, next);
                    have -= copy;
                    next += copy;
                    state.length -= copy;
                }
                if (state.length) break inf_leave;
            }
            state.length = 0;
            state.mode = $b562a383a327bea1$var$NAME;
        /* falls through */ case $b562a383a327bea1$var$NAME:
            if (state.flags & 0x0800) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    // TODO: 2 or 1 bytes?
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.name_max*/ ) state.head.name += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200) state.check = $44e7d98dd6723a9a$exports(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.name = null;
            state.length = 0;
            state.mode = $b562a383a327bea1$var$COMMENT;
        /* falls through */ case $b562a383a327bea1$var$COMMENT:
            if (state.flags & 0x1000) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.comm_max*/ ) state.head.comment += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200) state.check = $44e7d98dd6723a9a$exports(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.comment = null;
            state.mode = $b562a383a327bea1$var$HCRC;
        /* falls through */ case $b562a383a327bea1$var$HCRC:
            if (state.flags & 0x0200) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (hold !== (state.check & 0xffff)) {
                    strm.msg = "header crc mismatch";
                    state.mode = $b562a383a327bea1$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            }
            if (state.head) {
                state.head.hcrc = state.flags >> 9 & 1;
                state.head.done = true;
            }
            strm.adler = state.check = 0;
            state.mode = $b562a383a327bea1$var$TYPE;
            break;
        case $b562a383a327bea1$var$DICTID:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            strm.adler = state.check = $b562a383a327bea1$var$zswap32(hold);
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $b562a383a327bea1$var$DICT;
        /* falls through */ case $b562a383a327bea1$var$DICT:
            if (state.havedict === 0) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                return $b562a383a327bea1$var$Z_NEED_DICT;
            }
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = $b562a383a327bea1$var$TYPE;
        /* falls through */ case $b562a383a327bea1$var$TYPE:
            if (flush === $b562a383a327bea1$var$Z_BLOCK || flush === $b562a383a327bea1$var$Z_TREES) break inf_leave;
        /* falls through */ case $b562a383a327bea1$var$TYPEDO:
            if (state.last) {
                //--- BYTEBITS() ---//
                hold >>>= bits & 7;
                bits -= bits & 7;
                //---//
                state.mode = $b562a383a327bea1$var$CHECK;
                break;
            }
            //=== NEEDBITS(3); */
            while(bits < 3){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.last = hold & 0x01 /*BITS(1)*/ ;
            //--- DROPBITS(1) ---//
            hold >>>= 1;
            bits -= 1;
            //---//
            switch(hold & 0x03){
                case 0:
                    /* stored block */ //Tracev((stderr, "inflate:     stored block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $b562a383a327bea1$var$STORED;
                    break;
                case 1:
                    /* fixed block */ $b562a383a327bea1$var$fixedtables(state);
                    //Tracev((stderr, "inflate:     fixed codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $b562a383a327bea1$var$LEN_; /* decode codes */ 
                    if (flush === $b562a383a327bea1$var$Z_TREES) {
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                        break inf_leave;
                    }
                    break;
                case 2:
                    /* dynamic block */ //Tracev((stderr, "inflate:     dynamic codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $b562a383a327bea1$var$TABLE;
                    break;
                case 3:
                    strm.msg = "invalid block type";
                    state.mode = $b562a383a327bea1$var$BAD;
            }
            //--- DROPBITS(2) ---//
            hold >>>= 2;
            bits -= 2;
            break;
        case $b562a383a327bea1$var$STORED:
            //--- BYTEBITS() ---// /* go to byte boundary */
            hold >>>= bits & 7;
            bits -= bits & 7;
            //---//
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if ((hold & 0xffff) !== (hold >>> 16 ^ 0xffff)) {
                strm.msg = "invalid stored block lengths";
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            state.length = hold & 0xffff;
            //Tracev((stderr, "inflate:       stored length %u\n",
            //        state.length));
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $b562a383a327bea1$var$COPY_;
            if (flush === $b562a383a327bea1$var$Z_TREES) break inf_leave;
        /* falls through */ case $b562a383a327bea1$var$COPY_:
            state.mode = $b562a383a327bea1$var$COPY;
        /* falls through */ case $b562a383a327bea1$var$COPY:
            copy = state.length;
            if (copy) {
                if (copy > have) copy = have;
                if (copy > left) copy = left;
                if (copy === 0) break inf_leave;
                //--- zmemcpy(put, next, copy); ---
                $701cc75d47025217$exports.arraySet(output, input, next, copy, put);
                //---//
                have -= copy;
                next += copy;
                left -= copy;
                put += copy;
                state.length -= copy;
                break;
            }
            //Tracev((stderr, "inflate:       stored end\n"));
            state.mode = $b562a383a327bea1$var$TYPE;
            break;
        case $b562a383a327bea1$var$TABLE:
            //=== NEEDBITS(14); */
            while(bits < 14){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.nlen = (hold & 0x1f) + 257;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ndist = (hold & 0x1f) + 1;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ncode = (hold & 0x0f) + 4;
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            //#ifndef PKZIP_BUG_WORKAROUND
            if (state.nlen > 286 || state.ndist > 30) {
                strm.msg = "too many length or distance symbols";
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            //#endif
            //Tracev((stderr, "inflate:       table sizes ok\n"));
            state.have = 0;
            state.mode = $b562a383a327bea1$var$LENLENS;
        /* falls through */ case $b562a383a327bea1$var$LENLENS:
            while(state.have < state.ncode){
                //=== NEEDBITS(3);
                while(bits < 3){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.lens[order[state.have++]] = hold & 0x07; //BITS(3);
                //--- DROPBITS(3) ---//
                hold >>>= 3;
                bits -= 3;
            //---//
            }
            while(state.have < 19)state.lens[order[state.have++]] = 0;
            // We have separate tables & no pointers. 2 commented lines below not needed.
            //state.next = state.codes;
            //state.lencode = state.next;
            // Switch to use dynamic table
            state.lencode = state.lendyn;
            state.lenbits = 7;
            opts = {
                bits: state.lenbits
            };
            ret = $86622ca50c32b2ec$exports($b562a383a327bea1$var$CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
            state.lenbits = opts.bits;
            if (ret) {
                strm.msg = "invalid code lengths set";
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            //Tracev((stderr, "inflate:       code lengths ok\n"));
            state.have = 0;
            state.mode = $b562a383a327bea1$var$CODELENS;
        /* falls through */ case $b562a383a327bea1$var$CODELENS:
            while(state.have < state.nlen + state.ndist){
                for(;;){
                    here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                if (here_val < 16) {
                    //--- DROPBITS(here.bits) ---//
                    hold >>>= here_bits;
                    bits -= here_bits;
                    //---//
                    state.lens[state.have++] = here_val;
                } else {
                    if (here_val === 16) {
                        //=== NEEDBITS(here.bits + 2);
                        n = here_bits + 2;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        if (state.have === 0) {
                            strm.msg = "invalid bit length repeat";
                            state.mode = $b562a383a327bea1$var$BAD;
                            break;
                        }
                        len = state.lens[state.have - 1];
                        copy = 3 + (hold & 0x03); //BITS(2);
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                    //---//
                    } else if (here_val === 17) {
                        //=== NEEDBITS(here.bits + 3);
                        n = here_bits + 3;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 3 + (hold & 0x07); //BITS(3);
                        //--- DROPBITS(3) ---//
                        hold >>>= 3;
                        bits -= 3;
                    //---//
                    } else {
                        //=== NEEDBITS(here.bits + 7);
                        n = here_bits + 7;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 11 + (hold & 0x7f); //BITS(7);
                        //--- DROPBITS(7) ---//
                        hold >>>= 7;
                        bits -= 7;
                    //---//
                    }
                    if (state.have + copy > state.nlen + state.ndist) {
                        strm.msg = "invalid bit length repeat";
                        state.mode = $b562a383a327bea1$var$BAD;
                        break;
                    }
                    while(copy--)state.lens[state.have++] = len;
                }
            }
            /* handle error breaks in while */ if (state.mode === $b562a383a327bea1$var$BAD) break;
            /* check for end-of-block code (better have one) */ if (state.lens[256] === 0) {
                strm.msg = "invalid code -- missing end-of-block";
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            /* build code tables -- note: do not change the lenbits or distbits
           values here (9 and 6) without reading the comments in inftrees.h
           concerning the ENOUGH constants, which depend on those values */ state.lenbits = 9;
            opts = {
                bits: state.lenbits
            };
            ret = $86622ca50c32b2ec$exports($b562a383a327bea1$var$LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.lenbits = opts.bits;
            // state.lencode = state.next;
            if (ret) {
                strm.msg = "invalid literal/lengths set";
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            state.distbits = 6;
            //state.distcode.copy(state.codes);
            // Switch to use dynamic table
            state.distcode = state.distdyn;
            opts = {
                bits: state.distbits
            };
            ret = $86622ca50c32b2ec$exports($b562a383a327bea1$var$DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.distbits = opts.bits;
            // state.distcode = state.next;
            if (ret) {
                strm.msg = "invalid distances set";
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            //Tracev((stderr, 'inflate:       codes ok\n'));
            state.mode = $b562a383a327bea1$var$LEN_;
            if (flush === $b562a383a327bea1$var$Z_TREES) break inf_leave;
        /* falls through */ case $b562a383a327bea1$var$LEN_:
            state.mode = $b562a383a327bea1$var$LEN;
        /* falls through */ case $b562a383a327bea1$var$LEN:
            if (have >= 6 && left >= 258) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                $4f67bc996330e695$exports(strm, _out);
                //--- LOAD() ---
                put = strm.next_out;
                output = strm.output;
                left = strm.avail_out;
                next = strm.next_in;
                input = strm.input;
                have = strm.avail_in;
                hold = state.hold;
                bits = state.bits;
                //---
                if (state.mode === $b562a383a327bea1$var$TYPE) state.back = -1;
                break;
            }
            state.back = 0;
            for(;;){
                here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if (here_op && (here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.lencode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            state.length = here_val;
            if (here_op === 0) {
                //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
                //        "inflate:         literal '%c'\n" :
                //        "inflate:         literal 0x%02x\n", here.val));
                state.mode = $b562a383a327bea1$var$LIT;
                break;
            }
            if (here_op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.back = -1;
                state.mode = $b562a383a327bea1$var$TYPE;
                break;
            }
            if (here_op & 64) {
                strm.msg = "invalid literal/length code";
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            state.extra = here_op & 15;
            state.mode = $b562a383a327bea1$var$LENEXT;
        /* falls through */ case $b562a383a327bea1$var$LENEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //Tracevv((stderr, "inflate:         length %u\n", state.length));
            state.was = state.length;
            state.mode = $b562a383a327bea1$var$DIST;
        /* falls through */ case $b562a383a327bea1$var$DIST:
            for(;;){
                here = state.distcode[hold & (1 << state.distbits) - 1]; /*BITS(state.distbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if ((here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.distcode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            if (here_op & 64) {
                strm.msg = "invalid distance code";
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            state.offset = here_val;
            state.extra = here_op & 15;
            state.mode = $b562a383a327bea1$var$DISTEXT;
        /* falls through */ case $b562a383a327bea1$var$DISTEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.offset += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //#ifdef INFLATE_STRICT
            if (state.offset > state.dmax) {
                strm.msg = "invalid distance too far back";
                state.mode = $b562a383a327bea1$var$BAD;
                break;
            }
            //#endif
            //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
            state.mode = $b562a383a327bea1$var$MATCH;
        /* falls through */ case $b562a383a327bea1$var$MATCH:
            if (left === 0) break inf_leave;
            copy = _out - left;
            if (state.offset > copy) {
                copy = state.offset - copy;
                if (copy > state.whave) {
                    if (state.sane) {
                        strm.msg = "invalid distance too far back";
                        state.mode = $b562a383a327bea1$var$BAD;
                        break;
                    }
                }
                if (copy > state.wnext) {
                    copy -= state.wnext;
                    from = state.wsize - copy;
                } else from = state.wnext - copy;
                if (copy > state.length) copy = state.length;
                from_source = state.window;
            } else {
                from_source = output;
                from = put - state.offset;
                copy = state.length;
            }
            if (copy > left) copy = left;
            left -= copy;
            state.length -= copy;
            do output[put++] = from_source[from++];
            while (--copy);
            if (state.length === 0) state.mode = $b562a383a327bea1$var$LEN;
            break;
        case $b562a383a327bea1$var$LIT:
            if (left === 0) break inf_leave;
            output[put++] = state.length;
            left--;
            state.mode = $b562a383a327bea1$var$LEN;
            break;
        case $b562a383a327bea1$var$CHECK:
            if (state.wrap) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    // Use '|' instead of '+' to make sure that result is signed
                    hold |= input[next++] << bits;
                    bits += 8;
                }
                //===//
                _out -= left;
                strm.total_out += _out;
                state.total += _out;
                if (_out) strm.adler = state.check = /*UPDATE(state.check, put - _out, _out);*/ state.flags ? $44e7d98dd6723a9a$exports(state.check, output, _out, put - _out) : $c2fc869ba2d0859c$exports(state.check, output, _out, put - _out);
                _out = left;
                // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
                if ((state.flags ? hold : $b562a383a327bea1$var$zswap32(hold)) !== state.check) {
                    strm.msg = "incorrect data check";
                    state.mode = $b562a383a327bea1$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   check matches trailer\n"));
            }
            state.mode = $b562a383a327bea1$var$LENGTH;
        /* falls through */ case $b562a383a327bea1$var$LENGTH:
            if (state.wrap && state.flags) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (hold !== (state.total & 0xffffffff)) {
                    strm.msg = "incorrect length check";
                    state.mode = $b562a383a327bea1$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   length matches trailer\n"));
            }
            state.mode = $b562a383a327bea1$var$DONE;
        /* falls through */ case $b562a383a327bea1$var$DONE:
            ret = $b562a383a327bea1$var$Z_STREAM_END;
            break inf_leave;
        case $b562a383a327bea1$var$BAD:
            ret = $b562a383a327bea1$var$Z_DATA_ERROR;
            break inf_leave;
        case $b562a383a327bea1$var$MEM:
            return $b562a383a327bea1$var$Z_MEM_ERROR;
        case $b562a383a327bea1$var$SYNC:
        /* falls through */ default:
            return $b562a383a327bea1$var$Z_STREAM_ERROR;
    }
    // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
    /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */ //--- RESTORE() ---
    strm.next_out = put;
    strm.avail_out = left;
    strm.next_in = next;
    strm.avail_in = have;
    state.hold = hold;
    state.bits = bits;
    //---
    if (state.wsize || _out !== strm.avail_out && state.mode < $b562a383a327bea1$var$BAD && (state.mode < $b562a383a327bea1$var$CHECK || flush !== $b562a383a327bea1$var$Z_FINISH)) {
        if ($b562a383a327bea1$var$updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
            state.mode = $b562a383a327bea1$var$MEM;
            return $b562a383a327bea1$var$Z_MEM_ERROR;
        }
    }
    _in -= strm.avail_in;
    _out -= strm.avail_out;
    strm.total_in += _in;
    strm.total_out += _out;
    state.total += _out;
    if (state.wrap && _out) strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/ state.flags ? $44e7d98dd6723a9a$exports(state.check, output, _out, strm.next_out - _out) : $c2fc869ba2d0859c$exports(state.check, output, _out, strm.next_out - _out);
    strm.data_type = state.bits + (state.last ? 64 : 0) + (state.mode === $b562a383a327bea1$var$TYPE ? 128 : 0) + (state.mode === $b562a383a327bea1$var$LEN_ || state.mode === $b562a383a327bea1$var$COPY_ ? 256 : 0);
    if ((_in === 0 && _out === 0 || flush === $b562a383a327bea1$var$Z_FINISH) && ret === $b562a383a327bea1$var$Z_OK) ret = $b562a383a327bea1$var$Z_BUF_ERROR;
    return ret;
}
function $b562a383a327bea1$var$inflateEnd(strm) {
    if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/ ) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    var state = strm.state;
    if (state.window) state.window = null;
    strm.state = null;
    return $b562a383a327bea1$var$Z_OK;
}
function $b562a383a327bea1$var$inflateGetHeader(strm, head) {
    var state;
    /* check state */ if (!strm || !strm.state) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    state = strm.state;
    if ((state.wrap & 2) === 0) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    /* save header structure */ state.head = head;
    head.done = false;
    return $b562a383a327bea1$var$Z_OK;
}
function $b562a383a327bea1$var$inflateSetDictionary(strm, dictionary) {
    var dictLength = dictionary.length;
    var state;
    var dictid;
    var ret;
    /* check state */ if (!strm /* == Z_NULL */  || !strm.state /* == Z_NULL */ ) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    state = strm.state;
    if (state.wrap !== 0 && state.mode !== $b562a383a327bea1$var$DICT) return $b562a383a327bea1$var$Z_STREAM_ERROR;
    /* check for correct dictionary identifier */ if (state.mode === $b562a383a327bea1$var$DICT) {
        dictid = 1; /* adler32(0, null, 0)*/ 
        /* dictid = adler32(dictid, dictionary, dictLength); */ dictid = $c2fc869ba2d0859c$exports(dictid, dictionary, dictLength, 0);
        if (dictid !== state.check) return $b562a383a327bea1$var$Z_DATA_ERROR;
    }
    /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */ ret = $b562a383a327bea1$var$updatewindow(strm, dictionary, dictLength, dictLength);
    if (ret) {
        state.mode = $b562a383a327bea1$var$MEM;
        return $b562a383a327bea1$var$Z_MEM_ERROR;
    }
    state.havedict = 1;
    // Tracev((stderr, "inflate:   dictionary set\n"));
    return $b562a383a327bea1$var$Z_OK;
}
$b562a383a327bea1$export$42de45683a92ba94 = $b562a383a327bea1$var$inflateReset;
$b562a383a327bea1$export$7633ac2cd30f9650 = $b562a383a327bea1$var$inflateReset2;
$b562a383a327bea1$export$6710ea52c4ec9d6a = $b562a383a327bea1$var$inflateResetKeep;
$b562a383a327bea1$export$9c140b25e26874f9 = $b562a383a327bea1$var$inflateInit;
$b562a383a327bea1$export$6792d92addc5c8a0 = $b562a383a327bea1$var$inflateInit2;
$b562a383a327bea1$export$cae1ce83fe4a1782 = $b562a383a327bea1$var$inflate;
$b562a383a327bea1$export$224e1a443c3fba76 = $b562a383a327bea1$var$inflateEnd;
$b562a383a327bea1$export$6d4647cb9e1c75fc = $b562a383a327bea1$var$inflateGetHeader;
$b562a383a327bea1$export$60da749bed98ccf8 = $b562a383a327bea1$var$inflateSetDictionary;
$b562a383a327bea1$export$220f6291ca35fd71 = "pako inflate (from Nodeca project)"; /* Not implemented
exports.inflateCopy = inflateCopy;
exports.inflateGetDictionary = inflateGetDictionary;
exports.inflateMark = inflateMark;
exports.inflatePrime = inflatePrime;
exports.inflateSync = inflateSync;
exports.inflateSyncPoint = inflateSyncPoint;
exports.inflateUndermine = inflateUndermine;
*/ 




var $c8d7af08a93a7841$exports = {};
"use strict";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
$c8d7af08a93a7841$exports = {
    /* Allowed flush values; see deflate() and inflate() below for details */ Z_NO_FLUSH: 0,
    Z_PARTIAL_FLUSH: 1,
    Z_SYNC_FLUSH: 2,
    Z_FULL_FLUSH: 3,
    Z_FINISH: 4,
    Z_BLOCK: 5,
    Z_TREES: 6,
    /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */ Z_OK: 0,
    Z_STREAM_END: 1,
    Z_NEED_DICT: 2,
    Z_ERRNO: -1,
    Z_STREAM_ERROR: -2,
    Z_DATA_ERROR: -3,
    //Z_MEM_ERROR:     -4,
    Z_BUF_ERROR: -5,
    //Z_VERSION_ERROR: -6,
    /* compression levels */ Z_NO_COMPRESSION: 0,
    Z_BEST_SPEED: 1,
    Z_BEST_COMPRESSION: 9,
    Z_DEFAULT_COMPRESSION: -1,
    Z_FILTERED: 1,
    Z_HUFFMAN_ONLY: 2,
    Z_RLE: 3,
    Z_FIXED: 4,
    Z_DEFAULT_STRATEGY: 0,
    /* Possible values of the data_type field (though see inflate()) */ Z_BINARY: 0,
    Z_TEXT: 1,
    //Z_ASCII:                1, // = Z_TEXT (deprecated)
    Z_UNKNOWN: 2,
    /* The deflate compression method */ Z_DEFLATED: 8
};




var $6e4bef2851e6b301$exports = {};
"use strict";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $6e4bef2851e6b301$var$GZheader() {
    /* true if compressed data believed to be text */ this.text = 0;
    /* modification time */ this.time = 0;
    /* extra flags (not used when writing a gzip file) */ this.xflags = 0;
    /* operating system */ this.os = 0;
    /* pointer to extra field or Z_NULL if none */ this.extra = null;
    /* extra field length (valid if extra != Z_NULL) */ this.extra_len = 0; // Actually, we don't need it in JS,
    // but leave for few code modifications
    //
    // Setup limits is not necessary because in js we should not preallocate memory
    // for inflate use constant limit in 65536 bytes
    //
    /* space at extra (only when reading header) */ // this.extra_max  = 0;
    /* pointer to zero-terminated file name or Z_NULL */ this.name = "";
    /* space at name (only when reading header) */ // this.name_max   = 0;
    /* pointer to zero-terminated comment or Z_NULL */ this.comment = "";
    /* space at comment (only when reading header) */ // this.comm_max   = 0;
    /* true if there was or will be a header crc */ this.hcrc = 0;
    /* true when done reading gzip header (not used when writing a gzip file) */ this.done = false;
}
$6e4bef2851e6b301$exports = $6e4bef2851e6b301$var$GZheader;


var $2c8537a6b47169be$var$toString = Object.prototype.toString;
/**
 * class Inflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[inflate]]
 * and [[inflateRaw]].
 **/ /* internal
 * inflate.chunks -> Array
 *
 * Chunks of output data, if [[Inflate#onData]] not overridden.
 **/ /**
 * Inflate.result -> Uint8Array|Array|String
 *
 * Uncompressed result, generated by default [[Inflate#onData]]
 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Inflate#push]] with `Z_FINISH` / `true` param) or if you
 * push a chunk with explicit flush (call [[Inflate#push]] with
 * `Z_SYNC_FLUSH` param).
 **/ /**
 * Inflate.err -> Number
 *
 * Error code after inflate finished. 0 (Z_OK) on success.
 * Should be checked if broken data possible.
 **/ /**
 * Inflate.msg -> String
 *
 * Error message, if [[Inflate.err]] != 0
 **/ /**
 * new Inflate(options)
 * - options (Object): zlib inflate options.
 *
 * Creates new inflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `windowBits`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw inflate
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 * By default, when no options set, autodetect deflate/gzip data format via
 * wrapper header.
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * var inflate = new pako.Inflate({ level: 3});
 *
 * inflate.push(chunk1, false);
 * inflate.push(chunk2, true);  // true -> last chunk
 *
 * if (inflate.err) { throw new Error(inflate.err); }
 *
 * console.log(inflate.result);
 * ```
 **/ function $2c8537a6b47169be$var$Inflate(options) {
    if (!(this instanceof $2c8537a6b47169be$var$Inflate)) return new $2c8537a6b47169be$var$Inflate(options);
    this.options = $701cc75d47025217$exports.assign({
        chunkSize: 16384,
        windowBits: 0,
        to: ""
    }, options || {});
    var opt = this.options;
    // Force window size for `raw` data, if not set directly,
    // because we have no header for autodetect.
    if (opt.raw && opt.windowBits >= 0 && opt.windowBits < 16) {
        opt.windowBits = -opt.windowBits;
        if (opt.windowBits === 0) opt.windowBits = -15;
    }
    // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
    if (opt.windowBits >= 0 && opt.windowBits < 16 && !(options && options.windowBits)) opt.windowBits += 32;
    // Gzip header has no info about windows size, we can do autodetect only
    // for deflate. So, if window size not set, force it to max when gzip possible
    if (opt.windowBits > 15 && opt.windowBits < 48) // bit 3 (16) -> gzipped data
    // bit 4 (32) -> autodetect gzip/deflate
    {
        if ((opt.windowBits & 15) === 0) opt.windowBits |= 15;
    }
    this.err = 0; // error code, if happens (0 = Z_OK)
    this.msg = ""; // error message
    this.ended = false; // used to avoid multiple onEnd() calls
    this.chunks = []; // chunks of compressed data
    this.strm = new $73d8265e2c50d00b$exports();
    this.strm.avail_out = 0;
    var status = $b562a383a327bea1$export$6792d92addc5c8a0(this.strm, opt.windowBits);
    if (status !== $c8d7af08a93a7841$exports.Z_OK) throw new Error($54a63c0c56b6e112$exports[status]);
    this.header = new $6e4bef2851e6b301$exports();
    $b562a383a327bea1$export$6d4647cb9e1c75fc(this.strm, this.header);
    // Setup dictionary
    if (opt.dictionary) {
        // Convert data if needed
        if (typeof opt.dictionary === "string") opt.dictionary = $d8cddf31faab2448$export$7a4c1b2f775b5a9f(opt.dictionary);
        else if ($2c8537a6b47169be$var$toString.call(opt.dictionary) === "[object ArrayBuffer]") opt.dictionary = new Uint8Array(opt.dictionary);
        if (opt.raw) {
            status = $b562a383a327bea1$export$60da749bed98ccf8(this.strm, opt.dictionary);
            if (status !== $c8d7af08a93a7841$exports.Z_OK) throw new Error($54a63c0c56b6e112$exports[status]);
        }
    }
}
/**
 * Inflate#push(data[, mode]) -> Boolean
 * - data (Uint8Array|Array|ArrayBuffer|String): input data
 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
 * new output chunks. Returns `true` on success. The last data block must have
 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
 * [[Inflate#onEnd]]. For interim explicit flushes (without ending the stream) you
 * can use mode Z_SYNC_FLUSH, keeping the decompression context.
 *
 * On fail call [[Inflate#onEnd]] with error code and return false.
 *
 * We strongly recommend to use `Uint8Array` on input for best speed (output
 * format is detected automatically). Also, don't skip last param and always
 * use the same type in your code (boolean or number). That will improve JS speed.
 *
 * For regular `Array`-s make sure all elements are [0..255].
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ $2c8537a6b47169be$var$Inflate.prototype.push = function(data, mode) {
    var strm = this.strm;
    var chunkSize = this.options.chunkSize;
    var dictionary = this.options.dictionary;
    var status, _mode;
    var next_out_utf8, tail, utf8str;
    // Flag to properly process Z_BUF_ERROR on testing inflate call
    // when we check that all output data was flushed.
    var allowBufError = false;
    if (this.ended) return false;
    _mode = mode === ~~mode ? mode : mode === true ? $c8d7af08a93a7841$exports.Z_FINISH : $c8d7af08a93a7841$exports.Z_NO_FLUSH;
    // Convert data if needed
    if (typeof data === "string") // Only binary strings can be decompressed on practice
    strm.input = $d8cddf31faab2448$export$1d1a7119601ff18c(data);
    else if ($2c8537a6b47169be$var$toString.call(data) === "[object ArrayBuffer]") strm.input = new Uint8Array(data);
    else strm.input = data;
    strm.next_in = 0;
    strm.avail_in = strm.input.length;
    do {
        if (strm.avail_out === 0) {
            strm.output = new $701cc75d47025217$exports.Buf8(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
        }
        status = $b562a383a327bea1$export$cae1ce83fe4a1782(strm, $c8d7af08a93a7841$exports.Z_NO_FLUSH); /* no bad return value */ 
        if (status === $c8d7af08a93a7841$exports.Z_NEED_DICT && dictionary) status = $b562a383a327bea1$export$60da749bed98ccf8(this.strm, dictionary);
        if (status === $c8d7af08a93a7841$exports.Z_BUF_ERROR && allowBufError === true) {
            status = $c8d7af08a93a7841$exports.Z_OK;
            allowBufError = false;
        }
        if (status !== $c8d7af08a93a7841$exports.Z_STREAM_END && status !== $c8d7af08a93a7841$exports.Z_OK) {
            this.onEnd(status);
            this.ended = true;
            return false;
        }
        if (strm.next_out) {
            if (strm.avail_out === 0 || status === $c8d7af08a93a7841$exports.Z_STREAM_END || strm.avail_in === 0 && (_mode === $c8d7af08a93a7841$exports.Z_FINISH || _mode === $c8d7af08a93a7841$exports.Z_SYNC_FLUSH)) {
                if (this.options.to === "string") {
                    next_out_utf8 = $d8cddf31faab2448$export$53dee3f58a714214(strm.output, strm.next_out);
                    tail = strm.next_out - next_out_utf8;
                    utf8str = $d8cddf31faab2448$export$49a50563f377746(strm.output, next_out_utf8);
                    // move tail
                    strm.next_out = tail;
                    strm.avail_out = chunkSize - tail;
                    if (tail) $701cc75d47025217$exports.arraySet(strm.output, strm.output, next_out_utf8, tail, 0);
                    this.onData(utf8str);
                } else this.onData($701cc75d47025217$exports.shrinkBuf(strm.output, strm.next_out));
            }
        }
        // When no more input data, we should check that internal inflate buffers
        // are flushed. The only way to do it when avail_out = 0 - run one more
        // inflate pass. But if output data not exists, inflate return Z_BUF_ERROR.
        // Here we set flag to process this error properly.
        //
        // NOTE. Deflate does not return error in this case and does not needs such
        // logic.
        if (strm.avail_in === 0 && strm.avail_out === 0) allowBufError = true;
    }while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== $c8d7af08a93a7841$exports.Z_STREAM_END);
    if (status === $c8d7af08a93a7841$exports.Z_STREAM_END) _mode = $c8d7af08a93a7841$exports.Z_FINISH;
    // Finalize on the last chunk.
    if (_mode === $c8d7af08a93a7841$exports.Z_FINISH) {
        status = $b562a383a327bea1$export$224e1a443c3fba76(this.strm);
        this.onEnd(status);
        this.ended = true;
        return status === $c8d7af08a93a7841$exports.Z_OK;
    }
    // callback interim results if Z_SYNC_FLUSH.
    if (_mode === $c8d7af08a93a7841$exports.Z_SYNC_FLUSH) {
        this.onEnd($c8d7af08a93a7841$exports.Z_OK);
        strm.avail_out = 0;
        return true;
    }
    return true;
};
/**
 * Inflate#onData(chunk) -> Void
 * - chunk (Uint8Array|Array|String): output data. Type of array depends
 *   on js engine support. When string output requested, each chunk
 *   will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ $2c8537a6b47169be$var$Inflate.prototype.onData = function(chunk) {
    this.chunks.push(chunk);
};
/**
 * Inflate#onEnd(status) -> Void
 * - status (Number): inflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called either after you tell inflate that the input stream is
 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
 * or if an error happened. By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ $2c8537a6b47169be$var$Inflate.prototype.onEnd = function(status) {
    // On success - join
    if (status === $c8d7af08a93a7841$exports.Z_OK) {
        if (this.options.to === "string") // Glue & convert here, until we teach pako to send
        // utf8 aligned strings to onData
        this.result = this.chunks.join("");
        else this.result = $701cc75d47025217$exports.flattenChunks(this.chunks);
    }
    this.chunks = [];
    this.err = status;
    this.msg = this.strm.msg;
};
/**
 * inflate(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Decompress `data` with inflate/ungzip and `options`. Autodetect
 * format via wrapper header by default. That's why we don't provide
 * separate `ungzip` method.
 *
 * Supported options are:
 *
 * - windowBits
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , input = pako.deflate([1,2,3,4,5,6,7,8,9])
 *   , output;
 *
 * try {
 *   output = pako.inflate(input);
 * } catch (err)
 *   console.log(err);
 * }
 * ```
 **/ function $2c8537a6b47169be$var$inflate(input, options) {
    var inflator = new $2c8537a6b47169be$var$Inflate(options);
    inflator.push(input, true);
    // That will never happens, if you don't cheat with options :)
    if (inflator.err) throw inflator.msg || $54a63c0c56b6e112$exports[inflator.err];
    return inflator.result;
}
/**
 * inflateRaw(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * The same as [[inflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function $2c8537a6b47169be$var$inflateRaw(input, options) {
    options = options || {};
    options.raw = true;
    return $2c8537a6b47169be$var$inflate(input, options);
}
$2c8537a6b47169be$export$d1de70a877d6e43c = $2c8537a6b47169be$var$Inflate;
$2c8537a6b47169be$export$cae1ce83fe4a1782 = $2c8537a6b47169be$var$inflate;
$2c8537a6b47169be$export$d0f0aa2d05c905c5 = $2c8537a6b47169be$var$inflateRaw;
$2c8537a6b47169be$export$95adf9d270383091 = $2c8537a6b47169be$var$inflate;



var $8fa5292818130bae$var$pako = {};
$8fa5292818130bae$require$assign($8fa5292818130bae$var$pako, $1d57b756249bc6d3$exports, $2c8537a6b47169be$exports, $c8d7af08a93a7841$exports);
$8fa5292818130bae$exports = $8fa5292818130bae$var$pako;


var $c488d752965ebb38$exports = {};
!function(e, r) {
    "function" == typeof define && define.amd ? define([], r) : $c488d752965ebb38$exports = r();
}($c488d752965ebb38$exports, function() {
    "use strict";
    function r(t) {
        if ("function" != typeof Promise) throw new Error("Promise implementation not available in this environment.");
        var a = [], n = [];
        function i(e) {
            for(var r = 0, t = a.length; r < t; ++r)a[r](e);
            n.push(e);
        }
        var o = new Promise(function(e, r) {
            t(e, r, i);
        });
        o.progress = function(e) {
            if ("function" != typeof e) throw new Error("cb is not a function.");
            for(var r = 0, t = n.length; r < t; ++r)e(n[r]);
            return a.push(e), o;
        };
        var s = o.then;
        return o.then = function(e, r, t) {
            return s.call(o, e, r), void 0 !== t && o.progress(t), o;
        }, o;
    }
    var t = (window || this).URL.createObjectURL(new Blob([
        '"use strict";function UntarWorker(){}var worker;function decodeUTF8(e){for(var r="",t=0;t<e.length;){var a=e[t++];if(127<a){if(191<a&&a<224){if(t>=e.length)throw"UTF-8 decode: incomplete 2-byte sequence";a=(31&a)<<6|63&e[t]}else if(223<a&&a<240){if(t+1>=e.length)throw"UTF-8 decode: incomplete 3-byte sequence";a=(15&a)<<12|(63&e[t])<<6|63&e[++t]}else{if(!(239<a&&a<248))throw"UTF-8 decode: unknown multibyte start 0x"+a.toString(16)+" at index "+(t-1);if(t+2>=e.length)throw"UTF-8 decode: incomplete 4-byte sequence";a=(7&a)<<18|(63&e[t])<<12|(63&e[++t])<<6|63&e[++t]}++t}if(a<=65535)r+=String.fromCharCode(a);else{if(!(a<=1114111))throw"UTF-8 decode: code point 0x"+a.toString(16)+" exceeds UTF-16 reach";a-=65536,r+=String.fromCharCode(a>>10|55296),r+=String.fromCharCode(1023&a|56320)}}return r}function PaxHeader(e){this._fields=e}function TarFile(){}function UntarStream(e){this._bufferView=new DataView(e),this._position=0}function UntarFileStream(e){this._stream=new UntarStream(e),this._globalPaxHeader=null}UntarWorker.prototype={onmessage:function(e){try{if("extract"!==e.data.type)throw new Error("Unknown message type: "+e.data.type);this.untarBuffer(e.data.buffer)}catch(e){this.postError(e)}},postError:function(e){this.postMessage({type:"error",data:{message:e.message}})},postLog:function(e,r){this.postMessage({type:"log",data:{level:e,msg:r}})},untarBuffer:function(e){try{for(var r=new UntarFileStream(e);r.hasNext();){var t=r.next();this.postMessage({type:"extract",data:t},[t.buffer])}this.postMessage({type:"complete"})}catch(e){this.postError(e)}},postMessage:function(e,r){self.postMessage(e,r)}},"undefined"!=typeof self&&(worker=new UntarWorker,self.onmessage=function(e){worker.onmessage(e)}),PaxHeader.parse=function(e){for(var r=new Uint8Array(e),t=[];0<r.length;){var a=parseInt(decodeUTF8(r.subarray(0,r.indexOf(32)))),n=decodeUTF8(r.subarray(0,a)).match(/^\\d+ ([^=]+)=(.*)\\n$/);if(null===n)throw new Error("Invalid PAX header data format.");var i=n[1],s=n[2];0===s.length?s=null:null!==s.match(/^\\d+$/)&&(s=parseInt(s));var o={name:i,value:s};t.push(o),r=r.subarray(a)}return new PaxHeader(t)},PaxHeader.prototype={applyHeader:function(a){this._fields.forEach(function(e){var r=e.name,t=e.value;"path"===r?(r="name",void 0!==a.prefix&&delete a.prefix):"linkpath"===r&&(r="linkname"),null===t?delete a[r]:a[r]=t})}},UntarStream.prototype={readString:function(e){for(var r=+e,t=[],a=0;a<e;++a){var n=this._bufferView.getUint8(this.position()+ +a,!0);if(0===n)break;t.push(n)}return this.seek(r),String.fromCharCode.apply(null,t)},readBuffer:function(e){var r,t,a;return"function"==typeof ArrayBuffer.prototype.slice?r=this._bufferView.buffer.slice(this.position(),this.position()+e):(r=new ArrayBuffer(e),t=new Uint8Array(r),a=new Uint8Array(this._bufferView.buffer,this.position(),e),t.set(a)),this.seek(e),r},seek:function(e){this._position+=e},peekUint32:function(){return this._bufferView.getUint32(this.position(),!0)},position:function(e){if(void 0===e)return this._position;this._position=e},size:function(){return this._bufferView.byteLength}},UntarFileStream.prototype={hasNext:function(){return this._stream.position()+4<this._stream.size()&&0!==this._stream.peekUint32()},next:function(){return this._readNextFile()},_readNextFile:function(){var e=this._stream,r=new TarFile,t=!1,a=null,n=e.position()+512;switch(r.name=e.readString(100),r.mode=e.readString(8),r.uid=parseInt(e.readString(8)),r.gid=parseInt(e.readString(8)),r.size=parseInt(e.readString(12),8),r.mtime=parseInt(e.readString(12),8),r.checksum=parseInt(e.readString(8)),r.type=e.readString(1),r.linkname=e.readString(100),r.ustarFormat=e.readString(6),-1<r.ustarFormat.indexOf("ustar")&&(r.version=e.readString(2),r.uname=e.readString(32),r.gname=e.readString(32),r.devmajor=parseInt(e.readString(8)),r.devminor=parseInt(e.readString(8)),r.namePrefix=e.readString(155),0<r.namePrefix.length&&(r.name=r.namePrefix+"/"+r.name)),e.position(n),r.type){case"0":case"":r.buffer=e.readBuffer(r.size);break;case"1":case"2":case"3":case"4":case"5":case"6":case"7":break;case"g":t=!0,this._globalPaxHeader=PaxHeader.parse(e.readBuffer(r.size));break;case"x":t=!0,a=PaxHeader.parse(e.readBuffer(r.size))}void 0===r.buffer&&(r.buffer=new ArrayBuffer(0));var i=n+r.size;return r.size%512!=0&&(i+=512-r.size%512),e.position(i),t&&(r=this._readNextFile()),null!==this._globalPaxHeader&&this._globalPaxHeader.applyHeader(r),null!==a&&a.applyHeader(r),r}};'
    ])), a = window || this, e = a.URL || a.webkitURL;
    var f = {
        blob: {
            get: function() {
                return this._blob || (this._blob = new Blob([
                    this.buffer
                ]));
            }
        },
        getBlobUrl: {
            value: function() {
                return this._blobUrl || (this._blobUrl = e.createObjectURL(this.blob));
            }
        },
        readAsString: {
            value: function() {
                for(var e = this.buffer, r = e.byteLength, t = new DataView(e), a = "", n = 0; n < r; ++n){
                    var i = t.getUint8(+n, !0);
                    a += String.fromCharCode(i);
                }
                return this._string = a;
            }
        },
        readAsJSON: {
            value: function() {
                return JSON.parse(this.readAsString());
            }
        }
    };
    return function(e) {
        if (!(e instanceof ArrayBuffer)) throw new TypeError("arrayBuffer is not an instance of ArrayBuffer.");
        if (!a.Worker) throw new Error("Worker implementation is not available in this environment.");
        return new r(function(a, n, i) {
            var o = new Worker(t), s = [];
            o.onerror = function(e) {
                n(e);
            }, o.onmessage = function(e) {
                switch((e = e.data).type){
                    case "log":
                        console[e.data.level]("Worker: " + e.data.msg);
                        break;
                    case "extract":
                        var r = (t = e.data, Object.defineProperties(t, f), t);
                        s.push(r), i(r);
                        break;
                    case "complete":
                        o.terminate(), a(s);
                        break;
                    case "error":
                        o.terminate(), n(new Error(e.data.message));
                        break;
                    default:
                        o.terminate(), n(new Error("Unknown message from worker: " + e.type));
                }
                var t;
            }, o.postMessage({
                type: "extract",
                buffer: e
            }, [
                e
            ]);
        });
    };
});


var $e835d3077c64ee50$exports = {};
/**
 * @module  string-to-arraybuffer
 */ "use strict";
var $1cf6ca991a8ade09$exports = {};
$1cf6ca991a8ade09$exports = function _atob(str) {
    return atob(str);
};



var $iIDdR = parcelRequire("iIDdR");
$e835d3077c64ee50$exports = function stringToArrayBuffer(arg) {
    if (typeof arg !== "string") throw Error("Argument should be a string");
    //valid data uri
    if (/^data\:/i.test(arg)) return $e835d3077c64ee50$var$decode(arg);
    //base64
    if ($iIDdR(arg)) arg = $1cf6ca991a8ade09$exports(arg);
    return $e835d3077c64ee50$var$str2ab(arg);
};
function $e835d3077c64ee50$var$str2ab(str) {
    var array = new Uint8Array(str.length);
    for(var i = 0; i < str.length; i++)array[i] = str.charCodeAt(i);
    return array.buffer;
}
function $e835d3077c64ee50$var$decode(uri) {
    // strip newlines
    uri = uri.replace(/\r?\n/g, "");
    // split the URI up into the "metadata" and the "data" portions
    var firstComma = uri.indexOf(",");
    if (-1 === firstComma || firstComma <= 4) throw new TypeError("malformed data-URI");
    // remove the "data:" scheme and parse the metadata
    var meta = uri.substring(5, firstComma).split(";");
    var base64 = false;
    var charset = "US-ASCII";
    for(var i = 0; i < meta.length; i++){
        if ("base64" == meta[i]) base64 = true;
        else if (0 == meta[i].indexOf("charset=")) charset = meta[i].substring(8);
    }
    // get the encoded data portion and decode URI-encoded chars
    var data = unescape(uri.substring(firstComma + 1));
    if (base64) data = $1cf6ca991a8ade09$exports(data);
    var abuf = $e835d3077c64ee50$var$str2ab(data);
    abuf.type = meta[0] || "text/plain";
    abuf.charset = charset;
    return abuf;
}


var $d243cabdb0815a3b$exports = {};
"use strict"; // In Browsers we create an adapter, get the SMART api from it and build the
var $2241136b1aba1e64$exports = {};
"use strict";
Object.defineProperty($2241136b1aba1e64$exports, "__esModule", {
    value: true
});
var $9b169f72336acb48$exports = {};
"use strict";
Object.defineProperty($9b169f72336acb48$exports, "__esModule", {
    value: true
});
$9b169f72336acb48$exports.init = $9b169f72336acb48$exports.ready = $9b169f72336acb48$exports.buildTokenRequest = $9b169f72336acb48$exports.completeAuth = $9b169f72336acb48$exports.onMessage = $9b169f72336acb48$exports.isInPopUp = $9b169f72336acb48$exports.isInFrame = $9b169f72336acb48$exports.authorize = $9b169f72336acb48$exports.getSecurityExtensions = $9b169f72336acb48$exports.fetchWellKnownJson = $9b169f72336acb48$exports.KEY = void 0;
var $3e6dcbd6932f03cd$exports = {};
"use strict";
/*
 * This file contains some shared functions. They are used by other modules, but
 * are defined here so that tests can import this library and test them.
 */ Object.defineProperty($3e6dcbd6932f03cd$exports, "__esModule", {
    value: true
});
$3e6dcbd6932f03cd$exports.getTargetWindow = $3e6dcbd6932f03cd$exports.getPatientParam = $3e6dcbd6932f03cd$exports.byCodes = $3e6dcbd6932f03cd$exports.byCode = $3e6dcbd6932f03cd$exports.getAccessTokenExpiration = $3e6dcbd6932f03cd$exports.jwtDecode = $3e6dcbd6932f03cd$exports.randomString = $3e6dcbd6932f03cd$exports.absolute = $3e6dcbd6932f03cd$exports.makeArray = $3e6dcbd6932f03cd$exports.setPath = $3e6dcbd6932f03cd$exports.getPath = $3e6dcbd6932f03cd$exports.humanizeError = $3e6dcbd6932f03cd$exports.fetchConformanceStatement = $3e6dcbd6932f03cd$exports.getAndCache = $3e6dcbd6932f03cd$exports.request = $3e6dcbd6932f03cd$exports.responseToJSON = $3e6dcbd6932f03cd$exports.checkResponse = $3e6dcbd6932f03cd$exports.units = $3e6dcbd6932f03cd$exports.debug = void 0;
var $d50f68baa55af7ac$exports = {};
"use strict";
Object.defineProperty($d50f68baa55af7ac$exports, "__esModule", {
    value: true
});
class $d50f68baa55af7ac$var$HttpError extends Error {
    constructor(message = "Unknown error", statusCode = 0, statusText = "Error", body = null){
        super(message);
        this.message = message;
        this.name = "HttpError";
        this.statusCode = statusCode;
        this.status = statusCode;
        this.statusText = statusText;
        this.body = body;
    }
    toJSON() {
        return {
            name: this.name,
            statusCode: this.statusCode,
            status: this.status,
            statusText: this.statusText,
            message: this.message,
            body: this.body
        };
    }
}
$d50f68baa55af7ac$exports.default = $d50f68baa55af7ac$var$HttpError;


var $e5e6e34664e6599f$exports = {};
"use strict";
Object.defineProperty($e5e6e34664e6599f$exports, "__esModule", {
    value: true
});
$e5e6e34664e6599f$exports.SMART_KEY = $e5e6e34664e6599f$exports.patientParams = $e5e6e34664e6599f$exports.fhirVersions = $e5e6e34664e6599f$exports.patientCompartment = void 0;
/**
 * Combined list of FHIR resource types accepting patient parameter in FHIR R2-R4
 */ $e5e6e34664e6599f$exports.patientCompartment = [
    "Account",
    "AdverseEvent",
    "AllergyIntolerance",
    "Appointment",
    "AppointmentResponse",
    "AuditEvent",
    "Basic",
    "BodySite",
    "BodyStructure",
    "CarePlan",
    "CareTeam",
    "ChargeItem",
    "Claim",
    "ClaimResponse",
    "ClinicalImpression",
    "Communication",
    "CommunicationRequest",
    "Composition",
    "Condition",
    "Consent",
    "Coverage",
    "CoverageEligibilityRequest",
    "CoverageEligibilityResponse",
    "DetectedIssue",
    "DeviceRequest",
    "DeviceUseRequest",
    "DeviceUseStatement",
    "DiagnosticOrder",
    "DiagnosticReport",
    "DocumentManifest",
    "DocumentReference",
    "EligibilityRequest",
    "Encounter",
    "EnrollmentRequest",
    "EpisodeOfCare",
    "ExplanationOfBenefit",
    "FamilyMemberHistory",
    "Flag",
    "Goal",
    "Group",
    "ImagingManifest",
    "ImagingObjectSelection",
    "ImagingStudy",
    "Immunization",
    "ImmunizationEvaluation",
    "ImmunizationRecommendation",
    "Invoice",
    "List",
    "MeasureReport",
    "Media",
    "MedicationAdministration",
    "MedicationDispense",
    "MedicationOrder",
    "MedicationRequest",
    "MedicationStatement",
    "MolecularSequence",
    "NutritionOrder",
    "Observation",
    "Order",
    "Patient",
    "Person",
    "Procedure",
    "ProcedureRequest",
    "Provenance",
    "QuestionnaireResponse",
    "ReferralRequest",
    "RelatedPerson",
    "RequestGroup",
    "ResearchSubject",
    "RiskAssessment",
    "Schedule",
    "ServiceRequest",
    "Specimen",
    "SupplyDelivery",
    "SupplyRequest",
    "VisionPrescription"
];
/**
 * Map of FHIR releases and their abstract version as number
 */ $e5e6e34664e6599f$exports.fhirVersions = {
    "0.4.0": 2,
    "0.5.0": 2,
    "1.0.0": 2,
    "1.0.1": 2,
    "1.0.2": 2,
    "1.1.0": 3,
    "1.4.0": 3,
    "1.6.0": 3,
    "1.8.0": 3,
    "3.0.0": 3,
    "3.0.1": 3,
    "3.3.0": 4,
    "3.5.0": 4,
    "4.0.0": 4,
    "4.0.1": 4
};
/**
 * Combined (FHIR R2-R4) list of search parameters that can be used to scope
 * a request by patient ID.
 */ $e5e6e34664e6599f$exports.patientParams = [
    "patient",
    "subject",
    "requester",
    "member",
    "actor",
    "beneficiary"
];
/**
 * The name of the sessionStorage entry that contains the current key
 */ $e5e6e34664e6599f$exports.SMART_KEY = "SMART_KEY";



var $1SXIy = parcelRequire("1SXIy");

// @ts-ignore
const { fetch: $3e6dcbd6932f03cd$var$fetch } = typeof FHIRCLIENT_PURE !== "undefined" ? window : (parcelRequire("R5nvG")); // $lab:coverage:on$
const $3e6dcbd6932f03cd$var$_debug = $1SXIy("FHIR");
$3e6dcbd6932f03cd$exports.debug = $3e6dcbd6932f03cd$var$_debug;
/**
 * The cache for the `getAndCache` function
 */ const $3e6dcbd6932f03cd$var$cache = {};
/**
 * A namespace with functions for converting between different measurement units
 */ $3e6dcbd6932f03cd$exports.units = {
    cm ({ code: code, value: value }) {
        $3e6dcbd6932f03cd$var$ensureNumerical({
            code: code,
            value: value
        });
        if (code == "cm") return value;
        if (code == "m") return value * 100;
        if (code == "in") return value * 2.54;
        if (code == "[in_us]") return value * 2.54;
        if (code == "[in_i]") return value * 2.54;
        if (code == "ft") return value * 30.48;
        if (code == "[ft_us]") return value * 30.48;
        throw new Error("Unrecognized length unit: " + code);
    },
    kg ({ code: code, value: value }) {
        $3e6dcbd6932f03cd$var$ensureNumerical({
            code: code,
            value: value
        });
        if (code == "kg") return value;
        if (code == "g") return value / 1000;
        if (code.match(/lb/)) return value / 2.20462;
        if (code.match(/oz/)) return value / 35.274;
        throw new Error("Unrecognized weight unit: " + code);
    },
    any (pq) {
        $3e6dcbd6932f03cd$var$ensureNumerical(pq);
        return pq.value;
    }
};
/**
 * Assertion function to guard arguments for `units` functions
 */ function $3e6dcbd6932f03cd$var$ensureNumerical({ value: value, code: code }) {
    if (typeof value !== "number") throw new Error("Found a non-numerical unit: " + value + " " + code);
}
/**
 * Used in fetch Promise chains to reject if the "ok" property is not true
 */ async function $3e6dcbd6932f03cd$var$checkResponse(resp) {
    if (!resp.ok) throw await $3e6dcbd6932f03cd$var$humanizeError(resp);
    return resp;
}
$3e6dcbd6932f03cd$exports.checkResponse = $3e6dcbd6932f03cd$var$checkResponse;
/**
 * Used in fetch Promise chains to return the JSON version of the response.
 * Note that `resp.json()` will throw on empty body so we use resp.text()
 * instead.
 */ function $3e6dcbd6932f03cd$var$responseToJSON(resp) {
    return resp.text().then((text)=>text.length ? JSON.parse(text) : "");
}
$3e6dcbd6932f03cd$exports.responseToJSON = $3e6dcbd6932f03cd$var$responseToJSON;
/**
 * This is our built-in request function. It does a few things by default
 * (unless told otherwise):
 * - Makes CORS requests
 * - Sets accept header to "application/json"
 * - Handles errors
 * - If the response is json return the json object
 * - If the response is text return the result text
 * - Otherwise return the response object on which we call stuff like `.blob()`
 */ function $3e6dcbd6932f03cd$var$request(url, options = {}) {
    return $3e6dcbd6932f03cd$var$fetch(url, Object.assign(Object.assign({
        mode: "cors"
    }, options), {
        headers: Object.assign({
            accept: "application/json"
        }, options.headers)
    })).then($3e6dcbd6932f03cd$var$checkResponse).then((res)=>{
        const type = res.headers.get("Content-Type") + "";
        if (type.match(/\bjson\b/i)) return $3e6dcbd6932f03cd$var$responseToJSON(res).then((body)=>({
                res: res,
                body: body
            }));
        if (type.match(/^text\//i)) return res.text().then((body)=>({
                res: res,
                body: body
            }));
        return {
            res: res
        };
    }).then(({ res: res, body: body })=>{
        // Some servers will reply after CREATE with json content type but with
        // empty body. In this case check if a location header is received and
        // fetch that to use it as the final result.
        if (!body && res.status == 201) {
            const location = res.headers.get("location") + "";
            if (location) return $3e6dcbd6932f03cd$var$request(location, Object.assign(Object.assign({}, options), {
                method: "GET",
                body: null
            }));
        } // For any non-text and non-json response return the Response object.
        // This to let users decide if they want to call text(), blob() or
        // something else on it
        if (body === undefined) return res;
         // Otherwise just return the parsed body (can also be "" or null)
        return body;
    });
}
$3e6dcbd6932f03cd$exports.request = $3e6dcbd6932f03cd$var$request;
/**
 * Makes a request using `fetch` and stores the result in internal memory cache.
 * The cache is cleared when the page is unloaded.
 * @param url The URL to request
 * @param requestOptions Request options
 * @param force If true, reload from source and update the cache, even if it has
 * already been cached.
 */ function $3e6dcbd6932f03cd$var$getAndCache(url, requestOptions, force = false) {
    if (force || !$3e6dcbd6932f03cd$var$cache[url]) {
        $3e6dcbd6932f03cd$var$cache[url] = $3e6dcbd6932f03cd$var$request(url, requestOptions);
        return $3e6dcbd6932f03cd$var$cache[url];
    }
    return Promise.resolve($3e6dcbd6932f03cd$var$cache[url]);
}
$3e6dcbd6932f03cd$exports.getAndCache = $3e6dcbd6932f03cd$var$getAndCache;
/**
 * Fetches the conformance statement from the given base URL.
 * Note that the result is cached in memory (until the page is reloaded in the
 * browser) because it might have to be re-used by the client
 * @param baseUrl The base URL of the FHIR server
 * @param [requestOptions] Any options passed to the fetch call
 */ function $3e6dcbd6932f03cd$var$fetchConformanceStatement(baseUrl = "/", requestOptions) {
    const url = String(baseUrl).replace(/\/*$/, "/") + "metadata";
    return $3e6dcbd6932f03cd$var$getAndCache(url, requestOptions).catch((ex)=>{
        throw new Error(`Failed to fetch the conformance statement from "${url}". ${ex}`);
    });
}
$3e6dcbd6932f03cd$exports.fetchConformanceStatement = $3e6dcbd6932f03cd$var$fetchConformanceStatement;
/**
 * Given a response object, generates and throws detailed HttpError.
 * @param resp The `Response` object of a failed `fetch` request
 */ async function $3e6dcbd6932f03cd$var$humanizeError(resp) {
    let msg = `${resp.status} ${resp.statusText}\nURL: ${resp.url}`;
    let body = null;
    try {
        const type = resp.headers.get("Content-Type") || "text/plain";
        if (type.match(/\bjson\b/i)) {
            body = await resp.json();
            if (body.error) {
                msg += "\n" + body.error;
                if (body.error_description) msg += ": " + body.error_description;
            } else msg += "\n\n" + JSON.stringify(body, null, 4);
        } else if (type.match(/^text\//i)) {
            body = await resp.text();
            if (body) msg += "\n\n" + body;
        }
    } catch (_) {}
    throw new $d50f68baa55af7ac$exports.default(msg, resp.status, resp.statusText, body);
}
$3e6dcbd6932f03cd$exports.humanizeError = $3e6dcbd6932f03cd$var$humanizeError;
/**
 * Walks through an object (or array) and returns the value found at the
 * provided path. This function is very simple so it intentionally does not
 * support any argument polymorphism, meaning that the path can only be a
 * dot-separated string. If the path is invalid returns undefined.
 * @param obj The object (or Array) to walk through
 * @param path The path (eg. "a.b.4.c")
 * @returns {*} Whatever is found in the path or undefined
 */ function $3e6dcbd6932f03cd$var$getPath(obj, path = "") {
    path = path.trim();
    if (!path) return obj;
    let segments = path.split(".");
    let result = obj;
    while(result && segments.length){
        const key = segments.shift();
        if (!key && Array.isArray(result)) return result.map((o)=>$3e6dcbd6932f03cd$var$getPath(o, segments.join(".")));
        else result = result[key];
    }
    return result;
}
$3e6dcbd6932f03cd$exports.getPath = $3e6dcbd6932f03cd$var$getPath;
/**
 * Like getPath, but if the node is found, its value is set to @value
 * @param obj The object (or Array) to walk through
 * @param path The path (eg. "a.b.4.c")
 * @param value The value to set
 * @param createEmpty If true, create missing intermediate objects or arrays
 * @returns The modified object
 */ function $3e6dcbd6932f03cd$var$setPath(obj, path, value, createEmpty = false) {
    path.trim().split(".").reduce((out, key, idx, arr)=>{
        if (out && idx === arr.length - 1) out[key] = value;
        else {
            if (out && out[key] === undefined && createEmpty) out[key] = arr[idx + 1].match(/^[0-9]+$/) ? [] : {};
            return out ? out[key] : undefined;
        }
    }, obj);
    return obj;
}
$3e6dcbd6932f03cd$exports.setPath = $3e6dcbd6932f03cd$var$setPath;
/**
 * If the argument is an array returns it as is. Otherwise puts it in an array
 * (`[arg]`) and returns the result
 * @param arg The element to test and possibly convert to array
 * @category Utility
 */ function $3e6dcbd6932f03cd$var$makeArray(arg) {
    if (Array.isArray(arg)) return arg;
    return [
        arg
    ];
}
$3e6dcbd6932f03cd$exports.makeArray = $3e6dcbd6932f03cd$var$makeArray;
/**
 * Given a path, converts it to absolute url based on the `baseUrl`. If baseUrl
 * is not provided, the result would be a rooted path (one that starts with `/`).
 * @param path The path to convert
 * @param baseUrl The base URL
 */ function $3e6dcbd6932f03cd$var$absolute(path, baseUrl) {
    if (path.match(/^http/)) return path;
    if (path.match(/^urn/)) return path;
    return String(baseUrl || "").replace(/\/+$/, "") + "/" + path.replace(/^\/+/, "");
}
$3e6dcbd6932f03cd$exports.absolute = $3e6dcbd6932f03cd$var$absolute;
/**
 * Generates random strings. By default this returns random 8 characters long
 * alphanumeric strings.
 * @param strLength The length of the output string. Defaults to 8.
 * @param charSet A string containing all the possible characters.
 *     Defaults to all the upper and lower-case letters plus digits.
 * @category Utility
 */ function $3e6dcbd6932f03cd$var$randomString(strLength = 8, charSet = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789") {
    const result = [];
    const len = charSet.length;
    while(strLength--)result.push(charSet.charAt(Math.floor(Math.random() * len)));
    return result.join("");
}
$3e6dcbd6932f03cd$exports.randomString = $3e6dcbd6932f03cd$var$randomString;
/**
 * Decodes a JWT token and returns it's body.
 * @param token The token to read
 * @param env An `Adapter` or any other object that has an `atob` method
 * @category Utility
 */ function $3e6dcbd6932f03cd$var$jwtDecode(token, env) {
    const payload = token.split(".")[1];
    return payload ? JSON.parse(env.atob(payload)) : null;
}
$3e6dcbd6932f03cd$exports.jwtDecode = $3e6dcbd6932f03cd$var$jwtDecode;
/**
 * Given a token response, computes and returns the expiresAt timestamp.
 * Note that this should only be used immediately after an access token is
 * received, otherwise the computed timestamp will be incorrect.
 * @param tokenResponse
 * @param env
 */ function $3e6dcbd6932f03cd$var$getAccessTokenExpiration(tokenResponse, env) {
    const now = Math.floor(Date.now() / 1000); // Option 1 - using the expires_in property of the token response
    if (tokenResponse.expires_in) return now + tokenResponse.expires_in;
     // Option 2 - using the exp property of JWT tokens (must not assume JWT!)
    if (tokenResponse.access_token) {
        let tokenBody = $3e6dcbd6932f03cd$var$jwtDecode(tokenResponse.access_token, env);
        if (tokenBody && tokenBody.exp) return tokenBody.exp;
    } // Option 3 - if none of the above worked set this to 5 minutes after now
    return now + 300;
}
$3e6dcbd6932f03cd$exports.getAccessTokenExpiration = $3e6dcbd6932f03cd$var$getAccessTokenExpiration;
/**
 * Groups the observations by code. Returns a map that will look like:
 * ```js
 * const map = client.byCodes(observations, "code");
 * // map = {
 * //     "55284-4": [ observation1, observation2 ],
 * //     "6082-2": [ observation3 ]
 * // }
 * ```
 * @param observations Array of observations
 * @param property The name of a CodeableConcept property to group by
 */ function $3e6dcbd6932f03cd$var$byCode(observations, property) {
    const ret = {};
    function handleCodeableConcept(concept, observation) {
        if (concept && Array.isArray(concept.coding)) concept.coding.forEach(({ code: code })=>{
            if (code) {
                ret[code] = ret[code] || [];
                ret[code].push(observation);
            }
        });
    }
    $3e6dcbd6932f03cd$var$makeArray(observations).forEach((o)=>{
        if (o.resourceType === "Observation" && o[property]) {
            if (Array.isArray(o[property])) o[property].forEach((concept)=>handleCodeableConcept(concept, o));
            else handleCodeableConcept(o[property], o);
        }
    });
    return ret;
}
$3e6dcbd6932f03cd$exports.byCode = $3e6dcbd6932f03cd$var$byCode;
/**
 * First groups the observations by code using `byCode`. Then returns a function
 * that accepts codes as arguments and will return a flat array of observations
 * having that codes. Example:
 * ```js
 * const filter = client.byCodes(observations, "category");
 * filter("laboratory") // => [ observation1, observation2 ]
 * filter("vital-signs") // => [ observation3 ]
 * filter("laboratory", "vital-signs") // => [ observation1, observation2, observation3 ]
 * ```
 * @param observations Array of observations
 * @param property The name of a CodeableConcept property to group by
 */ function $3e6dcbd6932f03cd$var$byCodes(observations, property) {
    const bank = $3e6dcbd6932f03cd$var$byCode(observations, property);
    return (...codes)=>codes.filter((code)=>code + "" in bank).reduce((prev, code)=>prev.concat(bank[code + ""]), []);
}
$3e6dcbd6932f03cd$exports.byCodes = $3e6dcbd6932f03cd$var$byCodes;
/**
 * Given a conformance statement and a resource type, returns the name of the
 * URL parameter that can be used to scope the resource type by patient ID.
 */ function $3e6dcbd6932f03cd$var$getPatientParam(conformance, resourceType) {
    // Find what resources are supported by this server
    const resources = $3e6dcbd6932f03cd$var$getPath(conformance, "rest.0.resource") || []; // Check if this resource is supported
    const meta = resources.find((r)=>r.type === resourceType);
    if (!meta) throw new Error(`Resource "${resourceType}" is not supported by this FHIR server`);
     // Check if any search parameters are available for this resource
    if (!Array.isArray(meta.searchParam)) throw new Error(`No search parameters supported for "${resourceType}" on this FHIR server`);
     // This is a rare case but could happen in generic workflows
    if (resourceType == "Patient" && meta.searchParam.find((x)=>x.name == "_id")) return "_id";
     // Now find the first possible parameter name
    const out = $e5e6e34664e6599f$exports.patientParams.find((p)=>meta.searchParam.find((x)=>x.name == p)); // If there is no match
    if (!out) throw new Error("I don't know what param to use for " + resourceType);
    return out;
}
$3e6dcbd6932f03cd$exports.getPatientParam = $3e6dcbd6932f03cd$var$getPatientParam;
/**
 * Resolves a reference to target window. It may also open new window or tab if
 * the `target = "popup"` or `target = "_blank"`.
 * @param target
 * @param width Only used when `target = "popup"`
 * @param height Only used when `target = "popup"`
 */ async function $3e6dcbd6932f03cd$var$getTargetWindow(target, width = 800, height = 720) {
    // The target can be a function that returns the target. This can be
    // used to open a layer pop-up with an iframe and then return a reference
    // to that iframe (or its name)
    if (typeof target == "function") target = await target();
     // The target can be a window reference
    if (target && typeof target == "object") return target;
     // At this point target must be a string
    if (typeof target != "string") {
        $3e6dcbd6932f03cd$var$_debug("Invalid target type '%s'. Failing back to '_self'.", typeof target);
        return self;
    } // Current window
    if (target == "_self") return self;
     // The parent frame
    if (target == "_parent") return parent;
     // The top window
    if (target == "_top") return top;
     // New tab or window
    if (target == "_blank") {
        let error, targetWindow = null;
        try {
            targetWindow = window.open("", "SMARTAuthPopup");
            if (!targetWindow) throw new Error("Perhaps window.open was blocked");
        } catch (e) {
            error = e;
        }
        if (!targetWindow) {
            $3e6dcbd6932f03cd$var$_debug("Cannot open window. Failing back to '_self'. %s", error);
            return self;
        } else return targetWindow;
    } // Popup window
    if (target == "popup") {
        let error, targetWindow = null; // if (!targetWindow || targetWindow.closed) {
        try {
            targetWindow = window.open("", "SMARTAuthPopup", [
                "height=" + height,
                "width=" + width,
                "menubar=0",
                "resizable=1",
                "status=0",
                "top=" + (screen.height - height) / 2,
                "left=" + (screen.width - width) / 2
            ].join(","));
            if (!targetWindow) throw new Error("Perhaps the popup window was blocked");
        } catch (e) {
            error = e;
        }
        if (!targetWindow) {
            $3e6dcbd6932f03cd$var$_debug("Cannot open window. Failing back to '_self'. %s", error);
            return self;
        } else return targetWindow;
    } // Frame or window by name
    const winOrFrame = frames[target];
    if (winOrFrame) return winOrFrame;
    $3e6dcbd6932f03cd$var$_debug("Unknown target '%s'. Failing back to '_self'.", target);
    return self;
}
$3e6dcbd6932f03cd$exports.getTargetWindow = $3e6dcbd6932f03cd$var$getTargetWindow;


var $e92efa1597823f07$exports = {};
"use strict";
"use strict";
var $b4169d2aeb59c4bd$exports = {};
var $522621bf8dedc975$exports = {};
var $522621bf8dedc975$var$check = function(it) {
    return it && it.Math == Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
$522621bf8dedc975$exports = // eslint-disable-next-line no-undef
$522621bf8dedc975$var$check(typeof globalThis == "object" && globalThis) || $522621bf8dedc975$var$check(typeof window == "object" && window) || $522621bf8dedc975$var$check(typeof self == "object" && self) || $522621bf8dedc975$var$check(typeof $parcel$global == "object" && $parcel$global) || // eslint-disable-next-line no-new-func
function() {
    return this;
}() || Function("return this")();


// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $b6802293d122f2d1$export$2d1720544b23b823;
var $b528d6fe2b4bbf77$exports = {};
var $313365deab5436f8$exports = {};
$313365deab5436f8$exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};


// Detect IE8's incomplete defineProperty implementation
$b528d6fe2b4bbf77$exports = !$313365deab5436f8$exports(function() {
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] != 7;
});


// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $5947130294e2f382$export$2d1720544b23b823;
"use strict";
var $5947130294e2f382$var$nativePropertyIsEnumerable = {}.propertyIsEnumerable;
var $5947130294e2f382$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $5947130294e2f382$var$NASHORN_BUG = $5947130294e2f382$var$getOwnPropertyDescriptor && !$5947130294e2f382$var$nativePropertyIsEnumerable.call({
    1: 2
}, 1);
$5947130294e2f382$export$2d1720544b23b823 = $5947130294e2f382$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $5947130294e2f382$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $5947130294e2f382$var$nativePropertyIsEnumerable;


var $521085e4351c0524$exports = {};
$521085e4351c0524$exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};


var $8600c461a671fd44$exports = {};
// toObject with fallback for non-array-like ES3 strings
var $4bbdba018a2f5bf8$exports = {};

var $708541b01e85f134$exports = {};
var $708541b01e85f134$var$toString = {}.toString;
$708541b01e85f134$exports = function(it) {
    return $708541b01e85f134$var$toString.call(it).slice(8, -1);
};


var $4bbdba018a2f5bf8$var$split = "".split;
// fallback for non-array-like ES3 and non-enumerable old V8 strings
$4bbdba018a2f5bf8$exports = $313365deab5436f8$exports(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins
    return !Object("z").propertyIsEnumerable(0);
}) ? function(it) {
    return $708541b01e85f134$exports(it) == "String" ? $4bbdba018a2f5bf8$var$split.call(it, "") : Object(it);
} : Object;


var $df4132cf23738c37$exports = {};
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
$df4132cf23738c37$exports = function(it) {
    if (it == undefined) throw TypeError("Can't call method on " + it);
    return it;
};


$8600c461a671fd44$exports = function(it) {
    return $4bbdba018a2f5bf8$exports($df4132cf23738c37$exports(it));
};


var $8a46f67d7a4a33d9$exports = {};
var $5108b27d34fd982c$exports = {};
$5108b27d34fd982c$exports = function(it) {
    return typeof it === "object" ? it !== null : typeof it === "function";
};


// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
$8a46f67d7a4a33d9$exports = function(input, PREFERRED_STRING) {
    if (!$5108b27d34fd982c$exports(input)) return input;
    var fn, val;
    if (PREFERRED_STRING && typeof (fn = input.toString) == "function" && !$5108b27d34fd982c$exports(val = fn.call(input))) return val;
    if (typeof (fn = input.valueOf) == "function" && !$5108b27d34fd982c$exports(val = fn.call(input))) return val;
    if (!PREFERRED_STRING && typeof (fn = input.toString) == "function" && !$5108b27d34fd982c$exports(val = fn.call(input))) return val;
    throw TypeError("Can't convert object to primitive value");
};


var $548714ce8e26417d$exports = {};
var $548714ce8e26417d$var$hasOwnProperty = {}.hasOwnProperty;
$548714ce8e26417d$exports = function(it, key) {
    return $548714ce8e26417d$var$hasOwnProperty.call(it, key);
};


var $8028c54a5bee899c$exports = {};


var $197c62e314d55e8f$exports = {};


var $197c62e314d55e8f$var$document = $522621bf8dedc975$exports.document;
// typeof document.createElement is 'object' in old IE
var $197c62e314d55e8f$var$EXISTS = $5108b27d34fd982c$exports($197c62e314d55e8f$var$document) && $5108b27d34fd982c$exports($197c62e314d55e8f$var$document.createElement);
$197c62e314d55e8f$exports = function(it) {
    return $197c62e314d55e8f$var$EXISTS ? $197c62e314d55e8f$var$document.createElement(it) : {};
};


// Thank's IE8 for his funny defineProperty
$8028c54a5bee899c$exports = !$b528d6fe2b4bbf77$exports && !$313365deab5436f8$exports(function() {
    return Object.defineProperty($197c62e314d55e8f$exports("div"), "a", {
        get: function() {
            return 7;
        }
    }).a != 7;
});


var $b6802293d122f2d1$var$nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
$b6802293d122f2d1$export$2d1720544b23b823 = $b528d6fe2b4bbf77$exports ? $b6802293d122f2d1$var$nativeGetOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $8600c461a671fd44$exports(O);
    P = $8a46f67d7a4a33d9$exports(P, true);
    if ($8028c54a5bee899c$exports) try {
        return $b6802293d122f2d1$var$nativeGetOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($548714ce8e26417d$exports(O, P)) return $521085e4351c0524$exports(!$5947130294e2f382$export$2d1720544b23b823.call(O, P), O[P]);
};


var $b4169d2aeb59c4bd$require$getOwnPropertyDescriptor = $b6802293d122f2d1$export$2d1720544b23b823;
var $3b0b8a842e7db2fa$exports = {};

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $48439982d42f0b86$export$2d1720544b23b823;


var $0e58bbd39513c715$exports = {};

$0e58bbd39513c715$exports = function(it) {
    if (!$5108b27d34fd982c$exports(it)) throw TypeError(String(it) + " is not an object");
    return it;
};



var $48439982d42f0b86$var$nativeDefineProperty = Object.defineProperty;
$48439982d42f0b86$export$2d1720544b23b823 = $b528d6fe2b4bbf77$exports ? $48439982d42f0b86$var$nativeDefineProperty : function defineProperty(O, P, Attributes) {
    $0e58bbd39513c715$exports(O);
    P = $8a46f67d7a4a33d9$exports(P, true);
    $0e58bbd39513c715$exports(Attributes);
    if ($8028c54a5bee899c$exports) try {
        return $48439982d42f0b86$var$nativeDefineProperty(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw TypeError("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};



$3b0b8a842e7db2fa$exports = $b528d6fe2b4bbf77$exports ? function(object, key, value) {
    return $48439982d42f0b86$export$2d1720544b23b823(object, key, $521085e4351c0524$exports(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};


var $7908108dad70270a$exports = {};



var $df5de4b38a284fac$exports = {};


$df5de4b38a284fac$exports = function(key, value) {
    try {
        $3b0b8a842e7db2fa$exports($522621bf8dedc975$exports, key, value);
    } catch (error) {
        $522621bf8dedc975$exports[key] = value;
    }
    return value;
};


var $ae7e223df2d98439$exports = {};
var $4c007602062f68eb$exports = {};


var $4c007602062f68eb$var$SHARED = "__core-js_shared__";
var $4c007602062f68eb$var$store = $522621bf8dedc975$exports[$4c007602062f68eb$var$SHARED] || $df5de4b38a284fac$exports($4c007602062f68eb$var$SHARED, {});
$4c007602062f68eb$exports = $4c007602062f68eb$var$store;


var $ae7e223df2d98439$var$functionToString = Function.toString;
// this helper broken in `3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof $4c007602062f68eb$exports.inspectSource != "function") $4c007602062f68eb$exports.inspectSource = function(it) {
    return $ae7e223df2d98439$var$functionToString.call(it);
};
$ae7e223df2d98439$exports = $4c007602062f68eb$exports.inspectSource;


var $47a69d56756e2420$exports = {};
var $8bbb716f557d606b$exports = {};


var $8bbb716f557d606b$var$WeakMap = $522621bf8dedc975$exports.WeakMap;
$8bbb716f557d606b$exports = typeof $8bbb716f557d606b$var$WeakMap === "function" && /native code/.test($ae7e223df2d98439$exports($8bbb716f557d606b$var$WeakMap));







var $dd4e1f76c1a3e6d1$exports = {};
var $bf8f0888716fee33$exports = {};
var $1da1877e002003ea$exports = {};
$1da1877e002003ea$exports = false;



($bf8f0888716fee33$exports = function(key, value) {
    return $4c007602062f68eb$exports[key] || ($4c007602062f68eb$exports[key] = value !== undefined ? value : {});
})("versions", []).push({
    version: "3.8.3",
    mode: $1da1877e002003ea$exports ? "pure" : "global",
    copyright: "\xa9 2021 Denis Pushkarev (zloirock.ru)"
});


var $ea4eeca8461cc1dd$exports = {};
var $ea4eeca8461cc1dd$var$id = 0;
var $ea4eeca8461cc1dd$var$postfix = Math.random();
$ea4eeca8461cc1dd$exports = function(key) {
    return "Symbol(" + String(key === undefined ? "" : key) + ")_" + (++$ea4eeca8461cc1dd$var$id + $ea4eeca8461cc1dd$var$postfix).toString(36);
};


var $dd4e1f76c1a3e6d1$var$keys = $bf8f0888716fee33$exports("keys");
$dd4e1f76c1a3e6d1$exports = function(key) {
    return $dd4e1f76c1a3e6d1$var$keys[key] || ($dd4e1f76c1a3e6d1$var$keys[key] = $ea4eeca8461cc1dd$exports(key));
};


var $937519ee856dcf2c$exports = {};
$937519ee856dcf2c$exports = {};


var $47a69d56756e2420$var$WeakMap = $522621bf8dedc975$exports.WeakMap;
var $47a69d56756e2420$var$set, $47a69d56756e2420$var$get, $47a69d56756e2420$var$has;
var $47a69d56756e2420$var$enforce = function(it) {
    return $47a69d56756e2420$var$has(it) ? $47a69d56756e2420$var$get(it) : $47a69d56756e2420$var$set(it, {});
};
var $47a69d56756e2420$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$5108b27d34fd982c$exports(it) || (state = $47a69d56756e2420$var$get(it)).type !== TYPE) throw TypeError("Incompatible receiver, " + TYPE + " required");
        return state;
    };
};
if ($8bbb716f557d606b$exports) {
    var $47a69d56756e2420$var$store = $4c007602062f68eb$exports.state || ($4c007602062f68eb$exports.state = new $47a69d56756e2420$var$WeakMap());
    var $47a69d56756e2420$var$wmget = $47a69d56756e2420$var$store.get;
    var $47a69d56756e2420$var$wmhas = $47a69d56756e2420$var$store.has;
    var $47a69d56756e2420$var$wmset = $47a69d56756e2420$var$store.set;
    $47a69d56756e2420$var$set = function(it, metadata) {
        metadata.facade = it;
        $47a69d56756e2420$var$wmset.call($47a69d56756e2420$var$store, it, metadata);
        return metadata;
    };
    $47a69d56756e2420$var$get = function(it) {
        return $47a69d56756e2420$var$wmget.call($47a69d56756e2420$var$store, it) || {};
    };
    $47a69d56756e2420$var$has = function(it) {
        return $47a69d56756e2420$var$wmhas.call($47a69d56756e2420$var$store, it);
    };
} else {
    var $47a69d56756e2420$var$STATE = $dd4e1f76c1a3e6d1$exports("state");
    $937519ee856dcf2c$exports[$47a69d56756e2420$var$STATE] = true;
    $47a69d56756e2420$var$set = function(it, metadata) {
        metadata.facade = it;
        $3b0b8a842e7db2fa$exports(it, $47a69d56756e2420$var$STATE, metadata);
        return metadata;
    };
    $47a69d56756e2420$var$get = function(it) {
        return $548714ce8e26417d$exports(it, $47a69d56756e2420$var$STATE) ? it[$47a69d56756e2420$var$STATE] : {};
    };
    $47a69d56756e2420$var$has = function(it) {
        return $548714ce8e26417d$exports(it, $47a69d56756e2420$var$STATE);
    };
}
$47a69d56756e2420$exports = {
    set: $47a69d56756e2420$var$set,
    get: $47a69d56756e2420$var$get,
    has: $47a69d56756e2420$var$has,
    enforce: $47a69d56756e2420$var$enforce,
    getterFor: $47a69d56756e2420$var$getterFor
};


var $7908108dad70270a$var$getInternalState = $47a69d56756e2420$exports.get;
var $7908108dad70270a$var$enforceInternalState = $47a69d56756e2420$exports.enforce;
var $7908108dad70270a$var$TEMPLATE = String(String).split("String");
($7908108dad70270a$exports = function(O, key, value, options) {
    var unsafe = options ? !!options.unsafe : false;
    var simple = options ? !!options.enumerable : false;
    var noTargetGet = options ? !!options.noTargetGet : false;
    var state;
    if (typeof value == "function") {
        if (typeof key == "string" && !$548714ce8e26417d$exports(value, "name")) $3b0b8a842e7db2fa$exports(value, "name", key);
        state = $7908108dad70270a$var$enforceInternalState(value);
        if (!state.source) state.source = $7908108dad70270a$var$TEMPLATE.join(typeof key == "string" ? key : "");
    }
    if (O === $522621bf8dedc975$exports) {
        if (simple) O[key] = value;
        else $df5de4b38a284fac$exports(key, value);
        return;
    } else if (!unsafe) delete O[key];
    else if (!noTargetGet && O[key]) simple = true;
    if (simple) O[key] = value;
    else $3b0b8a842e7db2fa$exports(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, "toString", function toString() {
    return typeof this == "function" && $7908108dad70270a$var$getInternalState(this).source || $ae7e223df2d98439$exports(this);
});



var $ed4b47ade736f234$exports = {};

var $3cc0f7b078939566$exports = {};
var $356d39974f050129$exports = {};
var $75816cb5d62c4a4c$exports = {};

$75816cb5d62c4a4c$exports = $522621bf8dedc975$exports;



var $356d39974f050129$var$aFunction = function(variable) {
    return typeof variable == "function" ? variable : undefined;
};
$356d39974f050129$exports = function(namespace, method) {
    return arguments.length < 2 ? $356d39974f050129$var$aFunction($75816cb5d62c4a4c$exports[namespace]) || $356d39974f050129$var$aFunction($522621bf8dedc975$exports[namespace]) : $75816cb5d62c4a4c$exports[namespace] && $75816cb5d62c4a4c$exports[namespace][method] || $522621bf8dedc975$exports[namespace] && $522621bf8dedc975$exports[namespace][method];
};


// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
var $10cf332cacc4d7d0$export$2d1720544b23b823;
var $dd6ce52a9bf80a06$exports = {};


var $ac20abc70d0c4a7a$exports = {};

var $07d7dbf49780d461$exports = {};
var $b70e87322e341b61$exports = {};
var $b70e87322e341b61$var$ceil = Math.ceil;
var $b70e87322e341b61$var$floor = Math.floor;
// `ToInteger` abstract operation
// https://tc39.es/ecma262/#sec-tointeger
$b70e87322e341b61$exports = function(argument) {
    return isNaN(argument = +argument) ? 0 : (argument > 0 ? $b70e87322e341b61$var$floor : $b70e87322e341b61$var$ceil)(argument);
};


var $07d7dbf49780d461$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
$07d7dbf49780d461$exports = function(argument) {
    return argument > 0 ? $07d7dbf49780d461$var$min($b70e87322e341b61$exports(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


var $b827c328804febf9$exports = {};

var $b827c328804febf9$var$max = Math.max;
var $b827c328804febf9$var$min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
$b827c328804febf9$exports = function(index, length) {
    var integer = $b70e87322e341b61$exports(index);
    return integer < 0 ? $b827c328804febf9$var$max(integer + length, 0) : $b827c328804febf9$var$min(integer, length);
};


// `Array.prototype.{ indexOf, includes }` methods implementation
var $ac20abc70d0c4a7a$var$createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $8600c461a671fd44$exports($this);
        var length = $07d7dbf49780d461$exports(O.length);
        var index = $b827c328804febf9$exports(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
$ac20abc70d0c4a7a$exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $ac20abc70d0c4a7a$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $ac20abc70d0c4a7a$var$createMethod(false)
};


var $dd6ce52a9bf80a06$require$indexOf = $ac20abc70d0c4a7a$exports.indexOf;

$dd6ce52a9bf80a06$exports = function(object, names) {
    var O = $8600c461a671fd44$exports(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$548714ce8e26417d$exports($937519ee856dcf2c$exports, key) && $548714ce8e26417d$exports(O, key) && result.push(key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($548714ce8e26417d$exports(O, key = names[i++])) ~$dd6ce52a9bf80a06$require$indexOf(result, key) || result.push(key);
    return result;
};


var $481fe3c95c6a6c1f$exports = {};
// IE8- don't enum bug keys
$481fe3c95c6a6c1f$exports = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
];


var $10cf332cacc4d7d0$var$hiddenKeys = $481fe3c95c6a6c1f$exports.concat("length", "prototype");
$10cf332cacc4d7d0$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $dd6ce52a9bf80a06$exports(O, $10cf332cacc4d7d0$var$hiddenKeys);
};


var $56fbf5f35a17b68c$export$2d1720544b23b823;
$56fbf5f35a17b68c$export$2d1720544b23b823 = Object.getOwnPropertySymbols;



// all object keys, includes non-enumerable and symbols
$3cc0f7b078939566$exports = $356d39974f050129$exports("Reflect", "ownKeys") || function ownKeys(it) {
    var keys = $10cf332cacc4d7d0$export$2d1720544b23b823($0e58bbd39513c715$exports(it));
    var getOwnPropertySymbols = $56fbf5f35a17b68c$export$2d1720544b23b823;
    return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};




$ed4b47ade736f234$exports = function(target, source) {
    var keys = $3cc0f7b078939566$exports(source);
    var defineProperty = $48439982d42f0b86$export$2d1720544b23b823;
    var getOwnPropertyDescriptor = $b6802293d122f2d1$export$2d1720544b23b823;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$548714ce8e26417d$exports(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};


var $810cb9f0cd974b2c$exports = {};

var $810cb9f0cd974b2c$var$replacement = /#|\.prototype\./;
var $810cb9f0cd974b2c$var$isForced = function(feature, detection) {
    var value = $810cb9f0cd974b2c$var$data[$810cb9f0cd974b2c$var$normalize(feature)];
    return value == $810cb9f0cd974b2c$var$POLYFILL ? true : value == $810cb9f0cd974b2c$var$NATIVE ? false : typeof detection == "function" ? $313365deab5436f8$exports(detection) : !!detection;
};
var $810cb9f0cd974b2c$var$normalize = $810cb9f0cd974b2c$var$isForced.normalize = function(string) {
    return String(string).replace($810cb9f0cd974b2c$var$replacement, ".").toLowerCase();
};
var $810cb9f0cd974b2c$var$data = $810cb9f0cd974b2c$var$isForced.data = {};
var $810cb9f0cd974b2c$var$NATIVE = $810cb9f0cd974b2c$var$isForced.NATIVE = "N";
var $810cb9f0cd974b2c$var$POLYFILL = $810cb9f0cd974b2c$var$isForced.POLYFILL = "P";
$810cb9f0cd974b2c$exports = $810cb9f0cd974b2c$var$isForced;


/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/ $b4169d2aeb59c4bd$exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $522621bf8dedc975$exports;
    else if (STATIC) target = $522621bf8dedc975$exports[TARGET] || $df5de4b38a284fac$exports(TARGET, {});
    else target = ($522621bf8dedc975$exports[TARGET] || {}).prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.noTargetGet) {
            descriptor = $b4169d2aeb59c4bd$require$getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $810cb9f0cd974b2c$exports(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty === typeof targetProperty) continue;
            $ed4b47ade736f234$exports(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $3b0b8a842e7db2fa$exports(sourceProperty, "sham", true);
        // extend global
        $7908108dad70270a$exports(target, key, sourceProperty, options);
    }
};


var $db50d60baaf2d7fb$exports = {};
"use strict";
var $6704ebc8aacd45a8$exports = {};

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
$6704ebc8aacd45a8$exports = Array.isArray || function isArray(arg) {
    return $708541b01e85f134$exports(arg) == "Array";
};



var $b5550d2cba85f3d8$exports = {};
var $0ff0224673933bde$exports = {};
$0ff0224673933bde$exports = function(it) {
    if (typeof it != "function") throw TypeError(String(it) + " is not a function");
    return it;
};


// optional / simple context binding
$b5550d2cba85f3d8$exports = function(fn, that, length) {
    $0ff0224673933bde$exports(fn);
    if (that === undefined) return fn;
    switch(length){
        case 0:
            return function() {
                return fn.call(that);
            };
        case 1:
            return function(a) {
                return fn.call(that, a);
            };
        case 2:
            return function(a, b) {
                return fn.call(that, a, b);
            };
        case 3:
            return function(a, b, c) {
                return fn.call(that, a, b, c);
            };
    }
    return function() {
        return fn.apply(that, arguments);
    };
};


// `FlattenIntoArray` abstract operation
// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var $db50d60baaf2d7fb$var$flattenIntoArray = function(target, original, source, sourceLen, start, depth, mapper, thisArg) {
    var targetIndex = start;
    var sourceIndex = 0;
    var mapFn = mapper ? $b5550d2cba85f3d8$exports(mapper, thisArg, 3) : false;
    var element;
    while(sourceIndex < sourceLen){
        if (sourceIndex in source) {
            element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
            if (depth > 0 && $6704ebc8aacd45a8$exports(element)) targetIndex = $db50d60baaf2d7fb$var$flattenIntoArray(target, original, element, $07d7dbf49780d461$exports(element.length), targetIndex, depth - 1) - 1;
            else {
                if (targetIndex >= 0x1FFFFFFFFFFFFF) throw TypeError("Exceed the acceptable array length");
                target[targetIndex] = element;
            }
            targetIndex++;
        }
        sourceIndex++;
    }
    return targetIndex;
};
$db50d60baaf2d7fb$exports = $db50d60baaf2d7fb$var$flattenIntoArray;


var $cf244a6b5b7342f4$exports = {};

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
$cf244a6b5b7342f4$exports = function(argument) {
    return Object($df4132cf23738c37$exports(argument));
};




var $ab32fde6f1ce2ab0$exports = {};


var $81e25041e160c1a0$exports = {};




var $b160f445534e015b$exports = {};

$b160f445534e015b$exports = !!Object.getOwnPropertySymbols && !$313365deab5436f8$exports(function() {
    // Chrome 38 Symbol has incorrect toString conversion
    // eslint-disable-next-line no-undef
    return !String(Symbol());
});


var $66e605a0a319f59d$exports = {};

$66e605a0a319f59d$exports = $b160f445534e015b$exports && !Symbol.sham && typeof Symbol.iterator == "symbol";


var $81e25041e160c1a0$var$WellKnownSymbolsStore = $bf8f0888716fee33$exports("wks");
var $81e25041e160c1a0$var$Symbol = $522621bf8dedc975$exports.Symbol;
var $81e25041e160c1a0$var$createWellKnownSymbol = $66e605a0a319f59d$exports ? $81e25041e160c1a0$var$Symbol : $81e25041e160c1a0$var$Symbol && $81e25041e160c1a0$var$Symbol.withoutSetter || $ea4eeca8461cc1dd$exports;
$81e25041e160c1a0$exports = function(name) {
    if (!$548714ce8e26417d$exports($81e25041e160c1a0$var$WellKnownSymbolsStore, name)) {
        if ($b160f445534e015b$exports && $548714ce8e26417d$exports($81e25041e160c1a0$var$Symbol, name)) $81e25041e160c1a0$var$WellKnownSymbolsStore[name] = $81e25041e160c1a0$var$Symbol[name];
        else $81e25041e160c1a0$var$WellKnownSymbolsStore[name] = $81e25041e160c1a0$var$createWellKnownSymbol("Symbol." + name);
    }
    return $81e25041e160c1a0$var$WellKnownSymbolsStore[name];
};


var $ab32fde6f1ce2ab0$var$SPECIES = $81e25041e160c1a0$exports("species");
// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
$ab32fde6f1ce2ab0$exports = function(originalArray, length) {
    var C;
    if ($6704ebc8aacd45a8$exports(originalArray)) {
        C = originalArray.constructor;
        // cross-realm fallback
        if (typeof C == "function" && (C === Array || $6704ebc8aacd45a8$exports(C.prototype))) C = undefined;
        else if ($5108b27d34fd982c$exports(C)) {
            C = C[$ab32fde6f1ce2ab0$var$SPECIES];
            if (C === null) C = undefined;
        }
    }
    return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
};


// `Array.prototype.flat` method
// https://tc39.es/ecma262/#sec-array.prototype.flat
$b4169d2aeb59c4bd$exports({
    target: "Array",
    proto: true
}, {
    flat: function flat() {
        var depthArg = arguments.length ? arguments[0] : undefined;
        var O = $cf244a6b5b7342f4$exports(this);
        var sourceLen = $07d7dbf49780d461$exports(O.length);
        var A = $ab32fde6f1ce2ab0$exports(O, 0);
        A.length = $db50d60baaf2d7fb$exports(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : $b70e87322e341b61$exports(depthArg));
        return A;
    }
});


// this method was added to unscopables after implementation
// in popular engines, so it's moved to a separate module
var $d1b271288b2d747c$exports = {};

var $236e195b6e0ec5d8$exports = {};

var $fd91945c12990404$exports = {};



var $ab442fa43ac80640$exports = {};


// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
$ab442fa43ac80640$exports = Object.keys || function keys(O) {
    return $dd6ce52a9bf80a06$exports(O, $481fe3c95c6a6c1f$exports);
};


// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
$fd91945c12990404$exports = $b528d6fe2b4bbf77$exports ? Object.defineProperties : function defineProperties(O, Properties) {
    $0e58bbd39513c715$exports(O);
    var keys = $ab442fa43ac80640$exports(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)$48439982d42f0b86$export$2d1720544b23b823(O, key = keys[index++], Properties[key]);
    return O;
};




var $148c7b2c2aeb3b17$exports = {};

$148c7b2c2aeb3b17$exports = $356d39974f050129$exports("document", "documentElement");




var $236e195b6e0ec5d8$var$GT = ">";
var $236e195b6e0ec5d8$var$LT = "<";
var $236e195b6e0ec5d8$var$PROTOTYPE = "prototype";
var $236e195b6e0ec5d8$var$SCRIPT = "script";
var $236e195b6e0ec5d8$var$IE_PROTO = $dd4e1f76c1a3e6d1$exports("IE_PROTO");
var $236e195b6e0ec5d8$var$EmptyConstructor = function() {};
var $236e195b6e0ec5d8$var$scriptTag = function(content) {
    return $236e195b6e0ec5d8$var$LT + $236e195b6e0ec5d8$var$SCRIPT + $236e195b6e0ec5d8$var$GT + content + $236e195b6e0ec5d8$var$LT + "/" + $236e195b6e0ec5d8$var$SCRIPT + $236e195b6e0ec5d8$var$GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var $236e195b6e0ec5d8$var$NullProtoObjectViaActiveX = function(activeXDocument) {
    activeXDocument.write($236e195b6e0ec5d8$var$scriptTag(""));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    activeXDocument = null; // avoid memory leak
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $236e195b6e0ec5d8$var$NullProtoObjectViaIFrame = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = $197c62e314d55e8f$exports("iframe");
    var JS = "java" + $236e195b6e0ec5d8$var$SCRIPT + ":";
    var iframeDocument;
    iframe.style.display = "none";
    $148c7b2c2aeb3b17$exports.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write($236e195b6e0ec5d8$var$scriptTag("document.F=Object"));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var $236e195b6e0ec5d8$var$activeXDocument;
var $236e195b6e0ec5d8$var$NullProtoObject = function() {
    try {
        /* global ActiveXObject */ $236e195b6e0ec5d8$var$activeXDocument = document.domain && new ActiveXObject("htmlfile");
    } catch (error) {}
    $236e195b6e0ec5d8$var$NullProtoObject = $236e195b6e0ec5d8$var$activeXDocument ? $236e195b6e0ec5d8$var$NullProtoObjectViaActiveX($236e195b6e0ec5d8$var$activeXDocument) : $236e195b6e0ec5d8$var$NullProtoObjectViaIFrame();
    var length = $481fe3c95c6a6c1f$exports.length;
    while(length--)delete $236e195b6e0ec5d8$var$NullProtoObject[$236e195b6e0ec5d8$var$PROTOTYPE][$481fe3c95c6a6c1f$exports[length]];
    return $236e195b6e0ec5d8$var$NullProtoObject();
};
$937519ee856dcf2c$exports[$236e195b6e0ec5d8$var$IE_PROTO] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
$236e195b6e0ec5d8$exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $236e195b6e0ec5d8$var$EmptyConstructor[$236e195b6e0ec5d8$var$PROTOTYPE] = $0e58bbd39513c715$exports(O);
        result = new $236e195b6e0ec5d8$var$EmptyConstructor();
        $236e195b6e0ec5d8$var$EmptyConstructor[$236e195b6e0ec5d8$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$236e195b6e0ec5d8$var$IE_PROTO] = O;
    } else result = $236e195b6e0ec5d8$var$NullProtoObject();
    return Properties === undefined ? result : $fd91945c12990404$exports(result, Properties);
};



var $d1b271288b2d747c$var$UNSCOPABLES = $81e25041e160c1a0$exports("unscopables");
var $d1b271288b2d747c$var$ArrayPrototype = Array.prototype;
// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if ($d1b271288b2d747c$var$ArrayPrototype[$d1b271288b2d747c$var$UNSCOPABLES] == undefined) $48439982d42f0b86$export$2d1720544b23b823($d1b271288b2d747c$var$ArrayPrototype, $d1b271288b2d747c$var$UNSCOPABLES, {
    configurable: true,
    value: $236e195b6e0ec5d8$exports(null)
});
// add a key to Array.prototype[@@unscopables]
$d1b271288b2d747c$exports = function(key) {
    $d1b271288b2d747c$var$ArrayPrototype[$d1b271288b2d747c$var$UNSCOPABLES][key] = true;
};


// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$d1b271288b2d747c$exports("flat");


Object.defineProperty($e92efa1597823f07$exports, "__esModule", {
    value: true
});

var $824f57624c1a1876$exports = {};
"use strict";
Object.defineProperty($824f57624c1a1876$exports, "__esModule", {
    value: true
}); // This map contains reusable debug messages (only those used in multiple places)
$824f57624c1a1876$exports.default = {
    expired: "Session expired! Please re-launch the app",
    noScopeForId: "Trying to get the ID of the selected %s. Please add 'launch' or 'launch/%s' to the requested scopes and try again.",
    noIfNoAuth: "You are trying to get %s but the app is not authorized yet.",
    noFreeContext: "Please don't use open fhir servers if you need to access launch context items like the %S."
};




// @ts-ignore
const { Response: $e92efa1597823f07$var$Response } = typeof FHIRCLIENT_PURE !== "undefined" ? window : (parcelRequire("R5nvG")); // $lab:coverage:on$
const $e92efa1597823f07$var$debug = $3e6dcbd6932f03cd$exports.debug.extend("client");
/**
 * Adds patient context to requestOptions object to be used with [[Client.request]]
 * @param requestOptions Can be a string URL (relative to the serviceUrl), or an
 * object which will be passed to fetch()
 * @param client Current FHIR client object containing patient context
 * @return requestOptions object contextualized to current patient
 */ async function $e92efa1597823f07$var$contextualize(requestOptions, client) {
    const base = $3e6dcbd6932f03cd$exports.absolute("/", client.state.serverUrl);
    async function contextualURL(_url) {
        const resourceType = _url.pathname.split("/").pop();
        if (!resourceType) throw new Error(`Invalid url "${_url}"`);
        if ($e5e6e34664e6599f$exports.patientCompartment.indexOf(resourceType) == -1) throw new Error(`Cannot filter "${resourceType}" resources by patient`);
        const conformance = await $3e6dcbd6932f03cd$exports.fetchConformanceStatement(client.state.serverUrl);
        const searchParam = $3e6dcbd6932f03cd$exports.getPatientParam(conformance, resourceType);
        _url.searchParams.set(searchParam, client.patient.id);
        return _url.href;
    }
    if (typeof requestOptions == "string" || requestOptions instanceof URL) return {
        url: await contextualURL(new URL(requestOptions + "", base))
    };
    requestOptions.url = await contextualURL(new URL(requestOptions.url + "", base));
    return requestOptions;
}
/**
 * Gets single reference by id. Caches the result.
 * @param refId
 * @param cache A map to store the resolved refs
 * @param client The client instance
 * @param [signal] The `AbortSignal` if any
 * @returns The resolved reference
 * @private
 */ function $e92efa1597823f07$var$getRef(refId, cache, client, signal) {
    if (!cache[refId]) // Note that we set cache[refId] immediately! When the promise is
    // settled it will be updated. This is to avoid a ref being fetched
    // twice because some of these requests are executed in parallel.
    cache[refId] = client.request({
        url: refId,
        signal: signal
    }).then((res)=>{
        cache[refId] = res;
        return res;
    }, (error)=>{
        delete cache[refId];
        throw error;
    });
    return Promise.resolve(cache[refId]);
}
/**
 * Resolves a reference in the given resource.
 * @param obj FHIR Resource
 */ function $e92efa1597823f07$var$resolveRef(obj, path, graph, cache, client, signal) {
    const node = $3e6dcbd6932f03cd$exports.getPath(obj, path);
    if (node) {
        const isArray = Array.isArray(node);
        return Promise.all($3e6dcbd6932f03cd$exports.makeArray(node).filter(Boolean).map((item, i)=>{
            const ref = item.reference;
            if (ref) return $e92efa1597823f07$var$getRef(ref, cache, client, signal).then((sub)=>{
                if (graph) {
                    if (isArray) {
                        if (path.indexOf("..") > -1) $3e6dcbd6932f03cd$exports.setPath(obj, `${path.replace("..", `.${i}.`)}`, sub);
                        else $3e6dcbd6932f03cd$exports.setPath(obj, `${path}.${i}`, sub);
                    } else $3e6dcbd6932f03cd$exports.setPath(obj, path, sub);
                }
            }).catch((ex)=>{
                /* ignore missing references */ if (ex.status !== 404) throw ex;
            });
        }));
    }
}
/**
 * Given a resource and a list of ref paths - resolves them all
 * @param obj FHIR Resource
 * @param fhirOptions The fhir options of the initiating request call
 * @param cache A map to store fetched refs
 * @param client The client instance
 * @private
 */ function $e92efa1597823f07$var$resolveRefs(obj, fhirOptions, cache, client, signal) {
    // 1. Sanitize paths, remove any invalid ones
    let paths = $3e6dcbd6932f03cd$exports.makeArray(fhirOptions.resolveReferences).filter(Boolean) // No false, 0, null, undefined or ""
    .map((path)=>String(path).trim()).filter(Boolean); // No space-only strings
    // 2. Remove duplicates
    paths = paths.filter((p, i)=>{
        const index = paths.indexOf(p, i + 1);
        if (index > -1) {
            $e92efa1597823f07$var$debug('Duplicated reference path "%s"', p);
            return false;
        }
        return true;
    }); // 3. Early exit if no valid paths are found
    if (!paths.length) return Promise.resolve();
     // 4. Group the paths by depth so that child refs are looked up
    // after their parents!
    const groups = {};
    paths.forEach((path)=>{
        const len = path.split(".").length;
        if (!groups[len]) groups[len] = [];
        groups[len].push(path);
    }); // 5. Execute groups sequentially! Paths within same group are
    // fetched in parallel!
    let task = Promise.resolve();
    Object.keys(groups).sort().forEach((len)=>{
        const group = groups[len];
        task = task.then(()=>Promise.all(group.map((path)=>{
                return $e92efa1597823f07$var$resolveRef(obj, path, !!fhirOptions.graph, cache, client, signal);
            })));
    });
    return task;
}
/**
 * This is a FHIR client that is returned to you from the `ready()` call of the
 * **SMART API**. You can also create it yourself if needed:
 *
 * ```js
 * // BROWSER
 * const client = FHIR.client("https://r4.smarthealthit.org");
 *
 * // SERVER
 * const client = smart(req, res).client("https://r4.smarthealthit.org");
 * ```
 */ class $e92efa1597823f07$var$Client {
    /**
   * Validates the parameters, creates an instance and tries to connect it to
   * FhirJS, if one is available globally.
   */ constructor(environment, state){
        /**
     * @category Utility
     */ this.units = $3e6dcbd6932f03cd$exports.units;
        const _state = typeof state == "string" ? {
            serverUrl: state
        } : state; // Valid serverUrl is required!
        if (!_state.serverUrl || !_state.serverUrl.match(/https?:\/\/.+/)) throw new Error('A "serverUrl" option is required and must begin with "http(s)"');
        this.state = _state;
        this.environment = environment;
        this._refreshTask = null;
        const client = this; // patient api ---------------------------------------------------------
        this.patient = {
            get id () {
                return client.getPatientId();
            },
            read: (requestOptions = {})=>{
                const id = this.patient.id;
                return id ? this.request(Object.assign(Object.assign({}, requestOptions), {
                    url: `Patient/${id}`
                })) : Promise.reject(new Error("Patient is not available"));
            },
            request: (requestOptions, fhirOptions = {})=>{
                if (this.patient.id) return (async ()=>{
                    const options = await $e92efa1597823f07$var$contextualize(requestOptions, this);
                    return this.request(options, fhirOptions);
                })();
                else return Promise.reject(new Error("Patient is not available"));
            }
        }; // encounter api -------------------------------------------------------
        this.encounter = {
            get id () {
                return client.getEncounterId();
            },
            read: (requestOptions = {})=>{
                const id = this.encounter.id;
                return id ? this.request(Object.assign(Object.assign({}, requestOptions), {
                    url: `Encounter/${id}`
                })) : Promise.reject(new Error("Encounter is not available"));
            }
        }; // user api ------------------------------------------------------------
        this.user = {
            get fhirUser () {
                return client.getFhirUser();
            },
            get id () {
                return client.getUserId();
            },
            get resourceType () {
                return client.getUserType();
            },
            read: (requestOptions = {})=>{
                const fhirUser = this.user.fhirUser;
                return fhirUser ? this.request(Object.assign(Object.assign({}, requestOptions), {
                    url: fhirUser
                })) : Promise.reject(new Error("User is not available"));
            }
        }; // fhir.js api (attached automatically in browser)
        // ---------------------------------------------------------------------
        this.connect(environment.fhir);
    }
    /**
   * This method is used to make the "link" between the `fhirclient` and the
   * `fhir.js`, if one is available.
   * **Note:** This is called by the constructor. If fhir.js is available in
   * the global scope as `fhir`, it will automatically be linked to any [[Client]]
   * instance. You should only use this method to connect to `fhir.js` which
   * is not global.
   */ connect(fhirJs) {
        if (typeof fhirJs == "function") {
            const options = {
                baseUrl: this.state.serverUrl.replace(/\/$/, "")
            };
            const accessToken = this.getState("tokenResponse.access_token");
            if (accessToken) options.auth = {
                token: accessToken
            };
            else {
                const { username: username, password: password } = this.state;
                if (username && password) options.auth = {
                    user: username,
                    pass: password
                };
            }
            this.api = fhirJs(options);
            const patientId = this.getState("tokenResponse.patient");
            if (patientId) this.patient.api = fhirJs(Object.assign(Object.assign({}, options), {
                patient: patientId
            }));
        }
        return this;
    }
    /**
   * Returns the ID of the selected patient or null. You should have requested
   * "launch/patient" scope. Otherwise this will return null.
   */ getPatientId() {
        const tokenResponse = this.state.tokenResponse;
        if (tokenResponse) {
            // We have been authorized against this server but we don't know
            // the patient. This should be a scope issue.
            if (!tokenResponse.patient) {
                if (!(this.state.scope || "").match(/\blaunch(\/patient)?\b/)) $e92efa1597823f07$var$debug($824f57624c1a1876$exports.default.noScopeForId, "patient", "patient");
                else // The server should have returned the patient!
                $e92efa1597823f07$var$debug("The ID of the selected patient is not available. Please check if your server supports that.");
                return null;
            }
            return tokenResponse.patient;
        }
        if (this.state.authorizeUri) $e92efa1597823f07$var$debug($824f57624c1a1876$exports.default.noIfNoAuth, "the ID of the selected patient");
        else $e92efa1597823f07$var$debug($824f57624c1a1876$exports.default.noFreeContext, "selected patient");
        return null;
    }
    /**
   * Returns the ID of the selected encounter or null. You should have
   * requested "launch/encounter" scope. Otherwise this will return null.
   * Note that not all servers support the "launch/encounter" scope so this
   * will be null if they don't.
   */ getEncounterId() {
        const tokenResponse = this.state.tokenResponse;
        if (tokenResponse) {
            // We have been authorized against this server but we don't know
            // the encounter. This should be a scope issue.
            if (!tokenResponse.encounter) {
                if (!(this.state.scope || "").match(/\blaunch(\/encounter)?\b/)) $e92efa1597823f07$var$debug($824f57624c1a1876$exports.default.noScopeForId, "encounter", "encounter");
                else // The server should have returned the encounter!
                $e92efa1597823f07$var$debug("The ID of the selected encounter is not available. Please check if your server supports that, and that the selected patient has any recorded encounters.");
                return null;
            }
            return tokenResponse.encounter;
        }
        if (this.state.authorizeUri) $e92efa1597823f07$var$debug($824f57624c1a1876$exports.default.noIfNoAuth, "the ID of the selected encounter");
        else $e92efa1597823f07$var$debug($824f57624c1a1876$exports.default.noFreeContext, "selected encounter");
        return null;
    }
    /**
   * Returns the (decoded) id_token if any. You need to request "openid" and
   * "profile" scopes if you need to receive an id_token (if you need to know
   * who the logged-in user is).
   */ getIdToken() {
        const tokenResponse = this.state.tokenResponse;
        if (tokenResponse) {
            const idToken = tokenResponse.id_token;
            const scope = this.state.scope || ""; // We have been authorized against this server but we don't have
            // the id_token. This should be a scope issue.
            if (!idToken) {
                const hasOpenid = scope.match(/\bopenid\b/);
                const hasProfile = scope.match(/\bprofile\b/);
                const hasFhirUser = scope.match(/\bfhirUser\b/);
                if (!hasOpenid || !(hasFhirUser || hasProfile)) $e92efa1597823f07$var$debug("You are trying to get the id_token but you are not using the right scopes. Please add 'openid' and 'fhirUser' or 'profile' to the scopes you are requesting.");
                else // The server should have returned the id_token!
                $e92efa1597823f07$var$debug("The id_token is not available. Please check if your server supports that.");
                return null;
            }
            return $3e6dcbd6932f03cd$exports.jwtDecode(idToken, this.environment);
        }
        if (this.state.authorizeUri) $e92efa1597823f07$var$debug($824f57624c1a1876$exports.default.noIfNoAuth, "the id_token");
        else $e92efa1597823f07$var$debug($824f57624c1a1876$exports.default.noFreeContext, "id_token");
        return null;
    }
    /**
   * Returns the profile of the logged_in user (if any). This is a string
   * having the following shape `"{user type}/{user id}"`. For example:
   * `"Practitioner/abc"` or `"Patient/xyz"`.
   */ getFhirUser() {
        const idToken = this.getIdToken();
        if (idToken) return idToken.profile;
        return null;
    }
    /**
   * Returns the user ID or null.
   */ getUserId() {
        const profile = this.getFhirUser();
        if (profile) return profile.split("/")[1];
        return null;
    }
    /**
   * Returns the type of the logged-in user or null. The result can be
   * "Practitioner", "Patient" or "RelatedPerson".
   */ getUserType() {
        const profile = this.getFhirUser();
        if (profile) return profile.split("/")[0];
        return null;
    }
    /**
   * Builds and returns the value of the `Authorization` header that can be
   * sent to the FHIR server
   */ getAuthorizationHeader() {
        const accessToken = this.getState("tokenResponse.access_token");
        if (accessToken) return "Bearer " + accessToken;
        const { username: username, password: password } = this.state;
        if (username && password) return "Basic " + this.environment.btoa(username + ":" + password);
        return null;
    }
    /**
   * Used internally to clear the state of the instance and the state in the
   * associated storage.
   */ async _clearState() {
        const storage = this.environment.getStorage();
        const key = await storage.get($e5e6e34664e6599f$exports.SMART_KEY);
        if (key) await storage.unset(key);
        await storage.unset($e5e6e34664e6599f$exports.SMART_KEY);
        this.state.tokenResponse = {};
    }
    /**
   * Creates a new resource in a server-assigned location
   * @see http://hl7.org/fhir/http.html#create
   * @param resource A FHIR resource to be created
   * @param [requestOptions] Any options to be passed to the fetch call.
   * Note that `method` and `body` will be ignored.
   * @category Request
   */ create(resource, requestOptions = {}) {
        return this.request(Object.assign(Object.assign({}, requestOptions), {
            url: `${resource.resourceType}`,
            method: "POST",
            body: JSON.stringify(resource),
            headers: Object.assign({
                // TODO: Do we need to alternate with "application/json+fhir"?
                "Content-Type": "application/json"
            }, requestOptions.headers)
        }));
    }
    /**
   * Creates a new current version for an existing resource or creates an
   * initial version if no resource already exists for the given id.
   * @see http://hl7.org/fhir/http.html#update
   * @param resource A FHIR resource to be updated
   * @param requestOptions Any options to be passed to the fetch call.
   * Note that `method` and `body` will be ignored.
   * @category Request
   */ update(resource, requestOptions = {}) {
        return this.request(Object.assign(Object.assign({}, requestOptions), {
            url: `${resource.resourceType}/${resource.id}`,
            method: "PUT",
            body: JSON.stringify(resource),
            headers: Object.assign({
                // TODO: Do we need to alternate with "application/json+fhir"?
                "Content-Type": "application/json"
            }, requestOptions.headers)
        }));
    }
    /**
   * Removes an existing resource.
   * @see http://hl7.org/fhir/http.html#delete
   * @param url Relative URI of the FHIR resource to be deleted
   * (format: `resourceType/id`)
   * @param requestOptions Any options (except `method` which will be fixed
   * to `DELETE`) to be passed to the fetch call.
   * @category Request
   */ delete(url, requestOptions = {}) {
        return this.request(Object.assign(Object.assign({}, requestOptions), {
            url: url,
            method: "DELETE"
        }));
    }
    /**
   * @param requestOptions Can be a string URL (relative to the serviceUrl),
   * or an object which will be passed to fetch()
   * @param fhirOptions Additional options to control the behavior
   * @param _resolvedRefs DO NOT USE! Used internally.
   * @category Request
   */ async request(requestOptions, fhirOptions = {}, _resolvedRefs = {}) {
        var _a;
        const debugRequest = $3e6dcbd6932f03cd$exports.debug.extend("client:request");
        if (!requestOptions) throw new Error("request requires an url or request options as argument");
         // url -----------------------------------------------------------------
        let url;
        if (typeof requestOptions == "string" || requestOptions instanceof URL) {
            url = String(requestOptions);
            requestOptions = {};
        } else url = String(requestOptions.url);
        url = $3e6dcbd6932f03cd$exports.absolute(url, this.state.serverUrl);
        const options = {
            graph: fhirOptions.graph !== false,
            flat: !!fhirOptions.flat,
            pageLimit: (_a = fhirOptions.pageLimit) !== null && _a !== void 0 ? _a : 1,
            resolveReferences: fhirOptions.resolveReferences || [],
            useRefreshToken: fhirOptions.useRefreshToken !== false,
            onPage: typeof fhirOptions.onPage == "function" ? fhirOptions.onPage : undefined
        };
        const signal = requestOptions.signal || undefined; // Refresh the access token if needed
        const job = options.useRefreshToken ? this.refreshIfNeeded({
            signal: signal
        }).then(()=>requestOptions) : Promise.resolve(requestOptions);
        return job // Add the Authorization header now, after the access token might
        // have been updated
        .then((requestOptions)=>{
            const authHeader = this.getAuthorizationHeader();
            if (authHeader) requestOptions.headers = Object.assign(Object.assign({}, requestOptions.headers), {
                Authorization: authHeader
            });
            return requestOptions;
        }) // Make the request
        .then((requestOptions)=>{
            debugRequest("%s, options: %O, fhirOptions: %O", url, requestOptions, options);
            return $3e6dcbd6932f03cd$exports.request(url, requestOptions);
        }) // Handle 401 ------------------------------------------------------
        .catch(async (error)=>{
            if (error.status == 401) {
                // !accessToken -> not authorized -> No session. Need to launch.
                if (!this.getState("tokenResponse.access_token")) throw new Error("This app cannot be accessed directly. Please launch it as SMART app!");
                 // auto-refresh not enabled and Session expired.
                // Need to re-launch. Clear state to start over!
                if (!options.useRefreshToken) {
                    debugRequest("Your session has expired and the useRefreshToken option is set to false. Please re-launch the app.");
                    await this._clearState();
                    throw new Error($824f57624c1a1876$exports.default.expired);
                } // otherwise -> auto-refresh failed. Session expired.
                // Need to re-launch. Clear state to start over!
                debugRequest("Auto-refresh failed! Please re-launch the app.");
                await this._clearState();
                throw new Error($824f57624c1a1876$exports.default.expired);
            }
            throw error;
        }) // Handle 403 ------------------------------------------------------
        .catch((error)=>{
            if (error.status == 403) debugRequest("Permission denied! Please make sure that you have requested the proper scopes.");
            throw error;
        }).then((data)=>{
            // Handle raw responses (anything other than json) -------------
            if (!data) return data;
            if (typeof data == "string") return data;
            if (data instanceof $e92efa1597823f07$var$Response) return data; // Resolve References ------------------------------------------
            return (async (_data)=>{
                if (_data.resourceType == "Bundle") await Promise.all((_data.entry || []).map((item)=>$e92efa1597823f07$var$resolveRefs(item.resource, options, _resolvedRefs, this, signal)));
                else await $e92efa1597823f07$var$resolveRefs(_data, options, _resolvedRefs, this, signal);
                return _data;
            })(data) // Pagination ----------------------------------------------
            .then(async (_data)=>{
                if (_data && _data.resourceType == "Bundle") {
                    const links = _data.link || [];
                    if (options.flat) _data = (_data.entry || []).map((entry)=>entry.resource);
                    if (options.onPage) await options.onPage(_data, Object.assign({}, _resolvedRefs));
                    if (--options.pageLimit) {
                        const next = links.find((l)=>l.relation == "next");
                        _data = $3e6dcbd6932f03cd$exports.makeArray(_data);
                        if (next && next.url) {
                            const nextPage = await this.request({
                                url: next.url,
                                signal: // Aborting the main request (even after it is complete)
                                // must propagate to any child requests and abort them!
                                // To do so, just pass the same AbortSignal if one is
                                // provided.
                                signal
                            }, options, _resolvedRefs);
                            if (options.onPage) return null;
                            if (options.resolveReferences.length) {
                                Object.assign(_resolvedRefs, nextPage.references);
                                return _data.concat($3e6dcbd6932f03cd$exports.makeArray(nextPage.data || nextPage));
                            }
                            return _data.concat($3e6dcbd6932f03cd$exports.makeArray(nextPage));
                        }
                    }
                }
                return _data;
            }) // Finalize ------------------------------------------------
            .then((_data)=>{
                if (options.graph) _resolvedRefs = {};
                else if (!options.onPage && options.resolveReferences.length) return {
                    data: _data,
                    references: _resolvedRefs
                };
                return _data;
            });
        });
    }
    /**
   * Checks if access token and refresh token are present. If they are, and if
   * the access token is expired or is about to expire in the next 10 seconds,
   * calls `this.refresh()` to obtain new access token.
   * @param requestOptions Any options to pass to the fetch call. Most of them
   * will be overridden, bit it might still be useful for passing additional
   * request options or an abort signal.
   * @category Request
   */ refreshIfNeeded(requestOptions = {}) {
        const accessToken = this.getState("tokenResponse.access_token");
        const refreshToken = this.getState("tokenResponse.refresh_token");
        const expiresAt = this.state.expiresAt || 0;
        if (accessToken && refreshToken && expiresAt - 10 < Date.now() / 1000) return this.refresh(requestOptions);
        return Promise.resolve(this.state);
    }
    /**
   * Use the refresh token to obtain new access token. If the refresh token is
   * expired (or this fails for any other reason) it will be deleted from the
   * state, so that we don't enter into loops trying to re-authorize.
   *
   * This method is typically called internally from [[Client.request]] if
   * certain request fails with 401.
   *
   * @param requestOptions Any options to pass to the fetch call. Most of them
   * will be overridden, bit it might still be useful for passing additional
   * request options or an abort signal.
   * @category Request
   */ refresh(requestOptions = {}) {
        var _a, _b;
        const debugRefresh = $3e6dcbd6932f03cd$exports.debug.extend("client:refresh");
        debugRefresh("Attempting to refresh with refresh_token...");
        const refreshToken = (_b = (_a = this.state) === null || _a === void 0 ? void 0 : _a.tokenResponse) === null || _b === void 0 ? void 0 : _b.refresh_token;
        if (!refreshToken) throw new Error("Unable to refresh. No refresh_token found.");
        const tokenUri = this.state.tokenUri;
        if (!tokenUri) throw new Error("Unable to refresh. No tokenUri found.");
        const scopes = this.getState("tokenResponse.scope") || "";
        const hasOfflineAccess = scopes.search(/\boffline_access\b/) > -1;
        const hasOnlineAccess = scopes.search(/\bonline_access\b/) > -1;
        if (!hasOfflineAccess && !hasOnlineAccess) throw new Error("Unable to refresh. No offline_access or online_access scope found.");
         // This method is typically called internally from `request` if certain
        // request fails with 401. However, clients will often run multiple
        // requests in parallel which may result in multiple refresh calls.
        // To avoid that, we keep a reference to the current refresh task (if any).
        if (!this._refreshTask) {
            const refreshRequestOptions = Object.assign(Object.assign({
                credentials: this.environment.options.refreshTokenWithCredentials || "same-origin"
            }, requestOptions), {
                method: "POST",
                mode: "cors",
                headers: Object.assign(Object.assign({}, requestOptions.headers || {}), {
                    "content-type": "application/x-www-form-urlencoded"
                }),
                body: `grant_type=refresh_token&refresh_token=${encodeURIComponent(refreshToken)}`
            }); // custom authorization header can be passed on manual calls
            if (!("authorization" in refreshRequestOptions.headers)) {
                const { clientSecret: clientSecret, clientId: clientId } = this.state;
                if (clientSecret) // @ts-ignore
                refreshRequestOptions.headers.authorization = "Basic " + this.environment.btoa(clientId + ":" + clientSecret);
            }
            this._refreshTask = $3e6dcbd6932f03cd$exports.request(tokenUri, refreshRequestOptions).then((data)=>{
                if (!data.access_token) throw new Error("No access token received");
                debugRefresh("Received new access token response %O", data);
                Object.assign(this.state.tokenResponse, data);
                this.state.expiresAt = $3e6dcbd6932f03cd$exports.getAccessTokenExpiration(data, this.environment);
                return this.state;
            }).catch((error)=>{
                var _a, _b;
                if ((_b = (_a = this.state) === null || _a === void 0 ? void 0 : _a.tokenResponse) === null || _b === void 0 ? void 0 : _b.refresh_token) {
                    debugRefresh("Deleting the expired or invalid refresh token.");
                    delete this.state.tokenResponse.refresh_token;
                }
                throw error;
            }).finally(()=>{
                this._refreshTask = null;
                const key = this.state.key;
                if (key) this.environment.getStorage().set(key, this.state);
                else debugRefresh("No 'key' found in Clint.state. Cannot persist the instance.");
            });
        }
        return this._refreshTask;
    }
    /**
   * Groups the observations by code. Returns a map that will look like:
   * ```js
   * const map = client.byCodes(observations, "code");
   * // map = {
   * //     "55284-4": [ observation1, observation2 ],
   * //     "6082-2": [ observation3 ]
   * // }
   * ```
   * @param observations Array of observations
   * @param property The name of a CodeableConcept property to group by
   * @todo This should be deprecated and moved elsewhere. One should not have
   * to obtain an instance of [[Client]] just to use utility functions like this.
   * @deprecated
   * @category Utility
   */ byCode(observations, property) {
        return $3e6dcbd6932f03cd$exports.byCode(observations, property);
    }
    /**
   * First groups the observations by code using `byCode`. Then returns a function
   * that accepts codes as arguments and will return a flat array of observations
   * having that codes. Example:
   * ```js
   * const filter = client.byCodes(observations, "category");
   * filter("laboratory") // => [ observation1, observation2 ]
   * filter("vital-signs") // => [ observation3 ]
   * filter("laboratory", "vital-signs") // => [ observation1, observation2, observation3 ]
   * ```
   * @param observations Array of observations
   * @param property The name of a CodeableConcept property to group by
   * @todo This should be deprecated and moved elsewhere. One should not have
   * to obtain an instance of [[Client]] just to use utility functions like this.
   * @deprecated
   * @category Utility
   */ byCodes(observations, property) {
        return $3e6dcbd6932f03cd$exports.byCodes(observations, property);
    }
    /**
   * Walks through an object (or array) and returns the value found at the
   * provided path. This function is very simple so it intentionally does not
   * support any argument polymorphism, meaning that the path can only be a
   * dot-separated string. If the path is invalid returns undefined.
   * @param obj The object (or Array) to walk through
   * @param path The path (eg. "a.b.4.c")
   * @returns {*} Whatever is found in the path or undefined
   * @todo This should be deprecated and moved elsewhere. One should not have
   * to obtain an instance of [[Client]] just to use utility functions like this.
   * @deprecated
   * @category Utility
   */ getPath(obj, path = "") {
        return $3e6dcbd6932f03cd$exports.getPath(obj, path);
    }
    /**
   * Returns a copy of the client state. Accepts a dot-separated path argument
   * (same as for `getPath`) to allow for selecting specific properties.
   * Examples:
   * ```js
   * client.getState(); // -> the entire state object
   * client.getState("serverUrl"); // -> the URL we are connected to
   * client.getState("tokenResponse.patient"); // -> The selected patient ID (if any)
   * ```
   * @param path The path (eg. "a.b.4.c")
   * @returns {*} Whatever is found in the path or undefined
   */ getState(path = "") {
        return $3e6dcbd6932f03cd$exports.getPath(Object.assign({}, this.state), path);
    }
    /**
   * Returns a promise that will be resolved with the fhir version as defined
   * in the CapabilityStatement.
   */ getFhirVersion() {
        return $3e6dcbd6932f03cd$exports.fetchConformanceStatement(this.state.serverUrl).then((metadata)=>metadata.fhirVersion);
    }
    /**
   * Returns a promise that will be resolved with the numeric fhir version
   * - 2 for DSTU2
   * - 3 for STU3
   * - 4 for R4
   * - 0 if the version is not known
   */ getFhirRelease() {
        return this.getFhirVersion().then((v)=>{
            var _a;
            return (_a = $e5e6e34664e6599f$exports.fhirVersions[v]) !== null && _a !== void 0 ? _a : 0;
        });
    }
}
$e92efa1597823f07$exports.default = $e92efa1597823f07$var$Client;



Object.defineProperty($9b169f72336acb48$exports, "KEY", {
    enumerable: true,
    get: function() {
        return $e5e6e34664e6599f$exports.SMART_KEY;
    }
});
const $9b169f72336acb48$var$debug = $3e6dcbd6932f03cd$exports.debug.extend("oauth2");
function $9b169f72336acb48$var$isBrowser() {
    return typeof window === "object";
}
/**
 * Fetches the well-known json file from the given base URL.
 * Note that the result is cached in memory (until the page is reloaded in the
 * browser) because it might have to be re-used by the client
 * @param baseUrl The base URL of the FHIR server
 */ function $9b169f72336acb48$var$fetchWellKnownJson(baseUrl = "/", requestOptions) {
    const url = String(baseUrl).replace(/\/*$/, "/") + ".well-known/smart-configuration";
    return $3e6dcbd6932f03cd$exports.getAndCache(url, requestOptions).catch((ex)=>{
        throw new Error(`Failed to fetch the well-known json "${url}". ${ex.message}`);
    });
}
$9b169f72336acb48$exports.fetchWellKnownJson = $9b169f72336acb48$var$fetchWellKnownJson;
/**
 * Fetch a "WellKnownJson" and extract the SMART endpoints from it
 */ function $9b169f72336acb48$var$getSecurityExtensionsFromWellKnownJson(baseUrl = "/", requestOptions) {
    return $9b169f72336acb48$var$fetchWellKnownJson(baseUrl, requestOptions).then((meta)=>{
        if (!meta.authorization_endpoint || !meta.token_endpoint) throw new Error("Invalid wellKnownJson");
        return {
            registrationUri: meta.registration_endpoint || "",
            authorizeUri: meta.authorization_endpoint,
            tokenUri: meta.token_endpoint
        };
    });
}
/**
 * Fetch a `CapabilityStatement` and extract the SMART endpoints from it
 */ function $9b169f72336acb48$var$getSecurityExtensionsFromConformanceStatement(baseUrl = "/", requestOptions) {
    return $3e6dcbd6932f03cd$exports.fetchConformanceStatement(baseUrl, requestOptions).then((meta)=>{
        const nsUri = "http://fhir-registry.smarthealthit.org/StructureDefinition/oauth-uris";
        const extensions = ($3e6dcbd6932f03cd$exports.getPath(meta || {}, "rest.0.security.extension") || []).filter((e)=>e.url === nsUri).map((o)=>o.extension)[0];
        const out = {
            registrationUri: "",
            authorizeUri: "",
            tokenUri: ""
        };
        if (extensions) extensions.forEach((ext)=>{
            if (ext.url === "register") out.registrationUri = ext.valueUri;
            if (ext.url === "authorize") out.authorizeUri = ext.valueUri;
            if (ext.url === "token") out.tokenUri = ext.valueUri;
        });
        return out;
    });
}
/**
 * This works similarly to `Promise.any()`. The tasks are objects containing a
 * request promise and it's AbortController. Returns a promise that will be
 * resolved with the return value of the first successful request, or rejected
 * with an aggregate error if all tasks fail. Any requests, other than the first
 * one that succeeds will be aborted.
 */ function $9b169f72336acb48$var$any(tasks) {
    const len = tasks.length;
    const errors = [];
    let resolved = false;
    return new Promise((resolve, reject)=>{
        function onSuccess(task, result) {
            task.complete = true;
            if (!resolved) {
                resolved = true;
                tasks.forEach((t)=>{
                    if (!t.complete) t.controller.abort();
                });
                resolve(result);
            }
        }
        function onError(error) {
            if (errors.push(error) === len) reject(new Error(errors.map((e)=>e.message).join("; ")));
        }
        tasks.forEach((t)=>{
            t.promise.then((result)=>onSuccess(t, result), onError);
        });
    });
}
/**
 * Given a FHIR server, returns an object with it's Oauth security endpoints
 * that we are interested in. This will try to find the info in both the
 * `CapabilityStatement` and the `.well-known/smart-configuration`. Whatever
 * Arrives first will be used and the other request will be aborted.
 * @param [baseUrl] Fhir server base URL
 * @param [env] The Adapter
 */ function $9b169f72336acb48$var$getSecurityExtensions(env, baseUrl = "/") {
    const AbortController = env.getAbortController();
    const abortController1 = new AbortController();
    const abortController2 = new AbortController();
    return $9b169f72336acb48$var$any([
        {
            controller: abortController1,
            promise: $9b169f72336acb48$var$getSecurityExtensionsFromWellKnownJson(baseUrl, {
                signal: abortController1.signal
            })
        },
        {
            controller: abortController2,
            promise: $9b169f72336acb48$var$getSecurityExtensionsFromConformanceStatement(baseUrl, {
                signal: abortController2.signal
            })
        }
    ]);
}
$9b169f72336acb48$exports.getSecurityExtensions = $9b169f72336acb48$var$getSecurityExtensions;
/**
 * Starts the SMART Launch Sequence.
 * > **IMPORTANT**:
 *   `authorize()` will end up redirecting you to the authorization server.
 *    This means that you should not add anything to the returned promise chain.
 *    Any code written directly after the authorize() call might not be executed
 *    due to that redirect!
 * @param env
 * @param [params]
 * @param [_noRedirect] If true, resolve with the redirect url without trying to redirect to it
 */ async function $9b169f72336acb48$var$authorize(env, params = {}, _noRedirect = false) {
    // Obtain input
    const { redirect_uri: redirect_uri, clientSecret: clientSecret, fakeTokenResponse: fakeTokenResponse, patientId: patientId, encounterId: encounterId, client_id: client_id, target: target, width: width, height: height } = params;
    let { iss: iss, launch: launch, fhirServiceUrl: fhirServiceUrl, redirectUri: redirectUri, scope: scope = "", clientId: clientId, completeInTarget: completeInTarget } = params;
    const url = env.getUrl();
    const storage = env.getStorage(); // For these three an url param takes precedence over inline option
    iss = url.searchParams.get("iss") || iss;
    fhirServiceUrl = url.searchParams.get("fhirServiceUrl") || fhirServiceUrl;
    launch = url.searchParams.get("launch") || launch;
    if (!clientId) clientId = client_id;
    if (!redirectUri) redirectUri = redirect_uri;
    if (!redirectUri) redirectUri = env.relative(".");
    else if (!redirectUri.match(/^https?\:\/\//)) redirectUri = env.relative(redirectUri);
    const serverUrl = String(iss || fhirServiceUrl || ""); // Validate input
    if (!serverUrl) throw new Error("No server url found. It must be specified as `iss` or as `fhirServiceUrl` parameter");
    if (iss) $9b169f72336acb48$var$debug("Making %s launch...", launch ? "EHR" : "standalone");
     // append launch scope if needed
    if (launch && !scope.match(/launch/)) scope += " launch";
    if ($9b169f72336acb48$var$isBrowser()) {
        const inFrame = $9b169f72336acb48$var$isInFrame();
        const inPopUp = $9b169f72336acb48$var$isInPopUp();
        if ((inFrame || inPopUp) && completeInTarget !== true && completeInTarget !== false) {
            // completeInTarget will default to true if authorize is called from
            // within an iframe. This is to avoid issues when the entire app
            // happens to be rendered in an iframe (including in some EHRs),
            // even though that was not how the app developer's intention.
            completeInTarget = inFrame; // In this case we can't always make the best decision so ask devs
            // to be explicit in their configuration.
            console.warn('Your app is being authorized from within an iframe or popup window. Please be explicit and provide a "completeInTarget" option. Use "true" to complete the authorization in the same window, or "false" to try to complete it in the parent or the opener window. See http://docs.smarthealthit.org/client-js/api.html');
        }
    } // If `authorize` is called, make sure we clear any previous state (in case
    // this is a re-authorize)
    const oldKey = await storage.get($e5e6e34664e6599f$exports.SMART_KEY);
    await storage.unset(oldKey); // create initial state
    const stateKey = $3e6dcbd6932f03cd$exports.randomString(16);
    const state = {
        clientId: clientId,
        scope: scope,
        redirectUri: redirectUri,
        serverUrl: serverUrl,
        clientSecret: clientSecret,
        tokenResponse: {},
        key: stateKey,
        completeInTarget: completeInTarget
    };
    const fullSessionStorageSupport = $9b169f72336acb48$var$isBrowser() ? $3e6dcbd6932f03cd$exports.getPath(env, "options.fullSessionStorageSupport") : true;
    if (fullSessionStorageSupport) await storage.set($e5e6e34664e6599f$exports.SMART_KEY, stateKey);
     // fakeTokenResponse to override stuff (useful in development)
    if (fakeTokenResponse) Object.assign(state.tokenResponse, fakeTokenResponse);
     // Fixed patientId (useful in development)
    if (patientId) Object.assign(state.tokenResponse, {
        patient: patientId
    });
     // Fixed encounterId (useful in development)
    if (encounterId) Object.assign(state.tokenResponse, {
        encounter: encounterId
    });
    let redirectUrl = redirectUri + "?state=" + encodeURIComponent(stateKey); // bypass oauth if fhirServiceUrl is used (but iss takes precedence)
    if (fhirServiceUrl && !iss) {
        $9b169f72336acb48$var$debug("Making fake launch...");
        await storage.set(stateKey, state);
        if (_noRedirect) return redirectUrl;
        return await env.redirect(redirectUrl);
    } // Get oauth endpoints and add them to the state
    const extensions = await $9b169f72336acb48$var$getSecurityExtensions(env, serverUrl);
    Object.assign(state, extensions);
    await storage.set(stateKey, state); // If this happens to be an open server and there is no authorizeUri
    if (!state.authorizeUri) {
        if (_noRedirect) return redirectUrl;
        return await env.redirect(redirectUrl);
    } // build the redirect uri
    const redirectParams = [
        "response_type=code",
        "client_id=" + encodeURIComponent(clientId || ""),
        "scope=" + encodeURIComponent(scope),
        "redirect_uri=" + encodeURIComponent(redirectUri),
        "aud=" + encodeURIComponent(serverUrl),
        "state=" + encodeURIComponent(stateKey)
    ]; // also pass this in case of EHR launch
    if (launch) redirectParams.push("launch=" + encodeURIComponent(launch));
    redirectUrl = state.authorizeUri + "?" + redirectParams.join("&");
    if (_noRedirect) return redirectUrl;
    if (target && $9b169f72336acb48$var$isBrowser()) {
        let win;
        win = await $3e6dcbd6932f03cd$exports.getTargetWindow(target, width, height);
        if (win !== self) try {
            // Also remove any old state from the target window and then
            // transfer the current state there
            win.sessionStorage.removeItem(oldKey);
            win.sessionStorage.setItem(stateKey, JSON.stringify(state));
        } catch (ex) {
            $3e6dcbd6932f03cd$exports.debug(`Failed to modify window.sessionStorage. Perhaps it is from different origin?. Failing back to "_self". %s`, ex);
            win = self;
        }
        if (win !== self) try {
            win.location.href = redirectUrl;
            self.addEventListener("message", $9b169f72336acb48$var$onMessage);
        } catch (ex) {
            $3e6dcbd6932f03cd$exports.debug(`Failed to modify window.location. Perhaps it is from different origin?. Failing back to "_self". %s`, ex);
            self.location.href = redirectUrl;
        }
        else self.location.href = redirectUrl;
        return;
    } else return await env.redirect(redirectUrl);
}
$9b169f72336acb48$exports.authorize = $9b169f72336acb48$var$authorize;
/**
 * Checks if called within a frame. Only works in browsers!
 * If the current window has a `parent` or `top` properties that refer to
 * another window, returns true. If trying to access `top` or `parent` throws an
 * error, returns true. Otherwise returns `false`.
 */ function $9b169f72336acb48$var$isInFrame() {
    try {
        return self !== top && parent !== self;
    } catch (e) {
        return true;
    }
}
$9b169f72336acb48$exports.isInFrame = $9b169f72336acb48$var$isInFrame;
/**
 * Checks if called within another window (popup or tab). Only works in browsers!
 * To consider itself called in a new window, this function verifies that:
 * 1. `self === top` (not in frame)
 * 2. `!!opener && opener !== self` The window has an opener
 * 3. `!!window.name` The window has a `name` set
 */ function $9b169f72336acb48$var$isInPopUp() {
    try {
        return self === top && !!opener && opener !== self && !!window.name;
    } catch (e) {
        return false;
    }
}
$9b169f72336acb48$exports.isInPopUp = $9b169f72336acb48$var$isInPopUp;
/**
 * Another window can send a "completeAuth" message to this one, making it to
 * navigate to e.data.url
 * @param e The message event
 */ function $9b169f72336acb48$var$onMessage(e) {
    if (e.data.type == "completeAuth" && e.origin === new URL(self.location.href).origin) {
        window.removeEventListener("message", $9b169f72336acb48$var$onMessage);
        window.location.href = e.data.url;
    }
}
$9b169f72336acb48$exports.onMessage = $9b169f72336acb48$var$onMessage;
/**
 * The completeAuth function should only be called on the page that represents
 * the redirectUri. We typically land there after a redirect from the
 * authorization server..
 */ async function $9b169f72336acb48$var$completeAuth(env) {
    var _a, _b;
    const url = env.getUrl();
    const Storage = env.getStorage();
    const params = url.searchParams;
    let key = params.get("state");
    const code = params.get("code");
    const authError = params.get("error");
    const authErrorDescription = params.get("error_description");
    if (!key) key = await Storage.get($e5e6e34664e6599f$exports.SMART_KEY);
     // Start by checking the url for `error` and `error_description` parameters.
    // This happens when the auth server rejects our authorization attempt. In
    // this case it has no other way to tell us what the error was, other than
    // appending these parameters to the redirect url.
    // From client's point of view, this is not very reliable (because we can't
    // know how we have landed on this page - was it a redirect or was it loaded
    // manually). However, if `completeAuth()` is being called, we can assume
    // that the url comes from the auth server (otherwise the app won't work
    // anyway).
    if (authError || authErrorDescription) throw new Error([
        authError,
        authErrorDescription
    ].filter(Boolean).join(": "));
    $9b169f72336acb48$var$debug("key: %s, code: %s", key, code); // key might be coming from the page url so it might be empty or missing
    if (!key) throw new Error("No 'state' parameter found. Please (re)launch the app.");
     // Check if we have a previous state
    let state = await Storage.get(key);
    const fullSessionStorageSupport = $9b169f72336acb48$var$isBrowser() ? $3e6dcbd6932f03cd$exports.getPath(env, "options.fullSessionStorageSupport") : true; // If we are in a popup window or an iframe and the authorization is
    // complete, send the location back to our opener and exit.
    if ($9b169f72336acb48$var$isBrowser() && state && !state.completeInTarget) {
        const inFrame = $9b169f72336acb48$var$isInFrame();
        const inPopUp = $9b169f72336acb48$var$isInPopUp(); // we are about to return to the opener/parent where completeAuth will
        // be called again. In rare cases the opener or parent might also be
        // a frame or popup. Then inFrame or inPopUp will be true but we still
        // have to stop going up the chain. To guard against that weird form of
        // recursion we pass one additional parameter to the url which we later
        // remove.
        if ((inFrame || inPopUp) && !url.searchParams.get("complete")) {
            url.searchParams.set("complete", "1");
            const { href: href, origin: origin } = url;
            if (inFrame) parent.postMessage({
                type: "completeAuth",
                url: href
            }, origin);
            if (inPopUp) {
                opener.postMessage({
                    type: "completeAuth",
                    url: href
                }, origin);
                window.close();
            }
            return new Promise(()=>{});
        }
    }
    url.searchParams.delete("complete"); // Do we have to remove the `code` and `state` params from the URL?
    const hasState = params.has("state");
    if ($9b169f72336acb48$var$isBrowser() && $3e6dcbd6932f03cd$exports.getPath(env, "options.replaceBrowserHistory") && (code || hasState)) {
        // `code` is the flag that tell us to request an access token.
        // We have to remove it, otherwise the page will authorize on
        // every load!
        if (code) {
            params.delete("code");
            $9b169f72336acb48$var$debug("Removed code parameter from the url.");
        } // If we have `fullSessionStorageSupport` it means we no longer
        // need the `state` key. It will be stored to a well know
        // location - sessionStorage[SMART_KEY]. However, no
        // fullSessionStorageSupport means that this "well know location"
        // might be shared between windows and tabs. In this case we
        // MUST keep the `state` url parameter.
        if (hasState && fullSessionStorageSupport) {
            params.delete("state");
            $9b169f72336acb48$var$debug("Removed state parameter from the url.");
        } // If the browser does not support the replaceState method for the
        // History Web API, the "code" parameter cannot be removed. As a
        // consequence, the page will (re)authorize on every load. The
        // workaround is to reload the page to new location without those
        // parameters. If that is not acceptable replaceBrowserHistory
        // should be set to false.
        if (window.history.replaceState) window.history.replaceState({}, "", url.href);
    } // If the state does not exist, it means the page has been loaded directly.
    if (!state) throw new Error("No state found! Please (re)launch the app.");
     // Assume the client has already completed a token exchange when
    // there is no code (but we have a state) or access token is found in state
    const authorized = !code || ((_a = state.tokenResponse) === null || _a === void 0 ? void 0 : _a.access_token); // If we are authorized already, then this is just a reload.
    // Otherwise, we have to complete the code flow
    if (!authorized && state.tokenUri) {
        if (!code) throw new Error("'code' url parameter is required");
        $9b169f72336acb48$var$debug("Preparing to exchange the code for access token...");
        const requestOptions = $9b169f72336acb48$var$buildTokenRequest(env, code, state);
        $9b169f72336acb48$var$debug("Token request options: %O", requestOptions); // The EHR authorization server SHALL return a JSON structure that
        // includes an access token or a message indicating that the
        // authorization request has been denied.
        const tokenResponse = await $3e6dcbd6932f03cd$exports.request(state.tokenUri, requestOptions);
        $9b169f72336acb48$var$debug("Token response: %O", tokenResponse);
        if (!tokenResponse.access_token) throw new Error("Failed to obtain access token.");
         // Now we need to determine when is this authorization going to expire
        state.expiresAt = $3e6dcbd6932f03cd$exports.getAccessTokenExpiration(tokenResponse, env); // save the tokenResponse so that we don't have to re-authorize on
        // every page reload
        state = Object.assign(Object.assign({}, state), {
            tokenResponse: tokenResponse
        });
        await Storage.set(key, state);
        $9b169f72336acb48$var$debug("Authorization successful!");
    } else $9b169f72336acb48$var$debug(((_b = state.tokenResponse) === null || _b === void 0 ? void 0 : _b.access_token) ? "Already authorized" : "No authorization needed");
    if (fullSessionStorageSupport) await Storage.set($e5e6e34664e6599f$exports.SMART_KEY, key);
    const client = new $e92efa1597823f07$exports.default(env, state);
    $9b169f72336acb48$var$debug("Created client instance: %O", client);
    return client;
}
$9b169f72336acb48$exports.completeAuth = $9b169f72336acb48$var$completeAuth;
/**
 * Builds the token request options. Does not make the request, just
 * creates it's configuration and returns it in a Promise.
 */ function $9b169f72336acb48$var$buildTokenRequest(env, code, state) {
    const { redirectUri: redirectUri, clientSecret: clientSecret, tokenUri: tokenUri, clientId: clientId } = state;
    if (!redirectUri) throw new Error("Missing state.redirectUri");
    if (!tokenUri) throw new Error("Missing state.tokenUri");
    if (!clientId) throw new Error("Missing state.clientId");
    const requestOptions = {
        method: "POST",
        headers: {
            "content-type": "application/x-www-form-urlencoded"
        },
        body: `code=${code}&grant_type=authorization_code&redirect_uri=${encodeURIComponent(redirectUri)}`
    }; // For public apps, authentication is not possible (and thus not required),
    // since a client with no secret cannot prove its identity when it issues a
    // call. (The end-to-end system can still be secure because the client comes
    // from a known, https protected endpoint specified and enforced by the
    // redirect uri.) For confidential apps, an Authorization header using HTTP
    // Basic authentication is required, where the username is the app’s
    // client_id and the password is the app’s client_secret (see example).
    if (clientSecret) {
        requestOptions.headers.Authorization = "Basic " + env.btoa(clientId + ":" + clientSecret);
        $9b169f72336acb48$var$debug("Using state.clientSecret to construct the authorization header: %s", requestOptions.headers.Authorization);
    } else {
        $9b169f72336acb48$var$debug("No clientSecret found in state. Adding the clientId to the POST body");
        requestOptions.body += `&client_id=${encodeURIComponent(clientId)}`;
    }
    return requestOptions;
}
$9b169f72336acb48$exports.buildTokenRequest = $9b169f72336acb48$var$buildTokenRequest;
/**
 * @param env
 * @param [onSuccess]
 * @param [onError]
 */ async function $9b169f72336acb48$var$ready(env, onSuccess, onError) {
    let task = $9b169f72336acb48$var$completeAuth(env);
    if (onSuccess) task = task.then(onSuccess);
    if (onError) task = task.catch(onError);
    return task;
}
$9b169f72336acb48$exports.ready = $9b169f72336acb48$var$ready;
/**
 * This function can be used when you want to handle everything in one page
 * (no launch endpoint needed). You can think of it as if it does:
 * ```js
 * authorize(options).then(ready)
 * ```
 *
 * **Be careful with init()!** There are some details you need to be aware of:
 *
 * 1. It will only work if your launch_uri is the same as your redirect_uri.
 *    While this should be valid, we can’t promise that every EHR will allow you
 *    to register client with such settings.
 * 2. Internally, `init()` will be called twice. First it will redirect to the
 *    EHR, then the EHR will redirect back to the page where init() will be
 *    called again to complete the authorization. This is generally fine,
 *    because the returned promise will only be resolved once, after the second
 *    execution, but please also consider the following:
 *    - You should wrap all your app’s code in a function that is only executed
 *      after `init()` resolves!
 *    - Since the page will be loaded twice, you must be careful if your code
 *      has global side effects that can persist between page reloads
 *      (for example writing to localStorage).
 * 3. For standalone launch, only use init in combination with offline_access
 *    scope. Once the access_token expires, if you don’t have a refresh_token
 *    there is no way to re-authorize properly. We detect that and delete the
 *    expired access token, but it still means that the user will have to
 *    refresh the page twice to re-authorize.
 * @param env The adapter
 * @param options The authorize options
 */ async function $9b169f72336acb48$var$init(env, options) {
    const url = env.getUrl();
    const code = url.searchParams.get("code");
    const state = url.searchParams.get("state"); // if `code` and `state` params are present we need to complete the auth flow
    if (code && state) return $9b169f72336acb48$var$completeAuth(env);
     // Check for existing client state. If state is found, it means a client
    // instance have already been created in this session and we should try to
    // "revive" it.
    const storage = env.getStorage();
    const key = state || await storage.get($e5e6e34664e6599f$exports.SMART_KEY);
    const cached = await storage.get(key);
    if (cached) return new $e92efa1597823f07$exports.default(env, cached);
     // Otherwise try to launch
    return $9b169f72336acb48$var$authorize(env, options).then(()=>{
        // `init` promises a Client but that cannot happen in this case. The
        // browser will be redirected (unload the page and be redirected back
        // to it later and the same init function will be called again). On
        // success, authorize will resolve with the redirect url but we don't
        // want to return that from this promise chain because it is not a
        // Client instance. At the same time, if authorize fails, we do want to
        // pass the error to those waiting for a client instance.
        return new Promise(()=>{});
    });
}
$9b169f72336acb48$exports.init = $9b169f72336acb48$var$init;



var $5420394c952b9a4a$exports = {};
"use strict";
Object.defineProperty($5420394c952b9a4a$exports, "__esModule", {
    value: true
});
class $5420394c952b9a4a$var$Storage {
    /**
   * Gets the value at `key`. Returns a promise that will be resolved
   * with that value (or undefined for missing keys).
   */ async get(key) {
        const value = sessionStorage[key];
        if (value) return JSON.parse(value);
        return null;
    }
    /**
   * Sets the `value` on `key` and returns a promise that will be resolved
   * with the value that was set.
   */ async set(key, value) {
        sessionStorage[key] = JSON.stringify(value);
        return value;
    }
    /**
   * Deletes the value at `key`. Returns a promise that will be resolved
   * with true if the key was deleted or with false if it was not (eg. if
   * did not exist).
   */ async unset(key) {
        if (key in sessionStorage) {
            delete sessionStorage[key];
            return true;
        }
        return false;
    }
}
$5420394c952b9a4a$exports.default = $5420394c952b9a4a$var$Storage;


/**
 * Browser Adapter
 */ class $2241136b1aba1e64$var$BrowserAdapter {
    /**
   * @param options Environment-specific options
   */ constructor(options = {}){
        /**
     * Stores the URL instance associated with this adapter
     */ this._url = null;
        /**
     * Holds the Storage instance associated with this instance
     */ this._storage = null;
        this.options = Object.assign({
            // Replaces the browser's current URL
            // using window.history.replaceState API or by reloading.
            replaceBrowserHistory: true,
            // When set to true, this variable will fully utilize
            // HTML5 sessionStorage API.
            // This variable can be overridden to false by setting
            // FHIR.oauth2.settings.fullSessionStorageSupport = false.
            // When set to false, the sessionStorage will be keyed
            // by a state variable. This is to allow the embedded IE browser
            // instances instantiated on a single thread to continue to
            // function without having sessionStorage data shared
            // across the embedded IE instances.
            fullSessionStorageSupport: true,
            // Do we want to send cookies while making a request to the token
            // endpoint in order to obtain new access token using existing
            // refresh token. In rare cases the auth server might require the
            // client to send cookies along with those requests. In this case
            // developers will have to change this before initializing the app
            // like so:
            // `FHIR.oauth2.settings.refreshTokenWithCredentials = "include";`
            // or
            // `FHIR.oauth2.settings.refreshTokenWithCredentials = "same-origin";`
            // Can be one of:
            // "include"     - always send cookies
            // "same-origin" - only send cookies if we are on the same domain (default)
            // "omit"        - do not send cookies
            refreshTokenWithCredentials: "same-origin"
        }, options);
    }
    /**
   * Given a relative path, returns an absolute url using the instance base URL
   */ relative(path) {
        return new URL(path, this.getUrl().href).href;
    }
    /**
   * In browsers we need to be able to (dynamically) check if fhir.js is
   * included in the page. If it is, it should have created a "fhir" variable
   * in the global scope.
   */ get fhir() {
        // @ts-ignore
        return typeof fhir === "function" ? fhir : null;
    }
    /**
   * Given the current environment, this method must return the current url
   * as URL instance
   */ getUrl() {
        if (!this._url) this._url = new URL(location + "");
        return this._url;
    }
    /**
   * Given the current environment, this method must redirect to the given
   * path
   */ redirect(to) {
        location.href = to;
    }
    /**
   * Returns a BrowserStorage object which is just a wrapper around
   * sessionStorage
   */ getStorage() {
        if (!this._storage) this._storage = new $5420394c952b9a4a$exports.default();
        return this._storage;
    }
    /**
   * Returns a reference to the AbortController constructor. In browsers,
   * AbortController will always be available as global (native or polyfilled)
   */ getAbortController() {
        return AbortController;
    }
    /**
   * ASCII string to Base64
   */ atob(str) {
        return window.atob(str);
    }
    /**
   * Base64 to ASCII string
   */ btoa(str) {
        return window.btoa(str);
    }
    /**
   * Creates and returns adapter-aware SMART api. Not that while the shape of
   * the returned object is well known, the arguments to this function are not.
   * Those who override this method are free to require any environment-specific
   * arguments. For example in node we will need a request, a response and
   * optionally a storage or storage factory function.
   */ getSmartApi() {
        return {
            ready: (...args)=>$9b169f72336acb48$exports.ready(this, ...args),
            authorize: (options)=>$9b169f72336acb48$exports.authorize(this, options),
            init: (options)=>$9b169f72336acb48$exports.init(this, options),
            client: (state)=>new $e92efa1597823f07$exports.default(this, state),
            options: this.options
        };
    }
}
$2241136b1aba1e64$exports.default = $2241136b1aba1e64$var$BrowserAdapter;


const $d243cabdb0815a3b$var$adapter = new $2241136b1aba1e64$exports.default();
const { ready: $d243cabdb0815a3b$var$ready, authorize: $d243cabdb0815a3b$var$authorize, init: $d243cabdb0815a3b$var$init, client: $d243cabdb0815a3b$var$client, options: $d243cabdb0815a3b$var$options } = $d243cabdb0815a3b$var$adapter.getSmartApi(); // We have two kinds of browser builds - "pure" for new browsers and "legacy"


// for old ones. In pure builds we assume that the browser supports everything
// we need. In legacy mode, the library also acts as a polyfill. Babel will
// automatically polyfill everything except "fetch", which we have to handle
// manually.
// @ts-ignore
if (typeof FHIRCLIENT_PURE == "undefined") {
    const fetch = (parcelRequire("R5nvG"));
    (parcelRequire("lzME1"));
    if (!window.fetch) {
        window.fetch = fetch.default;
        window.Headers = fetch.Headers;
        window.Request = fetch.Request;
        window.Response = fetch.Response;
    }
} // $lab:coverage:off$
const $d243cabdb0815a3b$var$FHIR = {
    AbortController: window.AbortController,
    client: $d243cabdb0815a3b$var$client,
    oauth2: {
        settings: $d243cabdb0815a3b$var$options,
        ready: $d243cabdb0815a3b$var$ready,
        authorize: $d243cabdb0815a3b$var$authorize,
        init: $d243cabdb0815a3b$var$init
    }
};
$d243cabdb0815a3b$exports = $d243cabdb0815a3b$var$FHIR; // $lab:coverage:on$


var $03fb4dd33620a748$exports = {};
// Updates an LForms form definition or a FHIR resource generated by LForms,
// to be compatible with the latest LForms version.
"use strict";
var $c0724f9ae622cd19$exports = {};
$c0724f9ae622cd19$exports = JSON.parse('["29.0.0","28.0.0","26.0.0","25.0.0","24.0.0","23.0.0","22.0.0"]');


var $ab6c97af2c6a3f00$exports = {};
$ab6c97af2c6a3f00$exports = {};

$ab6c97af2c6a3f00$exports["29.0.0"] = (parcelRequire("lAjGr"));

$ab6c97af2c6a3f00$exports["28.0.0"] = (parcelRequire("1m1ub"));

$ab6c97af2c6a3f00$exports["26.0.0"] = (parcelRequire("bPSgt"));

$ab6c97af2c6a3f00$exports["25.0.0"] = (parcelRequire("7U9wy"));

$ab6c97af2c6a3f00$exports["24.0.0"] = (parcelRequire("63bjx"));

$ab6c97af2c6a3f00$exports["23.0.0"] = (parcelRequire("jfylo"));

$ab6c97af2c6a3f00$exports["22.0.0"] = (parcelRequire("8tvbb"));



/**
 *  Updates an LForms form definition or a FHIR resource generated by LForms,
 *  to be compatible with the latest LForms version.
 * @param parsedJSON the parsed JSON containing the form
 *  definition or FHIR resource to be updated.
 * @param version (optional) the version to update to.  Updates for version
 *  numbers greater than this number will not be run.
 * @return the updated form definition or FHIR resource.
 */ $03fb4dd33620a748$exports = {
    update: function(parsedJSON, version) {
        let stopVersion = version;
        let util = (parcelRequire("bVDgi"));
        // Determine the lforms version
        var isFHIR = util.isFHIRResource(parsedJSON);
        var lformsVersion;
        if (isFHIR) {
            let meta = parsedJSON.meta;
            if (meta) {
                let tags = meta.tag;
                if (tags) for (let t of tags){
                    let tagVersion = util.versionFromTag(t);
                    if (tagVersion) {
                        lformsVersion = tagVersion;
                        break;
                    }
                }
            }
        } else lformsVersion = parsedJSON.lformsVersion;
        // Determine which update steps need to run.
        let updateSteps = [];
        for(let i = 0, len = $c0724f9ae622cd19$exports.length, uv; i < len && (uv = $c0724f9ae622cd19$exports[i]) && util.versionLessThan(lformsVersion, uv); ++i)if (!stopVersion || !util.versionLessThan(stopVersion, uv)) updateSteps.push(uv);
        let latestVersion = updateSteps[0];
        for (let step of updateSteps.reverse())parsedJSON = $ab6c97af2c6a3f00$exports[step](parsedJSON);
        // If we ran any of the updates, update the version tag
        if (updateSteps.length) {
            if (isFHIR) {
                // Update or set the tag
                let meta = parsedJSON.meta;
                if (!meta) meta = parsedJSON.meta = {};
                let tags = meta.tag;
                if (!tags) tags = meta.tag = [];
                let versionTag;
                // for existing tags
                for (let t of tags){
                    let version = util.versionFromTag(t);
                    if (version) {
                        versionTag = t;
                        break;
                    }
                }
                let versionDisplay = util.makeVersionTag(latestVersion);
                if (versionTag) {
                    versionTag.code = versionDisplay;
                    delete versionTag.display; // in case it was from the old version tag format
                } else tags.push({
                    code: versionDisplay
                });
            } else parsedJSON.lformsVersion = latestVersion;
        }
        return parsedJSON;
    }
};


/**
 *  A default terminology server that can be used (when s=default is specified).
 */ const $d0da80b062bdb80c$export$aed56e8085cffbd2 = "https://tx.fhir.org/r4";
function $d0da80b062bdb80c$export$86cc832846d0eff1(packageID, version) {
    return `https://packages2.fhir.org/web/${packageID}-${version}.tgz`;
}


let $4bd47ebd12fc5c3c$var$urlQSelected = null;
let $4bd47ebd12fc5c3c$var$qCanonical;
let $4bd47ebd12fc5c3c$var$urlPSelected = null;
let $4bd47ebd12fc5c3c$var$urlSSelected = null;
let $4bd47ebd12fc5c3c$var$results;
$4bd47ebd12fc5c3c$var$initResults();
// A set of resource types from a package file a Questionnaire might need.
const $4bd47ebd12fc5c3c$var$qResourceTypes = new Set([
    "ValueSet",
    "CodeSystem",
    "Library",
    "Questionnaire"
]);
/**
 *  A wrapper for the fetch request that sets the referrer header, so that
 *  servers getting requests for packages and ValueSets will know who is making
 *  the request.
 * @param url the URL to fetch.
 * @return the return from the standard fetch call.
 */ async function $4bd47ebd12fc5c3c$var$qvFetch(url, options) {
    return qvOrigFetch(url, Object.assign({
        referrer: "/questionnaire-viewer",
        referrerPolicy: "unsafe-url" // send the referrer cross-origin
    }, options));
}
// Force LForms to use the above settings.
window.qvOrigFetch = fetch;
window.fetch = $4bd47ebd12fc5c3c$var$qvFetch;
/**
 * Converts a Blob containing JSON data into a JavaScript object.
 * (This function was written an AI.)
 * Note:  js-untar incorrectly assumes each character is 1 byte, which is not correct for UTF-8.
 *
 * @param {Blob} blob - The Blob object containing JSON data.
 * @returns {Promise<Object>} A promise that resolves with the parsed JSON object.
 *                            If parsing fails, the promise is rejected with an error.
 */ function $4bd47ebd12fc5c3c$var$blobToJson(blob) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onload = function(event) {
            try {
                const json = JSON.parse(event.target.result);
                resolve(json);
            } catch (error) {
                reject(new Error("Failed to parse JSON: " + error.message));
            }
        };
        reader.onerror = function() {
            reject(new Error("Failed to read Blob: " + reader.error));
        };
        reader.readAsText(blob, "UTF-8");
    });
}
/**
 * Add a FHIR Questionnaire to page and display it
 * @param {*} dataQ FHIR Questionnaire data (LForms format also supported)
 * @param {*} dataPackage FHIR resource package data, optional
 * @returns a Promise that resolves after the Questionnaire load attempt is
 *  complete.  Errors will have been handled and messages displayed.
 */ async function $4bd47ebd12fc5c3c$var$addQuestionnaire(dataQ, dataPackage) {
    if (dataQ && dataQ.resourceType === "Questionnaire") {
        let message = "The Questionnaire loaded from " + $4bd47ebd12fc5c3c$var$urlQSelected + " cannot be processed by LHC-Forms.  Please check if the Questionnaire is valid" + " or if it has features that LHC-Forms does not support yet.";
        // Run the updater in case it was created with an older version of
        // LHC-Forms.
        let lfData;
        // Convert FHIR Questionnaire to LForms format
        try {
            dataQ = (0, (/*@__PURE__*/$parcel$interopDefault($03fb4dd33620a748$exports))).update(dataQ);
            lfData = LForms.Util.convertFHIRQuestionnaireToLForms(dataQ);
        } catch (error) {
            if (error.message) error = error.message;
            console.error("Error:", error);
            $4bd47ebd12fc5c3c$var$results.gotQ = false;
            $4bd47ebd12fc5c3c$export$bc691a1689470b26(message + " (Details: " + error + ")");
        }
        if (lfData) {
            // Add resource package if there is one
            if (dataPackage) lfData._packageStore = dataPackage;
            // Turn off the top-level questions and controls (optional)
            lfData.templateOptions = {
                showFormHeader: false,
                hideFormControls: true
            };
            // Add the form to the page
            try {
                return LForms.Util.addFormToPage(lfData, "qv-lforms").then(async function() {
                    await $4bd47ebd12fc5c3c$var$showInfoMessages();
                    LForms.Def.ScreenReaderLog.add("A questionnaire has been displayed on the page");
                }).catch((error)=>{
                    console.error("Error:", error);
                    $4bd47ebd12fc5c3c$var$results.gotQ = true; // not sure if we did, but probably
                    $4bd47ebd12fc5c3c$export$bc691a1689470b26(error);
                    $4bd47ebd12fc5c3c$var$showInfoMessages();
                });
            } catch (error) {
                console.error("Error:", error);
                $4bd47ebd12fc5c3c$var$results.gotQ = false;
                $4bd47ebd12fc5c3c$export$bc691a1689470b26(message);
            }
        }
        return Promise.reject();
    }
}
/**
 * Show or hide the loading message
 * @param {*} show a flag decides whether to show or hide the loading message
 */ function $4bd47ebd12fc5c3c$var$setLoadingMessage(show) {
    let loadingEle = document.getElementById("qv-loading");
    if (show) loadingEle.style.display = "";
    else loadingEle.style.display = "none";
}
/**
 * Display information message once a Questionnaire is successfully loaded,
 * with or without a package file loaded successfully.
 */ async function $4bd47ebd12fc5c3c$var$showInfoMessages() {
    let formInfo = document.getElementById("qv-form-info");
    let formRendered = document.querySelector("wc-lhc-form,lforms");
    let notes = "";
    const errors = [];
    if ($4bd47ebd12fc5c3c$var$results.hasUrlQ && $4bd47ebd12fc5c3c$var$results.gotQ && formRendered) {
        notes = "The following Questionnaire was loaded from " + $4bd47ebd12fc5c3c$var$urlQSelected;
        if ($4bd47ebd12fc5c3c$var$results.pendingServerConnection) await $4bd47ebd12fc5c3c$var$results.pendingServerConnection;
        if ($4bd47ebd12fc5c3c$var$results.hasUrlP || $4bd47ebd12fc5c3c$var$results.hasUrlS) {
            if ($4bd47ebd12fc5c3c$var$results.gotP || $4bd47ebd12fc5c3c$var$results.gotS) {
                const sources = [];
                if ($4bd47ebd12fc5c3c$var$results.gotP) sources.push($4bd47ebd12fc5c3c$var$urlPSelected);
                if ($4bd47ebd12fc5c3c$var$results.gotS) sources.push($4bd47ebd12fc5c3c$var$urlSSelected);
                notes += ", with resources from " + sources.join(" and ");
            }
            notes += ".";
            let errorMsg;
            if ($4bd47ebd12fc5c3c$var$results.hasUrlP && !$4bd47ebd12fc5c3c$var$results.gotP) {
                switch($4bd47ebd12fc5c3c$var$results.pErrorLocation){
                    case "untar":
                        errorMsg = "to untar the package file from " + $4bd47ebd12fc5c3c$var$urlPSelected;
                        break;
                    case "unzip":
                        errorMsg = "to unzip the package file from " + $4bd47ebd12fc5c3c$var$urlPSelected;
                        break;
                    case "reader":
                        errorMsg = "to read the package file from " + $4bd47ebd12fc5c3c$var$urlPSelected;
                        break;
                    case "fetch":
                        errorMsg = "to fetch the package file from " + $4bd47ebd12fc5c3c$var$urlPSelected;
                        break;
                    default:
                        errorMsg = "to fetch/process the package file from " + $4bd47ebd12fc5c3c$var$urlPSelected;
                }
                if (errorMsg) errors.push("Failed " + errorMsg);
            }
            if ($4bd47ebd12fc5c3c$var$results.hasUrlS && !$4bd47ebd12fc5c3c$var$results.gotS) errorMsg = "Failed to access to the FHIR Server at " + $4bd47ebd12fc5c3c$var$urlSSelected;
        }
        if (errors.length) $4bd47ebd12fc5c3c$export$bc691a1689470b26(errors);
        else if (!LForms.lformsVersion || LForms.lformsVersion < "36.15.0") {
            // Check for messages about ValueSets that couldn't be loaded, which in
            // earlier versions of LForms did not get thrown as exceptions.
            let answerMessages = LForms.Util.getAnswersResourceStatus();
            if (answerMessages && answerMessages.length > 0) $4bd47ebd12fc5c3c$export$bc691a1689470b26(answerMessages);
        }
        if (document.getElementById("qv-error").style.display == "") notes += "  Please note the error messages above.";
    }
    formInfo.textContent = notes;
    $4bd47ebd12fc5c3c$var$setLoadingMessage(false);
}
/**
 * Load a FHIR Questionnaire resource, either from the URL or from the FHIR resource package data
 * and shows it on the page
 * @param {*} packageData a FHIR resource package, optional
 * @param qData (optional) the Questionnaire definition, pulled from packageData
 * @returns a Promise that resolves after the Questionnaire load attempt is
 *  complete.  Errors will have been handled and messages displayed.
 */ function $4bd47ebd12fc5c3c$var$loadQuestionnaire(packageData, qData) {
    let qPromise;
    if (qData) qPromise = Promise.resolve(qData);
    else if ($4bd47ebd12fc5c3c$var$qCanonical) qPromise = Promise.reject(`Questionnaire "${$4bd47ebd12fc5c3c$var$qCanonical}" was not found in the package.`);
    else if ($4bd47ebd12fc5c3c$var$urlQSelected) qPromise = fetch($4bd47ebd12fc5c3c$var$urlQSelected).then((res)=>{
        if (res.ok) return res.json();
        else throw "No data returned from " + $4bd47ebd12fc5c3c$var$urlQSelected;
    }).then((json)=>{
        if (json.resourceType !== "Questionnaire") throw "No Questionnaire (JSON) returned from " + $4bd47ebd12fc5c3c$var$urlQSelected;
        return json;
    });
    else qPromise = Promise.reject("No parameters specified a questionnaire to display");
    return qPromise.then((qJson)=>{
        $4bd47ebd12fc5c3c$var$results.gotQ = true;
        return $4bd47ebd12fc5c3c$var$addQuestionnaire(qJson, packageData);
    }).catch((error)=>{
        console.error("Error:", error);
        if (typeof error === "string") $4bd47ebd12fc5c3c$export$bc691a1689470b26(error);
        else $4bd47ebd12fc5c3c$export$bc691a1689470b26("Failed to load Questionnaire from " + $4bd47ebd12fc5c3c$var$urlQSelected);
    });
}
/**
 * Construct a files info array with the same structure of 'files' in .index.json
 *  where resourceType, url and version are used in LHC-Forms to identifier a resource.
 *  See https://confluence.hl7.org/display/FHIR/NPM+Package+Specification#NPMPackageSpecification-.index.json
 * @param {*} extractedFiles an array of file objects extracted from a tar file using js-untar-lhc npm package.
 * @return the package data and the questionnaire if it was found in the
 *  package.
 */ async function $4bd47ebd12fc5c3c$var$constructResourcePackage(extractedFiles) {
    let packageData = [], qData;
    for(let j = 0, jLen = extractedFiles.length; j < jLen; j++){
        let extractedFile = extractedFiles[j];
        if (extractedFile.name.match(/^package.*\.json$/)) {
            console.log("Reading:  " + extractedFile.name);
            let fileContent = await $4bd47ebd12fc5c3c$var$blobToJson(extractedFile.blob);
            if (fileContent && $4bd47ebd12fc5c3c$var$qResourceTypes.has(fileContent.resourceType)) {
                if (fileContent.resourceType != "Questionnaire") packageData.push({
                    filename: extractedFile.name.replace(/^package\//, ""),
                    fileContent: fileContent,
                    url: fileContent.url,
                    version: fileContent.version,
                    resourceType: fileContent.resourceType
                });
                else if ($4bd47ebd12fc5c3c$var$qCanonical && $4bd47ebd12fc5c3c$var$canonicalMatchesQuestionnaire($4bd47ebd12fc5c3c$var$qCanonical, fileContent)) qData = fileContent;
            }
        }
    }
    return [
        packageData,
        qData
    ];
}
// Written by AI (with a few iterations).
/**
 * Checks if a given FHIR canonical URL matches a Questionnaire definition.
 *
 * @param {string} canonicalUrl - The FHIR canonical URL to check.
 * @param {object} questionnaire - The Questionnaire definition object.
 * @returns {boolean} - Returns true if the canonical matches the Questionnaire definition, false otherwise.
 */ function $4bd47ebd12fc5c3c$var$canonicalMatchesQuestionnaire(canonicalUrl, questionnaire) {
    if (!questionnaire || !questionnaire.url) return false; // Return false if the questionnaire is invalid or has no URL
    // Split the canonical URL into base URL and version (if present)
    const [baseCanonicalUrl, canonicalVersion] = canonicalUrl.split("|");
    // Check if the base URLs match
    const baseUrlsMatch = baseCanonicalUrl === questionnaire.url;
    // If the canonical URL has a version, check if it matches the questionnaire version
    if (canonicalVersion) return baseUrlsMatch && canonicalVersion === questionnaire.version; // Check version if present
    // If the canonical URL does not have a version, just return the base URL match
    return baseUrlsMatch;
}
/**
 * Load a FHIR resource package file, which is a gzipped tar file.
 * See https://confluence.hl7.org/display/FHIR/NPM+Package+Specification
 * It then processes the file in memory and call loadQuestionnaire to add the questionnaire to the page.
 * See https://stackoverflow.com/questions/47443433/extracting-gzip-data-in-javascript-with-pako-encoding-issues
 * @param {*} urlPackage URL of a FHIR resource package
 */ async function $4bd47ebd12fc5c3c$var$loadPackageAndQuestionnaire(urlPackage) {
    let packageData = [];
    if (urlPackage) return fetch(urlPackage).then((response)=>{
        if (!response.ok) throw "Unable to fetch " + urlPackage;
        else return response.blob();
    }).then((response)=>{
        let reader = new FileReader();
        reader.onload = function(event) {
            try {
                let base64 = event.target.result;
                // base64 includes header info "data:application/gzip;base64,"
                // "data:application/gzip;base64,H4sIAAkTyF4AA+3RMQ6DMAyF4cw9RU6A4hDCeSIRdWMgRtDbN4BYkTpAl/9bLFtveJI1F210VXMjV8UQttn2odt3OfaDeCNtjN6JBFfv4mvSWHdnqdNcNE3WmiWN70++yuWpPFHoWVr/b4ek6fXvJgAAAAAAAAAAAAAAAACAX3wBvhQL0QAoAAA="
                // remove the header info
                let base64Content = base64.replace(/^data:[\/\+;a-zA-Z0-9\._-]+;base64,/, "");
                // convert arraybuffer to string
                const strData = atob(base64Content);
                // split it into an array rather than a "string"
                const charData = strData.split("").map(function(x) {
                    return x.charCodeAt(0);
                });
                // convert to binary
                const binData = new Uint8Array(charData);
                // inflate
                const unzippedData = (0, (/*@__PURE__*/$parcel$interopDefault($8fa5292818130bae$exports))).inflate(binData);
                // unzippedData could be too long and result in an error:
                //  "Uncaught RangeError: Maximum call stack size exceeded"
                // Use the following loop instead
                const uint16Data = new Uint16Array(unzippedData);
                let strAsciiData = "";
                let len = uint16Data.length;
                for(let i = 0; i < len; i++)strAsciiData += String.fromCharCode(uint16Data[i]);
                // convert string to ArrayBuffer
                const abData = (0, (/*@__PURE__*/$parcel$interopDefault($e835d3077c64ee50$exports)))(strAsciiData);
                // process the tar file
                // Note:
                //let fileJsonContent = extractedFile.readAsJSON();
                // readAsString (and readAsJSON) encountered two errors on on sample package.tgz file
                // 1) Uncaught RangeError: Maximum call stack size exceeded
                //    this is caused by the same reason above
                //    on line #89 in untar.js :
                //    (this._string = String.fromCharCode.apply(null, charCodes))
                //    where the side of charCodes could be too big.
                // 2) Uncaught SyntaxError: Unexpected token ï in JSON at position 0
                (0, (/*@__PURE__*/$parcel$interopDefault($c488d752965ebb38$exports)))(abData)// .progress(function(extractedFile) {
                // do something with a single extracted file
                //let fileStrContent = extractedFile.readAsString();
                // if (extractedFile && extractedFile.name.match(/\.json$/)) {
                //   packageFiles[extractedFile.name] = extractedFile.readAsJSON();
                // }
                // })
                .then(async function(extractedFiles) {
                    try {
                        if (Array.isArray(extractedFiles) && extractedFiles.length > 0) {
                            // all extracted files
                            let resInIndex = {}; // key is the file name, value is file info object
                            let qData; // the Questionnaire data read from the package
                            // check if the optional file, .index.json, is in the package
                            let indexFile = extractedFiles.find(function(file) {
                                return file.name === "package/.index.json";
                            });
                            // only process files listed in .index.json if there is a .index.json
                            if (indexFile) {
                                let indexFileContent = indexFile.readAsJSON();
                                if (indexFileContent.files.length) {
                                    for(let i = 0, iLen = indexFileContent.files.length; i < iLen; i++){
                                        let fileInfo = indexFileContent.files[i];
                                        if ($4bd47ebd12fc5c3c$var$qResourceTypes.has(fileInfo.resourceType)) resInIndex[fileInfo.filename] = fileInfo;
                                    }
                                    // remove the 'package/' from the file name and add file content
                                    for(let j = 0, jLen = extractedFiles.length; j < jLen; j++){
                                        let extractedFile = extractedFiles[j];
                                        let fileInfo = resInIndex[extractedFile.name.replace(/^package\//, "")];
                                        if (fileInfo && fileInfo.resourceType) {
                                            const fileContent = await $4bd47ebd12fc5c3c$var$blobToJson(extractedFile.blob);
                                            if (fileContent.resourceType != "Questionnaire") {
                                                fileInfo.fileContent = fileContent;
                                                packageData.push(fileInfo);
                                            } else if ($4bd47ebd12fc5c3c$var$qCanonical && $4bd47ebd12fc5c3c$var$canonicalMatchesQuestionnaire($4bd47ebd12fc5c3c$var$qCanonical, fileContent)) qData = fileContent;
                                        }
                                    }
                                } else [packageData, qData] = await $4bd47ebd12fc5c3c$var$constructResourcePackage(extractedFiles);
                            } else [packageData, qData] = await $4bd47ebd12fc5c3c$var$constructResourcePackage(extractedFiles);
                            // packageData has the same structure of the .index.json file in the package file, with an extra fileContent
                            // that contains the data in each resource file.
                            // See https://confluence.hl7.org/display/FHIR/NPM+Package+Specification
                            // load questionnaire with the pakcage data
                            $4bd47ebd12fc5c3c$var$results.gotP = true;
                            return $4bd47ebd12fc5c3c$var$loadQuestionnaire(packageData, qData);
                        } else {
                            $4bd47ebd12fc5c3c$var$results.gotP = false;
                            $4bd47ebd12fc5c3c$var$results.pErrorLocation = "untar";
                            return $4bd47ebd12fc5c3c$var$loadQuestionnaire(packageData);
                        }
                    } catch (error) {
                        console.error("Untar Error", urlPackage, error);
                        $4bd47ebd12fc5c3c$var$results.gotP = false;
                        $4bd47ebd12fc5c3c$var$results.pErrorLocation = "untar";
                        // try to load the questionnaire without the package, if we have a URL
                        if ($4bd47ebd12fc5c3c$var$urlQSelected) return $4bd47ebd12fc5c3c$var$loadQuestionnaire();
                    }
                }).catch(function(error) {
                    console.error("Untar Error", urlPackage, error);
                    $4bd47ebd12fc5c3c$var$results.gotP = false;
                    $4bd47ebd12fc5c3c$var$results.pErrorLocation = "untar";
                    // try to load the questionnaire without the package, if we have a URL
                    if ($4bd47ebd12fc5c3c$var$urlQSelected) return $4bd47ebd12fc5c3c$var$loadQuestionnaire();
                });
            } catch (error) {
                $4bd47ebd12fc5c3c$export$bc691a1689470b26(`Unable to unpack the package file ${urlPackage}.`);
                console.log("Unzip Error", urlPackage, error);
                $4bd47ebd12fc5c3c$var$results.gotP = false;
                $4bd47ebd12fc5c3c$var$results.pErrorLocation = "unzip";
                // try to load the questionnaire without the package, if we have a URL
                if ($4bd47ebd12fc5c3c$var$urlQSelected) return $4bd47ebd12fc5c3c$var$loadQuestionnaire();
            }
        };
        reader.onerror = function(error) {
            console.error("FileReader Error", urlPackage, error);
            $4bd47ebd12fc5c3c$var$results.gotP = false;
            esults.pErrorLocation = "reader";
            // try to load the questionnaire without the package
            return $4bd47ebd12fc5c3c$var$loadQuestionnaire();
        };
        reader.readAsDataURL(response);
    }).catch((error)=>{
        $4bd47ebd12fc5c3c$export$bc691a1689470b26("Unable to fetch " + urlPackage);
        console.error("Fetch Error:", urlPackage, error);
        $4bd47ebd12fc5c3c$var$results.gotP = false;
        $4bd47ebd12fc5c3c$var$results.pErrorLocation = "fetch";
        // try to load the questionnaire without the package, if we have a URL
        if ($4bd47ebd12fc5c3c$var$urlQSelected) return $4bd47ebd12fc5c3c$var$loadQuestionnaire();
    });
}
function $4bd47ebd12fc5c3c$export$bc691a1689470b26(messages) {
    if (messages) {
        let divError = document.getElementById("qv-error");
        const otherMessagesPresent = divError.style.display == "";
        divError.style.display = "";
        let divMessage = document.getElementById("qv-error-message");
        if (!Array.isArray(messages)) messages = [
            messages
        ];
        let ul;
        if (!otherMessagesPresent) {
            divMessage.textContent = "The following issues were encountered:";
            ul = document.createElement("ul");
        } else ul = document.querySelector("#qv-error-message ul");
        for(let i = 0, len = messages.length; i < len; ++i){
            const li = document.createElement("li");
            let m = messages[i];
            if (m.message) m = m.message;
            li.textContent = m;
            ul.appendChild(li);
        }
        divMessage.appendChild(ul);
    }
    $4bd47ebd12fc5c3c$var$setLoadingMessage(false);
}
/**
 * Clear up messages and previously loaded form before next Questionnaire is loaded
 */ function $4bd47ebd12fc5c3c$var$resetPage() {
    let divError = document.getElementById("qv-error");
    if (divError) divError.style.display = "none";
    let divMessage = document.getElementById("qv-error-message");
    if (divMessage) divMessage.textContent = "";
    let formInfo = document.getElementById("qv-form-info");
    if (formInfo) formInfo.textContent = "";
    // remove previously added form if any
    let formContainer = document.getElementById("qv-lforms");
    while(formContainer.firstChild)formContainer.removeChild(formContainer.lastChild);
    // reset FHIR context
    LForms.fhirContext = null;
    $4bd47ebd12fc5c3c$var$setLoadingMessage(false);
}
/**
 * Sets up a client for a standard (open) FHIR server.
 * @param urlFhirServer the URL of a FHIR server.
 *  whether communication with the server was successfully established.
 * @return a Promise which resolves or rejects to indicate the success.
 */ function $4bd47ebd12fc5c3c$var$setupFHIRServer(urlFhirServer) {
    return $4bd47ebd12fc5c3c$var$results.pendingServerConnection = new Promise((resolve, reject)=>{
        let fhir = (0, (/*@__PURE__*/$parcel$interopDefault($d243cabdb0815a3b$exports))).client(urlFhirServer);
        LForms.Util.setFHIRContext(fhir);
        // Retrieve the fhir version
        LForms.Util.getServerFHIRReleaseID(function(releaseID) {
            if (releaseID !== undefined) {
                $4bd47ebd12fc5c3c$var$results.gotS = true;
                resolve();
            } else {
                $4bd47ebd12fc5c3c$var$results.gotS = false;
                LForms.fhirContext = null;
                reject();
            }
        });
    });
}
/**
 *  Initializes the results object for keeping track of the state of the current
 *  attempt of show a Questionnaire.
 */ function $4bd47ebd12fc5c3c$var$initResults() {
    $4bd47ebd12fc5c3c$var$results = {
        hasUrlQ: false,
        gotQ: false,
        hasUrlP: false,
        gotP: false,
        hasUrlS: false,
        gotS: false
    };
}
/**
 * Show a Questionnaire based on the parameters
 */ async function $4bd47ebd12fc5c3c$var$showQuestionnaire() {
    $4bd47ebd12fc5c3c$var$initResults();
    // has a Questionnaire URL
    if ($4bd47ebd12fc5c3c$var$urlQSelected || $4bd47ebd12fc5c3c$var$qCanonical) {
        if ($4bd47ebd12fc5c3c$var$urlQSelected) $4bd47ebd12fc5c3c$var$results.hasUrlQ = true;
        $4bd47ebd12fc5c3c$var$setLoadingMessage(true);
        if ($4bd47ebd12fc5c3c$var$urlSSelected) {
            // use a FHIR server
            $4bd47ebd12fc5c3c$var$results.hasUrlS = true;
            $4bd47ebd12fc5c3c$var$setupFHIRServer($4bd47ebd12fc5c3c$var$urlSSelected);
        }
        if ($4bd47ebd12fc5c3c$var$urlPSelected) {
            // use a resource package
            $4bd47ebd12fc5c3c$var$results.hasUrlP = true;
            await $4bd47ebd12fc5c3c$var$loadPackageAndQuestionnaire($4bd47ebd12fc5c3c$var$urlPSelected);
        } else if ($4bd47ebd12fc5c3c$var$qCanonical) $4bd47ebd12fc5c3c$export$bc691a1689470b26("A Questionnaire canonical was specified, but no package URL was specified for retrieving it.");
        else // no package data
        $4bd47ebd12fc5c3c$var$loadQuestionnaire();
    } else // no Questionnaire URL
    $4bd47ebd12fc5c3c$export$bc691a1689470b26("Please provide the URL of a FHIR Questionnaire.");
}
/**
 *  Processed the parameters either from the URL or from the form.
 * @param configParams A Map-like object with the configuration
 *  parameter data.
 */ function $4bd47ebd12fc5c3c$var$processParameters(configParams) {
    $4bd47ebd12fc5c3c$var$urlQSelected = configParams.get("q");
    $4bd47ebd12fc5c3c$var$urlPSelected = configParams.get("p");
    $4bd47ebd12fc5c3c$var$urlSSelected = configParams.get("s");
    if ($4bd47ebd12fc5c3c$var$urlSSelected == "default") $4bd47ebd12fc5c3c$var$urlSSelected = (0, $d0da80b062bdb80c$export$aed56e8085cffbd2);
    if (!$4bd47ebd12fc5c3c$var$urlPSelected) {
        const pID = configParams.get("pID");
        const pVersion = configParams.get("pVersion");
        if (pID && pVersion) $4bd47ebd12fc5c3c$var$urlPSelected = (0, $d0da80b062bdb80c$export$86cc832846d0eff1)(pID, pVersion);
    }
    if (!$4bd47ebd12fc5c3c$var$urlQSelected) $4bd47ebd12fc5c3c$var$qCanonical = configParams.get("qCanonical");
}
function $4bd47ebd12fc5c3c$export$dfa97e2d2ba80ecd() {
    $4bd47ebd12fc5c3c$var$resetPage();
    // http://localhost:4029/?q=http://localhost:8080/questionnaire-use-package.json&p=http://localhost:8080/package.json.tgz
    const inputPanel = document.getElementById("qv-form-input");
    const urlLaunch = window.location.href;
    $4bd47ebd12fc5c3c$var$processParameters(new URL(urlLaunch).searchParams);
    // show input panel if parameters are not provided in URL
    if (!$4bd47ebd12fc5c3c$var$urlQSelected && !$4bd47ebd12fc5c3c$var$qCanonical) inputPanel.style.display = "";
    else $4bd47ebd12fc5c3c$var$showQuestionnaire();
}
function $4bd47ebd12fc5c3c$export$938775c66f690616() {
    // Some sample URLs for FHIR Questionnaire / LForms data
    // https://clinicaltables.nlm.nih.gov/loinc_form_definitions?loinc_num=[LOINC_NUM]>
    // https://clinicaltables.nlm.nih.gov/loinc_form_definitions?loinc_num=34565-2
    // https://lforms-fhir.nlm.nih.gov/baseR4/Questionnaire/55418-8
    // https://lforms-fhir.nlm.nih.gov/baseR4/Questionnaire/24322-0
    $4bd47ebd12fc5c3c$var$resetPage();
    let inputPanel = document.getElementById("qv-form-input");
    inputPanel.style.display = "";
    $4bd47ebd12fc5c3c$var$processParameters(new Map([
        [
            "q",
            document.getElementById("urlQuestionnaire").value
        ],
        [
            "p",
            document.getElementById("urlPackage").value
        ],
        [
            "s",
            document.getElementById("urlFhirServer").value
        ]
    ]));
    $4bd47ebd12fc5c3c$var$showQuestionnaire();
}
function $4bd47ebd12fc5c3c$export$1a1598eb56ac77b(eleId2Disable, eleId2Enable) {
    let eleDisable = document.getElementById(eleId2Disable);
    if (eleDisable) eleDisable.disabled = true;
    let eleEnable = document.getElementById(eleId2Enable);
    if (eleEnable) eleEnable.disabled = false;
}
// Parcel does not by default provide these exported functions on a global
// object, so create one here.
window.app = {
    onPageLoad: $4bd47ebd12fc5c3c$export$dfa97e2d2ba80ecd,
    viewQuestionnaire: $4bd47ebd12fc5c3c$export$938775c66f690616,
    toggleInputFields: $4bd47ebd12fc5c3c$export$1a1598eb56ac77b,
    showErrorMessages: $4bd47ebd12fc5c3c$export$bc691a1689470b26
};


const $a6657c075129ab8b$var$params = new URL(document.location).searchParams;
const $a6657c075129ab8b$var$lfv = $a6657c075129ab8b$var$params.get("lfv");
let $a6657c075129ab8b$var$lformsVersion = $a6657c075129ab8b$var$lfv || "29.2.3";
let $a6657c075129ab8b$var$supportedLFormsVersions;
if ($a6657c075129ab8b$var$lformsVersion == "latest") {
    $a6657c075129ab8b$var$supportedLFormsVersions = (0, $59b86b14c2bfb676$export$80204ecbcb196cff)();
    $a6657c075129ab8b$var$supportedLFormsVersions.then((versions)=>{
        $a6657c075129ab8b$var$lformsVersion = versions[0];
        $a6657c075129ab8b$var$loadLFormsAndShowHeader($a6657c075129ab8b$var$lformsVersion);
    });
} else if (/^\d+\.\d+\.\d+(-beta\.\d+)?$/.test($a6657c075129ab8b$var$lformsVersion)) {
    // For testing new releases of lforms, we would like to run as many tests as
    // possible with the new version.  However:
    // 1) We have a test that makes sure the default remains as 29.2.3, for
    //    backward-compatibility.
    // 2) Some tests confirm that the lfv parameter loads the requested version of
    //    lhc-forms
    // 3) We want to make sure that changes to the questionnaire-viewer do not
    //    break things for version 29.2.3, so we don't want to change the tests to
    //    always use the latest version.
    // Therefore, we have a variable here which can override the location for
    // loading the default version of lforms.   When testing a new version of
    // lforms, this can be set to a localhost webserver serving the new version--
    // and the only test that will fail will be the one that checks that the
    // default is version 29.2.3.  Also, when we change the default, we need to
    // change the loaded version to something greater than 33, since earlier
    // versions have a different file structure.
    window.urlForTestingLForms = undefined; // Set to override the default URL for loading LHC-Forms when the lfv parameter is not used
    let lformsLoadURL = undefined;
    if (urlForTestingLForms && !$a6657c075129ab8b$var$lfv) {
        $a6657c075129ab8b$var$lformsVersion = "33.0.0"; // not the version actually loaded, but affects the paths for the script & style tags
        lformsLoadURL = urlForTestingLForms;
    }
    $a6657c075129ab8b$var$loadLFormsAndShowHeader($a6657c075129ab8b$var$lformsVersion, lformsLoadURL);
} else {
    $a6657c075129ab8b$var$showHeader();
    $a6657c075129ab8b$var$showError('An invalid version "' + $a6657c075129ab8b$var$lformsVersion + '" of the LHC-Forms software was requested.');
}
/**
 *  Loads LForms, and shows the page header (which is initially hidden).
 * @param lformsVersion the version of LForms to load
 * @param lformsLoadURL (optional) a URL to use in loading LForms (in which case
 *  lformsVersion will be ignored)
 */ function $a6657c075129ab8b$var$loadLFormsAndShowHeader(lformsVersion, lformsLoadURL) {
    (0, $59b86b14c2bfb676$export$bec67c290a90f8)(lformsVersion, $a6657c075129ab8b$var$showHeader, lformsLoadURL).then(()=>$a6657c075129ab8b$var$initApp(), (e)=>{
        console.log(e); // in case some exception was thrown
        $a6657c075129ab8b$var$showHeader();
        $a6657c075129ab8b$var$showError('Unable to load version "' + lformsVersion + '" of the LHC-Forms software.');
    });
}
/**
 *  Shows the header, which is initially hidden under after the LForms CSS
 *  loads.
 */ function $a6657c075129ab8b$var$showHeader() {
    document.getElementById("header").style.display = "block";
}
/**
 *  Fetches and initializes the menu of LForms versions.
 */ function $a6657c075129ab8b$var$initLFormsVersionMenu() {
    // Get the list of lforms versions
    ($a6657c075129ab8b$var$supportedLFormsVersions || (0, $59b86b14c2bfb676$export$80204ecbcb196cff)()).then((versions)=>{
        const ac = new LForms.Def.Autocompleter.Prefetch("lformsVersion", versions, {
            defaultValue: LForms.lformsVersion,
            matchListValue: true,
            addSeqNum: false
        });
        ac.setFieldToListValue(LForms.lformsVersion);
        document.getElementById("lformsVersionMenu").style.display = "inline";
        LForms.Def.Autocompleter.Event.observeListSelections("lformsVersion", (data)=>{
            if (data.final_val && data.on_list && data.final_val != LForms.lformsVersion) (0, $59b86b14c2bfb676$export$3c5c654e2756614d)(data.final_val);
        });
    });
}
/**
 *  Initializes the app after everything has loaded.
 */ function $a6657c075129ab8b$var$initApp() {
    $a6657c075129ab8b$var$initLFormsVersionMenu();
    $4bd47ebd12fc5c3c$export$dfa97e2d2ba80ecd();
}
/**
 *  Waits for the application code to load, and then shows the given error
 *  message.
 */ function $a6657c075129ab8b$var$showError(msg) {
    $4bd47ebd12fc5c3c$export$bc691a1689470b26(msg);
}


//# sourceMappingURL=index.403b5f19.js.map
